import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  GUID: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Void: { input: any; output: any };
};

export type AiCallInputPayload = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  buyRate?: InputMaybe<Scalars['String']['input']>;
  currentMiles__vscMiles?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  dealSource?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  firstPaymentDate?: InputMaybe<Scalars['String']['input']>;
  isBuyerNotLessee?: InputMaybe<Scalars['String']['input']>;
  isDirectPayDeal?: InputMaybe<Scalars['String']['input']>;
  isLesseeOnlyOrDoubleTax?: InputMaybe<Scalars['String']['input']>;
  isRegTransferEligible?: InputMaybe<Scalars['String']['input']>;
  isTitleOnly?: InputMaybe<Scalars['String']['input']>;
  isWalkInRequired?: InputMaybe<Scalars['String']['input']>;
  lienholderName?: InputMaybe<Scalars['String']['input']>;
  maxMarkup?: InputMaybe<Scalars['String']['input']>;
  moneyDown?: InputMaybe<Scalars['String']['input']>;
  monthlyPaymentWithGap?: InputMaybe<Scalars['String']['input']>;
  monthlyPaymentWithNoCoverage?: InputMaybe<Scalars['String']['input']>;
  monthlyPaymentWithVSC?: InputMaybe<Scalars['String']['input']>;
  monthlyPaymentWithVSCGAP?: InputMaybe<Scalars['String']['input']>;
  originalWarrantyMiles?: InputMaybe<Scalars['String']['input']>;
  originalWarrantyYears?: InputMaybe<Scalars['String']['input']>;
  payoffAmount?: InputMaybe<Scalars['String']['input']>;
  repName?: InputMaybe<Scalars['String']['input']>;
  sellRate?: InputMaybe<Scalars['String']['input']>;
  termInMonths?: InputMaybe<Scalars['String']['input']>;
  vehicleMileage?: InputMaybe<Scalars['String']['input']>;
  vehicleYearMakeModel?: InputMaybe<Scalars['String']['input']>;
  vscMiles?: InputMaybe<Scalars['String']['input']>;
  vscYears?: InputMaybe<Scalars['String']['input']>;
};

export type AiCallPayload = {
  __typename?: 'AICallPayload';
  bankName?: Maybe<Scalars['String']['output']>;
  buyRate?: Maybe<Scalars['String']['output']>;
  currentMiles__vscMiles?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  dealSource?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  firstPaymentDate?: Maybe<Scalars['String']['output']>;
  isBuyerNotLessee?: Maybe<Scalars['String']['output']>;
  isDirectPayDeal?: Maybe<Scalars['String']['output']>;
  isLesseeOnlyOrDoubleTax?: Maybe<Scalars['String']['output']>;
  isRegTransferEligible?: Maybe<Scalars['String']['output']>;
  isTitleOnly?: Maybe<Scalars['String']['output']>;
  isWalkInRequired?: Maybe<Scalars['String']['output']>;
  lienholderName?: Maybe<Scalars['String']['output']>;
  maxMarkup?: Maybe<Scalars['String']['output']>;
  moneyDown?: Maybe<Scalars['String']['output']>;
  monthlyPaymentWithGap?: Maybe<Scalars['String']['output']>;
  monthlyPaymentWithNoCoverage?: Maybe<Scalars['String']['output']>;
  monthlyPaymentWithVSC?: Maybe<Scalars['String']['output']>;
  monthlyPaymentWithVSCGAP?: Maybe<Scalars['String']['output']>;
  originalWarrantyMiles?: Maybe<Scalars['String']['output']>;
  originalWarrantyYears?: Maybe<Scalars['String']['output']>;
  payoffAmount?: Maybe<Scalars['String']['output']>;
  repName?: Maybe<Scalars['String']['output']>;
  sellRate?: Maybe<Scalars['String']['output']>;
  termInMonths?: Maybe<Scalars['String']['output']>;
  vehicleMileage?: Maybe<Scalars['String']['output']>;
  vehicleYearMakeModel?: Maybe<Scalars['String']['output']>;
  vscMiles?: Maybe<Scalars['String']['output']>;
  vscYears?: Maybe<Scalars['String']['output']>;
};

export type AiCloserCallStatus = {
  __typename?: 'AICloserCallStatus';
  callSuccessful?: Maybe<Scalars['Boolean']['output']>;
  callSummary?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  event: Scalars['String']['output'];
  inVoicemail?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  userSentiment?: Maybe<Scalars['String']['output']>;
};

export type AcquirePayoffResponse = {
  __typename?: 'AcquirePayoffResponse';
  received: Scalars['Boolean']['output'];
};

export type AddressDetail = {
  __typename?: 'AddressDetail';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInputV2 = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  county?: InputMaybe<Scalars['String']['input']>;
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>;
  monthsAtHome?: InputMaybe<Scalars['Int']['input']>;
  residenceType?: InputMaybe<ResidenceTypeEnum>;
  state?: InputMaybe<Region>;
  yearsAtHome?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressTypeEnum {
  Buyer = 'buyer',
  CoBuyer = 'co_buyer',
  Current = 'current',
  DriversLicense = 'drivers_license',
  Mailing = 'mailing',
  Previous = 'previous',
}

/** The advisor bar's queue activity for the chosen pool and time frame. */
export type AdvisorSummaryStats = {
  __typename?: 'AdvisorSummaryStats';
  /** Deals that first entered Closing in the time frame. */
  apps: Scalars['Int']['output'];
  /** Deals that got a setter in the time frame. */
  assigned: Scalars['Int']['output'];
};

export type AdvisorSummaryStatsReply = {
  __typename?: 'AdvisorSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean']['output'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: AdvisorSummaryStats;
};

export type AffiliateApiKey = {
  __typename?: 'AffiliateApiKey';
  affiliate_provider_id?: Maybe<Scalars['String']['output']>;
  api_key_hash?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_used_at?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AffiliateApiKeyInput = {
  affiliate_provider_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliateDuplicateFound = {
  __typename?: 'AffiliateDuplicateFound';
  deal_id: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
};

export type AffiliateInput = {
  affiliate_provider_id?: InputMaybe<Scalars['ID']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  decision_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  decision_response?: InputMaybe<Lending_Tree_Decision_Response_Input>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lead_request?: InputMaybe<Scalars['JSONObject']['input']>;
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliateProviderInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AffiliateProviderRead = {
  __typename?: 'AffiliateProviderRead';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum AiInvolvementStatus {
  Complete = 'complete',
  Fail = 'fail',
  InProgress = 'in_progress',
  None = 'none',
}

export type Alert = {
  __typename?: 'Alert';
  alert_message?: Maybe<AlertMessage>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  priority: AlertPriority;
  seen_at?: Maybe<Scalars['DateTime']['output']>;
  type: AlertType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type AlertMessage = {
  __typename?: 'AlertMessage';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AlertPreferences = {
  __typename?: 'AlertPreferences';
  soundVolume: Scalars['Float']['output'];
};

export type AlertPreferencesInput = {
  soundVolume?: InputMaybe<Scalars['Float']['input']>;
};

export enum AlertPriority {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export type AlertRecipientsChangedPayload = {
  __typename?: 'AlertRecipientsChangedPayload';
  addedAlerts: Array<Alert>;
  removedAlertIds: Array<Scalars['ID']['output']>;
};

export enum AlertSortColumn {
  CreatedAt = 'created_at',
  Priority = 'priority',
  SeenAt = 'seen_at',
  Type = 'type',
  UpdatedAt = 'updated_at',
}

export type AlertSortingType = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<AlertSortColumn>;
};

export enum AlertType {
  AppointmentUpcoming = 'appointment_upcoming',
  ContractApproved = 'contract_approved',
  ContractFunded = 'contract_funded',
  ContractHeld = 'contract_held',
  ContractRejected = 'contract_rejected',
  DashboardDocumentUploaded = 'dashboard_document_uploaded',
  DealImportedInactivity = 'deal_imported_inactivity',
  DealIssueRaised = 'deal_issue_raised',
  DealIssueResolved = 'deal_issue_resolved',
  DownPaymentReceived = 'down_payment_received',
  DuplicatedDealImport = 'duplicated_deal_import',
  DuplicatedInfo = 'duplicated_info',
  DuplicatedLendingTreeInfo = 'duplicated_lending_tree_info',
  FundingRequirementAdded = 'funding_requirement_added',
  FundingRequirementResolved = 'funding_requirement_resolved',
  NoteCreated = 'note_created',
  PayoffRequestCompleted = 'payoff_request_completed',
  PayoffRequestFailed = 'payoff_request_failed',
  SecureFormCompleted = 'secure_form_completed',
  SecureFormExpired = 'secure_form_expired',
  TextMessageReceived = 'text_message_received',
  TieDownApproved = 'tie_down_approved',
  TieDownCountered = 'tie_down_countered',
  TieDownDeclined = 'tie_down_declined',
  TieDownSubmitted = 'tie_down_submitted',
}

export type AlertsConnection = {
  __typename?: 'AlertsConnection';
  items: Array<Maybe<Alert>>;
  pagination: Pagination;
  total: Scalars['Int']['output'];
};

export type AlertsFilter = {
  created_at?: InputMaybe<DateFilter>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priorities?: InputMaybe<Array<InputMaybe<AlertPriority>>>;
  seenOnly?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<AlertType>>>;
  unseenOnly?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<DateFilter>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AlertsMarkedSeenPayload = {
  __typename?: 'AlertsMarkedSeenPayload';
  alertIds: Array<Scalars['ID']['output']>;
};

export type AllDealsColumnSet = {
  __typename?: 'AllDealsColumnSet';
  /** Map of TanStack column id to boolean (true=shown, false=hidden). */
  columnVisibility: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AllDealsColumnSetInput = {
  columnVisibility: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type AllDealsFilterSet = {
  __typename?: 'AllDealsFilterSet';
  columnSetId?: Maybe<Scalars['String']['output']>;
  /** Saved filter snapshot in the flat all-deals search-param shape. */
  filters: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AllDealsFilterSetInput = {
  columnSetId?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type AllDealsTablePreferences = {
  __typename?: 'AllDealsTablePreferences';
  columnSets: Array<AllDealsColumnSet>;
  filterSets: Array<AllDealsFilterSet>;
};

export type AllDealsTablePreferencesInput = {
  columnSets?: InputMaybe<Array<AllDealsColumnSetInput>>;
  filterSets?: InputMaybe<Array<AllDealsFilterSetInput>>;
};

export enum AssignmentMode {
  Frequency = 'frequency',
  MaxDeals = 'max_deals',
}

export type Auth0Role = {
  __typename?: 'Auth0Role';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Auth0RoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum Auth0RoleName {
  AccountingTeam = 'AccountingTeam',
  Admin = 'Admin',
  CSuite = 'CSuite',
  CustomerService = 'CustomerService',
  D2dAdmin = 'D2dAdmin',
  D2dCloser = 'D2dCloser',
  D2dDev = 'D2dDev',
  D2dSetter = 'D2dSetter',
  D2dSetterLead = 'D2dSetterLead',
  FinanceTeam = 'FinanceTeam',
  FsManager = 'FsManager',
  FundingClerk = 'FundingClerk',
  FundingClerkManager = 'FundingClerkManager',
  InboundFinancialSpecialist = 'InboundFinancialSpecialist',
  InboundSalesAdvisor = 'InboundSalesAdvisor',
  InboundSalesPodLead = 'InboundSalesPodLead',
  OutboundAdvisorManager = 'OutboundAdvisorManager',
  OutboundSetter = 'OutboundSetter',
  OutboundWebAdvisor = 'OutboundWebAdvisor',
  PayoffClerk = 'PayoffClerk',
  PayoffManager = 'PayoffManager',
  SecondTurnFinancialSpecialist = 'SecondTurnFinancialSpecialist',
  StructuringAssistant = 'StructuringAssistant',
  StructuringManager = 'StructuringManager',
  TitleClerk = 'TitleClerk',
  TitleManager = 'TitleManager',
  WebAdmin = 'WebAdmin',
}

export type AutoStructureBankLogo = {
  __typename?: 'AutoStructureBankLogo';
  bank_name?: Maybe<Scalars['String']['output']>;
  bank_slug?: Maybe<TtNewBankEnum>;
  logo_url?: Maybe<Scalars['String']['output']>;
};

export type BackendLimits = {
  __typename?: 'BackendLimits';
  max_backend_amount?: Maybe<Scalars['Float']['output']>;
  max_backend_percentage?: Maybe<Scalars['Float']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BootReasonInputV2 = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  reason: BootReasonsEnum;
};

export enum BootReasonsEnum {
  BadContactInfo = 'bad_contact_info',
  BoughtOutThroughDifferentSource = 'bought_out_through_different_source',
  CashBuyer = 'cash_buyer',
  CustomerDoesNotQualify = 'customer_does_not_qualify',
  CustomerDoesNotWantToGiveInformationToProceed = 'customer_does_not_want_to_give_information_to_proceed',
  CustomerWaitingUntilEndOfLease = 'customer_waiting_until_end_of_lease',
  DealWasUnwound = 'deal_was_unwound',
  DirectPayState = 'direct_pay_state',
  DocFeeTooHigh = 'doc_fee_too_high',
  DuplicateDeal = 'duplicate_deal',
  ExtendedLease = 'extended_lease',
  LienholderNotApproved = 'lienholder_not_approved',
  ManufacturerNotApproved = 'manufacturer_not_approved',
  NoResponse = 'no_response',
  Other = 'other',
  PaymentOnApprovalTooHigh = 'payment_on_approval_too_high',
  PayoffAmountTooHighForFinancing = 'payoff_amount_too_high_for_financing',
  QuoteTooHigh = 'quote_too_high',
  RateTooHigh = 'rate_too_high',
  SalesTaxIssue = 'sales_tax_issue',
  ThoughtWeWereManufacturer = 'thought_we_were_manufacturer',
  TurnedVehicleBackInToDealership = 'turned_vehicle_back_in_to_dealership',
  VehicleDoesNotQualifyForOurFinancing = 'vehicle_does_not_qualify_for_our_financing',
}

export type CudlComment = {
  __typename?: 'CUDLComment';
  Body?: Maybe<Scalars['String']['output']>;
  ID?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
};

export type CudlComments = {
  __typename?: 'CUDLComments';
  Comment?: Maybe<Array<Maybe<CudlComment>>>;
};

export type CudlDecision = {
  __typename?: 'CUDLDecision';
  ID?: Maybe<Scalars['String']['output']>;
  IsCurrent?: Maybe<Scalars['Boolean']['output']>;
  OtherData?: Maybe<CudlDecisionOtherData>;
  Reasons?: Maybe<CudlReasons>;
  Status?: Maybe<Scalars['String']['output']>;
  Stipulations?: Maybe<CudlStipulations>;
};

export type CudlDecisionOtherData = {
  __typename?: 'CUDLDecisionOtherData';
  ReferralReasons?: Maybe<CudlReferralReasons>;
};

export type CudlDecisionReason = {
  __typename?: 'CUDLDecisionReason';
  Description?: Maybe<Scalars['String']['output']>;
};

export type CudlDecisions = {
  __typename?: 'CUDLDecisions';
  Decision?: Maybe<Array<Maybe<CudlDecision>>>;
};

export type CudlReasons = {
  __typename?: 'CUDLReasons';
  DecisionReason?: Maybe<Array<Maybe<CudlDecisionReason>>>;
};

export type CudlReferralReason = {
  __typename?: 'CUDLReferralReason';
  ReferralReasonText?: Maybe<Scalars['String']['output']>;
};

export type CudlReferralReasons = {
  __typename?: 'CUDLReferralReasons';
  ReferralReason?: Maybe<Array<Maybe<CudlReferralReason>>>;
};

export type CudlStipulations = {
  __typename?: 'CUDLStipulations';
  Stipulation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CudlVehicleLoanApplication = {
  __typename?: 'CUDLVehicleLoanApplication';
  Comments?: Maybe<CudlComments>;
  Decision?: Maybe<CudlDecision>;
  Decisions?: Maybe<CudlDecisions>;
  ID?: Maybe<Scalars['String']['output']>;
};

export type CalculateDealFeesResult = {
  __typename?: 'CalculateDealFeesResult';
  financialInfo: FinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type CallEvent = {
  __typename?: 'CallEvent';
  error_code?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  event_type: Scalars['String']['output'];
  hunt_group_slug?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  occurred_at: Scalars['String']['output'];
  participant_label?: Maybe<Scalars['String']['output']>;
  participant_number?: Maybe<Scalars['String']['output']>;
  participant_user_id?: Maybe<Scalars['String']['output']>;
  participant_user_name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sequence_number?: Maybe<Scalars['Int']['output']>;
  sip_response_code?: Maybe<Scalars['String']['output']>;
};

export enum CallEventDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export enum CallEventStatus {
  Answered = 'answered',
  Failed = 'failed',
  Missed = 'missed',
  Unknown = 'unknown',
  Voicemail = 'voicemail',
}

export type CallEventV2 = {
  __typename?: 'CallEventV2';
  agentName?: Maybe<Scalars['String']['output']>;
  callDuration?: Maybe<Scalars['String']['output']>;
  callStatus: CallEventStatus;
  callerName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: CallEventDirection;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CallHistoryItem = {
  __typename?: 'CallHistoryItem';
  agent_name?: Maybe<Scalars['String']['output']>;
  callDuration?: Maybe<Scalars['String']['output']>;
  calledNumber?: Maybe<Scalars['String']['output']>;
  conference_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  customer_name?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['Int']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  flow?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  hunt_group_name?: Maybe<Scalars['String']['output']>;
  hunt_group_slug?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Scalars['String']['output']>;
  recording_url?: Maybe<Scalars['String']['output']>;
  sip_failure_count?: Maybe<Scalars['Int']['output']>;
  twilioNumber?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  voicemail_reason?: Maybe<Scalars['String']['output']>;
  voicemail_recording_url?: Maybe<Scalars['String']['output']>;
  was_transferred?: Maybe<Scalars['Boolean']['output']>;
};

export type CallHistoryResult = {
  __typename?: 'CallHistoryResult';
  calls: Array<CallHistoryItem>;
  totalRecords: Scalars['Int']['output'];
};

export type CallHistoryStats = {
  __typename?: 'CallHistoryStats';
  answeredCalls: Scalars['Int']['output'];
  avgDurationSeconds?: Maybe<Scalars['Float']['output']>;
  callsByDay: Array<DayCount>;
  callsByFlowType: Array<FlowCount>;
  callsByOutcome: Array<OutcomeCount>;
  sipFailures: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  transferredCalls: Scalars['Int']['output'];
  voicemailCalls: Scalars['Int']['output'];
};

export type CallLifecycle = {
  __typename?: 'CallLifecycle';
  call: CallHistoryItem;
  events: Array<CallEvent>;
  participants: Array<CdrParticipantInLifecycle>;
};

export enum CallStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export type CdrParticipantInLifecycle = {
  __typename?: 'CdrParticipantInLifecycle';
  call_id?: Maybe<Scalars['String']['output']>;
  concluded_at?: Maybe<Scalars['String']['output']>;
  conference_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  joined_at?: Maybe<Scalars['String']['output']>;
  participant_number?: Maybe<Scalars['String']['output']>;
  participant_user_id?: Maybe<Scalars['String']['output']>;
  transferred?: Maybe<Scalars['Boolean']['output']>;
  transferred_from_number?: Maybe<Scalars['String']['output']>;
};

export type CheckPayoffRequestRequirementsResponse = {
  __typename?: 'CheckPayoffRequestRequirementsResponse';
  doubleTax: Scalars['Boolean']['output'];
  missingCombinationFields: Array<Array<Scalars['String']['output']>>;
  missingRequiredFields: Array<Scalars['String']['output']>;
  prsRequirementsMet: Scalars['Boolean']['output'];
  requirementsMet: Scalars['Boolean']['output'];
};

export type ClosingNoteSnapshot = {
  __typename?: 'ClosingNoteSnapshot';
  amountFinanced?: Maybe<Scalars['Float']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  buyerNotLessee?: Maybe<Scalars['Boolean']['output']>;
  closedByUserName?: Maybe<Scalars['String']['output']>;
  daysToPayment?: Maybe<Scalars['Float']['output']>;
  firstPaymentDate?: Maybe<Scalars['String']['output']>;
  gapPrice?: Maybe<Scalars['Float']['output']>;
  keyReplacementPrice?: Maybe<Scalars['Float']['output']>;
  moneyDown?: Maybe<Scalars['Float']['output']>;
  movedStateDuringLease?: Maybe<Scalars['Boolean']['output']>;
  optionType?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  plateTransfer?: Maybe<Scalars['Boolean']['output']>;
  productsLabel?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['Float']['output']>;
  sellRate?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['Float']['output']>;
  tireWheelPrice?: Maybe<Scalars['Float']['output']>;
  titleRegistrationOption?: Maybe<Scalars['String']['output']>;
  vscPrice?: Maybe<Scalars['Float']['output']>;
  vscTerm?: Maybe<Scalars['String']['output']>;
  vscType?: Maybe<Scalars['String']['output']>;
};

export type CommunicationEventEdge = {
  __typename?: 'CommunicationEventEdge';
  cursor: Scalars['String']['output'];
  node: CommunicationEventV2;
};

export type CommunicationEventV2 = CallEventV2 | MessageV2;

export type CommunicationHistoryConnection = {
  __typename?: 'CommunicationHistoryConnection';
  edges: Array<CommunicationEventEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CommunicationHistoryFilter = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type ComparePrequalSocials = {
  __typename?: 'ComparePrequalSocials';
  cobuyerMatches?: Maybe<Scalars['Boolean']['output']>;
  customerMatches?: Maybe<Scalars['Boolean']['output']>;
};

export enum ConsentAction {
  Detected = 'detected',
  OptIn = 'opt_in',
  OptOut = 'opt_out',
}

export enum ConsentBasis {
  Dnss = 'dnss',
  Glba = 'glba',
  Gpc = 'gpc',
}

export type ConsentDecisionInput = {
  action: ConsentAction;
  basis: ConsentBasis;
  identifiers: Array<ConsentIdentifierInput>;
  in_scope?: InputMaybe<Scalars['Boolean']['input']>;
  notice_version?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  resolution_source?: InputMaybe<Scalars['String']['input']>;
  source: ConsentSource;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum ConsentHowLinked {
  AtChoice = 'at_choice',
  IdentifiedOnOptedOutBrowser = 'identified_on_opted_out_browser',
  MatchedFromAnotherDevice = 'matched_from_another_device',
  TypedIntoForm = 'typed_into_form',
}

export enum ConsentIdType {
  AnonymousId = 'anonymous_id',
  Auth0Id = 'auth0_id',
  CustomerId = 'customer_id',
  Email = 'email',
  Phone = 'phone',
}

export type ConsentIdentifierInput = {
  id_type: ConsentIdType;
  id_value: Scalars['String']['input'];
};

export enum ConsentSource {
  GpcAuto = 'gpc_auto',
  LimitSharing = 'limit_sharing',
  PrivacyChoices = 'privacy_choices',
}

export type ContractDistribution = {
  __typename?: 'ContractDistribution';
  conversation_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  funder_comments?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jacket_id?: Maybe<Scalars['String']['output']>;
  sent_by_user_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractFundingRules = {
  __typename?: 'ContractFundingRules';
  first_contract_funds?: Maybe<Scalars['Boolean']['output']>;
  funding_priority_rules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  customerName: Scalars['String']['output'];
  dealId?: Maybe<Scalars['Int']['output']>;
  dealState?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageBody?: Maybe<Scalars['String']['output']>;
  lastMessageDate?: Maybe<Scalars['DateTime']['output']>;
  lastMessageFromCustomer?: Maybe<Scalars['Boolean']['output']>;
  lastMissedCallDate?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber: Scalars['String']['output'];
  /** The Lease End number replies to a number on no deal go out from. Deal threads read it from the deal. */
  textNumber?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
  unseenMissedCallCount: Scalars['Int']['output'];
  unseenMissedCallIds: Array<Scalars['ID']['output']>;
};

export type ConversationSummaryEdge = {
  __typename?: 'ConversationSummaryEdge';
  cursor: Scalars['String']['output'];
  node: ConversationSummary;
};

export type ConversationsInboxConnection = {
  __typename?: 'ConversationsInboxConnection';
  edges: Array<ConversationSummaryEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ConversationsInboxFilter = {
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  height?: Maybe<Scalars['Float']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xPosition?: Maybe<Scalars['Float']['output']>;
  yPosition?: Maybe<Scalars['Float']['output']>;
};

export enum Country {
  Ca = 'CA',
  Us = 'US',
}

export type CreateAndSendSecureLinkResult = {
  __typename?: 'CreateAndSendSecureLinkResult';
  emailError?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  textError?: Maybe<Scalars['String']['output']>;
};

export type CreateBookSheetsV2Response = {
  __typename?: 'CreateBookSheetsV2Response';
  category: DocumentCategoryId;
  files: Array<EnhancedDealMedia>;
  jdpError?: Maybe<Scalars['String']['output']>;
  kbbError?: Maybe<Scalars['String']['output']>;
};

export type CreateDealInput = {
  /** Defaults to true: assign the creating user as setter (and closer when permitted) and derive the pod and source from their sales pod. Pass false to leave the deal unassigned with a web source. */
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Country>;
  customer: CustomerInput;
  notes?: InputMaybe<Array<NoteInput>>;
  /** Defaults to buyout. */
  type?: InputMaybe<DealType>;
};

export type CreateFinixIdentityGraphQlType = {
  __typename?: 'CreateFinixIdentityGraphQLType';
  id?: Maybe<Scalars['String']['output']>;
  pi_b?: Maybe<Scalars['String']['output']>;
  pi_em?: Maybe<Scalars['String']['output']>;
  pi_ey?: Maybe<Scalars['String']['output']>;
  pi_lf?: Maybe<Scalars['String']['output']>;
  pi_t?: Maybe<Scalars['String']['output']>;
};

export type CreateFinixMerchantGraphQlType = {
  __typename?: 'CreateFinixMerchantGraphQLType';
  id?: Maybe<Scalars['String']['output']>;
};

export type CreateReferralPayload = {
  __typename?: 'CreateReferralPayload';
  id?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReferrerGraphQlType = {
  __typename?: 'CreateReferrerGraphQLType';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email_sent_instrument_expired_at?: Maybe<Scalars['DateTime']['output']>;
  email_sent_welcome_at?: Maybe<Scalars['DateTime']['output']>;
  finix_identity?: Maybe<Scalars['String']['output']>;
  finix_instrument?: Maybe<Scalars['String']['output']>;
  finix_merchant?: Maybe<Scalars['String']['output']>;
  finix_verify?: Maybe<Scalars['String']['output']>;
  flow_starts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instrument_brand?: Maybe<Scalars['String']['output']>;
  instrument_exp_mo?: Maybe<Scalars['String']['output']>;
  instrument_exp_yr?: Maybe<Scalars['String']['output']>;
  instrument_expired?: Maybe<Scalars['Boolean']['output']>;
  instrument_last_four?: Maybe<Scalars['String']['output']>;
  instrument_type?: Maybe<Scalars['String']['output']>;
  opted_in_at?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url_views?: Maybe<Scalars['Int']['output']>;
};

export type CreateTieDownInput = {
  deal_id: Scalars['ID']['input'];
  items: Array<TieDownItemInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<ProductSlug>>;
  ready_to_sign_today: Scalars['Boolean']['input'];
};

export type CreateTransactionInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<TtConditionFilterInput>;
  parameters?: InputMaybe<TtFeesInput>;
  processor?: InputMaybe<Processor>;
  state?: InputMaybe<StateAbbreviation>;
  types?: InputMaybe<Array<InputMaybe<TtProductType>>>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  auth0Roles: Array<InputMaybe<Auth0RoleInput>>;
  email: Scalars['String']['input'];
  huntGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location?: InputMaybe<LocationType>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiterId?: InputMaybe<Scalars['String']['input']>;
};

export type CreditAppInput = {
  cobuyer?: InputMaybe<CustomerInput>;
  contact?: InputMaybe<DealContactInput>;
  customer: CustomerInput;
  financial_info: FinancialInfoInput;
  id: Scalars['ID']['input'];
  odometer_status?: InputMaybe<OdometerStatus>;
  original_lessee?: InputMaybe<OriginalLesseeInput>;
  second_contact?: InputMaybe<DealContactInput>;
  state: Scalars['String']['input'];
};

export type CreditApplicationSubmission = {
  __typename?: 'CreditApplicationSubmission';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CreditApplicationSubmissionFilter = {
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CreditDecisionCreatedPayload = {
  __typename?: 'CreditDecisionCreatedPayload';
  creditDecisionId: Scalars['ID']['output'];
  dealId: Scalars['ID']['output'];
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomDateKeyEnum {
  AtAuction = 'at_auction',
  Booted = 'booted',
  Closed = 'closed',
  Closing = 'closing',
  DownPaymentReceived = 'down_payment_received',
  DownPaymentScheduled = 'down_payment_scheduled',
  Estimate = 'estimate',
  Finalized = 'finalized',
  Floor = 'floor',
  Funded = 'funded',
  PaidOff = 'paid_off',
  ReadyForPickup = 'ready_for_pickup',
  SendPayoff = 'send_payoff',
  SentToAudit = 'sent_to_audit',
  SentToBank = 'sent_to_bank',
  SentToProcessor = 'sent_to_processor',
  Signatures = 'signatures',
  Signed = 'signed',
  SoftClose = 'soft_close',
  Sold = 'sold',
  Structuring = 'structuring',
  StructuringInProgress = 'structuring_in_progress',
  TemporaryRegistrationTagsExpirationDate = 'temporary_registration_tags_expiration_date',
  TemporaryRegistrationTagsSentDate = 'temporary_registration_tags_sent_date',
  TitleReceived = 'title_received',
  TitleSent = 'title_sent',
  WaitingForTitle = 'waiting_for_title',
  WetSigReceivedDate = 'wet_sig_received_date',
  WetSigSentDate = 'wet_sig_sent_date',
}

export type CustomDateUpdatedPayload = {
  __typename?: 'CustomDateUpdatedPayload';
  date?: Maybe<Scalars['DateTime']['output']>;
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID']['output'];
};

export type CustomerContactInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationToBuyer?: InputMaybe<RelationToBuyerEnum>;
  suffix?: InputMaybe<NameSuffix>;
};

export enum CustomerNotificationCallToActions {
  OpenFrozenOrLockedCreditModal = 'OpenFrozenOrLockedCreditModal',
}

export type CustomerPhoneNumberChange = {
  __typename?: 'CustomerPhoneNumberChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['Int']['output'];
  deal_id: Scalars['Int']['output'];
  /** Customer phone column that changed on the deal. Expected values: phone_number, home_phone_number. */
  field: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  new_value?: Maybe<Scalars['String']['output']>;
  previous_value: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type DdSoftPull = {
  __typename?: 'DDSoftPull';
  cobuyer?: Maybe<Prequalification>;
  customer: Prequalification;
};

export type DashboardDealsWithCounts = {
  __typename?: 'DashboardDealsWithCounts';
  deals?: Maybe<Array<Maybe<Deal>>>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  stateCounts?: Maybe<Array<Maybe<StateCount>>>;
};

export type DashboardDocumentUpload = {
  __typename?: 'DashboardDocumentUpload';
  deal: Deal;
  fileType: Scalars['String']['output'];
};

export type DateFilter = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DayCount = {
  __typename?: 'DayCount';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export enum DealActionIssue {
  ActivePayoffRequest = 'active_payoff_request',
  CalculateGap = 'calculate_gap',
  CalculateKeyReplacement = 'calculate_key_replacement',
  CalculateTireWheel = 'calculate_tire_wheel',
  CalculateVsc = 'calculate_vsc',
  CobuyerCountryMismatch = 'cobuyer_country_mismatch',
  CobuyerRequired = 'cobuyer_required',
  GapPriceLessThanCost = 'gap_price_less_than_cost',
  GoodThroughDateNotInFuture = 'good_through_date_not_in_future',
  IncompleteCobuyerContactInfo = 'incomplete_cobuyer_contact_info',
  IncompleteCobuyerEmploymentInfo = 'incomplete_cobuyer_employment_info',
  IncompleteCobuyerPersonalInfo = 'incomplete_cobuyer_personal_info',
  IncompleteCobuyerResidentialInfo = 'incomplete_cobuyer_residential_info',
  IncompleteContactInfo = 'incomplete_contact_info',
  IncompleteEmploymentInfo = 'incomplete_employment_info',
  IncompletePersonalInfo = 'incomplete_personal_info',
  IncompleteResidentialInfo = 'incomplete_residential_info',
  IncompleteVehicleInfo = 'incomplete_vehicle_info',
  KeyPriceLessThanCost = 'key_price_less_than_cost',
  MarkupAboveMax = 'markup_above_max',
  MissingBank = 'missing_bank',
  MissingDaysToPayment = 'missing_days_to_payment',
  MissingFundingClerk = 'missing_funding_clerk',
  MissingGoodThroughDate = 'missing_good_through_date',
  MissingLienholder = 'missing_lienholder',
  MissingPermission = 'missing_permission',
  MissingPrequalification = 'missing_prequalification',
  MissingTerm = 'missing_term',
  MissingVehiclePayoff = 'missing_vehicle_payoff',
  NoSelectedPackage = 'no_selected_package',
  ScheduledFollowUp = 'scheduled_follow_up',
  SellRateLessThanBuyRate = 'sell_rate_less_than_buy_rate',
  TwPriceLessThanCost = 'tw_price_less_than_cost',
  VehiclePayoffNotGreaterThanZero = 'vehicle_payoff_not_greater_than_zero',
  VscPriceLessThanCost = 'vsc_price_less_than_cost',
}

export type DealActionValidation = {
  __typename?: 'DealActionValidation';
  isValid: Scalars['Boolean']['output'];
  issues?: Maybe<Array<Maybe<DealActionIssue>>>;
};

export type DealActivityLoggedSubscriptionPayload = {
  __typename?: 'DealActivityLoggedSubscriptionPayload';
  dealId: Scalars['Int']['output'];
};

export type DealAssignmentFilter = {
  /** When ownerIds contains exactly the authenticated user, also includes unassigned deals claimable by that user based on their permissions. */
  includeClaimableByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Assignees to match across the selected roles. Omitted or empty means no ownership filter. */
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limits which assignment fields are searched when ownerIds are provided. When omitted or empty, all assignment roles are searched. */
  roles?: InputMaybe<Array<DealAssignmentRole>>;
};

export type DealAssignmentLogEntry = {
  __typename?: 'DealAssignmentLogEntry';
  /** Assignment actor identifier. Usually a user ID; can also be system markers: system, historical. */
  assigned_by?: Maybe<Scalars['String']['output']>;
  assigned_by_user?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Assignment role field that changed on the deal. Expected values: setter_id, closer_id, closer2_id, second_turn_financial_specialist_id, title_clerk_id, title_clerk2_id, funding_clerk_id, structuring_manager_id. */
  role?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type DealAssignmentLogEntryInput = {
  /** Assignment actor identifier. Usually a user ID; can also be system markers: system, historical. */
  assigned_by?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Assignment role field that changed on the deal. Expected values: setter_id, closer_id, closer2_id, second_turn_financial_specialist_id, title_clerk_id, title_clerk2_id, funding_clerk_id, structuring_manager_id. */
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum DealAssignmentRole {
  Advisor = 'advisor',
  FinancialSpecialist1 = 'financialSpecialist1',
  FinancialSpecialist2 = 'financialSpecialist2',
  FundingClerk = 'fundingClerk',
  RegistrationAssistant = 'registrationAssistant',
  StructuringManager = 'structuringManager',
  TitleClerk = 'titleClerk',
}

export type DealContact = {
  __typename?: 'DealContact';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  opt_out_sent_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  opt_out_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
};

export type DealDates = {
  __typename?: 'DealDates';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** JSON map of custom milestone timestamps. Supports deal state keys plus wet_sig_sent_date, wet_sig_received_date, sent_to_audit, temporary_registration_tags_sent_date, and temporary_registration_tags_expiration_date. */
  custom_dates?: Maybe<Scalars['JSON']['output']>;
  /** JSON map keyed by deal state values with the UTC timestamp of the most recent entry into each state. Unlike deal_states, this does not preserve full transition history. */
  dates?: Maybe<Scalars['JSON']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealDatesInput = {
  /** JSON map of custom milestone timestamps. Supports deal state keys plus wet_sig_sent_date, wet_sig_received_date, sent_to_audit, temporary_registration_tags_sent_date, and temporary_registration_tags_expiration_date. */
  custom_dates?: InputMaybe<Scalars['JSON']['input']>;
  /** JSON map keyed by deal state values with the UTC timestamp of the most recent entry into each state. Unlike deal_states, this does not preserve full transition history. */
  dates?: InputMaybe<Scalars['JSON']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DealDocument = {
  __typename?: 'DealDocument';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  dealJacketId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  docStatCode?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  signAttributes?: Maybe<Array<Maybe<DealDocumentSignAttribute>>>;
  signatureStatus?: Maybe<DocumentSignatureStatus>;
  wetSignature?: Maybe<Scalars['Boolean']['output']>;
};

export type DealDocumentSignAttribute = {
  __typename?: 'DealDocumentSignAttribute';
  actorName?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<ActorType>;
  dateCoordinates?: Maybe<Coordinate>;
  dateFieldName?: Maybe<Scalars['String']['output']>;
  initialsType?: Maybe<Scalars['Boolean']['output']>;
  signCaptureTms?: Maybe<Scalars['String']['output']>;
  signFieldName?: Maybe<Scalars['String']['output']>;
  signPadText?: Maybe<Scalars['String']['output']>;
  signRequired?: Maybe<Scalars['Boolean']['output']>;
  signatureCoordinates?: Maybe<Coordinate>;
};

export type DealFinancialFieldChange = {
  __typename?: 'DealFinancialFieldChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  /** financial_infos column that was manually edited on the deal. Expected values: base_tax_amount, new_registration_fee. */
  field: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  new_value?: Maybe<Scalars['Float']['output']>;
  previous_value?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type DealImported = {
  __typename?: 'DealImported';
  deal_id: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
};

export type DealIssue = {
  __typename?: 'DealIssue';
  comment: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  slug: DealIssueSlug;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealIssueResolutionStatusChanged = {
  __typename?: 'DealIssueResolutionStatusChanged';
  dealId: Scalars['Int']['output'];
  dealIssues: Array<DealIssue>;
};

export enum DealIssueSlug {
  AddressMismatch = 'address_mismatch',
  ContractOutOfBalance = 'contract_out_of_balance',
  DownPaymentDiscrepancy = 'down_payment_discrepancy',
  NameMismatch = 'name_mismatch',
  Other = 'other',
  PayoffChange = 'payoff_change',
  RateChange = 'rate_change',
  SalesTaxIssue = 'sales_tax_issue',
  StructureViolation = 'structure_violation',
  VehicleInfoMismatch = 'vehicle_info_mismatch',
}

export enum DealLockStatus {
  AiCall = 'ai_call',
  CustomerEntry = 'customer_entry',
  MovingToClosing = 'moving_to_closing',
}

export type DealLockStatusSubscriptionPayload = {
  __typename?: 'DealLockStatusSubscriptionPayload';
  dealId: Scalars['Int']['output'];
  lockStatus?: Maybe<DealLockStatus>;
};

export enum DealMediaCustomerTypeEnum {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  Emissions = 'emissions',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  LicensePlate = 'license_plate',
  OdometerPicture = 'odometer_picture',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  Registration = 'registration',
  SafetyInspection = 'safety_inspection',
  SmogInspection = 'smog_inspection',
  VinInspection = 'vin_inspection',
}

export enum DealMediaNoSignatureUploadTypeEnum {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BookSheet = 'book_sheet',
  CpsGuaranteeOfTitle = 'cps_guarantee_of_title',
  CreditApproval = 'credit_approval',
  ElectronicSignatureAttestation = 'electronic_signature_attestation',
  ElectronicSignatureCertification = 'electronic_signature_certification',
  Emissions = 'emissions',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  LicensePlate = 'license_plate',
  OdometerPicture = 'odometer_picture',
  PayoffDocs = 'payoff_docs',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  RateExceptionForm = 'rate_exception_form',
  Registration = 'registration',
  ReleaseOfInterest = 'release_of_interest',
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation',
  SafetyInspection = 'safety_inspection',
  SantanderGuaranteeOfTitle = 'santander_guarantee_of_title',
  SignedDocs = 'signed_docs',
  SmogInspection = 'smog_inspection',
  TitleRelease = 'title_release',
  VinInspection = 'vin_inspection',
}

export enum DealMediaReleaseOfInterestTypeEnum {
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation',
}

export enum DealMediaSourceEnum {
  Customer = 'customer',
  System = 'system',
  User = 'user',
}

export enum DealMediaStateEnum {
  Active = 'active',
  Pending = 'pending',
}

export type DealMovedSubscriptionPayload = {
  __typename?: 'DealMovedSubscriptionPayload';
  dealId: Scalars['Int']['output'];
  rewritesMoney: Scalars['Boolean']['output'];
};

export enum DealNotificationFilter {
  Appointment = 'Appointment',
  Booted = 'Booted',
  Reminder = 'Reminder',
  UnreadTexts = 'UnreadTexts',
}

export type DealPackageConfig = {
  __typename?: 'DealPackageConfig';
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int']['output'];
};

export type DealPackageConfigInput = {
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int']['input'];
};

export type DealPodChange = {
  __typename?: 'DealPodChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  new_pod?: Maybe<Pod>;
  new_pod_id?: Maybe<Scalars['Int']['output']>;
  /** Pod assignment column that changed on the deal. Expected values: pod_id, fs_pod_id, titling_pod_id. */
  pod_type: Scalars['String']['output'];
  previous_pod?: Maybe<Pod>;
  previous_pod_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type DealProduct = {
  __typename?: 'DealProduct';
  cost?: Maybe<Scalars['Float']['output']>;
  coverage_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_currently_offered?: Maybe<Scalars['Boolean']['output']>;
  pen_contract_number?: Maybe<Scalars['String']['output']>;
  pen_form_id?: Maybe<Scalars['Int']['output']>;
  pen_rate_id?: Maybe<Scalars['Int']['output']>;
  pen_session_id?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product_catalog?: Maybe<ProductCatalogV2>;
  product_catalog_id: Scalars['Int']['output'];
  tax_amount?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealProductInputV2 = {
  cost: Scalars['Float']['input'];
  coverageType?: InputMaybe<Scalars['String']['input']>;
  penRateId?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  productCatalogId: Scalars['Int']['input'];
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type DealProductRateFailure = {
  __typename?: 'DealProductRateFailure';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  slug: ProductSlug;
};

export type DealProductRateInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  slug: ProductSlug;
};

export type DealProductRatesResult = {
  __typename?: 'DealProductRatesResult';
  dealProducts: Array<DealProduct>;
  failedSlugs: Array<DealProductRateFailure>;
  paymentOptions: PaymentOptionsV2;
};

export enum DealSortColumn {
  ApprovedDate = 'approved_date',
  CreatedAt = 'created_at',
  CustomerName = 'customer_name',
  DealStage = 'deal_stage',
  DefaultSortDate = 'default_sort_date',
  FollowUpDate = 'follow_up_date',
  LaneArrivalUtc = 'lane_arrival_utc',
  PriorityQueue = 'priority_queue',
  Profit = 'profit',
  TieDownSubmittedAt = 'tie_down_submitted_at',
  UsState = 'us_state',
}

export enum DealSource {
  All = 'all',
  CallIn = 'call_in',
  D2d = 'd2d',
  Outbound = 'outbound',
  Web = 'web',
}

export type DealSourceChange = {
  __typename?: 'DealSourceChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  /** Deal source value before/after an update. Persisted values: call-in, d2d, web, outbound. */
  new_source: Scalars['String']['output'];
  /** Deal source value before/after an update. Persisted values: call-in, d2d, web, outbound. */
  previous_source?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum DealStateEnum {
  AtAuction = 'at_auction',
  Booted = 'booted',
  Closed = 'closed',
  Closing = 'closing',
  Estimate = 'estimate',
  Finalized = 'finalized',
  Floor = 'floor',
  Funded = 'funded',
  PaidOff = 'paid_off',
  ReadyForPickup = 'ready_for_pickup',
  SendPayoff = 'send_payoff',
  SentToProcessor = 'sent_to_processor',
  Signatures = 'signatures',
  Signed = 'signed',
  SoftClose = 'soft_close',
  Sold = 'sold',
  Structuring = 'structuring',
  StructuringInProgress = 'structuring_in_progress',
  TitleReceived = 'title_received',
  TitleSent = 'title_sent',
  WaitingForTitle = 'waiting_for_title',
}

export type DealStats = {
  __typename?: 'DealStats';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  done_count: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  in_progress_count: Scalars['Int']['output'];
  last_computed_at: Scalars['DateTime']['output'];
  manufacturer: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealStatsByManufacturer = {
  __typename?: 'DealStatsByManufacturer';
  done_count: Scalars['Int']['output'];
  in_progress_count: Scalars['Int']['output'];
  last_computed_at: Scalars['DateTime']['output'];
  manufacturer: Scalars['String']['output'];
};

export type DealStatsByState = {
  __typename?: 'DealStatsByState';
  done_count: Scalars['Int']['output'];
  in_progress_count: Scalars['Int']['output'];
  last_computed_at: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
};

export type DealTieDown = {
  __typename?: 'DealTieDown';
  /** Whether the requesting user may review this deal's tie downs. Deal-level twin of TieDown.can_review: the predicate only depends on the deal and the user, so selecting it here avoids resolving it once per history row. */
  can_review: Scalars['Boolean']['output'];
  current?: Maybe<TieDown>;
  history: Array<TieDown>;
};

export enum DealType {
  Acquisition = 'acquisition',
  Buyout = 'buyout',
  Marketplace = 'marketplace',
  Refi = 'refi',
}

export type DealTypeChange = {
  __typename?: 'DealTypeChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  /** Deal type value before/after an update. Expected values: marketplace, buyout, refi, acquisition. */
  new_type: Scalars['String']['output'];
  /** Deal type value before/after an update. Expected values: marketplace, buyout, refi, acquisition. */
  previous_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type DealUnreadMessageCount = {
  __typename?: 'DealUnreadMessageCount';
  byRecipient: Array<RecipientUnreadCount>;
  missedCallCount: Scalars['Int']['output'];
  totalUnread: Scalars['Int']['output'];
};

export type DealWithErrors = {
  __typename?: 'DealWithErrors';
  deal?: Maybe<Deal>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Dealer = {
  __typename?: 'Dealer';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealsConnection = {
  __typename?: 'DealsConnection';
  items: Array<Maybe<Deal>>;
  pagination: Pagination;
  total: Scalars['Int']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type DealsFilter = {
  /** Only deals with an actioned tie down on a pod the current user leads (approved, countered, or declined), excluding signed and dead deals. */
  actionedTieDownReview?: InputMaybe<Scalars['Boolean']['input']>;
  approved_date?: InputMaybe<DateFilter>;
  assignment?: InputMaybe<DealAssignmentFilter>;
  banks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completion_date?: InputMaybe<DateFilter>;
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<Country>>>;
  created_at?: InputMaybe<DateFilter>;
  excludeScheduledFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  fsPodIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Only deals routed to an FS pod the current user belongs to, regardless of assignee. See:All FS Pods removes the pod restriction, including deals without an FS pod. */
  fsPodScoped?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  leaseIds?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  notifications?: InputMaybe<Array<DealNotificationFilter>>;
  payoffLienholderSlugs?: InputMaybe<Array<LienholderSlugEnum>>;
  /** Only deals awaiting financial specialist assignment (closer and closer2 unset), routed to an FS pod the current user belongs to (all FS pods with See:All FS Pods). */
  pendingFsAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deals awaiting FS assignment, plus uncalled deals from Closing through Signed, routed to an FS pod the current user belongs to (all FS pods with See:All FS Pods). FS-assigned deals stay until their first customer call. */
  pendingFsContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only deals with a pending tie down routed to a pod the current user leads. */
  pendingTieDownReview?: InputMaybe<Scalars['Boolean']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  selectedProducts?: InputMaybe<Array<InputMaybe<ProductSlug>>>;
  /** true for deals handed to the bank (the Bank lane), false for those not yet sent (the Signed lane). Omit to include both. */
  sentToBank?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<DealSource>;
  sources?: InputMaybe<Array<InputMaybe<DealSource>>>;
  state?: InputMaybe<Array<InputMaybe<DealStateEnum>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<DealType>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
  updated_at?: InputMaybe<DateFilter>;
  usStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum DecisionStipulation {
  BankruptcyDischargeRequired = 'bankruptcy_discharge_required',
  BuyersOrderRequired = 'buyers_order_required',
  EmploymentVerificationRequired = 'employment_verification_required',
  InsuranceRequired = 'insurance_required',
  PoiRequired = 'poi_required',
  PorRequired = 'por_required',
  ValidIdRequired = 'valid_id_required',
}

export type DeleteFinixInstrumentGraphQlType = {
  __typename?: 'DeleteFinixInstrumentGraphQLType';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DobSsnInput = {
  dob?: InputMaybe<Scalars['Date']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCategories = {
  __typename?: 'DocumentCategories';
  driver_files: DocumentCategory;
  miscellaneous: DocumentCategory;
  release_of_interest: DocumentCategory;
  signature_documents: DocumentCategory;
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  deal_id: Scalars['ID']['output'];
  documents?: Maybe<Array<EnhancedDealMedia>>;
  id: DocumentCategoryId;
  progress: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  uploaded: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
};

export enum DocumentCategoryId {
  DriverFiles = 'driver_files',
  Miscellaneous = 'miscellaneous',
  ReleaseOfInterest = 'release_of_interest',
  SignatureDocuments = 'signature_documents',
}

export type DocumentInfo = {
  __typename?: 'DocumentInfo';
  adobe_agreement_id?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  signed_at?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<DocumentInfoType>;
};

export type DocumentInfoInput = {
  adobe_agreement_id?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DocumentInfoType>;
};

export enum DocumentInfoType {
  Customer = 'customer',
  Roi = 'roi',
}

export type DocumentPreparationProgress = {
  __typename?: 'DocumentPreparationProgress';
  dealId: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  mediaLabel: Scalars['String']['output'];
  mediaType: DealMediaTypeEnum;
  status: DocumentPreparationStatus;
};

export type DocumentPreparationProgressSubscriptionArgs = {
  dealId: Scalars['Int']['input'];
  mediaType: DealMediaTypeEnum;
};

export enum DocumentPreparationStatus {
  Error = 'Error',
  Generated = 'Generated',
  PendingGeneration = 'PendingGeneration',
  PendingUpload = 'PendingUpload',
  Uploaded = 'Uploaded',
}

export enum DocumentProgressStatus {
  Failed = 'failed',
  GenerateDocuments = 'generate_documents',
  PendingLender = 'pending_lender',
  PendingR1 = 'pending_r1',
  ReadyForSignatures = 'ready_for_signatures',
  Required = 'required',
  SentForSignatures = 'sent_for_signatures',
  Signed = 'signed',
  UploadDocuments = 'upload_documents',
}

export enum DocumentSignatureStatus {
  Completed = 'completed',
  InProcess = 'in_process',
  Unstarted = 'unstarted',
}

export type DocumentationRequirements = {
  __typename?: 'DocumentationRequirements';
  bankruptcy_discharge_required?: Maybe<Scalars['Boolean']['output']>;
  buyers_order_required?: Maybe<Scalars['Boolean']['output']>;
  employment_verification_required?: Maybe<Scalars['Boolean']['output']>;
  insurance_required?: Maybe<Scalars['Boolean']['output']>;
  poi_required?: Maybe<Scalars['Boolean']['output']>;
  por_required?: Maybe<Scalars['Boolean']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valid_id_required?: Maybe<Scalars['Boolean']['output']>;
};

export type DownPaymentReceived = {
  __typename?: 'DownPaymentReceived';
  amount: Scalars['Float']['output'];
  dealId: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DriversLicenseGql = {
  __typename?: 'DriversLicenseGQL';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum DuplicateTypeEnum {
  CustomerOnly = 'customer_only',
  Entire = 'entire',
}

export type DuplicatedDealImport = {
  __typename?: 'DuplicatedDealImport';
  deal_id: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
};

export type DuplicatedInfo = {
  __typename?: 'DuplicatedInfo';
  deal_id: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type EmbeddedInsuranceNotification = {
  __typename?: 'EmbeddedInsuranceNotification';
  customer_id: Scalars['ID']['output'];
  deal_id: Scalars['ID']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum EmployerPhoneLookupForm {
  BuyerCurrent = 'BUYER_CURRENT',
  BuyerPrevious = 'BUYER_PREVIOUS',
  CobuyerCurrent = 'COBUYER_CURRENT',
  CobuyerPrevious = 'COBUYER_PREVIOUS',
}

export type EmployerPhoneLookupInput = {
  city: Scalars['String']['input'];
  employerName: Scalars['String']['input'];
  form: EmployerPhoneLookupForm;
  selfEmployed?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  temporaryInfoId: Scalars['ID']['input'];
  userPhone?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type EmployerPhoneLookupResult = {
  __typename?: 'EmployerPhoneLookupResult';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source: EmployerPhoneLookupSource;
};

export enum EmployerPhoneLookupSource {
  GooglePlaces = 'GOOGLE_PLACES',
  NotFound = 'NOT_FOUND',
  SelfEmployed = 'SELF_EMPLOYED',
}

export type EmploymentInfoInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['Int']['input'];
  employment?: InputMaybe<EmploymentInputV2>;
  prevEmployment?: InputMaybe<EmploymentInputV2>;
};

export type EmploymentInputV2 = {
  grossIncome?: InputMaybe<Scalars['Float']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  monthsAtJob?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<IncomeIntervalEnum>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  yearsAtJob?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmploymentStatusEnum {
  Employed = 'employed',
  NotEmployed = 'not_employed',
  Retired = 'retired',
}

export enum EmploymentTypeEnum {
  Current = 'current',
  Previous = 'previous',
}

export type EnhancedDealMedia = {
  __typename?: 'EnhancedDealMedia';
  calculated?: Maybe<EnhancedDealMediaCalculatedFields>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  cudl_document_id?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  generation_batch?: Maybe<Scalars['DateTime']['output']>;
  has_verified_digital_signature?: Maybe<Scalars['Boolean']['output']>;
  has_wet_signature?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_notarized?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  r1_document_id?: Maybe<Scalars['String']['output']>;
  signed_url?: Maybe<Scalars['String']['output']>;
  source?: Maybe<DealMediaSourceEnum>;
  state?: Maybe<DealMediaStateEnum>;
  type?: Maybe<DealMediaTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uploaded_by?: Maybe<User>;
  uploaded_by_user_id?: Maybe<Scalars['String']['output']>;
  uploaded_via_com?: Maybe<Scalars['Boolean']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  wet_signature_required?: Maybe<Scalars['Boolean']['output']>;
};

export type EnhancedDealMediaCalculatedFields = {
  __typename?: 'EnhancedDealMediaCalculatedFields';
  fileName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  verificationRules?: Maybe<Array<Maybe<TtValidationName>>>;
};

export type ExperianOutput = {
  __typename?: 'ExperianOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  riskModel?: Maybe<ExperianRiskModel>;
};

export type ExperianRiskModel = {
  __typename?: 'ExperianRiskModel';
  score?: Maybe<Scalars['String']['output']>;
};

export type ExternalCustomerInput = {
  dashboard_visited?: InputMaybe<Scalars['Boolean']['input']>;
  last_authenticated_route?: InputMaybe<Scalars['String']['input']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalDealInputType = {
  auto_import_variation?: InputMaybe<AutoImportVariation>;
};

export type ExternalPayoffIntelligenceFieldsInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractedDocumentGql = {
  __typename?: 'ExtractedDocumentGQL';
  documentName?: Maybe<Scalars['ID']['output']>;
  fields?: Maybe<Array<Maybe<ExtractedField>>>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ExtractedField = {
  __typename?: 'ExtractedField';
  confidence?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FeeGql = {
  __typename?: 'FeeGQL';
  baseTaxAmount?: Maybe<Scalars['Float']['output']>;
  docFeeTaxAmount?: Maybe<Scalars['Float']['output']>;
  feeProcessor?: Maybe<Scalars['String']['output']>;
  registrationTransferFee?: Maybe<Scalars['Float']['output']>;
  salesTaxRate?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<StateAbbreviation>;
  taxProcessor?: Maybe<Scalars['String']['output']>;
  totalFeeAmount?: Maybe<Scalars['Float']['output']>;
  warrantyTaxAmount?: Maybe<Scalars['Float']['output']>;
};

export type FetchDealProductRatesInput = {
  dealId: Scalars['Int']['input'];
  productSlugs?: InputMaybe<Array<ProductSlug>>;
};

export type File = {
  __typename?: 'File';
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<DealMediaTypeEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FillMessageTemplateInput = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  recipientPhone: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type FillMessageTemplateResult = {
  __typename?: 'FillMessageTemplateResult';
  renderedMessage: Scalars['String']['output'];
};

export type FilterType = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  banks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closedDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  closedDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  dealStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasTitleReceived?: InputMaybe<Scalars['Boolean']['input']>;
  lienholders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  processors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  titleDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  titleDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  titlingPods?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  usStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FinancialInfoFilter = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FinancialInfoInputV2Input = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']['input']>;
  bank_fees?: InputMaybe<Scalars['Float']['input']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']['input']>;
  base_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']['input']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']['input']>;
  closer_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']['input']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']['input']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']['input']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  doc_fee?: InputMaybe<Scalars['Float']['input']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']['input']>;
  first_payment_date?: InputMaybe<Scalars['Date']['input']>;
  money_down?: InputMaybe<Scalars['Float']['input']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']['input']>;
  new_lienholder?: InputMaybe<BankInput>;
  new_registration_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']['input']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']['input']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  quick_notes?: InputMaybe<Scalars['String']['input']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']['input']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']['input']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']['input']>;
  setter_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  title_fee?: InputMaybe<Scalars['Float']['input']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']['input']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type FinixPaymentInstrumentGraphQlType = {
  __typename?: 'FinixPaymentInstrumentGraphQLType';
  brand?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  expiration_month?: Maybe<Scalars['Int']['output']>;
  expiration_year?: Maybe<Scalars['Int']['output']>;
  last_four?: Maybe<Scalars['String']['output']>;
};

export type FlowCount = {
  __typename?: 'FlowCount';
  count: Scalars['Int']['output'];
  flow: Scalars['String']['output'];
};

export type FsSummaryStats = {
  __typename?: 'FsSummaryStats';
  funded?: Maybe<Scalars['Int']['output']>;
  leads?: Maybe<Scalars['Int']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
};

export type FsSummaryStatsReply = {
  __typename?: 'FsSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean']['output'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: FsSummaryStats;
};

export type FundingRequirement = {
  __typename?: 'FundingRequirement';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['Int']['output'];
  file?: Maybe<DealMedia>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  slug: FundingRequirementSlug;
  source: FundingRequirementSource;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FundingRequirementResolutionStatusChanged = {
  __typename?: 'FundingRequirementResolutionStatusChanged';
  dealId: Scalars['Int']['output'];
  fundingRequirements: Array<FundingRequirement>;
};

export enum FundingRequirementSlug {
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BankInterview = 'bank_interview',
  BankruptcyDischargeRequired = 'bankruptcy_discharge_required',
  BankruptcyLetter = 'bankruptcy_letter',
  BuyersOrderRequired = 'buyers_order_required',
  DownPayment = 'down_payment',
  Emissions = 'emissions',
  EmploymentVerificationRequired = 'employment_verification_required',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  InsuranceRequired = 'insurance_required',
  LicensePlate = 'license_plate',
  NameChangeDoc = 'name_change_doc',
  OdometerPicture = 'odometer_picture',
  PayoffVerification = 'payoff_verification',
  PersonalReferences = 'personal_references',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  PoiRequired = 'poi_required',
  PorRequired = 'por_required',
  ProofOfCurrMortgage = 'proof_of_curr_mortgage',
  ProofOfIncome = 'proof_of_income',
  ProofOfIncomeCobuyer = 'proof_of_income_cobuyer',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  ProofOfSsn = 'proof_of_ssn',
  PropertyTaxReceipt = 'property_tax_receipt',
  PurchaseOrder = 'purchase_order',
  Registration = 'registration',
  ReleaseOfInterest = 'release_of_interest',
  SafetyInspection = 'safety_inspection',
  SmogInspection = 'smog_inspection',
  ValidIdRequired = 'valid_id_required',
  VinInspection = 'vin_inspection',
}

export enum FundingRequirementSource {
  DecisionStipulation = 'decision_stipulation',
  Manual = 'manual',
  RequiredDocument = 'required_document',
}

export type GapLimits = {
  __typename?: 'GAPLimits';
  max_fltv?: Maybe<Scalars['Float']['output']>;
  max_gap_amount?: Maybe<Scalars['Float']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetRelationshipToDealByPhoneNumberResponse = {
  __typename?: 'GetRelationshipToDealByPhoneNumberResponse';
  relationship: Scalars['String']['output'];
};

export type HuntGroup = {
  __typename?: 'HuntGroup';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  default_queue?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  ring_all?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ImportType {
  AcquisitionAutoImport = 'acquisition_auto_import',
  AcquisitionFlowFinished = 'acquisition_flow_finished',
  Affiliate = 'affiliate',
  AffiliateAutomatic = 'affiliate_automatic',
  AffiliateFromThunder = 'affiliate_from_thunder',
  AffiliateInactivityImport = 'affiliate_inactivity_import',
  AutoStructureConditioned = 'auto_structure_conditioned',
  AutoStructureFailure = 'auto_structure_failure',
  AutoStructureSuccessImmediateImport = 'auto_structure_success_immediate_import',
  AutoStructureTimeout = 'auto_structure_timeout',
  AutomaticAssistant = 'automatic_assistant',
  AutomaticEquity = 'automatic_equity',
  AutomaticPayment = 'automatic_payment',
  Canada = 'canada',
  DocumentsPageFinished = 'documents_page_finished',
  FrozenOrLockedCredit = 'frozen_or_locked_credit',
  InactivityImport = 'inactivity_import',
  LienholderNotApproved = 'lienholder_not_approved',
  ManualImportPostHardPull = 'manual_import_post_hard_pull',
  ManualImportPostSoftPull = 'manual_import_post_soft_pull',
  ManualImportPreSoftPull = 'manual_import_pre_soft_pull',
  MarketingNurturePaymentCalculator = 'marketing_nurture_payment_calculator',
  MarketingNurtureVip = 'marketing_nurture_vip',
  NoKbbValuesFailure = 'no_kbb_values_failure',
  OtherLienholder = 'other_lienholder',
  PayoffRequestFailure = 'payoff_request_failure',
  PayoffRequestSuccess = 'payoff_request_success',
  PiUnavailable = 'pi_unavailable',
  PostHardPullAutoImport = 'post_hard_pull_auto_import',
  SoftPullFailure = 'soft_pull_failure',
  SoftPullFailureAutoImport = 'soft_pull_failure_auto_import',
  SoftPullSuccessAutoImport = 'soft_pull_success_auto_import',
}

export enum IncomeIntervalEnum {
  Annually = 'annually',
  Biweekly = 'biweekly',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export type IncrementReferrer = {
  __typename?: 'IncrementReferrer';
  ok: Scalars['Boolean']['output'];
};

export type KbbSelectedOptionsInput = {
  categoryGroup?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lendingOptionPrice?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  retailOptionPrice?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type KbbSelectedOptionsObject = {
  __typename?: 'KbbSelectedOptionsObject';
  carId?: Maybe<Scalars['Int']['output']>;
  selected_options?: Maybe<Array<Maybe<KbbSelectedOptionsType>>>;
};

export type KbbSelectedOptionsObjectInput = {
  selected_options?: InputMaybe<Array<InputMaybe<KbbSelectedOptionsInput>>>;
};

export enum LeExperianErrorCodeEnum {
  Frozen = 'FROZEN',
  Locked = 'LOCKED',
  NoRecordFound = 'NO_RECORD_FOUND',
}

export type LeadMatch = {
  __typename?: 'LeadMatch';
  address?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  line_type?: Maybe<PhoneLineType>;
  match_score: Scalars['Int']['output'];
  middle_name?: Maybe<Scalars['String']['output']>;
  phone_confidence?: Maybe<PhoneConfidence>;
  phone_confidence_score?: Maybe<Scalars['Int']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LeaseBuyoutStats = {
  __typename?: 'LeaseBuyoutStats';
  mileage?: Maybe<Mileage>;
  money?: Maybe<Money>;
  popularity?: Maybe<Popularity>;
  reliability?: Maybe<Reliability>;
  summary?: Maybe<Summary>;
  time?: Maybe<Time>;
};

export type Lender = {
  __typename?: 'Lender';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum LendingNetwork {
  Cudl = 'CUDL',
  R1 = 'R1',
}

export type LienholderContact = {
  __typename?: 'LienholderContact';
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export enum LienholderRequirement {
  AddressLine = 'addressLine',
  City = 'city',
  Dob = 'dob',
  DobYear = 'dobYear',
  FirstName = 'firstName',
  LastFourSsn = 'lastFourSSN',
  LastName = 'lastName',
  LastSixSsn = 'lastSixSSN',
  Make = 'make',
  Mileage = 'mileage',
  Model = 'model',
  PhoneNumber1 = 'phoneNumber1',
  Ssn = 'ssn',
  State = 'state',
  Vin = 'vin',
  Year = 'year',
  Zip = 'zip',
}

export enum LienholderSlugEnum {
  AcuraFinancialServices = 'acura_financial_services',
  Ally = 'ally',
  AudiFinancialServices = 'audi_financial_services',
  BentleyFinancialServices = 'bentley_financial_services',
  BethpageFcu = 'bethpage_fcu',
  BmwFs = 'bmw_fs',
  CalAutomotive = 'cal_automotive',
  CentennialLending = 'centennial_lending',
  ChaseAutoFinance = 'chase_auto_finance',
  ChrystlerCapitalCcap = 'chrystler_capital_ccap',
  DmAutoLeasing = 'dm_auto_leasing',
  FifthThirdBank = 'fifth_third_bank',
  FordMotorCredit = 'ford_motor_credit',
  FusionAutoFinance = 'fusion_auto_finance',
  GenesisFinance = 'genesis_finance',
  GmFinancial = 'gm_financial',
  HondaFinancialServices = 'honda_financial_services',
  HudsonValleyCu = 'hudson_valley_cu',
  HuntingtonNationalBank = 'huntington_national_bank',
  HyundaiMotorFinance = 'hyundai_motor_finance',
  KiaFinance = 'kia_finance',
  LandRoverFg = 'land_rover_fg',
  LexusFinancialServices = 'lexus_financial_services',
  MazdaFinancialServices = 'mazda_financial_services',
  MclarenFinancialServices = 'mclaren_financial_services',
  MercedesBenzFs = 'mercedes_benz_fs',
  MetroCu = 'metro_cu',
  MichiganStateUniversityFcu = 'michigan_state_university_fcu',
  MiniFs = 'mini_fs',
  Nbt = 'nbt',
  NissanFinance = 'nissan_finance',
  Other = 'other',
  PorchePaymentCenter = 'porche_payment_center',
  RocklandFcu = 'rockland_fcu',
  SantanderConsumerUsa = 'santander_consumer_usa',
  SeToyota = 'se_toyota',
  StellantisFinancialServicesInc = 'stellantis_financial_services_inc',
  SubaruMotorFinance = 'subaru_motor_finance',
  TeachersFcu = 'teachers_fcu',
  TeslaFinance = 'tesla_finance',
  Toyota = 'toyota',
  UsBank = 'us_bank',
  VisionsFcu = 'visions_fcu',
  VolkswagenCredit = 'volkswagen_credit',
  VolvoCarFs = 'volvo_car_fs',
  Westlake = 'westlake',
}

export type LienholderTrackRecord = {
  __typename?: 'LienholderTrackRecord';
  allTimeFundedCount?: Maybe<Scalars['Int']['output']>;
  lienholderFundedCount?: Maybe<Scalars['Int']['output']>;
};

export type LikelyAddress = {
  __typename?: 'LikelyAddress';
  address_line: Scalars['String']['output'];
  address_line_2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LoanLimits = {
  __typename?: 'LoanLimits';
  max_finance_amount?: Maybe<Scalars['Float']['output']>;
  max_loan_amount?: Maybe<Scalars['Float']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum LocationType {
  Idaho = 'idaho',
  Utah_1 = 'utah_1',
  Utah_2 = 'utah_2',
}

export type MarkAlertsAsSeenInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MediaSendResult = {
  __typename?: 'MediaSendResult';
  contentType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type MediaV2Response = {
  __typename?: 'MediaV2Response';
  categories: DocumentCategories;
  jurisdictionError?: Maybe<Scalars['String']['output']>;
  latestGenerationBatch?: Maybe<Scalars['DateTime']['output']>;
};

export type MergedDocuments = {
  __typename?: 'MergedDocuments';
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MessageData = {
  __typename?: 'MessageData';
  deals?: Maybe<Array<Maybe<Deal>>>;
  message?: Maybe<Message>;
  messageDetail?: Maybe<MessageDetail>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node: MessageV2;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  body: Scalars['String']['output'];
  category: MessageTemplateCategory;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: MessageTemplateType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  use_count: Scalars['Int']['output'];
};

export enum MessageTemplateCategory {
  Funding = 'funding',
  Payoff = 'payoff',
  Reviews = 'reviews',
  Sales = 'sales',
  Structuring = 'structuring',
  Titling = 'titling',
}

export enum MessageTemplateKey {
  ComAfterHoursHeldWelcome = 'com_after_hours_held_welcome',
  ComOptOut = 'com_opt_out',
  ComReferralFriend = 'com_referral_friend',
  ComReferralOwner = 'com_referral_owner',
  ComSignatureReminder = 'com_signature_reminder',
  ComStructuringWelcome = 'com_structuring_welcome',
  SecureLink = 'secure_link',
  TitlingTemporaryTags = 'titling_temporary_tags',
}

export enum MessageTemplateType {
  Email = 'email',
  Text = 'text',
}

export type MessageV2 = {
  __typename?: 'MessageV2';
  body?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  fromCustomer?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mediaListObj?: Maybe<MediaListObj>;
  sortId?: Maybe<Scalars['Int']['output']>;
  /** The Lease End number on this text: the one it went to, or the one it went out from. */
  textNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type MessagesCursorConnection = {
  __typename?: 'MessagesCursorConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessagesFilter = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealPhoneNumber: Scalars['String']['input'];
};

/** A phone number that has opted out of messaging with the deal’s sending number. Derived from text_messages at read time. Unrelated to the persons’ opt_out_sent_at column, which records that we sent them the opt-out disclosure. */
export type MessagingOptOut = {
  __typename?: 'MessagingOptOut';
  opted_out_at: Scalars['DateTime']['output'];
  phone_number: Scalars['String']['output'];
};

export type MethodFiAccount = {
  __typename?: 'MethodFiAccount';
  created_at?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MethodFiError>;
  holder_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  liability?: Maybe<MethodFiAccountLiability>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restricted_products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  update?: Maybe<Scalars['JSONObject']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MethodFiAccountLiability = {
  __typename?: 'MethodFiAccountLiability';
  fingerprint?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  mch_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MethodFiConnect = {
  __typename?: 'MethodFiConnect';
  accounts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MethodFiError>;
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MethodFiConnectAndRetrieveData = {
  __typename?: 'MethodFiConnectAndRetrieveData';
  accounts?: Maybe<Array<Maybe<MethodFiAccount>>>;
  connectedEntity?: Maybe<MethodFiConnect>;
  entity?: Maybe<MethodFiEntity>;
  vehicles?: Maybe<Array<Maybe<MethodFiVehicle>>>;
};

export type MethodFiEntity = {
  __typename?: 'MethodFiEntity';
  address?: Maybe<MethodFiEntityAddress>;
  available_subscriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MethodFiError>;
  id: Scalars['String']['output'];
  individual?: Maybe<MethodFiEntityIndividual>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restricted_products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  restricted_subscriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  verification?: Maybe<MethodFiEntityVerification>;
};

export type MethodFiEntityAddress = {
  __typename?: 'MethodFiEntityAddress';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type MethodFiEntityIndividual = {
  __typename?: 'MethodFiEntityIndividual';
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  ssn_4?: Maybe<Scalars['String']['output']>;
};

export type MethodFiEntityVerification = {
  __typename?: 'MethodFiEntityVerification';
  identity?: Maybe<MethodFiEntityVerificationIdentity>;
  phone?: Maybe<MethodFiEntityVerificationPhone>;
};

export type MethodFiEntityVerificationIdentity = {
  __typename?: 'MethodFiEntityVerificationIdentity';
  latest_verification_session?: Maybe<Scalars['String']['output']>;
  matched?: Maybe<Scalars['Boolean']['output']>;
  methods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type MethodFiEntityVerificationPhone = {
  __typename?: 'MethodFiEntityVerificationPhone';
  latest_verification_session?: Maybe<Scalars['String']['output']>;
  methods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type MethodFiError = {
  __typename?: 'MethodFiError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sub_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MethodFiIdentity = {
  __typename?: 'MethodFiIdentity';
  address?: Maybe<MethodFiIdentityAddress>;
  dob?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MethodFiIdentityAddress = {
  __typename?: 'MethodFiIdentityAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MethodFiRetrieveIdentitiesData = {
  __typename?: 'MethodFiRetrieveIdentitiesData';
  entity?: Maybe<MethodFiEntity>;
  ssnId?: Maybe<Scalars['String']['output']>;
};

export type MethodFiSessionState = {
  __typename?: 'MethodFiSessionState';
  entity?: Maybe<MethodFiEntity>;
  entityId: Scalars['String']['output'];
  identities?: Maybe<Array<Maybe<MethodFiIdentity>>>;
  tempInfoFormattedData?: Maybe<MethodFiTempInfoFormattedData>;
  vehicles?: Maybe<Array<Maybe<MethodFiVehicle>>>;
};

export type MethodFiTempInfoFormattedData = {
  __typename?: 'MethodFiTempInfoFormattedData';
  address_line?: Maybe<Scalars['String']['output']>;
  address_line_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type MethodFiVehicle = {
  __typename?: 'MethodFiVehicle';
  major_color?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type MethodFiVerificationSession = {
  __typename?: 'MethodFiVerificationSession';
  byo_kyc?: Maybe<Scalars['JSONObject']['output']>;
  byo_sms?: Maybe<Scalars['JSONObject']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  entity_id: Scalars['String']['output'];
  error?: Maybe<MethodFiError>;
  id: Scalars['String']['output'];
  kba?: Maybe<Scalars['JSONObject']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  sms?: Maybe<Scalars['JSONObject']['output']>;
  sna?: Maybe<Scalars['JSONObject']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type Mileage = {
  __typename?: 'Mileage';
  over_perc: Scalars['Int']['output'];
  score: Scalars['Boolean']['output'];
};

export enum MileageUnit {
  Kilometers = 'kilometers',
  Miles = 'miles',
}

export type Money = {
  __typename?: 'Money';
  equity?: Maybe<Scalars['Float']['output']>;
  replacement?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Boolean']['output'];
};

export type MyAppointmentSlotV2 = {
  __typename?: 'MyAppointmentSlotV2';
  dateUtc: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type NpsSurveyResultInput = {
  deal_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['String']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export enum NameSuffix {
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  Jr = 'JR',
  Sr = 'SR',
  V = 'V',
}

export type NavBarTextNotifications = {
  __typename?: 'NavBarTextNotifications';
  booted: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  followUp: Scalars['Boolean']['output'];
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type NoteInputV2 = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  creation_date_tz?: InputMaybe<Scalars['String']['input']>;
  deal_id: Scalars['ID']['input'];
  note_type?: InputMaybe<Scalars['String']['input']>;
  notification_id?: InputMaybe<Scalars['ID']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  recordingid?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type NotesCursorConnection = {
  __typename?: 'NotesCursorConnection';
  edges: Array<NoteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotesFilter = {
  created_at?: InputMaybe<DateFilter>;
  dealIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<DateFilter>;
};

export type NotificationSubscriber = {
  __typename?: 'NotificationSubscriber';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  subscriber_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationSubscriberInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subscriber_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUser = {
  __typename?: 'NotificationUser';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notification_id?: Maybe<Scalars['ID']['output']>;
  seen_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type NotificationUserInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notification_id?: InputMaybe<Scalars['ID']['input']>;
  seen_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum OdometerStatus {
  Changed = 'Changed',
  CustomerProvided = 'CustomerProvided',
  Mismatch = 'Mismatch',
  Verified = 'Verified',
  Warning = 'Warning',
}

export type OriginalLessee = {
  __typename?: 'OriginalLessee';
  address_line?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  ssn_id?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OriginalLesseeInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OriginalLesseeV2 = {
  __typename?: 'OriginalLesseeV2';
  address_line?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  ssn_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OriginalLesseeV2Input = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  ssn_id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Other = {
  __typename?: 'Other';
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OutcomeCount = {
  __typename?: 'OutcomeCount';
  count: Scalars['Int']['output'];
  outcome: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedBootedDeals = {
  __typename?: 'PaginatedBootedDeals';
  results?: Maybe<Array<Maybe<Deal>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedCallHistory = {
  __typename?: 'PaginatedCallHistory';
  calls?: Maybe<Array<Maybe<Call>>>;
  newMissedCallIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedDeals = {
  __typename?: 'PaginatedDeals';
  deals?: Maybe<Array<Maybe<Deal>>>;
  dealsMaxAge?: Maybe<Scalars['DateTime']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  results?: Maybe<Array<Maybe<User>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaperworkType {
  Adobe = 'adobe',
  LeaseEnd = 'lease_end',
  Paper = 'paper',
  RouteOne = 'route_one',
}

export type PatchDealProductPriceItemV2 = {
  cost: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  productCatalogId: Scalars['Int']['input'];
};

export type PatchDealProductPricesInputV2 = {
  dealId: Scalars['Int']['input'];
  products: Array<PatchDealProductPriceItemV2>;
};

export type PaymentLimits = {
  __typename?: 'PaymentLimits';
  max_payment_amount?: Maybe<Scalars['Float']['output']>;
  max_payment_percentage?: Maybe<Scalars['Float']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PaymentOptionsInput = {
  bank?: InputMaybe<Scalars['String']['input']>;
  bankFees?: InputMaybe<Scalars['Float']['input']>;
  banks?: InputMaybe<Array<InputMaybe<BankInput>>>;
  baseTaxAmount?: InputMaybe<Scalars['Float']['input']>;
  buyRate?: InputMaybe<Scalars['Float']['input']>;
  carMileage?: InputMaybe<Scalars['Int']['input']>;
  carYear?: InputMaybe<Scalars['Int']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  closer2Id?: InputMaybe<Scalars['String']['input']>;
  closerId?: InputMaybe<Scalars['String']['input']>;
  customerState?: InputMaybe<Scalars['String']['input']>;
  daysToPayment?: InputMaybe<Scalars['Int']['input']>;
  docFee?: InputMaybe<Scalars['Float']['input']>;
  gapCost?: InputMaybe<Scalars['Float']['input']>;
  gapPrice?: InputMaybe<Scalars['Float']['input']>;
  includeDocFeeInCommission?: InputMaybe<Scalars['Boolean']['input']>;
  lienholder?: InputMaybe<Scalars['String']['input']>;
  moneyDown?: InputMaybe<Scalars['Float']['input']>;
  newRegistrationFee?: InputMaybe<Scalars['Float']['input']>;
  prequalificationCreditScore?: InputMaybe<Scalars['Int']['input']>;
  registrationTransferFee?: InputMaybe<Scalars['Float']['input']>;
  sellRate?: InputMaybe<Scalars['Float']['input']>;
  setterId?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  titleFee?: InputMaybe<Scalars['Float']['input']>;
  titleRegistrationOption?: InputMaybe<TitleRegistrationOption>;
  userEnteredReserve?: InputMaybe<Scalars['Float']['input']>;
  vehiclePayoff?: InputMaybe<Scalars['Float']['input']>;
  vscCost?: InputMaybe<Scalars['Float']['input']>;
  vscPrice?: InputMaybe<Scalars['Float']['input']>;
  warrantyTaxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PaymentOptionsPackageProductV2 = {
  __typename?: 'PaymentOptionsPackageProductV2';
  cost: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  productCatalogId?: Maybe<Scalars['Int']['output']>;
  slug: ProductSlug;
  taxAmount: Scalars['Float']['output'];
};

export type PaymentOptionsPackageV2 = {
  __typename?: 'PaymentOptionsPackageV2';
  amountFinanced: Scalars['Float']['output'];
  buyPayment: Scalars['Float']['output'];
  closerCommission: Scalars['Float']['output'];
  isSelected: Scalars['Boolean']['output'];
  legacyOptionType: Scalars['String']['output'];
  products: Array<PaymentOptionsPackageProductV2>;
  profit: Scalars['Float']['output'];
  reserve: Scalars['Float']['output'];
  selectedProductSlugs: Array<ProductSlug>;
  sellPayment: Scalars['Float']['output'];
  setterCommission: Scalars['Float']['output'];
  slotIndex: Scalars['Int']['output'];
};

export type PaymentOptionsV2Input = {
  dealId: Scalars['Int']['input'];
  overrides?: InputMaybe<PaymentOptionsV2OverridesInput>;
  packageConfigs?: InputMaybe<Array<DealPackageConfigInput>>;
};

export type PaymentOptionsV2OverridesInput = {
  bank?: InputMaybe<Scalars['String']['input']>;
  bankFees?: InputMaybe<Scalars['Float']['input']>;
  baseTaxAmount?: InputMaybe<Scalars['Float']['input']>;
  buyRate?: InputMaybe<Scalars['Float']['input']>;
  carMileage?: InputMaybe<Scalars['Int']['input']>;
  carYear?: InputMaybe<Scalars['Int']['input']>;
  daysToPayment?: InputMaybe<Scalars['Int']['input']>;
  docFee?: InputMaybe<Scalars['Float']['input']>;
  moneyDown?: InputMaybe<Scalars['Float']['input']>;
  newRegistrationFee?: InputMaybe<Scalars['Float']['input']>;
  prequalificationCreditScore?: InputMaybe<Scalars['Int']['input']>;
  productOverrides?: InputMaybe<Array<PaymentOptionsV2ProductOverrideInput>>;
  registrationTransferFee?: InputMaybe<Scalars['Float']['input']>;
  sellRate?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  titleFee?: InputMaybe<Scalars['Float']['input']>;
  titleRegistrationOption?: InputMaybe<TitleRegistrationOption>;
  userEnteredReserve?: InputMaybe<Scalars['Float']['input']>;
  vehiclePayoff?: InputMaybe<Scalars['Float']['input']>;
  warrantyTaxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PaymentOptionsV2ProductOverrideInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productCatalogId?: InputMaybe<Scalars['Int']['input']>;
  productSlug?: InputMaybe<ProductSlug>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PayoffChange = {
  __typename?: 'PayoffChange';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  double_tax_applied?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  payoff_id?: Maybe<Scalars['Int']['output']>;
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']['output']>;
  sales_tax_from_payoff?: Maybe<Scalars['Float']['output']>;
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
};

export type PayoffChangeInput = {
  double_tax_applied?: InputMaybe<Scalars['Boolean']['input']>;
  payoff_id?: InputMaybe<Scalars['Int']['input']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']['input']>;
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
};

export type PayoffQueue = {
  __typename?: 'PayoffQueue';
  items: Array<PayoffQueueItem>;
  pagination: Pagination;
  total: Scalars['Int']['output'];
};

/** Minimal payoff request tile, backed by either a deal or temporary info. */
export type PayoffQueueItem = {
  __typename?: 'PayoffQueueItem';
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lienholderName: Scalars['String']['output'];
  needsPayoffDocuments?: Maybe<Scalars['Boolean']['output']>;
  payoffClerkId?: Maybe<Scalars['String']['output']>;
  payoffDocumentsUploaded?: Maybe<Scalars['Boolean']['output']>;
  status: PayoffRequestStatus;
  temporaryInfoId?: Maybe<Scalars['ID']['output']>;
  vehicleDescription: Scalars['String']['output'];
};

export type PayoffQueueUpdate = {
  __typename?: 'PayoffQueueUpdate';
  id: Scalars['ID']['output'];
};

export type PayoffRequestStatusUpdateV2 = {
  __typename?: 'PayoffRequestStatusUpdateV2';
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<PayoffRequestStatus>;
};

export type PayoffRequestStatusUpdateV2WithMessage = {
  __typename?: 'PayoffRequestStatusUpdateV2WithMessage';
  message?: Maybe<Scalars['String']['output']>;
  payoffRequest: PayoffRequestStatusUpdateV2;
};

export type PayoffUpdateV2Result = {
  __typename?: 'PayoffUpdateV2Result';
  paymentOptions: PaymentOptionsV2;
  payoff: Payoff;
};

export type PersonalInfoInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['Int']['input'];
  personalInfo?: InputMaybe<DobSsnInput>;
};

export enum PhoneConfidence {
  High = 'high',
  Highest = 'highest',
  Low = 'low',
  Lowest = 'lowest',
  Medium = 'medium',
}

export enum PhoneLineType {
  FixedVoip = 'fixedVoip',
  Landline = 'landline',
  Mobile = 'mobile',
  Other = 'other',
  Voip = 'voip',
}

export type PhotoToken = {
  __typename?: 'PhotoToken';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['ID']['output'];
  expires_at: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  token: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PhotoTokenValidationResult = {
  __typename?: 'PhotoTokenValidationResult';
  authToken: Scalars['String']['output'];
  dealId: Scalars['ID']['output'];
};

export type PodSummaryStats = {
  __typename?: 'PodSummaryStats';
  arpa?: Maybe<Scalars['Float']['output']>;
  assigned?: Maybe<Scalars['Int']['output']>;
  closePercentage?: Maybe<Scalars['Float']['output']>;
  funded?: Maybe<Scalars['Int']['output']>;
  gapPercentage?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  rpt?: Maybe<Scalars['Float']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  vscPercentage?: Maybe<Scalars['Float']['output']>;
};

export type PodSummaryStatsReply = {
  __typename?: 'PodSummaryStatsReply';
  /** Whether the user is in a pod of this bar's kind, so "My pod" is offered. */
  canPickMyPod: Scalars['Boolean']['output'];
  /** The pool these stats were counted for. */
  pool: StatsPool;
  stats: PodSummaryStats;
};

export type Popularity = {
  __typename?: 'Popularity';
  make?: Maybe<Scalars['Float']['output']>;
  make_perc?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['Float']['output']>;
  model_perc?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Boolean']['output'];
};

export type PrequalificationCheck = {
  __typename?: 'PrequalificationCheck';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type PrequalificationCreditReport = {
  __typename?: 'PrequalificationCreditReport';
  addresses?: Maybe<Array<PrequalificationCreditReportAddress>>;
  employments?: Maybe<Array<PrequalificationCreditReportEmployment>>;
  informationalMessages?: Maybe<Array<Scalars['String']['output']>>;
  names?: Maybe<PrequalificationCreditReportNames>;
  scoreFactors?: Maybe<Array<PrequalificationCreditScoreScoreFactor>>;
  tradelines?: Maybe<PrequalificationCreditReportTradelines>;
};

export type PrequalificationCreditReportAddress = {
  __typename?: 'PrequalificationCreditReportAddress';
  city?: Maybe<Scalars['String']['output']>;
  firstReportedDate?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetPrefix?: Maybe<Scalars['String']['output']>;
  streetSuffix?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationCreditReportEmployment = {
  __typename?: 'PrequalificationCreditReportEmployment';
  addressExtraLine?: Maybe<Scalars['String']['output']>;
  addressFirstLine?: Maybe<Scalars['String']['output']>;
  addressSecondLine?: Maybe<Scalars['String']['output']>;
  firstReportedDate?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationCreditReportName = {
  __typename?: 'PrequalificationCreditReportName';
  firstName: Scalars['String']['output'];
  generationCode?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  secondSurname?: Maybe<Scalars['String']['output']>;
  surname: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationCreditReportNames = {
  __typename?: 'PrequalificationCreditReportNames';
  aliases: Array<Maybe<PrequalificationCreditReportName>>;
  customerName?: Maybe<PrequalificationCreditReportName>;
};

export type PrequalificationCreditReportTradeline = {
  __typename?: 'PrequalificationCreditReportTradeline';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  amount1?: Maybe<Scalars['String']['output']>;
  amount1Qualifier?: Maybe<Scalars['String']['output']>;
  amount2?: Maybe<Scalars['String']['output']>;
  amount2Qualifier?: Maybe<Scalars['String']['output']>;
  amountPastDue?: Maybe<Scalars['String']['output']>;
  balanceAmount?: Maybe<Scalars['String']['output']>;
  balanceDate?: Maybe<Scalars['String']['output']>;
  delinquency30Days?: Maybe<Scalars['String']['output']>;
  delinquency60Days?: Maybe<Scalars['String']['output']>;
  delinquency90to180Days?: Maybe<Scalars['String']['output']>;
  ecoa?: Maybe<Scalars['String']['output']>;
  kob?: Maybe<Scalars['String']['output']>;
  monthlyPaymentAmount?: Maybe<Scalars['String']['output']>;
  monthsHistory?: Maybe<Scalars['String']['output']>;
  openDate?: Maybe<Scalars['String']['output']>;
  openOrClosed?: Maybe<Scalars['String']['output']>;
  paymentHistory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriberName?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationCreditReportTradelines = {
  __typename?: 'PrequalificationCreditReportTradelines';
  installment: Array<PrequalificationCreditReportTradeline>;
  revolving: Array<PrequalificationCreditReportTradeline>;
  unknown: Array<PrequalificationCreditReportTradeline>;
};

export type PrequalificationCreditReports = {
  __typename?: 'PrequalificationCreditReports';
  cobuyer?: Maybe<PrequalificationCreditReport>;
  customer: PrequalificationCreditReport;
};

export type PrequalificationCreditScoreScoreFactor = {
  __typename?: 'PrequalificationCreditScoreScoreFactor';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationRequest = {
  __typename?: 'PrequalificationRequest';
  first_name?: Maybe<Scalars['String']['output']>;
  gross_income?: Maybe<Scalars['Float']['output']>;
  income_sources?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lending_book_value?: Maybe<Scalars['Float']['output']>;
  money_down?: Maybe<Scalars['Float']['output']>;
  pay_frequency?: Maybe<Scalars['String']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PrequalificationStatus = {
  __typename?: 'PrequalificationStatus';
  can_run: Scalars['Boolean']['output'];
  checks: Array<PrequalificationCheck>;
  retry_notice?: Maybe<Scalars['String']['output']>;
  validation_errors: Array<Scalars['String']['output']>;
};

export type PriorCobuyer = {
  __typename?: 'PriorCobuyer';
  cobuyer: CreditApplicationBuyer;
  creditApplicationId: Scalars['ID']['output'];
  provider: LendingNetwork;
  relationshipToBuyer?: Maybe<RelationToBuyerEnum>;
  submittedAt: Scalars['DateTime']['output'];
};

export type PriorityQueueUpdate = {
  __typename?: 'PriorityQueueUpdate';
  dealId: Scalars['Int']['output'];
  followUpStatus?: Maybe<FollowUpStatusEnum>;
  previousFollowUpStatus?: Maybe<FollowUpStatusEnum>;
  previousState?: Maybe<DealStateEnum>;
  reason: Scalars['String']['output'];
  state: DealStateEnum;
};

export enum Processor {
  Atc = 'Atc',
  DlrDmv = 'DlrDmv',
  TaterTitle = 'TaterTitle',
  Vitu = 'Vitu',
}

export type ProductCatalogV2 = {
  __typename?: 'ProductCatalogV2';
  base_cost: Scalars['Float']['output'];
  base_price: Scalars['Float']['output'];
  bonus_amount: Scalars['Float']['output'];
  display_order: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  is_user_selectable: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  slug: ProductSlug;
};

export enum ProductSlug {
  AllyLimitedWarranty = 'ally_limited_warranty',
  Gap = 'gap',
  KeyReplacement = 'key_replacement',
  Maintenance = 'maintenance',
  TireWheel = 'tire_wheel',
  Vsc = 'vsc',
}

export type ProviderDecisionData = CudlVehicleLoanApplication | R1CreditDecisionData;

export type Query = {
  __typename?: 'Query';
  acquisitionOffer?: Maybe<AcquisitionOffer>;
  addressDetail?: Maybe<AddressDetail>;
  /** Returns the advisor bar's stats for the chosen pool and time frame. */
  advisorSummaryStatsV2: AdvisorSummaryStatsReply;
  affiliateByPhoneNumber?: Maybe<Affiliate>;
  affiliateDetails?: Maybe<Affiliate>;
  affiliateProviders?: Maybe<Array<Maybe<AffiliateProviderRead>>>;
  aiCallPayload?: Maybe<AiCallPayload>;
  alerts: AlertsConnection;
  articleImageUploadUrl?: Maybe<ArticleImageUploadUrl>;
  articles?: Maybe<Array<Maybe<Article>>>;
  auctionAverageTransportCost?: Maybe<Scalars['Int']['output']>;
  auctionDistances?: Maybe<AuctionDistances>;
  auctions?: Maybe<Array<Maybe<Auction>>>;
  bankInfo?: Maybe<Bank>;
  bankLogo?: Maybe<Scalars['String']['output']>;
  banks?: Maybe<Array<Maybe<Bank>>>;
  bookmarkedDeals: Array<Deal>;
  calculateOptions?: Maybe<Array<Maybe<KbbOption>>>;
  call?: Maybe<Call>;
  callInProgress?: Maybe<Conference>;
  carDetailLicensePlate?: Maybe<Car>;
  carDetailVin?: Maybe<Car>;
  carDistinctMake?: Maybe<Array<Maybe<CarDistinctMake>>>;
  carDistinctModel?: Maybe<Array<Maybe<CarDistinctModel>>>;
  checkAffiliateDealExists?: Maybe<Scalars['Boolean']['output']>;
  checkExistingAccountByEmail?: Maybe<Scalars['Boolean']['output']>;
  checkExistingAccountHasPassword?: Maybe<Scalars['Boolean']['output']>;
  checkFlowStatus?: Maybe<FlowStatus>;
  checkPayoffRequestRequirements: CheckPayoffRequestRequirementsResponse;
  checkSupportedLienholder: SupportedLienholderResponse;
  communicationHistoryV2: CommunicationHistoryConnection;
  comparePrequalSocials?: Maybe<ComparePrequalSocials>;
  completedDeals?: Maybe<PaginatedDeals>;
  consentOptOutLookup: Array<ConsentBasis>;
  conversationInboxThread: ConversationSummary;
  conversationsInbox: ConversationsInboxConnection;
  createFetchUrlsFromCom: Array<Scalars['String']['output']>;
  createReferral?: Maybe<CreateReferralPayload>;
  createReferrer?: Maybe<CreateReferrerGraphQlType>;
  creditApplicationSubmissions: Array<Maybe<CreditApplicationSubmission>>;
  creditApplicationV2?: Maybe<CreditApplication>;
  creditDecisionV2?: Maybe<CreditDecision>;
  currentConsentAgreementText?: Maybe<ConsentAgreement>;
  customer?: Maybe<Customer>;
  customerNotifications?: Maybe<Array<Maybe<CustomerNotification>>>;
  dashboardDeals?: Maybe<DashboardDealsWithCounts>;
  deal?: Maybe<Deal>;
  dealAdvisors?: Maybe<Deal>;
  dealContractDistribution?: Maybe<ContractDistribution>;
  dealIssues: Array<DealIssue>;
  dealPackageConfigs: Array<DealPackageConfig>;
  dealProductsV2: Array<DealProduct>;
  dealSetter?: Maybe<DealSetter>;
  dealStates?: Maybe<Array<Maybe<DealState>>>;
  dealStats?: Maybe<DealStats>;
  dealStatsByManufacturer?: Maybe<DealStatsByManufacturer>;
  dealStatsByState?: Maybe<DealStatsByState>;
  dealTieDowns: DealTieDown;
  dealUnreadMessageCount: DealUnreadMessageCount;
  dealV2?: Maybe<Deal>;
  dealVscRates: Array<VscRateOption>;
  dealerProducts?: Maybe<Array<Maybe<Product>>>;
  dealers: Array<Dealer>;
  dealsV2: DealsConnection;
  decodeAffiliateCarDetails?: Maybe<TemporaryData>;
  decryptTempInfoSSN?: Maybe<Scalars['String']['output']>;
  determineApprovalQuery?: Maybe<DetermineApproval>;
  duplicateDeals?: Maybe<Array<Maybe<Deal>>>;
  experianCreditReport?: Maybe<PrequalificationCreditReports>;
  externalUserPayoffRequest?: Maybe<PayoffRequest>;
  financialInfoPaymentEstimate?: Maybe<Array<Maybe<FinancialInfoPaymentEstimate>>>;
  financialInfoPaymentEstimateAffiliate?: Maybe<Array<Maybe<FinancialInfoPaymentEstimate>>>;
  financialInfoV2: FinancialInfo;
  followUp?: Maybe<FollowUp>;
  /** Returns the FS bar's stats for the chosen pool and time frame. */
  fsSummaryStatsV2: FsSummaryStatsReply;
  fundingRequirements: Array<FundingRequirement>;
  gapRates?: Maybe<Array<Maybe<Rate>>>;
  generateContracts?: Maybe<Contracts>;
  generateDocuments?: Maybe<Documents>;
  generatePurchaseOrder?: Maybe<PurchaseOrder>;
  generateR1EContract: Scalars['Boolean']['output'];
  generateROIDocuments?: Maybe<Documents>;
  generateTestDocuments?: Maybe<Scalars['Boolean']['output']>;
  getAffiliateApiKeys?: Maybe<Array<Maybe<AffiliateApiKey>>>;
  getAllHuntGroups?: Maybe<Array<Maybe<HuntGroup>>>;
  getAuth0Roles?: Maybe<Array<Auth0Role>>;
  getAvailableUsers?: Maybe<Array<Maybe<GetAvailableUsers>>>;
  getBase64StringFromS3Object?: Maybe<Scalars['String']['output']>;
  getBootedDeals?: Maybe<PaginatedBootedDeals>;
  getByAuth0Id?: Maybe<Customer>;
  getCallHistory: CallHistoryResult;
  getCallHistoryStats: CallHistoryStats;
  getCallLifecycle?: Maybe<CallLifecycle>;
  getCreditDecisionByProviderLender?: Maybe<CreditDecision>;
  getDDSoftPull: DdSoftPull;
  getDownPaymentAmountByMethod?: Maybe<Scalars['Float']['output']>;
  getEntity?: Maybe<MethodFiEntity>;
  getExternalAutoStructureBankLogos?: Maybe<Array<Maybe<AutoStructureBankLogo>>>;
  getFees?: Maybe<FeeGql>;
  getFinixPaymentInstrument?: Maybe<FinixPaymentInstrumentGraphQlType>;
  getFollowUpDealsPaginated?: Maybe<PaginatedDeals>;
  getInProgressCalls: Array<Maybe<Conference>>;
  getMethodFiSessionState?: Maybe<MethodFiSessionState>;
  getOperatingHoursAndTimeSlots?: Maybe<OperatingHoursTimeSlots>;
  getOwedAsReferee?: Maybe<Scalars['Int']['output']>;
  getR1CustomerCopy?: Maybe<Array<Maybe<DealDocument>>>;
  getR1DealDocument?: Maybe<DealDocument>;
  getRandomVin?: Maybe<Scalars['String']['output']>;
  getReferrerAggregate?: Maybe<ReferrerAggregateGraphQlType>;
  getReferrerByCustomerId?: Maybe<ReferrerGraphQlType>;
  getReferrerById?: Maybe<ReferrerGraphQlType>;
  getRelationshipToDealByPhoneNumber?: Maybe<GetRelationshipToDealByPhoneNumberResponse>;
  getSignaturePacketStatus?: Maybe<SignaturePacketStatus>;
  getThunderConversationHistoryByPhoneNumber?: Maybe<ThunderConversationHistory>;
  getTwilioNumbers?: Maybe<Array<Maybe<TwilioNumber>>>;
  getUploadUrl?: Maybe<MediaUploadUrl>;
  getUserCallHistory?: Maybe<PaginatedCallHistory>;
  getUserCreationData?: Maybe<UserCreationData>;
  getUserTwilioNumber?: Maybe<Scalars['String']['output']>;
  getUsers?: Maybe<PaginatedUser>;
  getWaitingCalls?: Maybe<GetWaitingCalls>;
  getWarrantyInfo?: Maybe<CarWarranty>;
  hasAnyDeal?: Maybe<Scalars['Boolean']['output']>;
  hasNpsSurveyResult?: Maybe<Scalars['Boolean']['output']>;
  inbox?: Maybe<InboxMessagesType>;
  incrementFlowStarts?: Maybe<IncrementReferrer>;
  incrementImpressions?: Maybe<IncrementReferrer>;
  inquiryPartner?: Maybe<Scalars['Void']['output']>;
  jdpValues?: Maybe<Car>;
  jurisdiction?: Maybe<TtJurisdiction>;
  kbbValues?: Maybe<KbbValuesResult>;
  kbbVin?: Maybe<KbbVinObjectResult>;
  kbbVinAffiliate?: Maybe<KbbVinObjectResult>;
  keyMetrics?: Maybe<Array<Maybe<KeyMetric>>>;
  keyReplacementRates?: Maybe<Array<Maybe<Rate>>>;
  laneKeyMetrics?: Maybe<Array<Maybe<LaneKeyMetric>>>;
  laneKeyMetricsReader?: Maybe<Array<Maybe<LaneKeyMetric>>>;
  latestThirdPartyPayoffSend?: Maybe<ThirdPartyPayoffSend>;
  leadMatches?: Maybe<Array<Maybe<LeadMatch>>>;
  leaderboardSetter: Array<LeaderboardSetterStats>;
  leaseBuyoutFromVehicleInfo?: Maybe<LeaseBuyoutStats>;
  lenders?: Maybe<Array<Maybe<Lender>>>;
  lienholderContact?: Maybe<LienholderContact>;
  lienholderTrackRecord?: Maybe<LienholderTrackRecord>;
  lienholderUtility?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  likelyAddress?: Maybe<LikelyAddress>;
  loggedUser?: Maybe<User>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  mediaFromCom?: Maybe<Array<DealMedia>>;
  mediaV2?: Maybe<MediaV2Response>;
  messageTemplateByKey?: Maybe<MessageTemplate>;
  messageTemplatesByType?: Maybe<Array<Maybe<MessageTemplate>>>;
  messages?: Maybe<MessagesWithErrors>;
  messagesDbCursorV2: MessagesCursorConnection;
  messagesDbPaginated?: Maybe<MessagesDbPaginated>;
  metricsPages?: Maybe<Array<Maybe<MetricsPages>>>;
  mmr?: Maybe<MmrResult>;
  myAppointmentSlotsV2: Array<MyAppointmentSlotV2>;
  myUnfinishedThunderClaims: Array<Maybe<ThunderCallNotification>>;
  navBarTextNotifications?: Maybe<NavBarTextNotifications>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notesV2Cursor: NotesCursorConnection;
  paymentEstimate?: Maybe<PaymentEstimate>;
  paymentEstimateAffiliate?: Maybe<PaymentEstimate>;
  paymentOptions?: Maybe<PaymentOptions>;
  paymentOptionsV2: PaymentOptionsV2;
  payoffCountMake?: Maybe<Array<Maybe<PayoffCountMake>>>;
  payoffCountModel?: Maybe<Array<Maybe<PayoffCountModel>>>;
  payoffDashboardDeals?: Maybe<PayoffDashboard>;
  payoffQueueRequests: PayoffQueue;
  payoffRequest?: Maybe<PayoffRequest>;
  payoffStatsMakeModelYear?: Maybe<Array<Maybe<PayoffStatsMakeModel>>>;
  payoffStatsMakeModelYearAffiliate?: Maybe<Array<Maybe<PayoffStatsMakeModel>>>;
  pendingTieDownsForReview: Array<TieDown>;
  pod?: Maybe<Pod>;
  podHours?: Maybe<Array<Maybe<PodHours>>>;
  /** Returns the pod bar's stats for the chosen pool and time frame. */
  podSummaryStatsV2: PodSummaryStatsReply;
  pods?: Maybe<Array<Maybe<Pod>>>;
  podsAll?: Maybe<Array<Maybe<Pod>>>;
  priorCobuyersForDeal: Array<PriorCobuyer>;
  products?: Maybe<Array<Maybe<Product>>>;
  productsCatalogV2: Array<ProductCatalogV2>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  recommendedLienholderSlugs: Array<Scalars['String']['output']>;
  retrieveDealDocsUploadedToR1?: Maybe<Array<Maybe<DealDocument>>>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  searchDeals: Array<Deal>;
  searchWebLeads?: Maybe<Array<Maybe<TemporaryInfo>>>;
  sendOwnerReferralLinkEmail?: Maybe<SendReferralLinkPayload>;
  sendOwnerReferralLinkSms?: Maybe<SendReferralLinkPayload>;
  sendReferralLinkEmail?: Maybe<SendReferralLinkPayload>;
  sendReferralLinkSms?: Maybe<SendReferralLinkPayload>;
  sidebarAppointmentsV2: Array<SidebarAppointmentV2>;
  smartPayoff?: Maybe<SmartPayoff>;
  smartPayoffAffiliate?: Maybe<SmartPayoffAffiliate>;
  socialProofStats?: Maybe<SocialProofStats>;
  startR1DocumentsFlow?: Maybe<Scalars['Boolean']['output']>;
  structuringFollowUp?: Maybe<StructuringFollowUp>;
  structuringFollowUpDeals?: Maybe<PaginatedDeals>;
  suggestedMessage?: Maybe<Scalars['String']['output']>;
  surcharges?: Maybe<Array<Maybe<Surcharge>>>;
  tags: Array<Tag>;
  taughtCallUrl?: Maybe<Scalars['String']['output']>;
  temporaryInfo?: Maybe<TemporaryInfo>;
  temporaryInfoAuthenticated?: Maybe<TemporaryInfo>;
  temporaryRegistrationTagsDeals?: Maybe<PaginatedDeals>;
  tieDown?: Maybe<TieDown>;
  tireWheelRates?: Maybe<Array<Maybe<Rate>>>;
  titlingDashboardDeals?: Maybe<PaginatedDeals>;
  titlingPodsAll?: Maybe<Array<Maybe<Pod>>>;
  titlingUsers?: Maybe<Array<Maybe<PodUser>>>;
  totalCompletedDeals?: Maybe<Scalars['Int']['output']>;
  userDeal?: Maybe<ExternalDeal>;
  userDeals?: Maybe<Array<Maybe<Deals>>>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userPreferences: UserPreferences;
  userTitlingPods?: Maybe<Array<Maybe<Pod>>>;
  validZip?: Maybe<Scalars['Boolean']['output']>;
  validateBankContract?: Maybe<Scalars['Boolean']['output']>;
  validateCreditApplicationV2?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  validateDealBeforeAction?: Maybe<DealActionValidation>;
  validatePhotoToken?: Maybe<PhotoTokenValidationResult>;
  validateReferrer?: Maybe<ValidateReferrer>;
  validateSecureLink?: Maybe<Scalars['Boolean']['output']>;
  vehicleMileage?: Maybe<VehicleMileageGql>;
  visibleArticles?: Maybe<VisibleArticles>;
  visibleReviews?: Maybe<Array<Maybe<Review>>>;
  vscRates?: Maybe<Array<Maybe<Rate>>>;
};

export type QueryAcquisitionOfferArgs = {
  accidents: AccidentsEnumType;
  book_value?: InputMaybe<Scalars['Int']['input']>;
  lienholder?: InputMaybe<Scalars['String']['input']>;
  lienholder_slug?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  mmr_value?: InputMaybe<Scalars['Float']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAddressDetailArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdvisorSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};

export type QueryAffiliateByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type QueryAffiliateDetailsArgs = {
  affiliateExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiCallPayloadArgs = {
  dealId: Scalars['String']['input'];
};

export type QueryAlertsArgs = {
  filter?: InputMaybe<AlertsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<AlertSortingType>;
};

export type QueryArticleImageUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};

export type QueryAuctionAverageTransportCostArgs = {
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAuctionDistancesArgs = {
  data?: InputMaybe<AuctionDistancesInput>;
};

export type QueryBankInfoArgs = {
  deal_id: Scalars['ID']['input'];
};

export type QueryBankLogoArgs = {
  bank_name: Scalars['String']['input'];
};

export type QueryBanksArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
  selectedBank?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCalculateOptionsArgs = {
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  configToModify?: InputMaybe<Array<InputMaybe<KbbConfigType>>>;
  startingVehicleOptions?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vin: Scalars['String']['input'];
};

export type QueryCallArgs = {
  call_id?: InputMaybe<Scalars['String']['input']>;
  conference_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCarDetailLicensePlateArgs = {
  license_plate_number: Scalars['String']['input'];
  license_plate_state: Scalars['String']['input'];
};

export type QueryCarDetailVinArgs = {
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCarDistinctModelArgs = {
  make: Scalars['String']['input'];
};

export type QueryCheckAffiliateDealExistsArgs = {
  affiliateExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckExistingAccountByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckFlowStatusArgs = {
  guid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckPayoffRequestRequirementsArgs = {
  dealId: Scalars['Int']['input'];
  lienholderSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckSupportedLienholderArgs = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  lienholderSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCommunicationHistoryV2Args = {
  filter: CommunicationHistoryFilter;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type QueryComparePrequalSocialsArgs = {
  cobuyerId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCompletedDealsArgs = {
  addressState?: InputMaybe<Scalars['String']['input']>;
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  dealState?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  types: Array<InputMaybe<DealType>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConsentOptOutLookupArgs = {
  identifiers: Array<ConsentIdentifierInput>;
};

export type QueryConversationInboxThreadArgs = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryConversationsInboxArgs = {
  filter?: InputMaybe<ConversationsInboxFilter>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type QueryCreateFetchUrlsFromComArgs = {
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryCreateReferralArgs = {
  deal_id?: InputMaybe<Scalars['Int']['input']>;
  referrer_id: Scalars['Int']['input'];
  temporary_info_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCreateReferrerArgs = {
  customer_id: Scalars['Int']['input'];
};

export type QueryCreditApplicationSubmissionsArgs = {
  filter?: InputMaybe<CreditApplicationSubmissionFilter>;
};

export type QueryCreditApplicationV2Args = {
  id: Scalars['ID']['input'];
};

export type QueryCreditDecisionV2Args = {
  id: Scalars['Int']['input'];
};

export type QueryCurrentConsentAgreementTextArgs = {
  agreementType?: InputMaybe<ConsentAgreementTypeEnum>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCustomerNotificationsArgs = {
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
};

export type QueryDashboardDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  closerLocation?: InputMaybe<LocationType>;
  fsPodIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  loadAll?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types: Array<InputMaybe<DealType>>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDealArgs = {
  id: Scalars['ID']['input'];
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  types: Array<InputMaybe<DealType>>;
};

export type QueryDealAdvisorsArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDealContractDistributionArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryDealIssuesArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryDealPackageConfigsArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryDealProductsV2Args = {
  dealId: Scalars['Int']['input'];
};

export type QueryDealSetterArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDealStatesArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDealStatsArgs = {
  manufacturer: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type QueryDealStatsByManufacturerArgs = {
  manufacturer: Scalars['String']['input'];
};

export type QueryDealStatsByStateArgs = {
  state: Scalars['String']['input'];
};

export type QueryDealTieDownsArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryDealUnreadMessageCountArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryDealV2Args = {
  id?: InputMaybe<Scalars['Int']['input']>;
  leaseId?: InputMaybe<Scalars['GUID']['input']>;
};

export type QueryDealVscRatesArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryDealerProductsArgs = {
  dealer_id: Scalars['ID']['input'];
};

export type QueryDealsV2Args = {
  filter?: InputMaybe<DealsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<SortingTypeV2>;
};

export type QueryDecodeAffiliateCarDetailsArgs = {
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  temp_info_id?: InputMaybe<Scalars['ID']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDecryptTempInfoSsnArgs = {
  tempInfoId: Scalars['ID']['input'];
};

export type QueryDetermineApprovalQueryArgs = {
  data?: InputMaybe<DetermineApprovalQueryInput>;
};

export type QueryDuplicateDealsArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  matchBootedDeals: Scalars['Boolean']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExperianCreditReportArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryExternalUserPayoffRequestArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFinancialInfoPaymentEstimateArgs = {
  endDate: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFinancialInfoPaymentEstimateAffiliateArgs = {
  endDate: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFinancialInfoV2Args = {
  filter?: InputMaybe<FinancialInfoFilter>;
};

export type QueryFollowUpArgs = {
  deal_id: Scalars['ID']['input'];
};

export type QueryFsSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};

export type QueryFundingRequirementsArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryGapRatesArgs = {
  bank?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID']['input'];
};

export type QueryGenerateContractsArgs = {
  data?: InputMaybe<ContractsInput>;
};

export type QueryGenerateDocumentsArgs = {
  data?: InputMaybe<DocumentsInput>;
};

export type QueryGeneratePurchaseOrderArgs = {
  deal_id: Scalars['ID']['input'];
};

export type QueryGenerateR1EContractArgs = {
  dealJacketId: Scalars['String']['input'];
};

export type QueryGenerateRoiDocumentsArgs = {
  data?: InputMaybe<DocumentsInput>;
};

export type QueryGenerateTestDocumentsArgs = {
  update_deal_id: Scalars['ID']['input'];
};

export type QueryGetAllHuntGroupsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetBase64StringFromS3ObjectArgs = {
  key: Scalars['String']['input'];
};

export type QueryGetBootedDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['DateTime']['input'];
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  types: Array<InputMaybe<DealType>>;
  unreadMessagesFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetCallHistoryArgs = {
  agentUserId?: InputMaybe<Scalars['String']['input']>;
  callSid?: InputMaybe<Scalars['String']['input']>;
  conferenceId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  hasEventType?: InputMaybe<Scalars['String']['input']>;
  huntGroupSlug?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCallHistoryStatsArgs = {
  agentUserId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  flowType?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCallLifecycleArgs = {
  callId?: InputMaybe<Scalars['String']['input']>;
  conferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCreditDecisionByProviderLenderArgs = {
  deal_id: Scalars['ID']['input'];
  provider_lender_id: Scalars['String']['input'];
};

export type QueryGetDdSoftPullArgs = {
  dealId: Scalars['ID']['input'];
  paymentEstimateInput: PaymentEstimateInput;
  shouldForceRetry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetDownPaymentAmountByMethodArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  paymentType?: InputMaybe<PaymentInstrumentType>;
};

export type QueryGetEntityArgs = {
  entityId: Scalars['String']['input'];
};

export type QueryGetFeesArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  bookValue?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cobuyerAddress?: InputMaybe<Scalars['String']['input']>;
  cobuyerCity?: InputMaybe<Scalars['String']['input']>;
  cobuyerCounty?: InputMaybe<Scalars['String']['input']>;
  cobuyerDob?: InputMaybe<Scalars['String']['input']>;
  cobuyerEmail?: InputMaybe<Scalars['String']['input']>;
  cobuyerFirstName?: InputMaybe<Scalars['String']['input']>;
  cobuyerLastName?: InputMaybe<Scalars['String']['input']>;
  cobuyerMiddleName?: InputMaybe<Scalars['String']['input']>;
  cobuyerPhone?: InputMaybe<Scalars['String']['input']>;
  cobuyerState?: InputMaybe<StateAbbreviation>;
  cobuyerSuffix?: InputMaybe<Scalars['String']['input']>;
  cobuyerZip?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  docFee?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedPayoff?: InputMaybe<Scalars['Float']['input']>;
  financialInfoId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<TtFuelType>;
  insuranceCompanyName?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyExpirationDate?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  mailingCity?: InputMaybe<Scalars['String']['input']>;
  mailingCounty?: InputMaybe<Scalars['String']['input']>;
  mailingState?: InputMaybe<StateAbbreviation>;
  mailingZipCode?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  newBank?: InputMaybe<Scalars['String']['input']>;
  newBankAddress?: InputMaybe<Scalars['String']['input']>;
  newBankAddress2?: InputMaybe<Scalars['String']['input']>;
  newBankCity?: InputMaybe<Scalars['String']['input']>;
  newBankEltCode?: InputMaybe<Scalars['String']['input']>;
  newBankState?: InputMaybe<StateAbbreviation>;
  newBankZip?: InputMaybe<Scalars['String']['input']>;
  newBankZipPlus4?: InputMaybe<Scalars['String']['input']>;
  odometerReading?: InputMaybe<Scalars['Int']['input']>;
  payoff?: InputMaybe<Scalars['Float']['input']>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  payoffWithoutSalesTax?: InputMaybe<Scalars['Float']['input']>;
  previouslyTitledState?: InputMaybe<StateAbbreviation>;
  retailBookValue?: InputMaybe<Scalars['Float']['input']>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  signedDate?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StateAbbreviation>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  titleRegistrationOption?: InputMaybe<Scalars['String']['input']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<TtVehicleType>;
  vin?: InputMaybe<Scalars['String']['input']>;
  warranty?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFinixPaymentInstrumentArgs = {
  paymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFollowUpDealsPaginatedArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  bootRequested?: InputMaybe<Scalars['Boolean']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  showMatureFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  sortColumn: Scalars['String']['input'];
  sortDirection: Scalars['String']['input'];
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  types: Array<InputMaybe<DealType>>;
};

export type QueryGetOwedAsRefereeArgs = {
  customer_id: Scalars['Int']['input'];
};

export type QueryGetR1CustomerCopyArgs = {
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  includeExtraPDFBinaries?: InputMaybe<Scalars['Boolean']['input']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetR1DealDocumentArgs = {
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  documentID: Scalars['String']['input'];
  includePdfBinary?: InputMaybe<Scalars['Boolean']['input']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetReferrerAggregateArgs = {
  referrer_id: Scalars['Int']['input'];
};

export type QueryGetReferrerByCustomerIdArgs = {
  customer_id: Scalars['Int']['input'];
};

export type QueryGetReferrerByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetRelationshipToDealByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type QueryGetSignaturePacketStatusArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryGetThunderConversationHistoryByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type QueryGetUploadUrlArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  useD2dDocumentCenterBucket?: InputMaybe<Scalars['Boolean']['input']>;
  useD2dVoiceRecordingsBucket?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetUserCallHistoryArgs = {
  items_per_page?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetUsersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  podId?: InputMaybe<Scalars['ID']['input']>;
  roleNames?: InputMaybe<Array<InputMaybe<Auth0RoleName>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  teamType?: InputMaybe<TeamType>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryGetWarrantyInfoArgs = {
  make: Scalars['String']['input'];
  mileage: Scalars['Int']['input'];
  year: Scalars['String']['input'];
};

export type QueryHasAnyDealArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHasNpsSurveyResultArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryInboxArgs = {
  filterBy?: InputMaybe<InboxFilterByEnum>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InboxOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIncrementFlowStartsArgs = {
  code: Scalars['String']['input'];
};

export type QueryIncrementImpressionsArgs = {
  code: Scalars['String']['input'];
};

export type QueryInquiryPartnerArgs = {
  company: Scalars['String']['input'];
  company_website?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  partner_type: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  social_media?: InputMaybe<Scalars['String']['input']>;
};

export type QueryJdpValuesArgs = {
  mileage: Scalars['Float']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
};

export type QueryJurisdictionArgs = {
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StateAbbreviation>;
};

export type QueryKbbValuesArgs = {
  data: KbbValuesDataType;
};

export type QueryKbbVinArgs = {
  vin: Scalars['String']['input'];
};

export type QueryKbbVinAffiliateArgs = {
  vin: Scalars['String']['input'];
};

export type QueryKeyMetricsArgs = {
  end_date: Scalars['DateTime']['input'];
  pod_ids: Array<InputMaybe<Scalars['String']['input']>>;
  start_date: Scalars['DateTime']['input'];
};

export type QueryKeyReplacementRatesArgs = {
  bank?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID']['input'];
};

export type QueryLaneKeyMetricsArgs = {
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  today?: InputMaybe<Scalars['DateTime']['input']>;
  types: Array<InputMaybe<DealType>>;
};

export type QueryLaneKeyMetricsReaderArgs = {
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  today?: InputMaybe<Scalars['DateTime']['input']>;
  types: Array<InputMaybe<DealType>>;
};

export type QueryLatestThirdPartyPayoffSendArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryLeadMatchesArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLeaderboardSetterArgs = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  teamType?: InputMaybe<TeamType>;
};

export type QueryLeaseBuyoutFromVehicleInfoArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  lienholder?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLendersArgs = {
  query: Scalars['String']['input'];
};

export type QueryLienholderContactArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryLienholderTrackRecordArgs = {
  lienholderSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLienholderUtilityArgs = {
  make?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLikelyAddressArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMediaArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryMediaFromComArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMediaV2Args = {
  dealId: Scalars['ID']['input'];
};

export type QueryMessageTemplateByKeyArgs = {
  key: MessageTemplateKey;
};

export type QueryMessageTemplatesByTypeArgs = {
  type?: InputMaybe<MessageTemplateType>;
};

export type QueryMessagesArgs = {
  dealPhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMessagesDbCursorV2Args = {
  filter: MessagesFilter;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type QueryMessagesDbPaginatedArgs = {
  dealId: Scalars['String']['input'];
  dealPhoneNumber: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type QueryMmrArgs = {
  color: Scalars['String']['input'];
  grade: Scalars['Float']['input'];
  mileage: Scalars['Int']['input'];
  state: Scalars['String']['input'];
  trim: Scalars['String']['input'];
  vin: Scalars['String']['input'];
};

export type QueryMyAppointmentSlotsV2Args = {
  date: Scalars['String']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
};

export type QueryNavBarTextNotificationsArgs = {
  assignedToMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  bootRequestedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  podIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sources: Array<Scalars['String']['input']>;
  types: Array<DealType>;
};

export type QueryNotesArgs = {
  deal_id: Scalars['ID']['input'];
};

export type QueryNotesV2CursorArgs = {
  filter?: InputMaybe<NotesFilter>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type QueryPaymentEstimateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
};

export type QueryPaymentEstimateAffiliateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
};

export type QueryPaymentOptionsArgs = {
  data?: InputMaybe<PaymentOptionsInput>;
};

export type QueryPaymentOptionsV2Args = {
  input: PaymentOptionsV2Input;
};

export type QueryPayoffCountMakeArgs = {
  make: Scalars['String']['input'];
};

export type QueryPayoffCountModelArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};

export type QueryPayoffQueueRequestsArgs = {
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryPayoffRequestArgs = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPayoffStatsMakeModelYearArgs = {
  end_date: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
  trim?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPayoffStatsMakeModelYearAffiliateArgs = {
  end_date: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  start_date: Scalars['String']['input'];
  trim?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPodArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPodSummaryStatsV2Args = {
  pool?: InputMaybe<StatsPool>;
  timeFrame?: StatsTimeFrame;
};

export type QueryPodsArgs = {
  hideArchived?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pod_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  team_type?: InputMaybe<Array<InputMaybe<TeamType>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPriorCobuyersForDealArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryProductsArgs = {
  provider_id: Scalars['ID']['input'];
};

export type QueryRecommendedLienholderSlugsArgs = {
  dealId: Scalars['Int']['input'];
};

export type QueryRetrieveDealDocsUploadedToR1Args = {
  dealId: Scalars['ID']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  includePdfBinary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchDealsArgs = {
  query: Scalars['String']['input'];
};

export type QuerySearchWebLeadsArgs = {
  query: Scalars['String']['input'];
};

export type QuerySendOwnerReferralLinkEmailArgs = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type QuerySendOwnerReferralLinkSmsArgs = {
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type QuerySendReferralLinkEmailArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type QuerySendReferralLinkSmsArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type QuerySmartPayoffArgs = {
  vin: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export type QuerySmartPayoffAffiliateArgs = {
  vin: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export type QuerySocialProofStatsArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryStartR1DocumentsFlowArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryStructuringFollowUpArgs = {
  dealId: Scalars['ID']['input'];
};

export type QueryStructuringFollowUpDealsArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  bootRequested?: InputMaybe<Scalars['Boolean']['input']>;
  dealTypes: Array<InputMaybe<DealType>>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  showScheduledFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
  sortColumn: StructuringFollowUpSortColumn;
  sortDirection: SortDirection;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QuerySuggestedMessageArgs = {
  customerId: Scalars['ID']['input'];
  dealId: Scalars['ID']['input'];
  draftMessage?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type QuerySurchargesArgs = {
  product_id: Scalars['Int']['input'];
};

export type QueryTagsArgs = {
  input?: InputMaybe<TagsInput>;
};

export type QueryTaughtCallUrlArgs = {
  callId?: InputMaybe<Scalars['String']['input']>;
  noteId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTemporaryInfoArgs = {
  allowImported?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type QueryTemporaryInfoAuthenticatedArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTemporaryRegistrationTagsDealsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type QueryTieDownArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTireWheelRatesArgs = {
  bank?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID']['input'];
};

export type QueryTitlingDashboardDealsArgs = {
  assignedToDeletedUsersFilter?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<FilterType>;
  includeTitleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showActiveTags?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<SortingType>;
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  types: Array<InputMaybe<DealType>>;
};

export type QueryTitlingUsersArgs = {
  titling_pod_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserDealArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryUserPermissionsArgs = {
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryValidZipArgs = {
  zipCode: Scalars['String']['input'];
};

export type QueryValidateBankContractArgs = {
  deal_id: Scalars['ID']['input'];
};

export type QueryValidateCreditApplicationV2Args = {
  id: Scalars['ID']['input'];
};

export type QueryValidateDealBeforeActionArgs = {
  dealId: Scalars['Int']['input'];
  nextDealState?: InputMaybe<DealStateEnum>;
};

export type QueryValidatePhotoTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryValidateReferrerArgs = {
  code: Scalars['String']['input'];
};

export type QueryValidateSecureLinkArgs = {
  token: Scalars['String']['input'];
};

export type QueryVehicleMileageArgs = {
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVisibleArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryVscRatesArgs = {
  bank?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<RateInput>;
  deal_id: Scalars['ID']['input'];
};

export type R1ContractValidationErrors = {
  __typename?: 'R1ContractValidationErrors';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type R1ContractValidationErrorsInput = {
  errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type R1ContractValidationWarnings = {
  __typename?: 'R1ContractValidationWarnings';
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type R1ContractValidationWarningsInput = {
  warnings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RecipientUnreadCount = {
  __typename?: 'RecipientUnreadCount';
  count: Scalars['Int']['output'];
  recipientId: Scalars['Int']['output'];
  recipientType: Scalars['String']['output'];
};

export enum ReferralSourceEnum {
  DidNotAsk = 'did_not_ask',
  InternetSearch = 'internet_search',
  Mailer = 'mailer',
  Other = 'other',
  RecommendationFromFriend = 'recommendation_from_friend',
  SocialMediaOrBlogPost = 'social_media_or_blog_post',
  Text = 'text',
  TrustedReview = 'trusted_review',
}

export type ReferrerAggregateGraphQlType = {
  __typename?: 'ReferrerAggregateGraphQLType';
  owed_referrals?: Maybe<Scalars['Int']['output']>;
  paid_referrals?: Maybe<Scalars['Int']['output']>;
  pending_referrals?: Maybe<Scalars['Int']['output']>;
  total_referrals?: Maybe<Scalars['Int']['output']>;
};

export type ReferrerDataGraphQlType = {
  __typename?: 'ReferrerDataGraphQLType';
  dfn?: Maybe<Scalars['String']['output']>;
  did?: Maybe<Scalars['Int']['output']>;
  dln?: Maybe<Scalars['String']['output']>;
  dmdl?: Maybe<Scalars['String']['output']>;
  dmke?: Maybe<Scalars['String']['output']>;
  rid?: Maybe<Scalars['Int']['output']>;
};

export type ReferrerGraphQlType = {
  __typename?: 'ReferrerGraphQLType';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_first_name?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  customer_last_name?: Maybe<Scalars['String']['output']>;
  email_sent_instrument_expired_at?: Maybe<Scalars['DateTime']['output']>;
  email_sent_welcome_at?: Maybe<Scalars['DateTime']['output']>;
  finix_identity?: Maybe<Scalars['String']['output']>;
  finix_instrument?: Maybe<Scalars['String']['output']>;
  finix_merchant?: Maybe<Scalars['String']['output']>;
  finix_verify?: Maybe<Scalars['String']['output']>;
  flow_starts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instrument_brand?: Maybe<Scalars['String']['output']>;
  instrument_exp_mo?: Maybe<Scalars['String']['output']>;
  instrument_exp_yr?: Maybe<Scalars['String']['output']>;
  instrument_expired?: Maybe<Scalars['Boolean']['output']>;
  instrument_last_four?: Maybe<Scalars['String']['output']>;
  instrument_type?: Maybe<Scalars['String']['output']>;
  opted_in_at?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url_views?: Maybe<Scalars['Int']['output']>;
};

export type ReferrerUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email_sent_instrument_expired_at?: InputMaybe<Scalars['DateTime']['input']>;
  email_sent_welcome_at?: InputMaybe<Scalars['DateTime']['input']>;
  finix_identity?: InputMaybe<Scalars['String']['input']>;
  finix_instrument?: InputMaybe<Scalars['String']['input']>;
  finix_merchant?: InputMaybe<Scalars['String']['input']>;
  finix_verify?: InputMaybe<Scalars['String']['input']>;
  flow_starts?: InputMaybe<Scalars['Int']['input']>;
  instrument_brand?: InputMaybe<Scalars['String']['input']>;
  instrument_exp_mo?: InputMaybe<Scalars['String']['input']>;
  instrument_exp_yr?: InputMaybe<Scalars['String']['input']>;
  instrument_expired?: InputMaybe<Scalars['Boolean']['input']>;
  instrument_last_four?: InputMaybe<Scalars['String']['input']>;
  instrument_type?: InputMaybe<Scalars['String']['input']>;
  opted_in_at?: InputMaybe<Scalars['String']['input']>;
  url_views?: InputMaybe<Scalars['Int']['input']>;
};

export enum Region {
  Ab = 'AB',
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Bc = 'BC',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Mb = 'MB',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nb = 'NB',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nl = 'NL',
  Nm = 'NM',
  Ns = 'NS',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  On = 'ON',
  Or = 'OR',
  Pa = 'PA',
  Pe = 'PE',
  Pr = 'PR',
  Pw = 'PW',
  Qc = 'QC',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Sk = 'SK',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export type Reliability = {
  __typename?: 'Reliability';
  make?: Maybe<Scalars['Float']['output']>;
  make_perc?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['Float']['output']>;
  model_perc?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Boolean']['output'];
};

export enum ResidenceTypeEnum {
  Buying = 'buying',
  Family = 'family',
  Own = 'own',
  Rent = 'rent',
}

export type ResidentialInfoInput = {
  address?: InputMaybe<AddressInputV2>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['Int']['input'];
  livesWithOtherBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  prevAddress?: InputMaybe<AddressInputV2>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  acquirePayoffForDeal: AcquirePayoffResponse;
  acquirePayoffForTemporaryInfo: AcquirePayoffResponse;
  acquisitionDealInfoUpsert?: Maybe<Deal>;
  addDealBookmark: Array<Deal>;
  addDocumentsToMediaCenter?: Maybe<Scalars['Boolean']['output']>;
  addLendersToCreditApplicationV2: CreditApplication;
  addNote?: Maybe<Note>;
  addParticipant?: Maybe<ResultAddParticipant>;
  applyDocumentSignature?: Maybe<Scalars['Void']['output']>;
  approveTieDown: TieDown;
  archivePod?: Maybe<Scalars['Void']['output']>;
  attachFundingRequirementFile: FundingRequirement;
  auctionUpsert?: Maybe<Auction>;
  authenticateAnonymousCustomer: Scalars['String']['output'];
  automateCreditApplication?: Maybe<Deal>;
  buyerCobuyerSwap?: Maybe<Deal>;
  buyerCobuyerSwapV2?: Maybe<Deal>;
  calculateDealFees: CalculateDealFeesResult;
  callOut?: Maybe<Call>;
  callOutWithAi?: Maybe<Scalars['String']['output']>;
  cancelBootRequestV2?: Maybe<Deal>;
  cancelPayoffRequestByTemporaryInfoId?: Maybe<PayoffRequest>;
  cancelTieDown: TieDown;
  clearR1DealDocs?: Maybe<Array<Maybe<EnhancedDealMedia>>>;
  conditionReportUpsert?: Maybe<ConditionReportUpsert>;
  connectAndRetrieveEntityData?: Maybe<MethodFiConnectAndRetrieveData>;
  counterTieDown: TieDown;
  createAffiliateApiKey?: Maybe<Scalars['String']['output']>;
  createAffiliateProvider?: Maybe<AffiliateProviderRead>;
  createAffiliateTemporaryInfo?: Maybe<TemporaryInfo>;
  createAndSendSecureLink?: Maybe<CreateAndSendSecureLinkResult>;
  createArticle?: Maybe<Article>;
  createBookSheetsV2: CreateBookSheetsV2Response;
  createCreditApplicationV2: CreditApplication;
  createDdDevDeal?: Maybe<Scalars['ID']['output']>;
  createDealIssue: DealIssue;
  createDealV2: Deal;
  createDownPaymentLink?: Maybe<Scalars['String']['output']>;
  createEmbeddedInsuranceLeadAndGetLink?: Maybe<CreateEmbeddedInsuranceLeadAndGetLinkGraphQlType>;
  createExternalDealUploadUrl?: Maybe<ExternalDealUploadUrl>;
  createExternalTempInfoUploadUrl?: Maybe<ExternalTempInfoUploadUrl>;
  createFeedback?: Maybe<Scalars['Void']['output']>;
  createFinixPaymentInstrumentTokenResolver?: Maybe<CreateFinixIdentityGraphQlType>;
  createFinixPaymentMerchantResolver?: Maybe<CreateFinixMerchantGraphQlType>;
  createFundingRequirement: FundingRequirement;
  createIndividualEntity?: Maybe<MethodFiEntity>;
  createJDPBookSheet?: Maybe<Scalars['Boolean']['output']>;
  createKBBBookSheet?: Maybe<Scalars['Boolean']['output']>;
  createKyoVerification?: Maybe<MethodFiVerificationSession>;
  createManualEntryTemporaryInfo?: Maybe<TemporaryInfo>;
  createManualPayoffRequest?: Maybe<PayoffRequest>;
  createNewEstimateAndSetFollowUp?: Maybe<Deal>;
  createNewEstimateFromFiles?: Maybe<CreateNewEstimateFromFiles>;
  createNpsSurveyResult?: Maybe<Scalars['Boolean']['output']>;
  createOptEvent?: Maybe<OptEvent>;
  createPayoffRequest?: Maybe<PayoffRequest>;
  createPotentialUser?: Maybe<PotentialUser>;
  createReferrerPaymentInstrumentResolver?: Maybe<CreateFinixIdentityGraphQlType>;
  createReview?: Maybe<Review>;
  createStructuringFollowUp?: Maybe<Scalars['Boolean']['output']>;
  createTemporaryInfo?: Maybe<TemporaryInfo>;
  createTemporaryInfoAffiliate?: Maybe<TemporaryInfo>;
  createTieDown: TieDown;
  createTransaction?: Maybe<Scalars['Float']['output']>;
  createUser?: Maybe<User>;
  createVerificationSession?: Maybe<MethodFiVerificationSession>;
  customDatesUpdate?: Maybe<DealDates>;
  customerInfoUpsert?: Maybe<Deal>;
  deactivateAffiliateApiKey?: Maybe<Scalars['Boolean']['output']>;
  dealAssign?: Maybe<Deal>;
  /** @deprecated DD 1.0 only. Use dealCompletedV2. */
  dealCompleted?: Maybe<Deal>;
  dealCompletedV2?: Maybe<Deal>;
  dealDetailNetsuite?: Maybe<Deal>;
  dealFinalizeAcquisition?: Maybe<Scalars['Boolean']['output']>;
  dealInfoUpsert?: Maybe<Deal>;
  dealSeen?: Maybe<Scalars['Boolean']['output']>;
  dealSendToBank?: Maybe<DealDates>;
  dealTagsUpsert: Array<Tag>;
  dealUnwound?: Maybe<Deal>;
  dealUpdateAssignments?: Maybe<Deal>;
  dealUpdateRequestBoot?: Maybe<Deal>;
  dealUpdateState?: Maybe<DealWithErrors>;
  dealUpdateStateAndSendEmails?: Maybe<Deal>;
  declineTieDown: TieDown;
  decryptSSN?: Maybe<DecryptedSsn>;
  deleteAndReplaceFiles?: Maybe<Scalars['Boolean']['output']>;
  deleteArticle?: Maybe<Article>;
  deleteComFlowFile?: Maybe<Scalars['Void']['output']>;
  deleteContracts?: Maybe<Scalars['Boolean']['output']>;
  deleteCreditApplicationV2: Scalars['ID']['output'];
  deleteDealIssue: Scalars['ID']['output'];
  deleteDealV2: Scalars['Int']['output'];
  deleteFundingRequirement: Scalars['ID']['output'];
  deleteNote: Scalars['ID']['output'];
  deleteReview?: Maybe<Review>;
  deleteStructuringFollowUp?: Maybe<Scalars['Boolean']['output']>;
  determineApprovalMutation?: Maybe<DetermineApproval>;
  disableFinixPaymentInstrumentResolver?: Maybe<DeleteFinixInstrumentGraphQlType>;
  dismissCustomerNotification?: Maybe<Array<Maybe<CustomerNotification>>>;
  distributeR1Contract: ContractDistribution;
  duplicateDeal: Deal;
  eiRedirect?: Maybe<EiRedirectGraphQlType>;
  employerPhoneLookup: EmployerPhoneLookupResult;
  ensureFinixIdentity?: Maybe<Scalars['String']['output']>;
  estimateUpsert?: Maybe<Deal>;
  executeCardDownPayment?: Maybe<FinixTransfer>;
  executeDownPayment?: Maybe<FinixTransfer>;
  executeExternalSoftPull?: Maybe<Scalars['Boolean']['output']>;
  externalAcquirePayoffForDeal: AcquirePayoffResponse;
  externalCustomerSetTempPassword?: Maybe<Customer>;
  externalCustomerUpdate?: Maybe<Customer>;
  externalUpdateDeal?: Maybe<Deal>;
  fetchDealProductRates: DealProductRatesResult;
  fileSend?: Maybe<Message>;
  fillMessageTemplate: FillMessageTemplateResult;
  finalizeR1Signing?: Maybe<Scalars['Void']['output']>;
  financialInfoAcquisitionUpsert?: Maybe<FinancialInfoAcquisition>;
  followUpComplete?: Maybe<FollowUp>;
  followUpDelete?: Maybe<FollowUp>;
  followUpInsert?: Maybe<FollowUp>;
  followUpUpdate?: Maybe<FollowUp>;
  generatePhotoToken?: Maybe<PhotoToken>;
  getMarketPrequalification: MarketPrequalification;
  getMarketPrequalificationAffiliate: MarketPrequalification;
  handleThunderOutboundCall?: Maybe<ResultHandleThunderOutboundCall>;
  handleThunderOutboundCallOutcome?: Maybe<Scalars['Boolean']['output']>;
  hangUpCall?: Maybe<Scalars['Boolean']['output']>;
  importDeal?: Maybe<Deal>;
  insertDevAffiliateFromTempInfo?: Maybe<Scalars['String']['output']>;
  linkConsentIdentifiers: Scalars['Boolean']['output'];
  linkIdentifiersToOptOuts: Scalars['Boolean']['output'];
  logSigningError?: Maybe<SigningError>;
  logViewedDocumentEvent?: Maybe<Scalars['Void']['output']>;
  manuallySelectBank: FinancialInfo;
  markAlertsAsSeen: Array<Alert>;
  markCustomerNotificationAsSeen?: Maybe<Array<Maybe<CustomerNotification>>>;
  markCustomerNotificationsAsSeen?: Maybe<Array<Maybe<CustomerNotification>>>;
  markMissedSipNotificationAsSeen?: Maybe<Scalars['Boolean']['output']>;
  markRecipientThreadSeen: DealUnreadMessageCount;
  markUnknownNumberThreadSeen: ConversationSummary;
  mediaDelete?: Maybe<Scalars['Boolean']['output']>;
  mediaDeleteFromCom?: Maybe<Scalars['Boolean']['output']>;
  mediaInsert?: Maybe<DealMedia>;
  mediaInsertCom?: Maybe<DealMedia>;
  mediaRename?: Maybe<Scalars['Boolean']['output']>;
  mediaUpdate?: Maybe<DealMedia>;
  mediaUpdateCom?: Maybe<DealMedia>;
  mergeCreditApplicationV2?: Maybe<Scalars['Boolean']['output']>;
  mergeFiles?: Maybe<MergedDocuments>;
  messageSend?: Maybe<Message>;
  messageSendV2?: Maybe<MessageV2>;
  mockDealProcessing?: Maybe<Scalars['Void']['output']>;
  newEstimateUpsert?: Maybe<Deal>;
  noteCreate?: Maybe<Note>;
  noteDelete?: Maybe<Note>;
  noteUpdate?: Maybe<Note>;
  notificationsSeen?: Maybe<Scalars['Boolean']['output']>;
  optOut?: Maybe<Scalars['Void']['output']>;
  overrideCalledByFinancialSpecialist?: Maybe<Deal>;
  patchDealProductPricesV2: Array<DealProduct>;
  payoffRequestCancel?: Maybe<PayoffRequest>;
  payoffRequestConfirm?: Maybe<PayoffRequest>;
  payoffRequestFail?: Maybe<PayoffRequest>;
  payoffRequestFailureRequest?: Maybe<PayoffRequest>;
  payoffRequestUpdate?: Maybe<PayoffRequest>;
  payoffUpdate?: Maybe<Payoff>;
  payoffUpdateV2: PayoffUpdateV2Result;
  podUpsert?: Maybe<Pod>;
  podUpsertAndPodUsersUpdate?: Maybe<BasePod>;
  processPaperwork?: Maybe<Deal>;
  recordConsentDecision: Scalars['ID']['output'];
  registerDealer?: Maybe<Scalars['String']['output']>;
  registerProduct?: Maybe<Scalars['String']['output']>;
  removeDealBookmark: Array<Deal>;
  removeDuplicateFinancialInfos?: Maybe<Scalars['Boolean']['output']>;
  requestBootV2?: Maybe<Deal>;
  resendEmails?: Maybe<Scalars['Boolean']['output']>;
  resetPasswordAndSendEmail?: Maybe<Scalars['Void']['output']>;
  resetProcessorAssignment?: Maybe<FinancialInfo>;
  resolveDealIssue: DealIssue;
  resolveFundingRequirement: FundingRequirement;
  restoreCobuyerFromCreditApplicationV2: Customer;
  retrieveEntityIdentities?: Maybe<MethodFiRetrieveIdentitiesData>;
  reviveBoot?: Maybe<Scalars['Boolean']['output']>;
  reviveBootV2?: Maybe<Deal>;
  revivePod?: Maybe<Pod>;
  runAutoStructureCrons?: Maybe<Scalars['Void']['output']>;
  saveConsent: SaveConsent;
  saveNewCustomerCallOutcome?: Maybe<Call>;
  secureLinkCustomerUpdate?: Maybe<Scalars['Void']['output']>;
  selectCreditDecision?: Maybe<SelectCreditDecision>;
  selectCreditDecisionV2: SelectCreditDecisionV2Result;
  selectDealProductVscRate: SelectDealProductVscRateResult;
  selectPackageSlot: Deal;
  sendContracts?: Maybe<Scalars['Boolean']['output']>;
  sendDevAffiliateToThunder?: Maybe<Scalars['JSONObject']['output']>;
  sendDocumentsWithAdobeAndUpdateState?: Maybe<Deal>;
  sendPaymentEstimateEmailAndText?: Maybe<Scalars['Boolean']['output']>;
  sendPaymentEstimateEmailAndTextAffiliate?: Maybe<Scalars['Boolean']['output']>;
  sendROIDocumentsWithAdobe?: Maybe<Deal>;
  sendThirdPartyPayoff: ThirdPartyPayoffSend;
  setDealProductManualTerm: DealProduct;
  setDealSubscription: Deal;
  setNotePinned: Note;
  setReadyForSignaturesStatus?: Maybe<Scalars['Boolean']['output']>;
  skipTimelineStep?: Maybe<Deal>;
  softDeleteUser?: Maybe<Scalars['Boolean']['output']>;
  storeSignatureData?: Maybe<Scalars['Boolean']['output']>;
  submitAfterHoursSelfServePayoff?: Maybe<PayoffRequest>;
  submitCreditApplicationV2: CreditApplication;
  submitMarketplaceSelfServePayoff?: Maybe<Deal>;
  submitToProviders?: Maybe<Deal>;
  submitToProvidersV2?: Maybe<Deal>;
  temporaryInfoImport?: Maybe<Deal>;
  temporaryInfoImportAffiliate?: Maybe<Deal>;
  temporaryInfoSsnUpdate?: Maybe<TemporaryInfo>;
  temporaryInfoUpdate?: Maybe<TemporaryInfo>;
  temporaryInfoUpdateAffiliate?: Maybe<TemporaryInfo>;
  transformLendingTreeLeadToDeal?: Maybe<Deal>;
  undoTieDownDecision: TieDown;
  unlinkTemporaryInfo?: Maybe<TemporaryInfo>;
  unlockDeal?: Maybe<Scalars['Boolean']['output']>;
  updateArticle?: Maybe<Article>;
  updateCar?: Maybe<Car>;
  updateCreditAppOnDeal?: Maybe<UpdateCreditAppOnDealResponse>;
  updateCreditApplicationV2: CreditApplication;
  updateCustomDate?: Maybe<DealDates>;
  updateCustomer?: Maybe<Customer>;
  updateCustomerAndAddress?: Maybe<Customer>;
  updateCustomerContactInfoAccordion?: Maybe<Customer>;
  updateDealContactV2?: Maybe<DealContact>;
  updateDealNeedsElectronicSignatureVerification?: Maybe<Deal>;
  updateDealPackageConfigSlot: UpdateDealPackageConfigSlotPayload;
  updateDealProductRates: DealProductRatesResult;
  updateDealProductsV2: Deal;
  updateDealV2: Deal;
  updateEmploymentInfo?: Maybe<Customer>;
  updateFinancialInfoV2: FinancialInfo;
  updateInsuranceInfo?: Maybe<ProofOfInsurance>;
  updateNoteText: Note;
  updateOriginalLesseeV2?: Maybe<OriginalLesseeV2>;
  updatePayoffClerk?: Maybe<Scalars['Boolean']['output']>;
  updatePersonalInformation?: Maybe<Customer>;
  updateProcessor?: Maybe<FinancialInfo>;
  updateReferrer?: Maybe<ReferrerGraphQlType>;
  updateResidentialInfo?: Maybe<Customer>;
  updateReview?: Maybe<Review>;
  updateSSN?: Maybe<Scalars['ID']['output']>;
  updateStructuringFollowUpNotes?: Maybe<Scalars['Boolean']['output']>;
  updateSubscriptionToNotificationsStatus?: Maybe<NotificationSubscriber>;
  updateTitlingOptions: TitlingOptionsResult;
  updateUser?: Maybe<User>;
  updateUserCallStatus?: Maybe<User>;
  updateUserPreferences: UserPreferences;
  updateUserSettings?: Maybe<User>;
  updateVerificationSession?: Maybe<MethodFiVerificationSession>;
  uploadAndSendMedia?: Maybe<MediaSendResult>;
  uploadDocument?: Maybe<ExtractedDocumentGql>;
  uploadDocumentToRouteOne?: Maybe<Scalars['Boolean']['output']>;
  /** Uploads one document to the deal's Route One funding jacket and returns the updated media row. */
  uploadDocumentToRouteOneV2?: Maybe<EnhancedDealMedia>;
  uploadDocumentsToCUDL?: Maybe<UploadDocumentsToCudlResult>;
  uploadDriversLicense?: Maybe<DriversLicenseGql>;
  upsertDealPackageConfigs: Array<DealPackageConfig>;
  upsertOriginalLessee?: Maybe<OriginalLessee>;
  vehicleInfoUpsert?: Maybe<Deal>;
  verifyAccount?: Maybe<Scalars['Void']['output']>;
  verifyFinixPaymentInstrumentResolver?: Maybe<VerifyFinixInstrumentGraphQlType>;
};

export type RootMutationTypeAcquirePayoffForDealArgs = {
  dealId: Scalars['Int']['input'];
  payloadFields: Array<Scalars['String']['input']>;
};

export type RootMutationTypeAcquirePayoffForTemporaryInfoArgs = {
  payloadFields: Array<Scalars['String']['input']>;
};

export type RootMutationTypeAcquisitionDealInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};

export type RootMutationTypeAddDealBookmarkArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeAddDocumentsToMediaCenterArgs = {
  deal_id: Scalars['ID']['input'];
  files?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
};

export type RootMutationTypeAddLendersToCreditApplicationV2Args = {
  id: Scalars['ID']['input'];
  lenderIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeAddNoteArgs = {
  input: NoteInputV2;
};

export type RootMutationTypeAddParticipantArgs = {
  agent_phone?: InputMaybe<Scalars['String']['input']>;
  conference_command?: InputMaybe<Scalars['String']['input']>;
  conference_id?: InputMaybe<Scalars['String']['input']>;
  hunt_group_slug?: InputMaybe<Scalars['String']['input']>;
  new_agent_phone?: InputMaybe<Scalars['String']['input']>;
  new_agent_user_id?: InputMaybe<Scalars['String']['input']>;
  waiting_call_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeApplyDocumentSignatureArgs = {
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  documentID: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSignature?: InputMaybe<Scalars['Boolean']['input']>;
  signatureData: Scalars['String']['input'];
  signatureFieldName: Scalars['String']['input'];
};

export type RootMutationTypeApproveTieDownArgs = {
  id: Scalars['ID']['input'];
  review_note?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeArchivePodArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RootMutationTypeAttachFundingRequirementFileArgs = {
  fileId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type RootMutationTypeAuctionUpsertArgs = {
  auction?: InputMaybe<AuctionInput>;
};

export type RootMutationTypeAuthenticateAnonymousCustomerArgs = {
  tempInfoId: Scalars['String']['input'];
};

export type RootMutationTypeAutomateCreditApplicationArgs = {
  deal_id: Scalars['ID']['input'];
};

export type RootMutationTypeBuyerCobuyerSwapArgs = {
  cobuyer_id: Scalars['ID']['input'];
  customer_id: Scalars['ID']['input'];
  deal_id: Scalars['ID']['input'];
};

export type RootMutationTypeBuyerCobuyerSwapV2Args = {
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeCalculateDealFeesArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeCallOutArgs = {
  calledNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  thunderCallerIdOverride?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCallOutWithAiArgs = {
  calledNumber: Scalars['String']['input'];
  payload: AiCallInputPayload;
};

export type RootMutationTypeCancelBootRequestV2Args = {
  id: Scalars['Int']['input'];
};

export type RootMutationTypeCancelPayoffRequestByTemporaryInfoIdArgs = {
  temporaryInfoId: Scalars['ID']['input'];
};

export type RootMutationTypeCancelTieDownArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeClearR1DealDocsArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeConditionReportUpsertArgs = {
  conditionReport?: InputMaybe<ConditionReportUpsertInput>;
};

export type RootMutationTypeConnectAndRetrieveEntityDataArgs = {
  devOldCarOverride?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['String']['input'];
  separateIdentityCall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeCounterTieDownArgs = {
  id: Scalars['ID']['input'];
  review_note?: InputMaybe<Scalars['String']['input']>;
  values: Array<TieDownCounteredValueInput>;
};

export type RootMutationTypeCreateAffiliateApiKeyArgs = {
  affiliateApiKey?: InputMaybe<AffiliateApiKeyInput>;
};

export type RootMutationTypeCreateAffiliateProviderArgs = {
  affiliateProvider?: InputMaybe<AffiliateProviderInput>;
};

export type RootMutationTypeCreateAffiliateTemporaryInfoArgs = {
  country?: InputMaybe<Country>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCreateAndSendSecureLinkArgs = {
  customerId: Scalars['ID']['input'];
  expiresInHours: Scalars['Int']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendText: Scalars['Boolean']['input'];
};

export type RootMutationTypeCreateArticleArgs = {
  article?: InputMaybe<ArticleInput>;
};

export type RootMutationTypeCreateBookSheetsV2Args = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateCreditApplicationV2Args = {
  input: CreditApplicationCreateInput;
};

export type RootMutationTypeCreateDealIssueArgs = {
  comment: Scalars['String']['input'];
  dealId: Scalars['Int']['input'];
  slug: DealIssueSlug;
};

export type RootMutationTypeCreateDealV2Args = {
  input: CreateDealInput;
};

export type RootMutationTypeCreateEmbeddedInsuranceLeadAndGetLinkArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateExternalDealUploadUrlArgs = {
  dealId: Scalars['ID']['input'];
  fileDescription: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type RootMutationTypeCreateExternalTempInfoUploadUrlArgs = {
  fileDescription: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  guid: Scalars['ID']['input'];
};

export type RootMutationTypeCreateFeedbackArgs = {
  deal_id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  improvements: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type RootMutationTypeCreateFinixPaymentInstrumentTokenResolverArgs = {
  identity: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootMutationTypeCreateFinixPaymentMerchantResolverArgs = {
  identity: Scalars['String']['input'];
};

export type RootMutationTypeCreateFundingRequirementArgs = {
  dealId: Scalars['Int']['input'];
  slug: FundingRequirementSlug;
};

export type RootMutationTypeCreateIndividualEntityArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RootMutationTypeCreateJdpBookSheetArgs = {
  customerState: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateKbbBookSheetArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateKyoVerificationArgs = {
  entityId: Scalars['String']['input'];
};

export type RootMutationTypeCreateManualEntryTemporaryInfoArgs = {
  device_type?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  kbb_trim_name?: InputMaybe<Scalars['String']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCreateManualPayoffRequestArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateNewEstimateAndSetFollowUpArgs = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  date_utc: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCreateNewEstimateFromFilesArgs = {
  data?: InputMaybe<TemporaryDataInput>;
  files?: InputMaybe<Array<InputMaybe<NewEstimateFileInput>>>;
};

export type RootMutationTypeCreateNpsSurveyResultArgs = {
  input: NpsSurveyResultInput;
};

export type RootMutationTypeCreateOptEventArgs = {
  event: OptEventInput;
};

export type RootMutationTypeCreatePayoffRequestArgs = {
  dealId: Scalars['ID']['input'];
  digitalPayoffAvailable: Scalars['Boolean']['input'];
  doubleTaxApplicable: Scalars['Boolean']['input'];
};

export type RootMutationTypeCreatePotentialUserArgs = {
  potential_user?: InputMaybe<PotentialUserInput>;
};

export type RootMutationTypeCreateReferrerPaymentInstrumentResolverArgs = {
  identity: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootMutationTypeCreateReviewArgs = {
  review?: InputMaybe<ReviewInput>;
};

export type RootMutationTypeCreateStructuringFollowUpArgs = {
  dealId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};

export type RootMutationTypeCreateTemporaryInfoArgs = {
  deal_type?: InputMaybe<DealType>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']['input']>;
  is_methodfi_flow?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  methodfi_flow_variation?: InputMaybe<Scalars['Int']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCreateTemporaryInfoAffiliateArgs = {
  device_type?: InputMaybe<Scalars['String']['input']>;
  extra_info?: InputMaybe<ExtraTempInfoInputType>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeCreateTieDownArgs = {
  input: CreateTieDownInput;
};

export type RootMutationTypeCreateTransactionArgs = {
  input?: InputMaybe<CreateTransactionInput>;
};

export type RootMutationTypeCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type RootMutationTypeCreateVerificationSessionArgs = {
  entityId: Scalars['String']['input'];
};

export type RootMutationTypeCustomDatesUpdateArgs = {
  date: Scalars['DateTime']['input'];
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeCustomerInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};

export type RootMutationTypeDeactivateAffiliateApiKeyArgs = {
  affiliateApiKeyId?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeDealAssignArgs = {
  allow_reassign?: InputMaybe<Scalars['Boolean']['input']>;
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  deal_id: Scalars['ID']['input'];
  deal_state?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type RootMutationTypeDealCompletedArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type RootMutationTypeDealCompletedV2Args = {
  id: Scalars['Int']['input'];
};

export type RootMutationTypeDealDetailNetsuiteArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDealFinalizeAcquisitionArgs = {
  address_line: Scalars['String']['input'];
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  cash_to_customer: Scalars['Float']['input'];
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  dob: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  mileage?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
  zip: Scalars['String']['input'];
};

export type RootMutationTypeDealInfoUpsertArgs = {
  car?: InputMaybe<CarInput>;
  customer?: InputMaybe<CustomerInput>;
  financialInfo?: InputMaybe<FinancialInfoInput>;
  publishUpdates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeDealSeenArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeDealSendToBankArgs = {
  dealId: Scalars['ID']['input'];
  sent: Scalars['Boolean']['input'];
  skipDistribute?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeDealTagsUpsertArgs = {
  dealId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type RootMutationTypeDealUnwoundArgs = {
  boot_reason: BootReasonInput;
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDealUpdateAssignmentsArgs = {
  closer2_id?: InputMaybe<Scalars['String']['input']>;
  closer_id?: InputMaybe<Scalars['String']['input']>;
  deal_source?: InputMaybe<Scalars['String']['input']>;
  fs_pod_id?: InputMaybe<Scalars['ID']['input']>;
  funding_clerk_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pod_id?: InputMaybe<Scalars['ID']['input']>;
  second_turn_financial_specialist_id?: InputMaybe<Scalars['String']['input']>;
  setter_id?: InputMaybe<Scalars['String']['input']>;
  structuring_manager_id?: InputMaybe<Scalars['String']['input']>;
  title_clerk2_id?: InputMaybe<Scalars['String']['input']>;
  title_clerk_id?: InputMaybe<Scalars['String']['input']>;
  titling_pod_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DealType>;
};

export type RootMutationTypeDealUpdateRequestBootArgs = {
  boot_deal?: InputMaybe<Scalars['Boolean']['input']>;
  boot_reason: BootReasonInput;
  id: Scalars['ID']['input'];
  partial_note?: InputMaybe<NoteInput>;
  request_boot: Scalars['Boolean']['input'];
};

export type RootMutationTypeDealUpdateStateArgs = {
  clearApprovedDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearSetDate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeDealUpdateStateAndSendEmailsArgs = {
  contactType?: InputMaybe<ContactType>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dealIsSigningOnCom?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isR1ContractUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  isR1ContractValidated?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
};

export type RootMutationTypeDeclineTieDownArgs = {
  id: Scalars['ID']['input'];
  review_note?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeDecryptSsnArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  originalLesseeId?: InputMaybe<Scalars['ID']['input']>;
  tempInfoId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeDeleteAndReplaceFilesArgs = {
  deal_id: Scalars['ID']['input'];
  files_to_delete?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
  files_to_upload?: InputMaybe<Array<InputMaybe<AddDocumentsToMediaCenterInput>>>;
};

export type RootMutationTypeDeleteArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeDeleteComFlowFileArgs = {
  key: Scalars['String']['input'];
};

export type RootMutationTypeDeleteContractsArgs = {
  filePaths: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeDeleteCreditApplicationV2Args = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDeleteDealIssueArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDeleteDealV2Args = {
  id: Scalars['Int']['input'];
};

export type RootMutationTypeDeleteFundingRequirementArgs = {
  id: Scalars['Int']['input'];
};

export type RootMutationTypeDeleteNoteArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDeleteReviewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeDeleteStructuringFollowUpArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDetermineApprovalMutationArgs = {
  data: DetermineApprovalInput;
};

export type RootMutationTypeDisableFinixPaymentInstrumentResolverArgs = {
  identity: Scalars['String']['input'];
  instrument: Scalars['String']['input'];
};

export type RootMutationTypeDismissCustomerNotificationArgs = {
  dealId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
};

export type RootMutationTypeDistributeR1ContractArgs = {
  dealId: Scalars['ID']['input'];
  documentIds: Array<Scalars['String']['input']>;
};

export type RootMutationTypeDuplicateDealArgs = {
  dealId: Scalars['ID']['input'];
  duplicationType: DuplicateTypeEnum;
};

export type RootMutationTypeEiRedirectArgs = {
  leadId: Scalars['String']['input'];
};

export type RootMutationTypeEmployerPhoneLookupArgs = {
  input: EmployerPhoneLookupInput;
};

export type RootMutationTypeEnsureFinixIdentityArgs = {
  address_city: Scalars['String']['input'];
  address_line_1: Scalars['String']['input'];
  address_postal_code: Scalars['String']['input'];
  address_state: Scalars['String']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  referrer_id: Scalars['Int']['input'];
};

export type RootMutationTypeEstimateUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};

export type RootMutationTypeExecuteCardDownPaymentArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fraudSessionId?: InputMaybe<Scalars['String']['input']>;
  idempotencyId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeExecuteDownPaymentArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bank?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fraudSessionId?: InputMaybe<Scalars['String']['input']>;
  idempotencyId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plaidAccountId?: InputMaybe<Scalars['String']['input']>;
  plaidToken?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeExecuteExternalSoftPullArgs = {
  isHardPull: Scalars['Boolean']['input'];
  paymentEstimateInput: PaymentEstimateInput;
};

export type RootMutationTypeExternalAcquirePayoffForDealArgs = {
  dealId: Scalars['ID']['input'];
  fields: ExternalPayoffIntelligenceFieldsInput;
  payloadFields: Array<LienholderRequirement>;
};

export type RootMutationTypeExternalCustomerSetTempPasswordArgs = {
  customerId: Scalars['Int']['input'];
};

export type RootMutationTypeExternalCustomerUpdateArgs = {
  customer?: InputMaybe<ExternalCustomerInput>;
  customerId: Scalars['ID']['input'];
};

export type RootMutationTypeExternalUpdateDealArgs = {
  data?: InputMaybe<ExternalDealInputType>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  tempInfoId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeFetchDealProductRatesArgs = {
  input: FetchDealProductRatesInput;
};

export type RootMutationTypeFileSendArgs = {
  dealPhoneNumber: Scalars['String']['input'];
  file: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type RootMutationTypeFillMessageTemplateArgs = {
  input: FillMessageTemplateInput;
};

export type RootMutationTypeFinalizeR1SigningArgs = {
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
};

export type RootMutationTypeFinancialInfoAcquisitionUpsertArgs = {
  car_id?: InputMaybe<Scalars['ID']['input']>;
  clear_override?: InputMaybe<Scalars['Boolean']['input']>;
  financialInfoAcquisition?: InputMaybe<FinancialInfoAcquisitionInput>;
  id: Scalars['ID']['input'];
  mmr?: InputMaybe<Scalars['Float']['input']>;
  override?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
};

export type RootMutationTypeFollowUpCompleteArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeFollowUpDeleteArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeFollowUpInsertArgs = {
  date_utc: Scalars['DateTime']['input'];
  deal_id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type: FollowUpTypeEnum;
  tz: Scalars['String']['input'];
};

export type RootMutationTypeFollowUpUpdateArgs = {
  date_utc: Scalars['DateTime']['input'];
  deal_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type: FollowUpTypeEnum;
  tz: Scalars['String']['input'];
};

export type RootMutationTypeGeneratePhotoTokenArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeGetMarketPrequalificationArgs = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prequalId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeGetMarketPrequalificationAffiliateArgs = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  prequalId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeHandleThunderOutboundCallArgs = {
  hunt_group_slug?: InputMaybe<Scalars['String']['input']>;
  thunder_call_notification_id?: InputMaybe<Scalars['ID']['input']>;
  waiting_call_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeHandleThunderOutboundCallOutcomeArgs = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  attemptNum?: InputMaybe<Scalars['Int']['input']>;
  calledNumber?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  thunderCallNotificationId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeHangUpCallArgs = {
  conference_id: Scalars['String']['input'];
};

export type RootMutationTypeImportDealArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeInsertDevAffiliateFromTempInfoArgs = {
  externalId: Scalars['ID']['input'];
  tempInfoId: Scalars['ID']['input'];
};

export type RootMutationTypeLinkConsentIdentifiersArgs = {
  consentEventId: Scalars['ID']['input'];
  howLinked: ConsentHowLinked;
  identifiers: Array<ConsentIdentifierInput>;
};

export type RootMutationTypeLinkIdentifiersToOptOutsArgs = {
  howLinked: ConsentHowLinked;
  identifiers: Array<ConsentIdentifierInput>;
};

export type RootMutationTypeLogSigningErrorArgs = {
  error: SigningErrorInput;
};

export type RootMutationTypeLogViewedDocumentEventArgs = {
  documentViewedEvent: SigningAuditDocumentViewedEvent;
};

export type RootMutationTypeManuallySelectBankArgs = {
  bank: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeMarkAlertsAsSeenArgs = {
  input?: InputMaybe<MarkAlertsAsSeenInput>;
};

export type RootMutationTypeMarkCustomerNotificationAsSeenArgs = {
  dealId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
};

export type RootMutationTypeMarkCustomerNotificationsAsSeenArgs = {
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
};

export type RootMutationTypeMarkMissedSipNotificationAsSeenArgs = {
  callIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeMarkRecipientThreadSeenArgs = {
  dealId: Scalars['Int']['input'];
  recipientId: Scalars['Int']['input'];
  recipientType: Scalars['String']['input'];
};

export type RootMutationTypeMarkUnknownNumberThreadSeenArgs = {
  phone: Scalars['String']['input'];
};

export type RootMutationTypeMediaDeleteArgs = {
  filePath: Scalars['String']['input'];
};

export type RootMutationTypeMediaDeleteFromComArgs = {
  dealId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
};

export type RootMutationTypeMediaInsertArgs = {
  dealId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeMediaInsertComArgs = {
  dealId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  type: Scalars['String']['input'];
};

export type RootMutationTypeMediaRenameArgs = {
  dealId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};

export type RootMutationTypeMediaUpdateArgs = {
  dealId: Scalars['ID']['input'];
  has_verified_digital_signature?: InputMaybe<Scalars['Boolean']['input']>;
  has_wet_signature?: InputMaybe<Scalars['Boolean']['input']>;
  is_notarized?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  newFileName?: InputMaybe<Scalars['String']['input']>;
  oldKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeMediaUpdateComArgs = {
  dealId: Scalars['ID']['input'];
  newFileName?: InputMaybe<Scalars['String']['input']>;
  oldKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeMergeCreditApplicationV2Args = {
  approved_date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  imported_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  set_date?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<DealStateEnum>;
};

export type RootMutationTypeMergeFilesArgs = {
  dealId: Scalars['ID']['input'];
  docs?: InputMaybe<Array<InputMaybe<DealMediaInput>>>;
};

export type RootMutationTypeMessageSendArgs = {
  dealPhoneNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type RootMutationTypeMessageSendV2Args = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealPhoneNumber: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type RootMutationTypeMockDealProcessingArgs = {
  deal_id: Scalars['ID']['input'];
  has_gap: Scalars['Boolean']['input'];
  has_vsc: Scalars['Boolean']['input'];
  is_conditioned: Scalars['Boolean']['input'];
};

export type RootMutationTypeNewEstimateUpsertArgs = {
  newEstimateUpsertInput?: InputMaybe<NewEstimateUpsertInput>;
};

export type RootMutationTypeNoteCreateArgs = {
  note?: InputMaybe<NoteInput>;
};

export type RootMutationTypeNoteDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeNoteUpdateArgs = {
  note?: InputMaybe<NoteInput>;
};

export type RootMutationTypeNotificationsSeenArgs = {
  notificationIds: Array<Scalars['ID']['input']>;
  seen: Scalars['Boolean']['input'];
};

export type RootMutationTypeOptOutArgs = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeOverrideCalledByFinancialSpecialistArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypePatchDealProductPricesV2Args = {
  input: PatchDealProductPricesInputV2;
};

export type RootMutationTypePayoffRequestCancelArgs = {
  payoffRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypePayoffRequestConfirmArgs = {
  payoffRequest: PayoffRequestConfirmInput;
};

export type RootMutationTypePayoffRequestFailArgs = {
  payoffRequest: PayoffRequestInput;
};

export type RootMutationTypePayoffRequestFailureRequestArgs = {
  payoffRequest: PayoffRequestInput;
};

export type RootMutationTypePayoffRequestUpdateArgs = {
  payoffRequest: PayoffRequestInput;
};

export type RootMutationTypePayoffUpdateArgs = {
  dealId: Scalars['ID']['input'];
  payoffInfo: PayoffInput;
};

export type RootMutationTypePayoffUpdateV2Args = {
  dealId: Scalars['ID']['input'];
  doubleTaxApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  payoffInfo: PayoffInput;
};

export type RootMutationTypePodUpsertArgs = {
  pod?: InputMaybe<BasePodInput>;
};

export type RootMutationTypePodUpsertAndPodUsersUpdateArgs = {
  newPod: PodInput;
  oldPod?: InputMaybe<PodInput>;
};

export type RootMutationTypeProcessPaperworkArgs = {
  id: Scalars['ID']['input'];
  paperwork_type: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type RootMutationTypeRecordConsentDecisionArgs = {
  decision: ConsentDecisionInput;
};

export type RootMutationTypeRegisterDealerArgs = {
  dealer?: InputMaybe<DealerInput>;
};

export type RootMutationTypeRegisterProductArgs = {
  dealer_id: Scalars['ID']['input'];
  product_id: Scalars['ID']['input'];
  provider_dealer_code: Scalars['String']['input'];
};

export type RootMutationTypeRemoveDealBookmarkArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeRequestBootV2Args = {
  bootDeal?: InputMaybe<Scalars['Boolean']['input']>;
  bootReason: BootReasonInputV2;
  id: Scalars['Int']['input'];
  partialNote?: InputMaybe<NoteInputV2>;
  requestBoot: Scalars['Boolean']['input'];
  requestConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeResendEmailsArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeResetPasswordAndSendEmailArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeResetProcessorAssignmentArgs = {
  dealId: Scalars['ID']['input'];
  fiId: Scalars['ID']['input'];
};

export type RootMutationTypeResolveDealIssueArgs = {
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
};

export type RootMutationTypeResolveFundingRequirementArgs = {
  id: Scalars['Int']['input'];
  resolved: Scalars['Boolean']['input'];
};

export type RootMutationTypeRestoreCobuyerFromCreditApplicationV2Args = {
  creditApplicationId: Scalars['Int']['input'];
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeRetrieveEntityIdentitiesArgs = {
  entityId: Scalars['String']['input'];
};

export type RootMutationTypeReviveBootArgs = {
  id: Scalars['ID']['input'];
  reassign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeReviveBootV2Args = {
  id: Scalars['Int']['input'];
  reassign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeRevivePodArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RootMutationTypeSaveConsentArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ConsentNameEnumType>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type RootMutationTypeSaveNewCustomerCallOutcomeArgs = {
  call_id: Scalars['String']['input'];
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_description?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeSecureLinkCustomerUpdateArgs = {
  ssn: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootMutationTypeSelectCreditDecisionArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeSelectCreditDecisionV2Args = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeSelectDealProductVscRateArgs = {
  input: SelectDealProductVscRateInput;
};

export type RootMutationTypeSelectPackageSlotArgs = {
  input: SelectPackageSlotInput;
};

export type RootMutationTypeSendContractsArgs = {
  deal_id: Scalars['ID']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeSendDevAffiliateToThunderArgs = {
  externalId: Scalars['String']['input'];
};

export type RootMutationTypeSendDocumentsWithAdobeAndUpdateStateArgs = {
  deal_id: Scalars['ID']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  state: DealStateEnum;
};

export type RootMutationTypeSendPaymentEstimateEmailAndTextArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeSendPaymentEstimateEmailAndTextAffiliateArgs = {
  data?: InputMaybe<PaymentEstimateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeSendRoiDocumentsWithAdobeArgs = {
  deal_id: Scalars['ID']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeSendThirdPartyPayoffArgs = {
  dealId: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};

export type RootMutationTypeSetDealProductManualTermArgs = {
  input: SetDealProductManualTermInputV2;
};

export type RootMutationTypeSetDealSubscriptionArgs = {
  dealId: Scalars['Int']['input'];
  subscribed: Scalars['Boolean']['input'];
};

export type RootMutationTypeSetNotePinnedArgs = {
  id: Scalars['ID']['input'];
  isPinned: Scalars['Boolean']['input'];
};

export type RootMutationTypeSetReadyForSignaturesStatusArgs = {
  dealId: Scalars['ID']['input'];
  documentProgressStatus?: InputMaybe<DocumentProgressStatus>;
};

export type RootMutationTypeSkipTimelineStepArgs = {
  dealId: Scalars['ID']['input'];
  documentProgressStatus?: InputMaybe<DocumentProgressStatus>;
};

export type RootMutationTypeSoftDeleteUserArgs = {
  id: Scalars['String']['input'];
};

export type RootMutationTypeStoreSignatureDataArgs = {
  customer_id: Scalars['ID']['input'];
  initials_data_url?: InputMaybe<Scalars['String']['input']>;
  initials_strokes?: InputMaybe<Scalars['String']['input']>;
  signature_data_url?: InputMaybe<Scalars['String']['input']>;
  signature_strokes?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeSubmitAfterHoursSelfServePayoffArgs = {
  dealId: Scalars['ID']['input'];
  goodThroughDate: Scalars['DateTime']['input'];
  vehiclePayoff: Scalars['Float']['input'];
};

export type RootMutationTypeSubmitCreditApplicationV2Args = {
  id: Scalars['ID']['input'];
  lenderIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type RootMutationTypeSubmitMarketplaceSelfServePayoffArgs = {
  dealId: Scalars['ID']['input'];
  goodThroughDate: Scalars['DateTime']['input'];
  vehiclePayoff: Scalars['Float']['input'];
};

export type RootMutationTypeSubmitToProvidersArgs = {
  deal?: InputMaybe<DealInput>;
  lenderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RootMutationTypeSubmitToProvidersV2Args = {
  dealId: Scalars['ID']['input'];
  lenderIds: Array<Scalars['String']['input']>;
};

export type RootMutationTypeTemporaryInfoImportArgs = {
  id: Scalars['ID']['input'];
  importType?: InputMaybe<ImportType>;
  transformType: TransformType;
};

export type RootMutationTypeTemporaryInfoImportAffiliateArgs = {
  id: Scalars['ID']['input'];
  importType?: InputMaybe<ImportType>;
  transformType: TransformType;
};

export type RootMutationTypeTemporaryInfoSsnUpdateArgs = {
  isCobuyer: Scalars['Boolean']['input'];
  ssn: Scalars['String']['input'];
  tempInfoId: Scalars['ID']['input'];
};

export type RootMutationTypeTemporaryInfoUpdateArgs = {
  info?: InputMaybe<TemporaryInfoInput>;
};

export type RootMutationTypeTemporaryInfoUpdateAffiliateArgs = {
  info?: InputMaybe<TemporaryInfoInput>;
};

export type RootMutationTypeTransformLendingTreeLeadToDealArgs = {
  affiliate: AffiliateInput;
};

export type RootMutationTypeUndoTieDownDecisionArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeUnlinkTemporaryInfoArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeUnlockDealArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeUpdateArticleArgs = {
  article?: InputMaybe<ArticleInput>;
};

export type RootMutationTypeUpdateCarArgs = {
  car?: InputMaybe<CarInput>;
};

export type RootMutationTypeUpdateCreditAppOnDealArgs = {
  input: CreditAppInput;
};

export type RootMutationTypeUpdateCreditApplicationV2Args = {
  input: CreditApplicationUpdateInput;
};

export type RootMutationTypeUpdateCustomDateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateKey: CustomDateKeyEnum;
  dealId: Scalars['ID']['input'];
};

export type RootMutationTypeUpdateCustomerArgs = {
  customer?: InputMaybe<CustomerInput>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootMutationTypeUpdateCustomerAndAddressArgs = {
  customer?: InputMaybe<CustomerInput>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
};

export type RootMutationTypeUpdateCustomerContactInfoAccordionArgs = {
  customerContactInfo?: InputMaybe<CustomerContactInfoInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeUpdateDealContactV2Args = {
  contactData?: InputMaybe<DealContactInput>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  dealId: Scalars['Int']['input'];
};

export type RootMutationTypeUpdateDealNeedsElectronicSignatureVerificationArgs = {
  deal_id: Scalars['ID']['input'];
  needs_electronic_signature_verification: Scalars['Boolean']['input'];
};

export type RootMutationTypeUpdateDealPackageConfigSlotArgs = {
  input: UpdateDealPackageConfigSlotInput;
};

export type RootMutationTypeUpdateDealProductRatesArgs = {
  input: UpdateDealProductRatesInput;
};

export type RootMutationTypeUpdateDealProductsV2Args = {
  input: UpdateDealProductsInputV2;
};

export type RootMutationTypeUpdateDealV2Args = {
  input: DealInput;
};

export type RootMutationTypeUpdateEmploymentInfoArgs = {
  input: EmploymentInfoInput;
};

export type RootMutationTypeUpdateFinancialInfoV2Args = {
  id: Scalars['Int']['input'];
  input: FinancialInfoInputV2Input;
};

export type RootMutationTypeUpdateInsuranceInfoArgs = {
  expiration_date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  insurance_company?: InputMaybe<Scalars['String']['input']>;
  policy_no?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeUpdateNoteTextArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNoteTextInput;
};

export type RootMutationTypeUpdateOriginalLesseeV2Args = {
  dealId: Scalars['Int']['input'];
  originalLessee?: InputMaybe<OriginalLesseeV2Input>;
};

export type RootMutationTypeUpdatePayoffClerkArgs = {
  payoff_clerk_id?: InputMaybe<Scalars['String']['input']>;
  payoff_request_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeUpdatePersonalInformationArgs = {
  input: PersonalInfoInput;
};

export type RootMutationTypeUpdateProcessorArgs = {
  dealId: Scalars['ID']['input'];
  fiId: Scalars['ID']['input'];
  processor?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeUpdateReferrerArgs = {
  data?: InputMaybe<ReferrerUpdateInput>;
  id: Scalars['Int']['input'];
};

export type RootMutationTypeUpdateResidentialInfoArgs = {
  input: ResidentialInfoInput;
};

export type RootMutationTypeUpdateReviewArgs = {
  review?: InputMaybe<ReviewInput>;
};

export type RootMutationTypeUpdateSsnArgs = {
  ssn: Scalars['String']['input'];
  ssnId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeUpdateStructuringFollowUpNotesArgs = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};

export type RootMutationTypeUpdateSubscriptionToNotificationsStatusArgs = {
  dealId: Scalars['ID']['input'];
  subscribeToNotifications: Scalars['Boolean']['input'];
};

export type RootMutationTypeUpdateTitlingOptionsArgs = {
  input: TitlingInput;
};

export type RootMutationTypeUpdateUserArgs = {
  allAuth0RoleIds: Array<Scalars['String']['input']>;
  updateUserInput: UpdateUserInput;
};

export type RootMutationTypeUpdateUserCallStatusArgs = {
  status: CallStatus;
};

export type RootMutationTypeUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};

export type RootMutationTypeUpdateUserSettingsArgs = {
  accept_ai_touched_deals: Scalars['Boolean']['input'];
  accept_overnight_deals: Scalars['Boolean']['input'];
  accept_unseen_deals: Scalars['Boolean']['input'];
  accept_with_upcoming_appointment: Scalars['Boolean']['input'];
  assignment_mode: AssignmentMode;
  auto_assign_deals: Scalars['Boolean']['input'];
  deals_with_bank_fees: Scalars['Boolean']['input'];
  deals_with_direct_pay: Scalars['Boolean']['input'];
  deals_with_double_tax: Scalars['Boolean']['input'];
  deals_with_down_payment: Scalars['Boolean']['input'];
  deals_with_gap: Scalars['Boolean']['input'];
  deals_with_stipulations: Scalars['Boolean']['input'];
  deals_with_vsc: Scalars['Boolean']['input'];
  frequency_minutes: Scalars['Int']['input'];
  hours: Scalars['String']['input'];
  id: Scalars['String']['input'];
  max_auto_assign_deals: Scalars['Int']['input'];
  on_vacation: Scalars['Boolean']['input'];
  user_type: UserType;
};

export type RootMutationTypeUpdateVerificationSessionArgs = {
  code: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  verificationSessionId: Scalars['String']['input'];
};

export type RootMutationTypeUploadAndSendMediaArgs = {
  contentType: Scalars['String']['input'];
  dealId: Scalars['Int']['input'];
  dealPhoneNumber: Scalars['String']['input'];
  fileData: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type RootMutationTypeUploadDocumentArgs = {
  bytes?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<TtDocumentName>;
};

export type RootMutationTypeUploadDocumentToRouteOneArgs = {
  dealId: Scalars['ID']['input'];
  doc: UploadDocumentsInput;
  subscriptionArgs?: InputMaybe<DocumentPreparationProgressSubscriptionArgs>;
  withCobuyer: Scalars['Boolean']['input'];
};

export type RootMutationTypeUploadDocumentToRouteOneV2Args = {
  dealId: Scalars['ID']['input'];
  doc: UploadDocumentsInput;
  withCobuyer: Scalars['Boolean']['input'];
};

export type RootMutationTypeUploadDocumentsToCudlArgs = {
  dealId: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};

export type RootMutationTypeUploadDriversLicenseArgs = {
  bytes?: InputMaybe<Scalars['String']['input']>;
  includeGender?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeUpsertDealPackageConfigsArgs = {
  input: UpsertDealPackageConfigsInput;
};

export type RootMutationTypeUpsertOriginalLesseeArgs = {
  deal_id: Scalars['Int']['input'];
  original_lessee: OriginalLesseeInput;
};

export type RootMutationTypeVehicleInfoUpsertArgs = {
  deal?: InputMaybe<DealInput>;
};

export type RootMutationTypeVerifyAccountArgs = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']['input']>;
  ssn_last_4?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeVerifyFinixPaymentInstrumentResolverArgs = {
  identity: Scalars['String']['input'];
  instrument: Scalars['String']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  inProgressCalls?: Maybe<Array<Maybe<Conference>>>;
  onAICloser?: Maybe<Deal>;
  onAICloserCallStatus?: Maybe<AiCloserCallStatus>;
  /** Signals that the advisor bar's stats changed for the chosen pool. */
  onAdvisorSummaryStatsUpdate: Scalars['Boolean']['output'];
  onAffiliateDuplicateFound?: Maybe<AffiliateDuplicateFound>;
  onAlertCreated: Array<Alert>;
  onAlertRecipientsChanged: AlertRecipientsChangedPayload;
  onAlertsMarkedSeen: AlertsMarkedSeenPayload;
  onContractDistributionUpdated?: Maybe<ContractDistribution>;
  onCreditDecisionCreated?: Maybe<CreditDecisionCreatedPayload>;
  onCreditDecisionSelected?: Maybe<SelectCreditDecision>;
  onCustomDateUpdated?: Maybe<CustomDateUpdatedPayload>;
  onDashboardDocumentUpload?: Maybe<DashboardDocumentUpload>;
  onDealActivityLogged?: Maybe<DealActivityLoggedSubscriptionPayload>;
  onDealComplete?: Maybe<Array<Maybe<Deal>>>;
  onDealImported?: Maybe<DealImported>;
  onDealIssueResolutionStatusChanged: DealIssueResolutionStatusChanged;
  onDealIssuesUpdated: Array<DealIssue>;
  onDealLockStatus?: Maybe<DealLockStatusSubscriptionPayload>;
  onDealMoved?: Maybe<DealMovedSubscriptionPayload>;
  onDealTieDownsChanged: DealTieDown;
  onDealUpdate?: Maybe<Array<Maybe<Deal>>>;
  onDocumentPreparationProgress?: Maybe<DocumentPreparationProgress>;
  onDocumentProgressStatus?: Maybe<Array<Maybe<Deal>>>;
  onDownPaymentReceived?: Maybe<DownPaymentReceived>;
  onDuplicatedDealImport?: Maybe<DuplicatedDealImport>;
  onDuplicatedInfo?: Maybe<DuplicatedInfo>;
  onEmbeddedInsuranceNotification?: Maybe<EmbeddedInsuranceNotification>;
  onFollowUpUpdate?: Maybe<Array<Maybe<Deal>>>;
  /** Signals that the FS bar's stats changed for the chosen pool. */
  onFsSummaryStatsUpdate?: Maybe<Scalars['Boolean']['output']>;
  onFundingRequirementResolutionStatusChanged: FundingRequirementResolutionStatusChanged;
  onFundingRequirementsUpdated: Array<FundingRequirement>;
  onMessageCreatedV2?: Maybe<MessageV2>;
  onMessageReceivedV2?: Maybe<MessageV2>;
  onMissedSipCall?: Maybe<OnMissedSipCall>;
  onNewMessage?: Maybe<MessageData>;
  onNoDealNotification?: Maybe<Array<Maybe<Notification>>>;
  onNoteCreated: Array<Note>;
  onNoteDeleted: Array<Scalars['ID']['output']>;
  onNoteUpdated: Array<Note>;
  onPayoffQueueUpdate?: Maybe<PayoffQueueUpdate>;
  onPayoffRequestStatusUpdate?: Maybe<PayoffRequestStatusUpdateWithMessage>;
  onPayoffRequestStatusUpdateV2?: Maybe<PayoffRequestStatusUpdateV2WithMessage>;
  onPayoffRequestUpdate?: Maybe<PayoffRequestPopulated>;
  /** Signals that the pod bar's stats changed for the chosen pool. */
  onPodSummaryStatsUpdate: Scalars['Boolean']['output'];
  onPriorityQueueUpdate: PriorityQueueUpdate;
  onSecureLinkCreated?: Maybe<SecureLinkNotification>;
  onSecureLinkExpired?: Maybe<SecureLinkNotification>;
  onSipRegistrationFailure?: Maybe<OnSipRegistrationFailure>;
  onStructuringFollowUpUpdate?: Maybe<Array<Maybe<Deal>>>;
  onTagsCreated?: Maybe<TagsPayload>;
  onTagsDeleted?: Maybe<TagsPayload>;
  onTemporaryRegistrationTagsDealsUpdated?: Maybe<Array<Maybe<Deal>>>;
  onTieDownChanged: TieDown;
  onTransactionCreated?: Maybe<FinancialInfo>;
  onUnknownNumberMessageReceived: Scalars['String']['output'];
  onWaitingQueue?: Maybe<OnWaitingQueue>;
  switchCallStatus?: Maybe<Scalars['String']['output']>;
};

export type RootSubscriptionTypeOnAiCloserArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnAiCloserCallStatusArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnAdvisorSummaryStatsUpdateArgs = {
  pool: StatsPool;
};

export type RootSubscriptionTypeOnAlertCreatedArgs = {
  filter?: InputMaybe<AlertsFilter>;
};

export type RootSubscriptionTypeOnContractDistributionUpdatedArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnCreditDecisionCreatedArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnCreditDecisionSelectedArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnCustomDateUpdatedArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnDealActivityLoggedArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnDealCompleteArgs = {
  endDate: Scalars['DateTime']['input'];
  sources: Array<InputMaybe<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  types: Array<InputMaybe<DealType>>;
};

export type RootSubscriptionTypeOnDealIssueResolutionStatusChangedArgs = {
  dealIds: Array<Scalars['Int']['input']>;
};

export type RootSubscriptionTypeOnDealIssuesUpdatedArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnDealLockStatusArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnDealMovedArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnDealTieDownsChangedArgs = {
  dealId: Scalars['ID']['input'];
};

export type RootSubscriptionTypeOnDealUpdateArgs = {
  dealIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sources: Array<Scalars['String']['input']>;
  types?: InputMaybe<Array<DealType>>;
};

export type RootSubscriptionTypeOnDocumentPreparationProgressArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnDocumentProgressStatusArgs = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  fundingClerkOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootSubscriptionTypeOnFollowUpUpdateArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
  followUpStatus?: InputMaybe<FollowUpStatusEnum>;
  followUpType?: InputMaybe<FollowUpTypeEnum>;
  scheduledByMeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
};

export type RootSubscriptionTypeOnFsSummaryStatsUpdateArgs = {
  pool: StatsPool;
};

export type RootSubscriptionTypeOnFundingRequirementResolutionStatusChangedArgs = {
  dealIds: Array<Scalars['Int']['input']>;
};

export type RootSubscriptionTypeOnFundingRequirementsUpdatedArgs = {
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnMessageCreatedV2Args = {
  activePhoneNumber: Scalars['String']['input'];
  dealId?: InputMaybe<Scalars['Int']['input']>;
  notifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootSubscriptionTypeOnMessageReceivedV2Args = {
  activePhoneNumber: Scalars['String']['input'];
  dealId: Scalars['Int']['input'];
};

export type RootSubscriptionTypeOnNewMessageArgs = {
  activePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dealPhoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  isWidgetOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootSubscriptionTypeOnNoteCreatedArgs = {
  filter?: InputMaybe<NotesFilter>;
};

export type RootSubscriptionTypeOnNoteDeletedArgs = {
  filter?: InputMaybe<NotesFilter>;
};

export type RootSubscriptionTypeOnNoteUpdatedArgs = {
  filter?: InputMaybe<NotesFilter>;
};

export type RootSubscriptionTypeOnPayoffRequestStatusUpdateArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionTypeOnPayoffRequestStatusUpdateV2Args = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionTypeOnPodSummaryStatsUpdateArgs = {
  pool: StatsPool;
};

export type RootSubscriptionTypeOnPriorityQueueUpdateArgs = {
  assignment?: InputMaybe<DealAssignmentFilter>;
  fsPodScoped?: InputMaybe<Scalars['Boolean']['input']>;
  states: Array<DealStateEnum>;
};

export type RootSubscriptionTypeOnSecureLinkCreatedArgs = {
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RootSubscriptionTypeOnSecureLinkExpiredArgs = {
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RootSubscriptionTypeOnStructuringFollowUpUpdateArgs = {
  assignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<DealType>>>;
};

export type RootSubscriptionTypeOnTagsCreatedArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionTypeOnTagsDeletedArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionTypeOnTieDownChangedArgs = {
  dealId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootSubscriptionTypeOnTransactionCreatedArgs = {
  dealId: Scalars['ID']['input'];
};

export type SaveConsent = {
  __typename?: 'SaveConsent';
  consent?: Maybe<Consent>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
};

export type SecureLinkNotification = {
  __typename?: 'SecureLinkNotification';
  customer_id: Scalars['ID']['output'];
  deal_id: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  reason: SecureLinkNotificationReason;
};

export enum SecureLinkNotificationReason {
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Used = 'USED',
}

export enum SecureLinkStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
}

export type SelectCreditDecision = {
  __typename?: 'SelectCreditDecision';
  creditDecision?: Maybe<CreditDecision>;
  financialInfo: FinancialInfo;
};

export type SelectCreditDecisionV2Result = {
  __typename?: 'SelectCreditDecisionV2Result';
  creditDecision: CreditDecision;
  financialInfo: FinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type SelectDealProductVscRateInput = {
  dealId: Scalars['Int']['input'];
  penRateId: Scalars['Int']['input'];
};

export type SelectDealProductVscRateResult = {
  __typename?: 'SelectDealProductVscRateResult';
  paymentOptions: PaymentOptionsV2;
  vscDealProduct: DealProduct;
};

export type SelectPackageSlotInput = {
  dealId: Scalars['Int']['input'];
  selectedPackageSlotIndex: Scalars['Int']['input'];
};

export type SendReferralLinkPayload = {
  __typename?: 'SendReferralLinkPayload';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetDealProductManualTermInputV2 = {
  dealId: Scalars['Int']['input'];
  slug: ProductSlug;
  termMiles: Scalars['Int']['input'];
  termMonths: Scalars['Int']['input'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  tracker_url?: Maybe<Scalars['String']['output']>;
  tracking_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SidebarAppointmentV2 = {
  __typename?: 'SidebarAppointmentV2';
  customerId?: Maybe<Scalars['ID']['output']>;
  dateUtc: Scalars['DateTime']['output'];
  dealId: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  followUpId: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status: FollowUpStatusEnum;
  type: FollowUpTypeEnum;
  tz?: Maybe<Scalars['String']['output']>;
};

export type SignatureData = {
  __typename?: 'SignatureData';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  initials_data_url?: Maybe<Scalars['String']['output']>;
  initials_strokes?: Maybe<Scalars['String']['output']>;
  signature_data_url?: Maybe<Scalars['String']['output']>;
  signature_strokes?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SignaturePacketStatus = {
  __typename?: 'SignaturePacketStatus';
  documents: Array<SigningDocumentStatus>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SigningDocumentStatus = {
  __typename?: 'SigningDocumentStatus';
  buyerSigned: Scalars['Boolean']['output'];
  cobuyerSigned?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  requiresCobuyerSignature: Scalars['Boolean']['output'];
  signatureStatus: DocumentSignatureStatus;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export enum SigningErrorEnum {
  ApplyDealerSignature = 'APPLY_DEALER_SIGNATURE',
  ApplySignature = 'APPLY_SIGNATURE',
  FinalizeSigning = 'FINALIZE_SIGNING',
  GenerationDate = 'GENERATION_DATE',
  RetrieveDocuments = 'RETRIEVE_DOCUMENTS',
  RetrieveDocumentPdf = 'RETRIEVE_DOCUMENT_PDF',
}

export enum SigningSolutionEnum {
  AdobeSign = 'adobe_sign',
  RouteOne = 'route_one',
}

/** A document the current deal configuration intentionally did not generate. */
export type SkippedDocument = {
  __typename?: 'SkippedDocument';
  filename: Scalars['String']['output'];
  mediaType: DealMediaTypeEnum;
};

export type SocialProofStats = {
  __typename?: 'SocialProofStats';
  allTimeFundedCount?: Maybe<Scalars['Int']['output']>;
  customerCountByState?: Maybe<Scalars['Int']['output']>;
  customerState?: Maybe<Scalars['String']['output']>;
  nationalBrandCount?: Maybe<Scalars['Int']['output']>;
  trustpilotRating?: Maybe<Scalars['Float']['output']>;
  trustpilotReviewCount?: Maybe<Scalars['Int']['output']>;
  vehicleBrand?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type SortingType = {
  direction?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type SortingTypeV2 = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<DealSortColumn>;
};

export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export type StateCount = {
  __typename?: 'StateCount';
  count?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum StatesTaxedOnWarranty {
  Ar = 'AR',
  Ct = 'CT',
  Fl = 'FL',
  Hi = 'HI',
  Ks = 'KS',
  Me = 'ME',
  Ne = 'NE',
  Nj = 'NJ',
  Ny = 'NY',
  Oh = 'OH',
  Pa = 'PA',
  Sd = 'SD',
  Tn = 'TN',
  Ut = 'UT',
  Wi = 'WI',
  Wy = 'WY',
}

export enum StatsPool {
  Company = 'COMPANY',
  Me = 'ME',
  MyPod = 'MY_POD',
}

export enum StatsTimeFrame {
  LastSevenDays = 'LAST_SEVEN_DAYS',
  MonthToDate = 'MONTH_TO_DATE',
  Today = 'TODAY',
}

export type StructuringFollowUp = {
  __typename?: 'StructuringFollowUp';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  creator_id?: Maybe<Scalars['ID']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StructuringFollowUpStatus>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StructuringFollowUpInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StructuringFollowUpStatus>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum StructuringFollowUpSortColumn {
  Advisor = 'advisor',
  Customer = 'customer',
  Date = 'date',
  DealState = 'dealState',
  StructuringManager = 'structuringManager',
}

export enum StructuringFollowUpStatus {
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
}

export type Summary = {
  __typename?: 'Summary';
  points?: Maybe<SummaryPoints>;
  score: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type SummaryPoints = {
  __typename?: 'SummaryPoints';
  equity?: Maybe<Scalars['String']['output']>;
  mileage_overage?: Maybe<Scalars['String']['output']>;
  popularity?: Maybe<Scalars['String']['output']>;
  reliability?: Maybe<Scalars['String']['output']>;
  replacement_cost?: Maybe<Scalars['String']['output']>;
};

export type SupportedLienholderResponse = {
  __typename?: 'SupportedLienholderResponse';
  isSupported: Scalars['Boolean']['output'];
  missingRequiredFields: Array<LienholderRequirement>;
  requiredFields: Array<LienholderRequirement>;
  requirementsMet: Scalars['Boolean']['output'];
};

export type TtConditionFilterInput = {
  buyerIsNotLessee?: InputMaybe<Scalars['Boolean']['input']>;
  canVerifyDigitalSignatures?: InputMaybe<Scalars['Boolean']['input']>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  driversLicenseAddress?: InputMaybe<Scalars['String']['input']>;
  driversLicenseState?: InputMaybe<Scalars['String']['input']>;
  hasCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictionState?: InputMaybe<Scalars['String']['input']>;
  lienholder?: InputMaybe<Scalars['String']['input']>;
  movedStateDuringLease?: InputMaybe<Scalars['Boolean']['input']>;
  newBank?: InputMaybe<TtNewBankEnum>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']['input']>;
  transferringRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleAge?: InputMaybe<Scalars['Int']['input']>;
};

export type TtDocumentConditionsFields = {
  __typename?: 'TTDocumentConditionsFields';
  description?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TtDocumentFields = {
  __typename?: 'TTDocumentFields';
  conditions?: Maybe<Array<Maybe<TtDocumentConditionsFields>>>;
  documentTypeId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  supportsImageExtraction?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<TtDocumentTypeFields>;
  validations?: Maybe<Array<Maybe<TtValidation>>>;
};

export enum TtDocumentName {
  AcuraSpecificOdometerStatement = 'AcuraSpecificOdometerStatement',
  ApplicationForCopyOfRegistration = 'ApplicationForCopyOfRegistration',
  BackOfDriversLicense = 'BackOfDriversLicense',
  BillOfSale = 'BillOfSale',
  CaliforniaSpecialInterestLicensePlateApplication = 'CaliforniaSpecialInterestLicensePlateApplication',
  CobuyerBackOfDriversLicense = 'CobuyerBackOfDriversLicense',
  CobuyerDriversLicense = 'CobuyerDriversLicense',
  CobuyerElectronicRegistrationAndTitleAgreement = 'CobuyerElectronicRegistrationAndTitleAgreement',
  CobuyerJointTenancyWithRightsOfSurvivorship = 'CobuyerJointTenancyWithRightsOfSurvivorship',
  CobuyerOdometerStatement = 'CobuyerOdometerStatement',
  CobuyerPowerOfAttorney = 'CobuyerPowerOfAttorney',
  CobuyerProcessorPowerOfAttorney = 'CobuyerProcessorPowerOfAttorney',
  CobuyerRegistrationSpecificPowerOfAttorney = 'CobuyerRegistrationSpecificPowerOfAttorney',
  CobuyerSecurePowerOfAttorney = 'CobuyerSecurePowerOfAttorney',
  CobuyerStateSpecificOdometerStatement = 'CobuyerStateSpecificOdometerStatement',
  CobuyerStateSpecificPowerOfAttorney = 'CobuyerStateSpecificPowerOfAttorney',
  CobuyerSupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause = 'CobuyerSupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause',
  DriversLicense = 'DriversLicense',
  ElectronicRegistrationAndTitleAgreement = 'ElectronicRegistrationAndTitleAgreement',
  ElectronicSignatureAttestation = 'ElectronicSignatureAttestation',
  ElectronicSignatureCertification = 'ElectronicSignatureCertification',
  Emissions = 'Emissions',
  GmAssignmentOfTitleDamageDisclosure = 'GMAssignmentOfTitleDamageDisclosure',
  GmLeasePacket = 'GMLeasePacket',
  HondaSpecificOdometerStatement = 'HondaSpecificOdometerStatement',
  IdahoSalesTaxExemption = 'IdahoSalesTaxExemption',
  JointOdometerStatement = 'JointOdometerStatement',
  LaSpecificMercedesSpecificFloodDamageDisclosure = 'LASpecificMercedesSpecificFloodDamageDisclosure',
  LeaseEndPayoffAuthorization = 'LeaseEndPayoffAuthorization',
  LexusSpecificPowerOfAttorney = 'LexusSpecificPowerOfAttorney',
  LicensePlate = 'LicensePlate',
  LienholderSpecificBillOfSale = 'LienholderSpecificBillOfSale',
  LienholderSpecificOdometerStatement = 'LienholderSpecificOdometerStatement',
  Odometer = 'Odometer',
  OdometerStatement = 'OdometerStatement',
  OhioSpecificHondaSpecificOdometerStatement = 'OhioSpecificHondaSpecificOdometerStatement',
  OhioSpecificHondaSpecificPowerOfAttorney = 'OhioSpecificHondaSpecificPowerOfAttorney',
  PlateTransferLetter = 'PlateTransferLetter',
  PorscheSpecificOdometerStatement = 'PorscheSpecificOdometerStatement',
  PorscheSpecificPayoffInstructions = 'PorscheSpecificPayoffInstructions',
  PowerOfAttorney = 'PowerOfAttorney',
  ProcessorPowerOfAttorney = 'ProcessorPowerOfAttorney',
  ProofOfInsurance = 'ProofOfInsurance',
  ProofOfResidence = 'ProofOfResidence',
  ProofOfResidence2 = 'ProofOfResidence2',
  PropertyTaxReceipt = 'PropertyTaxReceipt',
  PurchaseOrder = 'PurchaseOrder',
  Registration = 'Registration',
  RegistrationSpecificPowerOfAttorney = 'RegistrationSpecificPowerOfAttorney',
  SafetyInspection = 'SafetyInspection',
  SalesTaxExemption = 'SalesTaxExemption',
  SecurePowerOfAttorney = 'SecurePowerOfAttorney',
  SmogInspection = 'SmogInspection',
  StateSpecificBillOfSale = 'StateSpecificBillOfSale',
  StateSpecificDamageDisclosure = 'StateSpecificDamageDisclosure',
  StateSpecificOdometerStatement = 'StateSpecificOdometerStatement',
  StateSpecificPowerOfAttorney = 'StateSpecificPowerOfAttorney',
  SupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause = 'SupplementalSecureAndVerifiableIdentificationInformationAndAttestationClause',
  TaterDocumentPacket = 'TaterDocumentPacket',
  TeslaSpecificDocumentPacket = 'TeslaSpecificDocumentPacket',
  TitleApp = 'TitleApp',
  ToyotaSpecificPowerOfAttorney = 'ToyotaSpecificPowerOfAttorney',
  UsBankSpecificAlabamaSpecificAirbagDisclosure = 'USBankSpecificAlabamaSpecificAirbagDisclosure',
  UsBankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'USBankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation',
  VinInspection = 'VINInspection',
}

export type TtDocumentTypeFields = {
  __typename?: 'TTDocumentTypeFields';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<Maybe<TtParameterFields>>>;
};

export type TtFeesInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bookValue?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cobuyerAddress?: InputMaybe<Scalars['String']['input']>;
  cobuyerCity?: InputMaybe<Scalars['String']['input']>;
  cobuyerCounty?: InputMaybe<Scalars['String']['input']>;
  cobuyerDob?: InputMaybe<Scalars['String']['input']>;
  cobuyerEmail?: InputMaybe<Scalars['String']['input']>;
  cobuyerFirstName?: InputMaybe<Scalars['String']['input']>;
  cobuyerLastName?: InputMaybe<Scalars['String']['input']>;
  cobuyerMiddleName?: InputMaybe<Scalars['String']['input']>;
  cobuyerPhone?: InputMaybe<Scalars['String']['input']>;
  cobuyerState?: InputMaybe<StateAbbreviation>;
  cobuyerSuffix?: InputMaybe<Scalars['String']['input']>;
  cobuyerZip?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  docFee?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estimatedPayoff?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<TtFuelType>;
  insuranceCompanyName?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyExpirationDate?: InputMaybe<Scalars['String']['input']>;
  insurancePolicyNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  mailingCity?: InputMaybe<Scalars['String']['input']>;
  mailingCounty?: InputMaybe<Scalars['String']['input']>;
  mailingState?: InputMaybe<StateAbbreviation>;
  mailingZipCode?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  newBank?: InputMaybe<Scalars['String']['input']>;
  newBankAddress?: InputMaybe<Scalars['String']['input']>;
  newBankAddress2?: InputMaybe<Scalars['String']['input']>;
  newBankCity?: InputMaybe<Scalars['String']['input']>;
  newBankEltCode?: InputMaybe<Scalars['String']['input']>;
  newBankState?: InputMaybe<StateAbbreviation>;
  newBankZip?: InputMaybe<Scalars['String']['input']>;
  newBankZipPlus4?: InputMaybe<Scalars['String']['input']>;
  odometerReading?: InputMaybe<Scalars['Int']['input']>;
  payoff?: InputMaybe<Scalars['Float']['input']>;
  payoffIncludesSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  payoffWithoutSalesTax?: InputMaybe<Scalars['Float']['input']>;
  previouslyTitledState?: InputMaybe<StateAbbreviation>;
  retailBookValue?: InputMaybe<Scalars['Float']['input']>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  signedDate?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StateAbbreviation>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  titleRegistrationOption?: InputMaybe<Scalars['String']['input']>;
  transferringPlates?: InputMaybe<Scalars['Boolean']['input']>;
  trim?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<TtVehicleType>;
  vin?: InputMaybe<Scalars['String']['input']>;
  warranty?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum TtFuelType {
  Diesel = 'Diesel',
  Electric = 'Electric',
  Gasoline = 'Gasoline',
  Hybrid = 'Hybrid',
  PlugInHybrid = 'PlugInHybrid',
}

export enum TtGetFeesSourceType {
  ComDevTool = 'COM_DEV_TOOL',
  ComEnterPayoff = 'COM_ENTER_PAYOFF',
  ComImportInfo = 'COM_IMPORT_INFO',
  ComPaymentCalculator = 'COM_PAYMENT_CALCULATOR',
  ComPrequalification = 'COM_PREQUALIFICATION',
  ComSoftPull = 'COM_SOFT_PULL',
  D2DGetTaxesAndFees = 'D2D_GET_TAXES_AND_FEES',
  D2DPrequalification = 'D2D_PREQUALIFICATION',
  DdAutoStructure = 'DD_AUTO_STRUCTURE',
  DdCalcFees = 'DD_CALC_FEES',
  DdLendingTree = 'DD_LENDING_TREE',
  DdMoveToStructuring = 'DD_MOVE_TO_STRUCTURING',
  DdPaymentEstimate = 'DD_PAYMENT_ESTIMATE',
  DdPayoffTax = 'DD_PAYOFF_TAX',
  DdPrequalification = 'DD_PREQUALIFICATION',
  MktPaymentCalculator = 'MKT_PAYMENT_CALCULATOR',
  NoneGetTaxesAndFeesInput = 'NONE_GET_TAXES_AND_FEES_INPUT',
  NonePaymentEstimateLogic = 'NONE_PAYMENT_ESTIMATE_LOGIC',
}

export type TtJurisdiction = {
  __typename?: 'TTJurisdiction';
  allowPlateTransfer?: Maybe<Scalars['Boolean']['output']>;
  allowRegistrationTransfer?: Maybe<Scalars['Boolean']['output']>;
  hasRegistrationOnly?: Maybe<Scalars['Boolean']['output']>;
  hasTitleAndRegistration?: Maybe<Scalars['Boolean']['output']>;
  hasTitleOnly?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  products?: Maybe<TtttProductFieldsConnection>;
  registrationProduct?: Maybe<TtProductFields>;
  requireWalkIn?: Maybe<Scalars['Boolean']['output']>;
  supportedProcessors?: Maybe<Array<Maybe<Processor>>>;
  titleProduct?: Maybe<TtProductFields>;
};

export type TtJurisdictionProductsArgs = {
  filter?: InputMaybe<TtProductFilter>;
};

export enum TtNewBankEnum {
  Afcu = 'AFCU',
  AllyFinancial = 'AllyFinancial',
  ArraFinance = 'ArraFinance',
  CapitalOne = 'CapitalOne',
  Chase = 'Chase',
  ConsumerPortfolioServices = 'ConsumerPortfolioServices',
  ExeterFinance = 'ExeterFinance',
  FifthThird = 'FifthThird',
  FirstInterstate = 'FirstInterstate',
  GlobalLendingServices = 'GlobalLendingServices',
  Iccu = 'ICCU',
  InnoFiAutoFinance = 'InnoFiAutoFinance',
  LentegrityAutoFinance = 'LentegrityAutoFinance',
  Lookout = 'Lookout',
  Mechanics = 'Mechanics',
  MountainAmerica = 'MountainAmerica',
  Occu = 'OCCU',
  Pnc = 'PNC',
  PrestigeFinancial = 'PrestigeFinancial',
  Santander = 'Santander',
  SantanderConsumerInc = 'SantanderConsumerInc',
  Td = 'TD',
  Upgrade = 'Upgrade',
  WellsFargo = 'WellsFargo',
  Westlake = 'Westlake',
  Wings = 'Wings',
}

export type TtPageInfo = {
  __typename?: 'TTPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type TtParameterFields = {
  __typename?: 'TTParameterFields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TtProductFields = {
  __typename?: 'TTProductFields';
  documents?: Maybe<TtttDocumentFieldsConnection>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TtProductType>;
  validations?: Maybe<Array<Maybe<TtValidation>>>;
};

export type TtProductFieldsDocumentsArgs = {
  conditions?: InputMaybe<TtConditionFilterInput>;
};

export type TtProductFilter = {
  types?: InputMaybe<Array<InputMaybe<TtProductType>>>;
};

export enum TtProductType {
  Payoff = 'Payoff',
  Registration = 'Registration',
  Title = 'Title',
}

export type TtttDocumentFieldsConnection = {
  __typename?: 'TTTTDocumentFieldsConnection';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<TtDocumentFields>>>;
  pageInfo?: Maybe<TtPageInfo>;
};

export type TtttProductFieldsConnection = {
  __typename?: 'TTTTProductFieldsConnection';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<TtProductFields>>>;
  pageInfo?: Maybe<TtPageInfo>;
};

export type TtValidation = {
  __typename?: 'TTValidation';
  description?: Maybe<Scalars['String']['output']>;
  internalDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum TtValidationName {
  CobuyerOnInsurance = 'CobuyerOnInsurance',
  DigitalSignature = 'DigitalSignature',
  DigitalWetSignature = 'DigitalWetSignature',
  DriversLicenseAddressMatch = 'DriversLicenseAddressMatch',
  DriversLicenseNameMatch = 'DriversLicenseNameMatch',
  DriversLicenseStateMatch = 'DriversLicenseStateMatch',
  InsuranceNameMatch = 'InsuranceNameMatch',
  InsuranceNotExpired = 'InsuranceNotExpired',
  InsuranceStateMatch = 'InsuranceStateMatch',
  InsuranceVinMatch = 'InsuranceVinMatch',
  LiabilityInsuranceRequired = 'LiabilityInsuranceRequired',
  NotarizationRequired = 'NotarizationRequired',
  RegistrationNotExpired = 'RegistrationNotExpired',
  RegistrationNotExpired60Days = 'RegistrationNotExpired60Days',
  RegistrationNotExpired90Days = 'RegistrationNotExpired90Days',
  RegistrationPictureRequired = 'RegistrationPictureRequired',
  VerifiedDigitalSignature = 'VerifiedDigitalSignature',
  WetSignature = 'WetSignature',
}

export enum TtVehicleType {
  ExtendedCabPickup = 'ExtendedCabPickup',
  Motorhome = 'Motorhome',
  MultipurposePassengerVehicle = 'MultipurposePassengerVehicle',
  PassengerCar = 'PassengerCar',
  Pickup = 'Pickup',
  Suv = 'SUV',
  Sedan = 'Sedan',
  Truck = 'Truck',
}

export type Tag = {
  __typename?: 'Tag';
  badge_variant?: Maybe<Scalars['Int']['output']>;
  color: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_dashboard_visible: Scalars['Boolean']['output'];
  slug: TagSlugEnum;
  tagged_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum TagSlugEnum {
  AutomaticAssistant = 'automatic_assistant',
  AutomaticEquity = 'automatic_equity',
  AutomaticPayment = 'automatic_payment',
  Bankruptcy = 'bankruptcy',
  ContractExpired = 'contract_expired',
  CreditFrozen = 'credit_frozen',
  DirectPay = 'direct_pay',
  DoubleTax = 'double_tax',
  DownPaymentCompleted = 'down_payment_completed',
  EmailPreferred = 'email_preferred',
  GaBankFees = 'ga_bank_fees',
  GaDownPayment = 'ga_down_payment',
  GaNetsuite = 'ga_netsuite',
  GaPayoffCheck = 'ga_payoff_check',
  GaReserve = 'ga_reserve',
  GaTitlePayment = 'ga_title_payment',
  HeldAtBank = 'held_at_bank',
  HotLead = 'hot_lead',
  InterviewCompleted = 'interview_completed',
  Itin = 'itin',
  LendingTree = 'lending_tree',
  ManagerReview = 'manager_review',
  MortgageCurrent = 'mortgage_current',
  MortgagePastDue = 'mortgage_past_due',
  NeedPo = 'need_po',
  NeedSsc = 'need_ssc',
  NeedVciDocs = 'need_vci_docs',
  NeedsCobuyer = 'needs_cobuyer',
  NeedsConsent = 'needs_consent',
  NeedsIncome = 'needs_income',
  NeedsMoneyDown = 'needs_money_down',
  NeedsRecontracting = 'needs_recontracting',
  NoRoiNeeded = 'no_roi_needed',
  NoStips = 'no_stips',
  OrderVerified = 'order_verified',
  PaymentCalculatorLead = 'payment_calculator_lead',
  PayoffFailed = 'payoff_failed',
  PayoffVerified = 'payoff_verified',
  PicturesCompleted = 'pictures_completed',
  PoCollected = 'po_collected',
  PoeCompleted = 'poe_completed',
  PoiCollected = 'poi_collected',
  PorCollected = 'por_collected',
  PromoJuly2024 = 'promo_july2024',
  ProofOfEmployment = 'proof_of_employment',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidency = 'proof_of_residency',
  RateReductionOffer = 'rate_reduction_offer',
  Recontracted = 'recontracted',
  ReferencesNeeded = 'references_needed',
  Refi = 'refi',
  ReleaseOfInterest = 'release_of_interest',
  Repo = 'repo',
  RoiSent = 'roi_sent',
  RoiSigned = 'roi_signed',
  SentToBank = 'sent_to_bank',
  SpanishSpeaker = 'spanish_speaker',
  StructureUpdated = 'structure_updated',
  StructureViolation = 'structure_violation',
  StructuringPayoff = 'structuring_payoff',
  TextPreferred = 'text_preferred',
  TwoCarDriver = 'two_car_driver',
  Unwind = 'unwind',
  VerifyingInfo = 'verifying_info',
  Vip = 'vip',
  VscGapContracts = 'vsc_gap_contracts',
  WaitingForApproval = 'waiting_for_approval',
  WaitingForDownPayment = 'waiting_for_down_payment',
  WaitingForInsurance = 'waiting_for_insurance',
  WaitingForInterview = 'waiting_for_interview',
  WaitingForLicense = 'waiting_for_license',
  WaitingForPayoff = 'waiting_for_payoff',
  WaitingForPics = 'waiting_for_pics',
  WaitingForSmog = 'waiting_for_smog',
  WaitingForTitle = 'waiting_for_title',
  WaitingForVinInspection = 'waiting_for_vin_inspection',
  WaitingForWetSigs = 'waiting_for_wet_sigs',
  WalkIn = 'walk_in',
  WantsToSell = 'wants_to_sell',
  ZeroBalanceAuto = 'zero_balance_auto',
  ZeroStipCompleted = 'zero_stip_completed',
}

export type TagsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagsPayload = {
  __typename?: 'TagsPayload';
  dealId: Scalars['ID']['output'];
  tags: Array<Tag>;
};

export type ThirdPartyPayoffSend = {
  __typename?: 'ThirdPartyPayoffSend';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  status: ThirdPartyPayoffSendStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum ThirdPartyPayoffSendStatus {
  Sending = 'SENDING',
  SendFailed = 'SEND_FAILED',
  Sent = 'SENT',
}

export type ThunderCallNotification = {
  __typename?: 'ThunderCallNotification';
  ai_call_opener?: Maybe<Scalars['String']['output']>;
  attempt_num: Scalars['Int']['output'];
  campaign_id?: Maybe<Scalars['String']['output']>;
  conversation_history: Scalars['JSON']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_phone_number: Scalars['String']['output'];
  deal_id?: Maybe<Scalars['Int']['output']>;
  first_name: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  last_name: Scalars['String']['output'];
  lead_id?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_rep_id?: Maybe<Scalars['String']['output']>;
  outcome_timestamp?: Maybe<Scalars['DateTime']['output']>;
  scheduled_call_time?: Maybe<Scalars['String']['output']>;
  thunder_phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ThunderConversationHistory = {
  __typename?: 'ThunderConversationHistory';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  messages: Array<Maybe<ThunderConversationMessage>>;
};

export type ThunderConversationMessage = {
  __typename?: 'ThunderConversationMessage';
  direction: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TieDown = {
  __typename?: 'TieDown';
  /** Snapshot of the deal's bank at submit. */
  bank?: Maybe<Scalars['String']['output']>;
  /** Whether the requesting user may decide (approve/counter/decline/undo) this tie down: a lead of the deal's pod, Review:Tie Downs, or super user. */
  can_review: Scalars['Boolean']['output'];
  /** The pod lead's offered values; populated only while status is countered. */
  countered_values?: Maybe<Array<TieDownCounteredValue>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<TieDownItem>>;
  note?: Maybe<Scalars['String']['output']>;
  products: Array<ProductSlug>;
  ready_to_sign_today: Scalars['Boolean']['output'];
  review_note?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewed_by?: Maybe<User>;
  reviewed_by_user_id?: Maybe<Scalars['String']['output']>;
  status: TieDownStatus;
  submitted_at: Scalars['DateTime']['output'];
  submitted_by?: Maybe<User>;
  submitted_by_user_id: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TieDownCounteredValue = {
  __typename?: 'TieDownCounteredValue';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  item_type: TieDownItemType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** The value the pod lead can get for this target. */
  value: Scalars['Float']['output'];
};

export type TieDownCounteredValueInput = {
  item_type: TieDownItemType;
  value: Scalars['Float']['input'];
};

export type TieDownItem = {
  __typename?: 'TieDownItem';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** The rep's hot button: the target the customer cannot move forward without. */
  is_mandatory: Scalars['Boolean']['output'];
  item_type: TieDownItemType;
  mode: TieDownItemMode;
  snapshot_value?: Maybe<Scalars['Float']['output']>;
  target_value: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TieDownItemInput = {
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  item_type: TieDownItemType;
  mode: TieDownItemMode;
  target_value: Scalars['Float']['input'];
};

export enum TieDownItemMode {
  Exact = 'exact',
  UpTo = 'up_to',
}

export enum TieDownItemType {
  MoneyDown = 'money_down',
  MonthlyPayment = 'monthly_payment',
  Rate = 'rate',
  Term = 'term',
}

export enum TieDownStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Countered = 'countered',
  Declined = 'declined',
  Pending = 'pending',
}

export type Time = {
  __typename?: 'Time';
  days?: Maybe<Scalars['Float']['output']>;
  score: Scalars['Boolean']['output'];
};

export enum TitleRegistrationOption {
  TitleAndNewRegistration = 'title_and_new_registration',
  TitleAndRegistrationTransfer = 'title_and_registration_transfer',
  TitleOnly = 'title_only',
}

export type TitlingAddress = {
  __typename?: 'TitlingAddress';
  id: Scalars['ID']['output'];
  movedStates: Scalars['Boolean']['output'];
};

export type TitlingFinancialInfo = {
  __typename?: 'TitlingFinancialInfo';
  buyerNotLessee: Scalars['Boolean']['output'];
  dealId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  needTemporaryRegistrationTags: Scalars['Boolean']['output'];
  plateTransfer: Scalars['Boolean']['output'];
  titleRegistrationOption: TitleRegistrationOption;
};

export type TitlingInput = {
  buyerNotLessee: Scalars['Boolean']['input'];
  dealId: Scalars['ID']['input'];
  movedStates: Scalars['Boolean']['input'];
  needTemporaryRegistrationTags: Scalars['Boolean']['input'];
  originalLesseeDeceased: Scalars['Boolean']['input'];
  plateTransfer: Scalars['Boolean']['input'];
  titleRegistrationOption: TitleRegistrationOption;
};

export type TitlingOptionsResult = {
  __typename?: 'TitlingOptionsResult';
  address: TitlingAddress;
  financialInfo: TitlingFinancialInfo;
  paymentOptions: PaymentOptionsV2;
};

export type UpdateCreditAppOnDealResponse = {
  __typename?: 'UpdateCreditAppOnDealResponse';
  cobuyer?: Maybe<Customer>;
  contact?: Maybe<DealContact>;
  customer: Customer;
  financial_info: FinancialInfo;
  id: Scalars['Int']['output'];
  odometer_status?: Maybe<OdometerStatus>;
  original_lessee?: Maybe<OriginalLessee>;
  second_contact?: Maybe<DealContact>;
  state: Scalars['String']['output'];
};

export type UpdateDealPackageConfigSlotInput = {
  dealId: Scalars['Int']['input'];
  selectedProductSlugs: Array<ProductSlug>;
  slotIndex: Scalars['Int']['input'];
};

export type UpdateDealPackageConfigSlotPayload = {
  __typename?: 'UpdateDealPackageConfigSlotPayload';
  financialInfo: FinancialInfo;
  paymentOption: PaymentOptionsPackageV2;
};

export type UpdateDealProductRatesInput = {
  dealId: Scalars['Int']['input'];
  products: Array<DealProductRateInput>;
};

export type UpdateDealProductsInputV2 = {
  dealId: Scalars['Int']['input'];
  packageConfigs?: InputMaybe<Array<DealPackageConfigInput>>;
  products: Array<DealProductInputV2>;
  selectedPackageSlotIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNoteTextInput = {
  text: Scalars['String']['input'];
};

export type UpdateUserInput = {
  auth0Roles: Array<InputMaybe<Auth0RoleInput>>;
  email: Scalars['String']['input'];
  huntGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['String']['input'];
  location?: InputMaybe<LocationType>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  podIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  recruiterId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPreferencesInput = {
  alerts?: InputMaybe<AlertPreferencesInput>;
  allDealsTable?: InputMaybe<AllDealsTablePreferencesInput>;
};

export type UploadDocumentsInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UploadDocumentsToCudlResult = {
  __typename?: 'UploadDocumentsToCUDLResult';
  errors: Array<Scalars['String']['output']>;
  uploadedDocuments: Array<Scalars['String']['output']>;
};

export type UpsertDealPackageConfigsInput = {
  configs: Array<DealPackageConfigInput>;
  dealId: Scalars['Int']['input'];
};

export type UserCreationData = {
  __typename?: 'UserCreationData';
  huntGroups?: Maybe<Array<HuntGroup>>;
  pods?: Maybe<Array<Pod>>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  alerts: AlertPreferences;
  allDealsTable: AllDealsTablePreferences;
  id: Scalars['ID']['output'];
};

export type UserRoles = {
  __typename?: 'UserRoles';
  roles?: Maybe<Array<Maybe<Auth0Role>>>;
};

export enum UserType {
  Ai = 'ai',
  Human = 'human',
}

export type VscLimits = {
  __typename?: 'VSCLimits';
  max_vsc_amount?: Maybe<Scalars['Float']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ValidateReferrer = {
  __typename?: 'ValidateReferrer';
  data?: Maybe<ReferrerDataGraphQlType>;
  valid: Scalars['Boolean']['output'];
};

export type VehicleMileageGql = {
  __typename?: 'VehicleMileageGQL';
  estimatedAverageMiles?: Maybe<Scalars['Float']['output']>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  lastOdometer?: Maybe<Scalars['Int']['output']>;
  lastOdometerDate?: Maybe<Scalars['String']['output']>;
  resultCode?: Maybe<Scalars['Int']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  rollback?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
};

export type VehicleUseRequirements = {
  __typename?: 'VehicleUseRequirements';
  commercial_use_allowed?: Maybe<Scalars['Boolean']['output']>;
  personal_use_only?: Maybe<Scalars['Boolean']['output']>;
  source_text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  use_restrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VerifyFinixInstrumentGraphQlType = {
  __typename?: 'VerifyFinixInstrumentGraphQLType';
  id?: Maybe<Scalars['String']['output']>;
};

export enum AccidentsEnumType {
  NoAccidents = 'no_accidents',
  OneAccident = 'one_accident',
  TwoOrMoreAccidents = 'two_or_more_accidents',
}

export type AcquisitionOffer = {
  __typename?: 'acquisitionOffer';
  appraisedValue?: Maybe<Scalars['Float']['output']>;
  estimatedFees?: Maybe<Scalars['Float']['output']>;
  offer?: Maybe<Scalars['Float']['output']>;
};

export enum ActorType {
  Applicant = 'Applicant',
  Buyer = 'Buyer',
  CoApplicant = 'CoApplicant',
  CoBuyer = 'CoBuyer',
  Customer = 'Customer',
  Dealer = 'Dealer',
  Guarantor = 'Guarantor',
  Sales = 'Sales',
}

export type AddDocumentsToMediaCenterInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'address';
  address_line?: Maybe<Scalars['String']['output']>;
  address_line_2?: Maybe<Scalars['String']['output']>;
  address_type?: Maybe<AddressTypeEnum>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  months_at_home?: Maybe<Scalars['Int']['output']>;
  moved_states?: Maybe<Scalars['Boolean']['output']>;
  /** Housing status. Expected canonical values: own, buying, family, rent. Legacy variants may exist. */
  residence_type?: Maybe<Scalars['String']['output']>;
  /** Two-letter state or province abbreviation (for example: UT, AB). */
  state?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  years_at_home?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<AddressTypeEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  monthly_payment?: InputMaybe<Scalars['Float']['input']>;
  months_at_home?: InputMaybe<Scalars['Int']['input']>;
  moved_states?: InputMaybe<Scalars['Boolean']['input']>;
  /** Housing status. Expected canonical values: own, buying, family, rent. Legacy variants may exist. */
  residence_type?: InputMaybe<Scalars['String']['input']>;
  /** Two-letter state or province abbreviation (for example: UT, AB). */
  state?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  years_at_home?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Affiliate = {
  __typename?: 'affiliate';
  affiliate_provider?: Maybe<Affiliate_Provider>;
  affiliate_provider_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  decision_accepted?: Maybe<Scalars['Boolean']['output']>;
  decision_response?: Maybe<Lending_Tree_Decision_Response>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lead_request?: Maybe<Scalars['JSONObject']['output']>;
  ssn_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum AffiliateProviderSlug {
  LendingTree = 'lending_tree',
}

export type Affiliate_Provider = {
  __typename?: 'affiliate_provider';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<AffiliateProviderSlug>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Article = {
  __typename?: 'article';
  com_visible?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnail_key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleImageUploadUrl = {
  __typename?: 'articleImageUploadUrl';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleInput = {
  com_visible?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  thumbnail_key?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Auction = {
  __typename?: 'auction';
  address_line?: Maybe<Scalars['String']['output']>;
  average_transport_cost?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AuctionDistances = {
  __typename?: 'auctionDistances';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  transport_cost?: Maybe<Scalars['Int']['output']>;
};

export type AuctionDistancesInput = {
  auctions?: InputMaybe<Array<InputMaybe<Destinations>>>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerState?: InputMaybe<Scalars['String']['input']>;
};

export type AuctionInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  average_transport_cost?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum AutoImportVariation {
  DisplayCustomizePackage = 'displayCustomizePackage',
  ImmediateImport = 'immediateImport',
}

export type Bank = {
  __typename?: 'bank';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  auto_structure_buyout?: Maybe<Scalars['Boolean']['output']>;
  auto_structure_refi?: Maybe<Scalars['Boolean']['output']>;
  bank_markups?: Maybe<Array<Maybe<BankMarkup>>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_decision_valid_days?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  /** Canonical lender name stored in LeaseEnd. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<LendingNetwork>;
  provider_lender_id?: Maybe<Scalars['String']['output']>;
  signing_solution?: Maybe<SigningSolutionEnum>;
  slug?: Maybe<TtNewBankEnum>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  use_in_states?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type BankInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  auto_structure_buyout?: InputMaybe<Scalars['Boolean']['input']>;
  auto_structure_refi?: InputMaybe<Scalars['Boolean']['input']>;
  bank_markups?: InputMaybe<Array<InputMaybe<BankMarkupInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  /** Canonical lender name stored in LeaseEnd. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<LendingNetwork>;
  provider_lender_id?: InputMaybe<Scalars['String']['input']>;
  signing_solution?: InputMaybe<SigningSolutionEnum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  use_in_states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type BankMarkup = {
  __typename?: 'bankMarkup';
  bank_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  max_markup?: Maybe<Scalars['Float']['output']>;
  term_max?: Maybe<Scalars['Int']['output']>;
  term_min?: Maybe<Scalars['Int']['output']>;
};

export type BankMarkupInput = {
  bank_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  max_markup?: InputMaybe<Scalars['Float']['input']>;
  term_max?: InputMaybe<Scalars['Int']['input']>;
  term_min?: InputMaybe<Scalars['Int']['input']>;
};

export type BasePod = {
  __typename?: 'basePod';
  active_reps_override?: Maybe<Scalars['Int']['output']>;
  active_reps_override_set_at?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assign_overnight_deals?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_deals?: Maybe<Scalars['Boolean']['output']>;
  closer_commission_rate?: Maybe<Scalars['Float']['output']>;
  closer_commission_type?: Maybe<CommissionType>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manager_commission_rate?: Maybe<Scalars['Float']['output']>;
  manager_commission_type?: Maybe<CommissionType>;
  name?: Maybe<Scalars['String']['output']>;
  parent_pod_id?: Maybe<Scalars['ID']['output']>;
  pause_auto_assign?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  problem_solver?: Maybe<Scalars['Boolean']['output']>;
  setter_commission_rate?: Maybe<Scalars['Float']['output']>;
  setter_commission_type?: Maybe<CommissionType>;
  special_commission_rate?: Maybe<Scalars['Float']['output']>;
  special_commission_type?: Maybe<CommissionType>;
  team_type?: Maybe<TeamType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  us_states_object?: Maybe<UsStatesObject>;
};

export type BasePodInput = {
  active_reps_override?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assign_overnight_deals?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']['input']>;
  closer_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  closer_commission_type?: InputMaybe<CommissionType>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manager_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  manager_commission_type?: InputMaybe<CommissionType>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_pod_id?: InputMaybe<Scalars['ID']['input']>;
  pause_auto_assign?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  problem_solver?: InputMaybe<Scalars['Boolean']['input']>;
  setter_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  setter_commission_type?: InputMaybe<CommissionType>;
  special_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  special_commission_type?: InputMaybe<CommissionType>;
  team_type?: InputMaybe<TeamType>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  us_states_object?: InputMaybe<UsStatesInputObject>;
};

export type BaseUser = {
  __typename?: 'baseUser';
  assignment_mode?: Maybe<AssignmentMode>;
  auto_assign_deals?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']['output']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']['output']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frequency_minutes?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  on_vacation?: Maybe<Scalars['Boolean']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  recruiter_id?: Maybe<Scalars['String']['output']>;
  twilio_number?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<UserType>;
};

export type BaseUserInput = {
  assignment_mode?: InputMaybe<AssignmentMode>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_marketplace_deals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: InputMaybe<Scalars['String']['input']>;
  can_claim_as_closer?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  frequency_minutes?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationType>;
  max_auto_assign_deals?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  on_vacation?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  recruiter_id?: InputMaybe<Scalars['String']['input']>;
  twilio_number?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<UserType>;
};

export type BootReasonInput = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Call = {
  __typename?: 'call';
  answered_by?: Maybe<Scalars['String']['output']>;
  answered_by_user_id?: Maybe<Scalars['ID']['output']>;
  callDuration?: Maybe<Scalars['String']['output']>;
  callStatus?: Maybe<Scalars['String']['output']>;
  calledCity?: Maybe<Scalars['String']['output']>;
  calledNumber?: Maybe<Scalars['String']['output']>;
  calledState?: Maybe<Scalars['String']['output']>;
  callerName?: Maybe<Scalars['String']['output']>;
  caller_city?: Maybe<Scalars['String']['output']>;
  caller_state?: Maybe<Scalars['String']['output']>;
  conferenceId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  flow?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isNewCustomer?: Maybe<Scalars['Boolean']['output']>;
  last_transfer_at?: Maybe<Scalars['DateTime']['output']>;
  new_customer_call_outcome?: Maybe<Scalars['String']['output']>;
  new_customer_call_outcome_description?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  pod_id?: Maybe<Scalars['ID']['output']>;
  recordingSid?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  selection?: Maybe<Scalars['String']['output']>;
  selection_message?: Maybe<Scalars['String']['output']>;
  transfer_count?: Maybe<Scalars['Int']['output']>;
  twilioNumber?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
  voicemail_recording_url?: Maybe<Scalars['String']['output']>;
};

export type Car = {
  __typename?: 'car';
  book_value?: Maybe<Scalars['Float']['output']>;
  /** Vehicle exterior color. By and large, this value is expected to be title-cased (for example: Black, Gray, White). Common canonical colors include Beige, Black, Blue, Brown, Gold, Gray, Green, Orange, Purple, Red, Silver, White, and Yellow. Legacy records may contain lowercase, nonstandard, or blank values. */
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jdp_adjusted_clean_retail?: Maybe<Scalars['Float']['output']>;
  jdp_adjusted_clean_trade?: Maybe<Scalars['Float']['output']>;
  jdp_mileage_adjustment?: Maybe<Scalars['Float']['output']>;
  jdp_trim_body?: Maybe<Scalars['String']['output']>;
  jdp_valuation_date?: Maybe<Scalars['Date']['output']>;
  jdp_vehicle_accessories_object?: Maybe<JdpVehicleAccessoriesObject>;
  kbb_lending_mileage_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_lending_option_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_retail_mileage_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_retail_option_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_selected_options_object?: Maybe<KbbSelectedOptionsObject>;
  kbb_trim_name?: Maybe<Scalars['String']['output']>;
  kbb_valuation_date?: Maybe<Scalars['String']['output']>;
  kbb_vehicle_id?: Maybe<Scalars['Int']['output']>;
  kbb_vehicle_name?: Maybe<Scalars['String']['output']>;
  license_plate_number?: Maybe<Scalars['String']['output']>;
  license_plate_state?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  mileage_unit?: Maybe<MileageUnit>;
  mmr?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  odometer_status?: Maybe<OdometerStatus>;
  payoff?: Maybe<Payoff>;
  registration_expiration?: Maybe<Scalars['DateTime']['output']>;
  retail_book_value?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Vehicle type classification used by lease/buyout workflows. Expected values: MULTIPURPOSE PASSENGER VEHICLE (MPV), TRUCK, PASSENGER CAR. */
  vehicle_type?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type CarDistinctMake = {
  __typename?: 'carDistinctMake';
  make?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type CarDistinctModel = {
  __typename?: 'carDistinctModel';
  model?: Maybe<Scalars['String']['output']>;
};

export type CarInput = {
  book_value?: InputMaybe<Scalars['Float']['input']>;
  /** Vehicle exterior color. By and large, this value is expected to be title-cased (for example: Black, Gray, White). Common canonical colors include Beige, Black, Blue, Brown, Gold, Gray, Green, Orange, Purple, Red, Silver, White, and Yellow. Legacy records may contain lowercase, nonstandard, or blank values. */
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jdp_adjusted_clean_retail?: InputMaybe<Scalars['Float']['input']>;
  jdp_adjusted_clean_trade?: InputMaybe<Scalars['Float']['input']>;
  jdp_mileage_adjustment?: InputMaybe<Scalars['Float']['input']>;
  jdp_trim_body?: InputMaybe<Scalars['String']['input']>;
  jdp_valuation_date?: InputMaybe<Scalars['Date']['input']>;
  jdp_vehicle_accessories_object?: InputMaybe<JdpVehicleAccessoriesObjectInput>;
  kbb_lending_mileage_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_lending_option_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_retail_mileage_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_retail_option_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_selected_options_object?: InputMaybe<KbbSelectedOptionsObjectInput>;
  kbb_trim_name?: InputMaybe<Scalars['String']['input']>;
  kbb_valuation_date?: InputMaybe<Scalars['String']['input']>;
  kbb_vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  kbb_vehicle_name?: InputMaybe<Scalars['String']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  mileage_unit?: InputMaybe<MileageUnit>;
  mmr?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  odometer_status?: InputMaybe<OdometerStatus>;
  payoff?: InputMaybe<PayoffInput>;
  registration_expiration?: InputMaybe<Scalars['DateTime']['input']>;
  retail_book_value?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Vehicle type classification used by lease/buyout workflows. Expected values: MULTIPURPOSE PASSENGER VEHICLE (MPV), TRUCK, PASSENGER CAR. */
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CarWarranty = {
  __typename?: 'carWarranty';
  full_miles?: Maybe<Scalars['Int']['output']>;
  full_status?: Maybe<Scalars['String']['output']>;
  full_years?: Maybe<Scalars['Int']['output']>;
  power_train_miles?: Maybe<Scalars['Int']['output']>;
  power_train_status?: Maybe<Scalars['String']['output']>;
  power_train_years?: Maybe<Scalars['Int']['output']>;
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  HsaFsa = 'HSA_FSA',
  NonReloadablePrepaid = 'NON_RELOADABLE_PREPAID',
  ReloadablePrepaid = 'RELOADABLE_PREPAID',
  Unknown = 'UNKNOWN',
}

export enum CommissionType {
  Flat = 'flat',
  Percentage = 'percentage',
}

export type ConditionRejection = {
  __typename?: 'conditionRejection';
  conditionRejectionText?: Maybe<Scalars['String']['output']>;
};

export type ConditionReport = {
  __typename?: 'conditionReport';
  accidents?: Maybe<AccidentsEnumType>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  exterior?: Maybe<Array<Maybe<ExteriorEnumType>>>;
  id?: Maybe<Scalars['ID']['output']>;
  interior?: Maybe<Array<Maybe<InteriorEnumType>>>;
  lights_on_dash?: Maybe<Scalars['Boolean']['output']>;
  overall_condition?: Maybe<OverallConditionEnumType>;
  score?: Maybe<Scalars['Float']['output']>;
  smoked_in?: Maybe<Scalars['Boolean']['output']>;
  tires?: Maybe<TiresEnumType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ConditionReportInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']['input']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  score?: InputMaybe<Scalars['Float']['input']>;
  smoked_in?: InputMaybe<Scalars['Boolean']['input']>;
  tires?: InputMaybe<TiresEnumType>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConditionReportUpsert = {
  __typename?: 'conditionReportUpsert';
  accidents?: Maybe<AccidentsEnumType>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  exterior?: Maybe<Array<Maybe<ExteriorEnumType>>>;
  id?: Maybe<Scalars['ID']['output']>;
  interior?: Maybe<Array<Maybe<InteriorEnumType>>>;
  lights_on_dash?: Maybe<Scalars['Boolean']['output']>;
  overall_condition?: Maybe<OverallConditionEnumType>;
  smoked_in?: Maybe<Scalars['Boolean']['output']>;
  tires?: Maybe<TiresEnumType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ConditionReportUpsertInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']['input']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  smoked_in?: InputMaybe<Scalars['Boolean']['input']>;
  tires?: InputMaybe<TiresEnumType>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type Conference = {
  __typename?: 'conference';
  agent_number?: Maybe<Scalars['String']['output']>;
  agent_user_id?: Maybe<Scalars['String']['output']>;
  conference_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['Int']['output']>;
  deal_state?: Maybe<Scalars['String']['output']>;
  deal_type?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  hunt_group_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_outbound?: Maybe<Scalars['Boolean']['output']>;
  is_thunder?: Maybe<Scalars['Boolean']['output']>;
  next_participant?: Maybe<Scalars['String']['output']>;
  participants_count?: Maybe<Scalars['Int']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  transferred_from?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Consent = {
  __typename?: 'consent';
  affiliate_id?: Maybe<Scalars['Int']['output']>;
  consent_agreement_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ConsentNameEnumType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type ConsentAgreement = {
  __typename?: 'consentAgreement';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ConsentAgreementTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export enum ConsentAgreementTypeEnum {
  AchPayment = 'ach_payment',
  CaliforniaDataSharingConsent = 'california_data_sharing_consent',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  HardPull = 'hard_pull',
  MarketplaceAcceptance = 'marketplace_acceptance',
  MarketplaceListing = 'marketplace_listing',
  MarketplaceSmsTextProgram = 'marketplace_sms_text_program',
  Methodfi = 'methodfi',
  SecureLinkBuyerSsn = 'secure_link_buyer_ssn',
  SoftPull = 'soft_pull',
  TermsAndConditions = 'terms_and_conditions',
}

export enum ConsentNameEnumType {
  AchPayment = 'ach_payment',
  CaliforniaDataSharingConsent = 'california_data_sharing_consent',
  CreditScoreHardPull = 'credit_score_hard_pull',
  CreditScoreSoftPull = 'credit_score_soft_pull',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  HistoricalCreditScoreHardPull = 'historical_credit_score_hard_pull',
  MarketplaceAcceptance = 'marketplace_acceptance',
  MarketplaceListing = 'marketplace_listing',
  MarketplaceSmsTextProgram = 'marketplace_sms_text_program',
  Methodfi = 'methodfi',
  SecureLinkBuyerSsn = 'secure_link_buyer_ssn',
  TermsAndConditions = 'terms_and_conditions',
}

export enum ContactType {
  Email = 'email',
  Text = 'text',
}

export type ContractTerm = {
  __typename?: 'contractTerm';
  financedTermQuantity?: Maybe<Scalars['Int']['output']>;
  totalDownPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type Contracts = {
  __typename?: 'contracts';
  files?: Maybe<Array<Maybe<File>>>;
};

export type ContractsInput = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateEmbeddedInsuranceLeadAndGetLinkGraphQlType = {
  __typename?: 'createEmbeddedInsuranceLeadAndGetLinkGraphQLType';
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateNewEstimateFromFiles = {
  __typename?: 'createNewEstimateFromFiles';
  deal?: Maybe<Deal>;
  uploadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreditApplication = {
  __typename?: 'creditApplication';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_application_data?: Maybe<CreditApplicationData>;
  credit_decisions?: Maybe<Array<Maybe<CreditDecision>>>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<LendingNetwork>;
  /** Provider grouping identifier for related decisions (RouteOne conversation ID or CUDL application ID). */
  provider_decision_group_id?: Maybe<Scalars['String']['output']>;
  r1_credit_app_guid?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CreditApplicationAddress = {
  __typename?: 'creditApplicationAddress';
  address_line?: Maybe<Scalars['String']['output']>;
  address_line_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  monthly_payment?: Maybe<Scalars['Float']['output']>;
  months_at_home?: Maybe<Scalars['Int']['output']>;
  residence_type?: Maybe<ResidenceTypeEnum>;
  state?: Maybe<Scalars['String']['output']>;
  years_at_home?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CreditApplicationAddressInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  monthly_payment?: InputMaybe<Scalars['Float']['input']>;
  months_at_home?: InputMaybe<Scalars['Int']['input']>;
  residence_type?: InputMaybe<ResidenceTypeEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  years_at_home?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreditApplicationBuyer = {
  __typename?: 'creditApplicationBuyer';
  address?: Maybe<CreditApplicationAddress>;
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<CreditApplicationEmployment>;
  first_name?: Maybe<Scalars['String']['output']>;
  home_phone_number?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  mailing_address?: Maybe<CreditApplicationAddress>;
  marital_status?: Maybe<MaritalStatusEnum>;
  middle_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  prev_address?: Maybe<CreditApplicationAddress>;
  prev_employment?: Maybe<CreditApplicationEmployment>;
  ssn_id?: Maybe<Scalars['ID']['output']>;
};

export type CreditApplicationBuyerInput = {
  address?: InputMaybe<CreditApplicationAddressInput>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<CreditApplicationEmploymentInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  home_phone_number?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  mailing_address?: InputMaybe<CreditApplicationAddressInput>;
  marital_status?: InputMaybe<MaritalStatusEnum>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  prev_address?: InputMaybe<CreditApplicationAddressInput>;
  prev_employment?: InputMaybe<CreditApplicationEmploymentInput>;
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreditApplicationCar = {
  __typename?: 'creditApplicationCar';
  book_value?: Maybe<Scalars['Float']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  kbb_trim_name?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  retail_book_value?: Maybe<Scalars['Float']['output']>;
  valuation_source?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type CreditApplicationCarInput = {
  book_value?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  kbb_trim_name?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  retail_book_value?: InputMaybe<Scalars['Float']['input']>;
  valuation_source?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CreditApplicationCreateInput = {
  credit_application_data: CreditApplicationDataInput;
  deal_id: Scalars['ID']['input'];
};

export type CreditApplicationData = {
  __typename?: 'creditApplicationData';
  car?: Maybe<CreditApplicationCar>;
  cobuyer?: Maybe<CreditApplicationBuyer>;
  customer?: Maybe<CreditApplicationBuyer>;
  finance?: Maybe<CreditApplicationFinance>;
  relationshipToBuyer?: Maybe<RelationToBuyerEnum>;
};

export type CreditApplicationDataInput = {
  car?: InputMaybe<CreditApplicationCarInput>;
  cobuyer?: InputMaybe<CreditApplicationBuyerInput>;
  customer?: InputMaybe<CreditApplicationBuyerInput>;
  finance?: InputMaybe<CreditApplicationFinanceInput>;
  relationshipToBuyer?: InputMaybe<RelationToBuyerEnum>;
};

export type CreditApplicationEmployment = {
  __typename?: 'creditApplicationEmployment';
  gross_income?: Maybe<Scalars['Float']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  months_at_job?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pay_frequency?: Maybe<IncomeIntervalEnum>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmploymentStatusEnum>;
  years_at_job?: Maybe<Scalars['Int']['output']>;
};

export type CreditApplicationEmploymentInput = {
  gross_income?: InputMaybe<Scalars['Float']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  months_at_job?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pay_frequency?: InputMaybe<IncomeIntervalEnum>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  years_at_job?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditApplicationFinance = {
  __typename?: 'creditApplicationFinance';
  amount_financed?: Maybe<Scalars['Float']['output']>;
  base_tax_amount?: Maybe<Scalars['Float']['output']>;
  buyer_not_lessee?: Maybe<Scalars['Boolean']['output']>;
  days_to_payment?: Maybe<Scalars['Int']['output']>;
  doc_fee?: Maybe<Scalars['Float']['output']>;
  gap_price?: Maybe<Scalars['Float']['output']>;
  money_down?: Maybe<Scalars['Float']['output']>;
  new_registration_fee?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Scalars['Float']['output']>;
  payoff?: Maybe<Scalars['Float']['output']>;
  registration_transfer_fee?: Maybe<Scalars['Float']['output']>;
  sell_rate?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  title_fee?: Maybe<Scalars['Float']['output']>;
  vsc_price?: Maybe<Scalars['Float']['output']>;
  vsc_term?: Maybe<Scalars['String']['output']>;
  warranty_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type CreditApplicationFinanceInput = {
  amount_financed?: InputMaybe<Scalars['Float']['input']>;
  base_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']['input']>;
  days_to_payment?: InputMaybe<Scalars['Int']['input']>;
  doc_fee?: InputMaybe<Scalars['Float']['input']>;
  gap_price?: InputMaybe<Scalars['Float']['input']>;
  money_down?: InputMaybe<Scalars['Float']['input']>;
  new_registration_fee?: InputMaybe<Scalars['Float']['input']>;
  payment?: InputMaybe<Scalars['Float']['input']>;
  payoff?: InputMaybe<Scalars['Float']['input']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']['input']>;
  sell_rate?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  title_fee?: InputMaybe<Scalars['Float']['input']>;
  vsc_price?: InputMaybe<Scalars['Float']['input']>;
  vsc_term?: InputMaybe<Scalars['String']['input']>;
  warranty_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreditApplicationUpdateInput = {
  credit_application_data: CreditApplicationDataInput;
  id: Scalars['ID']['input'];
};

export type CreditDecision = {
  __typename?: 'creditDecision';
  annual_percentage_rate?: Maybe<Scalars['Float']['output']>;
  /** Provider decision status code. Expected values: A (Accepted), D (Denied), O (Conditioned), C (Counteroffer), P (Pending Structure), R (Preliminary), I (Withdrawn), B (Booked), N (New), S (Submitted), OT (Funding). */
  application_status?: Maybe<CreditDecisionStatusEnum>;
  balance_amount?: Maybe<Scalars['Float']['output']>;
  bank?: Maybe<Bank>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lender_fees?: Maybe<Scalars['Float']['output']>;
  lender_structured_requirement?: Maybe<LenderStructuredRequirement>;
  max_markup?: Maybe<Scalars['Float']['output']>;
  profit?: Maybe<Scalars['Float']['output']>;
  /** Raw provider-specific decision payload. Shape depends on provider (RouteOne or CUDL). */
  provider_decision_data?: Maybe<ProviderDecisionData>;
  /** Provider grouping identifier shared by related credit decisions (RouteOne conversation ID or CUDL application ID). */
  provider_decision_group_id?: Maybe<Scalars['String']['output']>;
  /** Provider decision identifier (RouteOne application number or CUDL decision ID). */
  provider_decision_id?: Maybe<Scalars['String']['output']>;
  /** Provider lender identifier (RouteOne FSID or CUDL lender ID). */
  provider_lender_id?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum CreditDecisionStatusEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  I = 'I',
  N = 'N',
  O = 'O',
  Ot = 'OT',
  P = 'P',
  R = 'R',
  S = 'S',
}

export enum CreditScore {
  BelowAverage = 'BelowAverage',
  Fair = 'Fair',
  Good = 'Good',
  Great = 'Great',
}

export enum CreditScoreTierEnumType {
  Fair = 'fair',
  Good = 'good',
  NoResponse = 'no_response',
  Poor = 'poor',
  VeryGood = 'very_good',
}

export type Customer = {
  __typename?: 'customer';
  address?: Maybe<Address>;
  auth0_id?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  dashboard_visited?: Maybe<Scalars['Boolean']['output']>;
  dl_expiration_date?: Maybe<Scalars['DateTime']['output']>;
  dl_number?: Maybe<Scalars['String']['output']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  drivers_license_address?: Maybe<Address>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  finished_signing?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: Maybe<Scalars['Boolean']['output']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: Maybe<Scalars['Boolean']['output']>;
  home_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']['output']>;
  mailing_address?: Maybe<Address>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: Maybe<Scalars['String']['output']>;
  password_is_temp?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  prequalification?: Maybe<Prequalification>;
  prev_address?: Maybe<Address>;
  prev_employment?: Maybe<Employment>;
  proof_of_insurance?: Maybe<ProofOfInsurance>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  secure_link?: Maybe<SecureLink>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  signature_data?: Maybe<SignatureData>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dashboard_visited?: InputMaybe<Scalars['Boolean']['input']>;
  dl_expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  dl_number?: InputMaybe<Scalars['String']['input']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  drivers_license_address?: InputMaybe<AddressInput>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: InputMaybe<Scalars['Boolean']['input']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: InputMaybe<Scalars['Boolean']['input']>;
  home_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  mailing_address?: InputMaybe<AddressInput>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: InputMaybe<Scalars['String']['input']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  prev_address?: InputMaybe<AddressInput>;
  prev_employment?: InputMaybe<EmploymentInput>;
  proof_of_insurance?: InputMaybe<ProofOfInsuranceInput>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: InputMaybe<Scalars['Boolean']['input']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerNotification = {
  __typename?: 'customerNotification';
  auto_mark_as_seen: Scalars['Boolean']['output'];
  call_to_actions?: Maybe<Array<Maybe<CustomerNotificationCallToAction>>>;
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id: Scalars['ID']['output'];
  deal_id: Scalars['ID']['output'];
  dismissed_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  seen_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerNotificationCallToAction = {
  __typename?: 'customerNotificationCallToAction';
  action: CustomerNotificationCallToActions;
  label: Scalars['String']['output'];
};

export type Deal = {
  __typename?: 'deal';
  after_hours_held_at?: Maybe<Scalars['DateTime']['output']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']['output']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']['output']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']['output']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']['output']>;
  car?: Maybe<Car>;
  closer?: Maybe<User>;
  closer2?: Maybe<User>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']['output']>;
  cobuyer?: Maybe<Customer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']['output']>;
  completion_date_tz?: Maybe<Scalars['String']['output']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']['output']>;
  condition_report?: Maybe<ConditionReport>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  contact?: Maybe<DealContact>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']['output']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creation_date_tz?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  customer?: Maybe<Customer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']['output']>;
  dealIssues?: Maybe<Array<DealIssue>>;
  deal_assignment_log_entries?: Maybe<Array<Maybe<DealAssignmentLogEntry>>>;
  deal_dates?: Maybe<DealDates>;
  deal_financial_field_changes?: Maybe<Array<Maybe<DealFinancialFieldChange>>>;
  deal_phone_number_changes?: Maybe<Array<Maybe<CustomerPhoneNumberChange>>>;
  deal_pod_changes?: Maybe<Array<Maybe<DealPodChange>>>;
  deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  deal_source_changes?: Maybe<Array<Maybe<DealSourceChange>>>;
  deal_states?: Maybe<Array<Maybe<DealState>>>;
  deal_type_changes?: Maybe<Array<Maybe<DealTypeChange>>>;
  /** Primary queue sort timestamp. Initialized from lane_arrival_utc and updated by lane/state and follow-up events. */
  default_sort_date?: Maybe<Scalars['DateTime']['output']>;
  document_info?: Maybe<DocumentInfo>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']['output']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']['output']>;
  extracted_document_data?: Maybe<ExtractedDocumentData>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']['output']>;
  financial_info?: Maybe<FinancialInfo>;
  financial_info_acquisition?: Maybe<FinancialInfoAcquisition>;
  follow_up?: Maybe<FollowUp>;
  force_title_only_helper_link?: Maybe<ForceTitleOnlyHelperLink>;
  fs_pod?: Maybe<Pod>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']['output']>;
  fundingRequirements?: Maybe<Array<FundingRequirement>>;
  funding_clerk?: Maybe<User>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']['output']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isCobuyer?: Maybe<Scalars['Boolean']['output']>;
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** UTC timestamp for when the deal entered its current lane/state. */
  lane_arrival_utc?: Maybe<Scalars['DateTime']['output']>;
  /** UTC timestamp of the most recent outgoing customer communication. */
  last_outgoing_communication_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']['output']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notification_subscribers?: Maybe<Array<Maybe<NotificationSubscriber>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  original_lessee?: Maybe<OriginalLessee>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']['output']>;
  paperwork_type?: Maybe<PaperworkType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  pod?: Maybe<Pod>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']['output']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  product?: Maybe<Product>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']['output']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']['output']>;
  referral_source?: Maybe<ReferralSource>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']['output']>;
  roi_document_info?: Maybe<DocumentInfo>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']['output']>;
  second_contact?: Maybe<DealContact>;
  second_turn_financial_specialist?: Maybe<User>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']['output']>;
  selected_deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  selected_dealer_id?: Maybe<Scalars['Int']['output']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']['output']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']['output']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']['output']>;
  setter?: Maybe<User>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']['output']>;
  shipping_labels?: Maybe<Array<Maybe<ShippingLabel>>>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']['output']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']['output']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']['output']>;
  structuring_follow_up?: Maybe<StructuringFollowUp>;
  structuring_manager?: Maybe<User>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Tag>>;
  temporary_registration_tags_user?: Maybe<User>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']['output']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  title_clerk?: Maybe<User>;
  title_clerk2?: Maybe<User>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']['output']>;
  titling_pod?: Maybe<Pod>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealInput = {
  after_hours_held_at?: InputMaybe<Scalars['DateTime']['input']>;
  ai_involvement?: InputMaybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: InputMaybe<Scalars['String']['input']>;
  auto_import_variation?: InputMaybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: InputMaybe<Scalars['JSONObject']['input']>;
  called_by_financial_specialist?: InputMaybe<Scalars['DateTime']['input']>;
  car?: InputMaybe<CarInput>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: InputMaybe<Scalars['ID']['input']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: InputMaybe<Scalars['ID']['input']>;
  cobuyer?: InputMaybe<CustomerInput>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: InputMaybe<Scalars['Int']['input']>;
  completion_date_tz?: InputMaybe<Scalars['String']['input']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  condition_report?: InputMaybe<ConditionReportInput>;
  contact?: InputMaybe<DealContactInput>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  creation_date_tz?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<CustomerInput>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  deal_assignment_log_entries?: InputMaybe<Array<InputMaybe<DealAssignmentLogEntryInput>>>;
  deal_dates?: InputMaybe<DealDatesInput>;
  deal_products?: InputMaybe<Array<InputMaybe<DealProductInputV2>>>;
  deal_states?: InputMaybe<Array<InputMaybe<DealStateInput>>>;
  document_info?: InputMaybe<DocumentInfoInput>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: InputMaybe<Scalars['String']['input']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: InputMaybe<Scalars['ID']['input']>;
  financial_info?: InputMaybe<FinancialInfoInput>;
  financial_info_acquisition?: InputMaybe<FinancialInfoAcquisitionInput>;
  follow_up?: InputMaybe<FollowUpInput>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: InputMaybe<Scalars['ID']['input']>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  import_type?: InputMaybe<ImportType>;
  imported_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: InputMaybe<Scalars['GUID']['input']>;
  lock_status?: InputMaybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: InputMaybe<Scalars['String']['input']>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  notification_subscribers?: InputMaybe<Array<InputMaybe<NotificationSubscriberInput>>>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
  original_lessee?: InputMaybe<OriginalLesseeInput>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: InputMaybe<Scalars['Int']['input']>;
  paperwork_type?: InputMaybe<PaperworkType>;
  pod?: InputMaybe<PodInput>;
  /** ID of the primary sales pod assignment. */
  pod_id?: InputMaybe<Scalars['ID']['input']>;
  r1_contract_generation_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  r1_contract_manually_validated?: InputMaybe<Scalars['Boolean']['input']>;
  r1_contract_validation_errors_object?: InputMaybe<R1ContractValidationErrorsInput>;
  r1_contract_validation_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  r1_contract_validation_warnings_object?: InputMaybe<R1ContractValidationWarningsInput>;
  r1_contract_worksheet_created_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  /** RouteOne deal jacket identifier used for lender and e-contract workflows. */
  r1_jacket_id?: InputMaybe<Scalars['String']['input']>;
  r1_jacket_id_created_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  referral_source?: InputMaybe<ReferralSourceInput>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: InputMaybe<Scalars['Boolean']['input']>;
  roi_document_info?: InputMaybe<DocumentInfoInput>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: InputMaybe<Scalars['Boolean']['input']>;
  second_contact?: InputMaybe<DealContactInput>;
  second_turn_financial_specialist?: InputMaybe<UserInput>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: InputMaybe<Scalars['ID']['input']>;
  selected_dealer_id?: InputMaybe<Scalars['Int']['input']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: InputMaybe<Scalars['Int']['input']>;
  sent_to_netsuite?: InputMaybe<Scalars['Boolean']['input']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: InputMaybe<Scalars['ID']['input']>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: InputMaybe<Scalars['String']['input']>;
  structuring_follow_up?: InputMaybe<StructuringFollowUpInput>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: InputMaybe<Scalars['ID']['input']>;
  temporary_registration_tags_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: InputMaybe<Scalars['ID']['input']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: InputMaybe<Scalars['ID']['input']>;
  titling_pod?: InputMaybe<PodInput>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DealType>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DealMedia = {
  __typename?: 'dealMedia';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  cudl_document_id?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  generation_batch?: Maybe<Scalars['DateTime']['output']>;
  has_verified_digital_signature?: Maybe<Scalars['Boolean']['output']>;
  has_wet_signature?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_notarized?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  r1_document_id?: Maybe<Scalars['String']['output']>;
  signed_url?: Maybe<Scalars['String']['output']>;
  source?: Maybe<DealMediaSourceEnum>;
  state?: Maybe<DealMediaStateEnum>;
  type?: Maybe<DealMediaTypeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uploaded_by_user_id?: Maybe<Scalars['String']['output']>;
  uploaded_via_com?: Maybe<Scalars['Boolean']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  wet_signature_required?: Maybe<Scalars['Boolean']['output']>;
};

export type DealMediaInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  cudl_document_id?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  generation_batch?: InputMaybe<Scalars['DateTime']['input']>;
  has_verified_digital_signature?: InputMaybe<Scalars['Boolean']['input']>;
  has_wet_signature?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_notarized?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  r1_document_id?: InputMaybe<Scalars['String']['input']>;
  signed_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DealMediaSourceEnum>;
  state?: InputMaybe<DealMediaStateEnum>;
  type?: InputMaybe<DealMediaTypeEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  uploaded_by_user_id?: InputMaybe<Scalars['String']['input']>;
  uploaded_via_com?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  wet_signature_required?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DealMediaTypeEnum {
  AcuraSpecificOdometerDoc = 'acura_specific_odometer_doc',
  AgreementToFurnishInsurance = 'agreement_to_furnish_insurance',
  AlabamaAirbagDisclosureStatement = 'alabama_airbag_disclosure_statement',
  AllyCertifiedPreOwnedAcknowledgement = 'ally_certified_pre_owned_acknowledgement',
  BackOfCoBuyersInsurance = 'back_of_co_buyers_insurance',
  BackOfCoBuyersLicense = 'back_of_co_buyers_license',
  BackOfDriversLicense = 'back_of_drivers_license',
  BackOfInsuranceCard = 'back_of_insurance_card',
  BookSheet = 'book_sheet',
  BuyersGuide = 'buyers_guide',
  CaliforniaSpecialInterestLicensePlateApplication = 'california_special_interest_license_plate_application',
  CaliforniaStatementOfFacts = 'california_statement_of_facts',
  CaliforniaStatementOfFactsCobuyer = 'california_statement_of_facts_cobuyer',
  CoBuyerConnecticutElectronicRegistrationAndTitleAgreement = 'co_buyer_connecticut_electronic_registration_and_title_agreement',
  CobuyerProcessorPowerOfAttorney = 'cobuyer_processor_power_of_attorney',
  CobuyerRegistrationSpecificPowerOfAttorney = 'cobuyer_registration_specific_power_of_attorney',
  CobuyerSecurePowerOfAttorney = 'cobuyer_secure_power_of_attorney',
  CobuyerStateSpecificOdoDoc = 'cobuyer_state_specific_odo_doc',
  ColoradoCobuyerSupplementalIdentificationClause = 'colorado_cobuyer_supplemental_identification_clause',
  ColoradoJointTenancy = 'colorado_joint_tenancy',
  ColoradoSupplementalIdentificationClause = 'colorado_supplemental_identification_clause',
  ConnecticutElectronicRegistrationAndTitleAgreement = 'connecticut_electronic_registration_and_title_agreement',
  Contract = 'contract',
  CpsGuaranteeOfTitle = 'cps_guarantee_of_title',
  CreditApplication = 'credit_application',
  CreditApproval = 'credit_approval',
  DamageDisclosure = 'damage_disclosure',
  DemandLetter = 'demand_letter',
  DownPayment = 'down_payment',
  ESignConsent = 'e_sign_consent',
  ElectronicSignatureAttestation = 'electronic_signature_attestation',
  ElectronicSignatureCertification = 'electronic_signature_certification',
  ElectronicSignatureVerification = 'electronic_signature_verification',
  Emissions = 'emissions',
  FirstFedCoverLetter = 'first_fed_cover_letter',
  FirstFedOdometerDisclosure = 'first_fed_odometer_disclosure',
  FirstFedPayoffAuthorization = 'first_fed_payoff_authorization',
  FrontOfCoBuyersInsurance = 'front_of_co_buyers_insurance',
  FrontOfCoBuyersLicense = 'front_of_co_buyers_license',
  FrontOfDriversLicense = 'front_of_drivers_license',
  FrontOfInsuranceCard = 'front_of_insurance_card',
  GlbaPrivacyNotice = 'glba_privacy_notice',
  GmAssignmentOfTitleDamageDisclosure = 'gm_assignment_of_title_damage_disclosure',
  GmLeasePacket = 'gm_lease_packet',
  HondaSpecificOdometerDoc = 'honda_specific_odometer_doc',
  IdahoSalesTaxExemption = 'idaho_sales_tax_exemption',
  IllinoisLeasedVehicleRegistrationAffirmation = 'illinois_leased_vehicle_registration_affirmation',
  LeaseAgreement = 'lease_agreement',
  LeaseEndAcqContract = 'lease_end_acq_contract',
  LeaseEndCashback = 'lease_end_cashback',
  LeaseendOdoDoc = 'leaseend_odo_doc',
  LeaseendOdoDocCobuyer = 'leaseend_odo_doc_cobuyer',
  LeaseendOdoDocJoint = 'leaseend_odo_doc_joint',
  LicensePlate = 'license_plate',
  LouisianaMercedesDamageDisclosure = 'louisiana_mercedes_damage_disclosure',
  MembershipForm = 'membership_form',
  MontrosePowerOfAttorney = 'montrose_power_of_attorney',
  NewHampshireRegistrationCopyApplication = 'new_hampshire_registration_copy_application',
  NewYorkCpsNoticeOfLien = 'new_york_cps_notice_of_lien',
  OdoDoc = 'odo_doc',
  OdometerPicture = 'odometer_picture',
  OhioHondaSpecificOdometerDoc = 'ohio_honda_specific_odometer_doc',
  Other = 'other',
  PayoffAuthorization = 'payoff_authorization',
  PayoffDocs = 'payoff_docs',
  PayoffPacket = 'payoff_packet',
  PhysicalSignatureCoverLetter = 'physical_signature_cover_letter',
  PicturesOfVehicle = 'pictures_of_vehicle',
  PlateTransferLetter = 'plate_transfer_letter',
  PorscheSpecificOdometerDoc = 'porsche_specific_odometer_doc',
  PorscheSpecificPayoffInstructions = 'porsche_specific_payoff_instructions',
  PowerOfAttorney = 'power_of_attorney',
  PowerOfAttorneyCobuyer = 'power_of_attorney_cobuyer',
  PrivacyPolicy = 'privacy_policy',
  ProcessorPowerOfAttorney = 'processor_power_of_attorney',
  ProofOfIncome = 'proof_of_income',
  ProofOfResidence = 'proof_of_residence',
  ProofOfResidence2 = 'proof_of_residence2',
  PropertyTaxReceipt = 'property_tax_receipt',
  PurchaseOrder = 'purchase_order',
  R1EContract = 'r1_e_contract',
  RateExceptionForm = 'rate_exception_form',
  ReassignmentDisclosure = 'reassignment_disclosure',
  Registration = 'registration',
  RegistrationComplete = 'registration_complete',
  RegistrationSpecificPowerOfAttorney = 'registration_specific_power_of_attorney',
  ReleaseOfInterest = 'release_of_interest',
  RoiGmAssignmentOfTitleDamageDisclosure = 'roi_gm_assignment_of_title_damage_disclosure',
  RoiGmLeasePacket = 'roi_gm_lease_packet',
  RoiLeaseEndOdometerStatement = 'roi_lease_end_odometer_statement',
  RoiLeaseEndPayoffAuthorization = 'roi_lease_end_payoff_authorization',
  RoiLeaseEndPurchaseOrder = 'roi_lease_end_purchase_order',
  RoiLexusSpecificPowerOfAttorney = 'roi_lexus_specific_power_of_attorney',
  RoiLienholderSpecificBillOfSale = 'roi_lienholder_specific_bill_of_sale',
  RoiLienholderSpecificOdometerStatement = 'roi_lienholder_specific_odometer_statement',
  RoiPorscheSpecificPayoffInstructions = 'roi_porsche_specific_payoff_instructions',
  RoiPowerOfAttorney = 'roi_power_of_attorney',
  RoiProcessorPowerOfAttorney = 'roi_processor_power_of_attorney',
  RoiTaterDocumentPacket = 'roi_tater_document_packet',
  RoiTeslaSpecificDocumentPacket = 'roi_tesla_specific_document_packet',
  RoiToyotaSpecificPowerOfAttorney = 'roi_toyota_specific_power_of_attorney',
  RoiUsbankSpecificAlabamaSpecificAirbagDisclosure = 'roi_usbank_specific_alabama_specific_airbag_disclosure',
  RoiUsbankSpecificIllinoisSpecificLeasedVehicleRegistrationAffirmation = 'roi_usbank_specific_illinois_specific_leased_vehicle_registration_affirmation',
  SafetyInspection = 'safety_inspection',
  SalesTaxExemption = 'sales_tax_exemption',
  SantanderCanadaConditionalSalesContract = 'santander_canada_conditional_sales_contract',
  SantanderCanadaCreditApplication = 'santander_canada_credit_application',
  SantanderCanadaCustomerIdentificationForm = 'santander_canada_customer_identification_form',
  SantanderGuaranteeOfTitle = 'santander_guarantee_of_title',
  SecurePowerOfAttorney = 'secure_power_of_attorney',
  SignedDocs = 'signed_docs',
  SmogInspection = 'smog_inspection',
  StateAndLienholderSpecificPowerOfAttorney = 'state_and_lienholder_specific_power_of_attorney',
  StateSpecificDamageDisclosure = 'state_specific_damage_disclosure',
  StateSpecificDocs = 'state_specific_docs',
  StateSpecificOdoDoc = 'state_specific_odo_doc',
  StateSpecificPowerOfAttorney = 'state_specific_power_of_attorney',
  StateSpecificPowerOfAttorneyCobuyer = 'state_specific_power_of_attorney_cobuyer',
  StateSpecificPurchaseOrder = 'state_specific_purchase_order',
  TaterDocs = 'tater_docs',
  TaxExemption = 'tax_exemption',
  TempTag = 'temp_tag',
  TexasHidalgoDoc = 'texas_hidalgo_doc',
  Title = 'title',
  TitleApplication = 'title_application',
  TitlePacket = 'title_packet',
  TitleRelease = 'title_release',
  VinInspection = 'vin_inspection',
  VscAndGap = 'vsc_and_gap',
  WetSignature = 'wet_signature',
}

export type DealSetter = {
  __typename?: 'dealSetter';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  setter?: Maybe<User>;
  setter_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type DealState = {
  __typename?: 'dealState';
  closing_note_snapshot?: Maybe<ClosingNoteSnapshot>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Workflow state snapshot recorded in deal history. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_date_utc?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type DealStateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Workflow state snapshot recorded in deal history. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserInput>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DealerInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  dealership_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  observes_daylight_saving?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Deals = {
  __typename?: 'deals';
  after_hours_held_at?: Maybe<Scalars['DateTime']['output']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']['output']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']['output']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']['output']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']['output']>;
  car?: Maybe<Car>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']['output']>;
  cobuyer?: Maybe<Customer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']['output']>;
  completion_date_tz?: Maybe<Scalars['String']['output']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']['output']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creation_date_tz?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']['output']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']['output']>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']['output']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isCobuyer?: Maybe<Scalars['Boolean']['output']>;
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']['output']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']['output']>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']['output']>;
  paperwork_type?: Maybe<PaperworkType>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']['output']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']['output']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']['output']>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']['output']>;
  selected_dealer_id?: Maybe<Scalars['Int']['output']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']['output']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']['output']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']['output']>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']['output']>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']['output']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']['output']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']['output']>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']['output']>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']['output']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Decision = {
  __typename?: 'decision';
  conditionRejection?: Maybe<Array<Maybe<ConditionRejection>>>;
  decisionComments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  financing?: Maybe<Financing>;
  stipulations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DecryptedSsn = {
  __typename?: 'decryptedSSN';
  ssn?: Maybe<Scalars['String']['output']>;
  ssnId?: Maybe<Scalars['ID']['output']>;
};

export type Deductible = {
  __typename?: 'deductible';
  amount?: Maybe<Scalars['String']['output']>;
  dealer_cost?: Maybe<Scalars['String']['output']>;
  deductible_type?: Maybe<Scalars['String']['output']>;
  f_i_markup?: Maybe<Scalars['String']['output']>;
  max_retail_price?: Maybe<Scalars['String']['output']>;
  min_retail_price?: Maybe<Scalars['String']['output']>;
  rate_id?: Maybe<Scalars['Int']['output']>;
  reduced_amount?: Maybe<Scalars['String']['output']>;
  retail_price?: Maybe<Scalars['String']['output']>;
};

export type Destinations = {
  address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type DetermineApproval = {
  __typename?: 'determineApproval';
  approved?: Maybe<Scalars['Boolean']['output']>;
  failedCriteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DetermineApprovalInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  book_value?: InputMaybe<Scalars['Float']['input']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  kbb_trim?: InputMaybe<Scalars['String']['input']>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']['input']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  smoked_in?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  temporary_info_id?: InputMaybe<Scalars['String']['input']>;
  tires?: InputMaybe<TiresEnumType>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
};

export type DetermineApprovalQueryInput = {
  accidents?: InputMaybe<AccidentsEnumType>;
  book_value?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  exterior?: InputMaybe<Array<InputMaybe<ExteriorEnumType>>>;
  financial_info_acquisition_id?: InputMaybe<Scalars['ID']['input']>;
  interior?: InputMaybe<Array<InputMaybe<InteriorEnumType>>>;
  kbb_trim?: InputMaybe<Scalars['String']['input']>;
  lights_on_dash?: InputMaybe<Scalars['Boolean']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  overall_condition?: InputMaybe<OverallConditionEnumType>;
  payoff?: InputMaybe<Scalars['Float']['input']>;
  smoked_in?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tires?: InputMaybe<TiresEnumType>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type Documents = {
  __typename?: 'documents';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  files?: Maybe<Array<Maybe<File>>>;
  penError?: Maybe<Scalars['String']['output']>;
  /** Documents skipped because their generation conditions were not met. */
  skippedDocuments: Array<SkippedDocument>;
};

export type DocumentsInput = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  generation_batch?: InputMaybe<Scalars['String']['input']>;
  internal_media?: InputMaybe<Array<InputMaybe<DealMediaTypeEnum>>>;
};

export enum DownPaymentStatus {
  Completed = 'COMPLETED',
  ManuallyCompleted = 'MANUALLY_COMPLETED',
  Na = 'NA',
  Requested = 'REQUESTED',
  Sent = 'SENT',
}

export type EiRedirectGraphQlType = {
  __typename?: 'eiRedirectGraphQLType';
  url?: Maybe<Scalars['String']['output']>;
};

export type Employment = {
  __typename?: 'employment';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  employment_type?: Maybe<EmploymentTypeEnum>;
  gross_income?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  months_at_job?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pay_frequency?: Maybe<IncomeIntervalEnum>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmploymentStatusEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  years_at_job?: Maybe<Scalars['Int']['output']>;
};

export enum EmploymentEnumType {
  FullTime = 'full_time',
  PartTime = 'part_time',
}

export type EmploymentInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  customer_id?: InputMaybe<Scalars['ID']['input']>;
  employment_type?: InputMaybe<EmploymentTypeEnum>;
  gross_income?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  months_at_job?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pay_frequency?: InputMaybe<IncomeIntervalEnum>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmploymentStatusEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  years_at_job?: InputMaybe<Scalars['Int']['input']>;
};

export enum ErrorCodeEnum {
  BadUserInput = 'BAD_USER_INPUT',
  CardPaymentLimitExceeded = 'CARD_PAYMENT_LIMIT_EXCEEDED',
  CardTypeMismatch = 'CARD_TYPE_MISMATCH',
  Forbidden = 'FORBIDDEN',
  LockTimeout = 'LOCK_TIMEOUT',
  NotFound = 'NOT_FOUND',
  ResetGuidError = 'RESET_GUID_ERROR',
  TempInfoNotFound = 'TEMP_INFO_NOT_FOUND',
  Unauthenticated = 'UNAUTHENTICATED',
}

export enum ExteriorEnumType {
  DentsOrDings = 'dents_or_dings',
  GlassWindshieldDamage = 'glass_windshield_damage',
  HailDamage = 'hail_damage',
  MinorScuffs = 'minor_scuffs',
  PaintDamage = 'paint_damage',
  Rusting = 'rusting',
}

export type ExternalCustomer = {
  __typename?: 'externalCustomer';
  address?: Maybe<Address>;
  auth0_id?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  dashboard_visited?: Maybe<Scalars['Boolean']['output']>;
  dl_expiration_date?: Maybe<Scalars['DateTime']['output']>;
  dl_number?: Maybe<Scalars['String']['output']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['Date']['output']>;
  drivers_license_address?: Maybe<Address>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  finished_signing?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: Maybe<Scalars['Boolean']['output']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: Maybe<Scalars['Boolean']['output']>;
  home_phone_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']['output']>;
  mailing_address?: Maybe<Address>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: Maybe<Scalars['String']['output']>;
  password_is_temp?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  prequalification?: Maybe<ExternalPrequalification>;
  prev_address?: Maybe<Address>;
  prev_employment?: Maybe<Employment>;
  proof_of_insurance?: Maybe<ProofOfInsurance>;
  relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  secure_link?: Maybe<SecureLink>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  signature_data?: Maybe<SignatureData>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalDeal = {
  __typename?: 'externalDeal';
  after_hours_held_at?: Maybe<Scalars['DateTime']['output']>;
  ai_involvement?: Maybe<AiInvolvementStatus>;
  /** UTC timestamp set when the deal reaches closing without one. Cleared by an unwind. */
  approved_date?: Maybe<Scalars['DateTime']['output']>;
  /** Persisted outbound SMS number used as the default sender for this deal. */
  assigned_sms_phone_number?: Maybe<Scalars['String']['output']>;
  auto_import_variation?: Maybe<AutoImportVariation>;
  /** Structured boot metadata with reason, comment, and author for the current or most recent boot request. */
  boot_reason?: Maybe<Scalars['JSONObject']['output']>;
  called_by_financial_specialist?: Maybe<Scalars['DateTime']['output']>;
  came_from_marketplace?: Maybe<Scalars['Boolean']['output']>;
  car?: Maybe<Car>;
  closer?: Maybe<User>;
  closer2?: Maybe<User>;
  /** User ID of the secondary closer/financial specialist. */
  closer2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary closer/financial specialist. */
  closer_id?: Maybe<Scalars['ID']['output']>;
  cobuyer?: Maybe<ExternalCustomer>;
  /** ID of the co-buyer customer on this deal, when present. */
  cobuyer_id?: Maybe<Scalars['Int']['output']>;
  completion_date_tz?: Maybe<Scalars['String']['output']>;
  /** UTC timestamp set the first time a non-marketplace deal reaches a workflow state used for completion reporting. For buyout/refi deals this begins at Funded; moving a deal back to Signed clears it. */
  completion_date_utc?: Maybe<Scalars['DateTime']['output']>;
  condition_report?: Maybe<ConditionReport>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  contact?: Maybe<DealContact>;
  /** ID of the secondary DealContact linked to this deal. */
  contact2_id?: Maybe<Scalars['Int']['output']>;
  /** ID of the primary DealContact linked to this deal. */
  contact_id?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Country>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creation_date_tz?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Legacy UTC creation timestamp. Use created_at instead. */
  creation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  credit_applications?: Maybe<Array<Maybe<CreditApplication>>>;
  customer?: Maybe<ExternalCustomer>;
  /** ID of the primary buyer customer on this deal. */
  customer_id?: Maybe<Scalars['Int']['output']>;
  deal_assignment_log_entries?: Maybe<Array<Maybe<DealAssignmentLogEntry>>>;
  deal_dates?: Maybe<DealDates>;
  deal_pod_changes?: Maybe<Array<Maybe<DealPodChange>>>;
  deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  deal_source_changes?: Maybe<Array<Maybe<DealSourceChange>>>;
  deal_states?: Maybe<Array<Maybe<DealState>>>;
  deal_type_changes?: Maybe<Array<Maybe<DealTypeChange>>>;
  /** Primary queue sort timestamp. Initialized from lane_arrival_utc and updated by lane/state and follow-up events. */
  default_sort_date?: Maybe<Scalars['DateTime']['output']>;
  document_info?: Maybe<DocumentInfo>;
  /** Document generation/signature progress status. Expected values: failed, generate_documents, pending_lender, pending_r1, ready_for_signatures, required, sent_for_signatures, signed, upload_documents. */
  document_progress_status?: Maybe<Scalars['String']['output']>;
  /** ID of the source deal this deal was duplicated from. */
  duplicated_from_deal_id?: Maybe<Scalars['ID']['output']>;
  extracted_document_data?: Maybe<ExtractedDocumentData>;
  /** Derived UTC timestamp representing when the deal reached finalized state, when available. */
  finalized_date?: Maybe<Scalars['DateTime']['output']>;
  financial_info?: Maybe<FinancialInfo>;
  financial_info_acquisition?: Maybe<FinancialInfoAcquisition>;
  follow_up?: Maybe<FollowUp>;
  force_title_only_helper_link?: Maybe<ForceTitleOnlyHelperLink>;
  fs_pod?: Maybe<Pod>;
  /** ID of the financial specialist pod assignment. */
  fs_pod_id?: Maybe<Scalars['ID']['output']>;
  funding_clerk?: Maybe<User>;
  /** User ID of the assigned funding clerk. */
  funding_clerk_id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. The deal's funding jacket id, resolved from deal_jackets: the Ally dealer jacket when Ally funds and one exists, otherwise the global jacket. No longer needed to call the API — every signing/document operation is keyed on dealId and re-resolves the funding jacket itself. Use has_funding_jacket for presence checks. */
  funding_jacket_id?: Maybe<Scalars['String']['output']>;
  /** Computed flag that is true when last_outgoing_communication_date_utc is within the last 24 hours. */
  hasRecentCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** True when the deal has a Route One jacket to sign on — i.e. it has been submitted to Route One. The deal-scoped presence gate for signing and document flows; prefer this over testing funding_jacket_id, which exists only for legacy call sites. */
  has_funding_jacket?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  import_type?: Maybe<ImportType>;
  imported_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** Computed flag that is true when the deal is unassigned for a claimable role and the requesting user holds that role's claim permission. */
  isClaimableByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isCobuyer?: Maybe<Scalars['Boolean']['output']>;
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** UTC timestamp for when the deal entered its current lane/state. */
  lane_arrival_utc?: Maybe<Scalars['DateTime']['output']>;
  /** UTC timestamp of the most recent outgoing customer communication. */
  last_outgoing_communication_date_utc?: Maybe<Scalars['DateTime']['output']>;
  /** Deprecated. Legacy external lease identifier retained for backward compatibility. */
  lease_id?: Maybe<Scalars['GUID']['output']>;
  lock_status?: Maybe<DealLockStatus>;
  /** Marketing or campaign attribution captured during intake or import. */
  marketing_source?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<DealMedia>>>;
  messaging_opt_outs?: Maybe<Array<MessagingOptOut>>;
  /** If true, post-signing electronic signature verification artifacts are required. */
  needs_electronic_signature_verification?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notification_subscribers?: Maybe<Array<Maybe<NotificationSubscriber>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  original_lessee?: Maybe<OriginalLessee>;
  /** ID of the original lessee record, when tracked separately from buyer/co-buyer. */
  original_lessee_id?: Maybe<Scalars['Int']['output']>;
  paperwork_type?: Maybe<PaperworkType>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  pod?: Maybe<Pod>;
  /** ID of the primary sales pod assignment. */
  pod_id?: Maybe<Scalars['ID']['output']>;
  prequalification_status?: Maybe<PrequalificationStatus>;
  product?: Maybe<Product>;
  r1_contract_generation_date_utc?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_manually_validated?: Maybe<Scalars['Boolean']['output']>;
  r1_contract_validation_errors_object?: Maybe<R1ContractValidationErrors>;
  r1_contract_validation_started_at?: Maybe<Scalars['DateTime']['output']>;
  r1_contract_validation_warnings_object?: Maybe<R1ContractValidationWarnings>;
  r1_contract_worksheet_created_date_utc?: Maybe<Scalars['DateTime']['output']>;
  referral_source?: Maybe<ReferralSource>;
  /** True when the deal currently has an active or pending boot request. */
  request_boot?: Maybe<Scalars['Boolean']['output']>;
  roi_document_info?: Maybe<DocumentInfo>;
  /** Controls whether this deal is visible to sales workflows and queue assignment logic. */
  sales_visibility?: Maybe<Scalars['Boolean']['output']>;
  second_contact?: Maybe<DealContact>;
  second_turn_financial_specialist?: Maybe<User>;
  /** Deprecated. Legacy second-turn financial specialist assignment field retained for backward compatibility. */
  second_turn_financial_specialist_id?: Maybe<Scalars['ID']['output']>;
  selected_deal_products?: Maybe<Array<Maybe<DealProduct>>>;
  selected_dealer_id?: Maybe<Scalars['Int']['output']>;
  /** Canonical selected package slot index for deal product/package configuration. */
  selected_package_slot_index?: Maybe<Scalars['Int']['output']>;
  sent_to_netsuite?: Maybe<Scalars['Boolean']['output']>;
  /** UTC timestamp set when the deal reaches structuring or structuring_in_progress without one. Cleared by an unwind. */
  set_date?: Maybe<Scalars['DateTime']['output']>;
  setter?: Maybe<User>;
  /** User ID of the assigned setter/advisor. */
  setter_id?: Maybe<Scalars['ID']['output']>;
  shipping_labels?: Maybe<Array<Maybe<ShippingLabel>>>;
  /** True when this deal is using COM digital-signing workflow. */
  signing_on_com?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Legacy field from the previous acquisitions flow. */
  sold_date?: Maybe<Scalars['DateTime']['output']>;
  /** Deal acquisition channel. Persisted values: call-in, d2d, web, outbound. 'all' is reserved for filtering and is not stored on deals. */
  source?: Maybe<Scalars['String']['output']>;
  /** Current workflow state for the deal. Expected values: estimate, floor, soft_close, structuring_in_progress, structuring, closing, closed, signatures, signed, funded, send_payoff, waiting_for_title, title_received, sent_to_processor, ready_for_pickup, paid_off, at_auction, sold, title_sent, booted, finalized. */
  state?: Maybe<Scalars['String']['output']>;
  structuring_follow_up?: Maybe<StructuringFollowUp>;
  structuring_manager?: Maybe<User>;
  /** User ID of the assigned structuring manager. */
  structuring_manager_id?: Maybe<Scalars['ID']['output']>;
  tags?: Maybe<Array<Tag>>;
  temporary_registration_tags_user?: Maybe<User>;
  temporary_registration_tags_user_id?: Maybe<Scalars['ID']['output']>;
  /** Latest tie down decision (approved, countered, or declined) on the deal; null while a request is pending or none was ever decided. Populated by the deal and deals V2 queries when dd-tie-downs is on; other parents resolve null. */
  tie_down_decision?: Maybe<TieDownStatus>;
  title_clerk?: Maybe<User>;
  title_clerk2?: Maybe<User>;
  /** User ID of the secondary title clerk or registration assistant assignment. */
  title_clerk2_id?: Maybe<Scalars['ID']['output']>;
  /** User ID of the primary title clerk assignment. */
  title_clerk_id?: Maybe<Scalars['ID']['output']>;
  titling_pod?: Maybe<Pod>;
  /** ID of the titling pod assignment. */
  titling_pod_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<DealType>;
  unread_message_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExternalDealUploadUrl = {
  __typename?: 'externalDealUploadUrl';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExternalPrequalification = {
  __typename?: 'externalPrequalification';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_score_tier?: Maybe<CreditScoreTierEnumType>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ltv?: Maybe<Scalars['Float']['output']>;
  payment_to_income?: Maybe<Scalars['Float']['output']>;
  prequalification_errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExternalTempInfoUploadUrl = {
  __typename?: 'externalTempInfoUploadUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type ExtraTempInfoInputType = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_chat?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  prequal_id?: InputMaybe<Scalars['ID']['input']>;
  shopping_cart?: InputMaybe<TemporaryShoppingCartDataInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  wants_to_sell?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractedDocumentData = {
  __typename?: 'extractedDocumentData';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  dl_address?: Maybe<Scalars['String']['output']>;
  dl_city?: Maybe<Scalars['String']['output']>;
  dl_document_number?: Maybe<Scalars['String']['output']>;
  dl_expiration_date?: Maybe<Scalars['String']['output']>;
  dl_first_name?: Maybe<Scalars['String']['output']>;
  dl_last_name?: Maybe<Scalars['String']['output']>;
  dl_middle_name?: Maybe<Scalars['String']['output']>;
  dl_sex?: Maybe<Scalars['String']['output']>;
  dl_state?: Maybe<Scalars['String']['output']>;
  dl_suffix?: Maybe<Scalars['String']['output']>;
  dl_zip?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insurance_company?: Maybe<Scalars['String']['output']>;
  insurance_company_confidence?: Maybe<Scalars['Int']['output']>;
  insurance_expiration?: Maybe<Scalars['String']['output']>;
  insurance_expiration_confidence?: Maybe<Scalars['Int']['output']>;
  insurance_name?: Maybe<Scalars['String']['output']>;
  insurance_name_confidence?: Maybe<Scalars['Int']['output']>;
  insurance_policy_number?: Maybe<Scalars['String']['output']>;
  insurance_policy_number_confidence?: Maybe<Scalars['Int']['output']>;
  insurance_state?: Maybe<Scalars['String']['output']>;
  insurance_state_confidence?: Maybe<Scalars['Int']['output']>;
  insurance_vin?: Maybe<Scalars['String']['output']>;
  insurance_vin_confidence?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FinancialInfo = {
  __typename?: 'financialInfo';
  /** Final realized reserve amount in USD. */
  actual_reserve?: Maybe<Scalars['Float']['output']>;
  /** Total financed principal amount in USD. */
  amount_financed?: Maybe<Scalars['Float']['output']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: Maybe<Scalars['String']['output']>;
  bank_fees?: Maybe<Scalars['Float']['output']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: Maybe<Scalars['Boolean']['output']>;
  bank_slug?: Maybe<TtNewBankEnum>;
  base_tax_amount?: Maybe<Scalars['Float']['output']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: Maybe<Scalars['Float']['output']>;
  buyer_not_lessee?: Maybe<Scalars['Boolean']['output']>;
  closer_commission?: Maybe<Scalars['Float']['output']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: Maybe<Scalars['Float']['output']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_card_payment_amount_limit?: Maybe<Scalars['Float']['output']>;
  credit_debit_payment_amount_allowed?: Maybe<Scalars['Float']['output']>;
  credit_payment_amount_allowed?: Maybe<Scalars['Float']['output']>;
  credit_payment_amount_limit?: Maybe<Scalars['Float']['output']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: Maybe<Scalars['Int']['output']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  debit_payment_amount_allowed?: Maybe<Scalars['Float']['output']>;
  debit_payment_amount_limit?: Maybe<Scalars['Float']['output']>;
  doc_fee?: Maybe<Scalars['Float']['output']>;
  down_payment_status?: Maybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: Maybe<Scalars['String']['output']>;
  first_payment_date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Resolved max markup: prefers selected_credit_decision.max_markup, falls back to bank_markups lookup by bank+term. */
  maxMarkup?: Maybe<Scalars['Float']['output']>;
  /**
   * Deprecated: minimum markup is no longer enforced for any bank; always null.
   * @deprecated Minimum markup is no longer enforced for any bank; always null. Remove from queries.
   */
  minMarkup?: Maybe<Scalars['Float']['output']>;
  money_down?: Maybe<Scalars['Float']['output']>;
  needs_temporary_registration_tags?: Maybe<Scalars['Boolean']['output']>;
  new_lienholder?: Maybe<Bank>;
  new_registration_fee?: Maybe<Scalars['Float']['output']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: Maybe<Scalars['String']['output']>;
  /** Estimated monthly payment amount in USD. */
  payment?: Maybe<Scalars['Float']['output']>;
  plate_transfer?: Maybe<Scalars['Boolean']['output']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['Float']['output']>;
  quick_notes?: Maybe<Scalars['String']['output']>;
  registration_transfer_fee?: Maybe<Scalars['Float']['output']>;
  /** Calculated reserve amount in USD. */
  reserve?: Maybe<Scalars['Float']['output']>;
  sales_tax_rate?: Maybe<Scalars['Float']['output']>;
  selected_credit_decision?: Maybe<CreditDecision>;
  selected_credit_decision_id?: Maybe<Scalars['ID']['output']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: Maybe<Scalars['Float']['output']>;
  setter_commission?: Maybe<Scalars['Float']['output']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  title_fee?: Maybe<Scalars['Float']['output']>;
  title_registration_option?: Maybe<TitleRegistrationOption>;
  tt_transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: Maybe<Scalars['Float']['output']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type FinancialInfoAcquisition = {
  __typename?: 'financialInfoAcquisition';
  appraised_value?: Maybe<Scalars['Float']['output']>;
  auction_fees?: Maybe<Scalars['Float']['output']>;
  auction_id?: Maybe<Scalars['ID']['output']>;
  cash_to_customer?: Maybe<Scalars['Float']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  estimated_dealer_fees?: Maybe<Scalars['Float']['output']>;
  gross_profit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_approved?: Maybe<Scalars['Boolean']['output']>;
  kbb_lending?: Maybe<Scalars['Float']['output']>;
  max_cash_to_customer?: Maybe<Scalars['Float']['output']>;
  max_total_cost?: Maybe<Scalars['Float']['output']>;
  offer?: Maybe<Scalars['Float']['output']>;
  overriding_user_id?: Maybe<Scalars['String']['output']>;
  sell_price?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  transport_cost?: Maybe<Scalars['Float']['output']>;
};

export type FinancialInfoAcquisitionInput = {
  appraised_value?: InputMaybe<Scalars['Float']['input']>;
  auction_fees?: InputMaybe<Scalars['Float']['input']>;
  auction_id?: InputMaybe<Scalars['ID']['input']>;
  cash_to_customer?: InputMaybe<Scalars['Float']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  estimated_dealer_fees?: InputMaybe<Scalars['Float']['input']>;
  gross_profit?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  kbb_lending?: InputMaybe<Scalars['Float']['input']>;
  max_cash_to_customer?: InputMaybe<Scalars['Float']['input']>;
  max_total_cost?: InputMaybe<Scalars['Float']['input']>;
  offer?: InputMaybe<Scalars['Float']['input']>;
  overriding_user_id?: InputMaybe<Scalars['String']['input']>;
  sell_price?: InputMaybe<Scalars['Float']['input']>;
  total_cost?: InputMaybe<Scalars['Float']['input']>;
  transport_cost?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialInfoInput = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']['input']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: InputMaybe<Scalars['String']['input']>;
  bank_fees?: InputMaybe<Scalars['Float']['input']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']['input']>;
  base_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']['input']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']['input']>;
  closer_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']['input']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']['input']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  doc_fee?: InputMaybe<Scalars['Float']['input']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']['input']>;
  first_payment_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  money_down?: InputMaybe<Scalars['Float']['input']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']['input']>;
  new_lienholder?: InputMaybe<BankInput>;
  new_registration_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']['input']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']['input']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  quick_notes?: InputMaybe<Scalars['String']['input']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']['input']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']['input']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']['input']>;
  setter_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  title_fee?: InputMaybe<Scalars['Float']['input']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialInfoPaymentEstimate = {
  __typename?: 'financialInfoPaymentEstimate';
  avg_payment?: Maybe<Scalars['Float']['output']>;
  max_payment?: Maybe<Scalars['Float']['output']>;
  min_payment?: Maybe<Scalars['Float']['output']>;
};

export type Financing = {
  __typename?: 'financing';
  annualPercentageRate?: Maybe<Scalars['Float']['output']>;
  downPaymentAmount?: Maybe<Scalars['Float']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
};

export type FinixTransfer = {
  __typename?: 'finixTransfer';
  amount?: Maybe<Scalars['Float']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<CardType>;
  failureCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maskedNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<PaymentState>;
};

export type FlowStatus = {
  __typename?: 'flowStatus';
  car?: Maybe<Car>;
  customerId?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  inFlow?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FollowUp = {
  __typename?: 'followUp';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  creator_id?: Maybe<Scalars['ID']['output']>;
  date_utc?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FollowUpStatusEnum>;
  type?: Maybe<FollowUpTypeEnum>;
  tz?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type FollowUpInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  creator_id?: InputMaybe<Scalars['ID']['input']>;
  date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FollowUpStatusEnum>;
  type?: InputMaybe<FollowUpTypeEnum>;
  tz?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FollowUpStatusEnum {
  Completed = 'completed',
  Deleted = 'deleted',
  Due = 'due',
  Scheduled = 'scheduled',
}

export enum FollowUpTypeEnum {
  Appointment = 'appointment',
  Reminder = 'reminder',
}

export type ForceTitleOnlyHelperLink = {
  __typename?: 'forceTitleOnlyHelperLink';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GetAvailableUsers = {
  __typename?: 'getAvailableUsers';
  assignment_mode?: Maybe<AssignmentMode>;
  auto_assign_deals?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']['output']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']['output']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frequency_minutes?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  in_call?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  on_vacation?: Maybe<Scalars['Boolean']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  recruiter_id?: Maybe<Scalars['String']['output']>;
  twilio_number?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<UserType>;
};

export type GetWaitingCalls = {
  __typename?: 'getWaitingCalls';
  data?: Maybe<Scalars['JSONObject']['output']>;
};

export enum InboxFilterByEnum {
  All = 'all',
  AllSalesPods = 'all_sales_pods',
  AllTitlePods = 'all_title_pods',
  MyLanes = 'my_lanes',
  MyTeams = 'my_teams',
  SalesPod = 'sales_pod',
  TitlePod = 'title_pod',
  YourMessages = 'your_messages',
}

export type InboxMessagesType = {
  __typename?: 'inboxMessagesType';
  messages?: Maybe<Array<Maybe<Message>>>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
};

export enum InboxOrderByEnum {
  DateNewest = 'date_newest',
  DateOldest = 'date_oldest',
  Deal = 'deal',
}

export enum InteriorEnumType {
  EntertainmentConsoleDamage = 'entertainment_console_damage',
  RipsOrTears = 'rips_or_tears',
  SmellsOrOdors = 'smells_or_odors',
  Stains = 'stains',
}

export type JdpVehicleAccessories = {
  __typename?: 'jdpVehicleAccessories';
  acccode?: Maybe<Scalars['String']['output']>;
  accdesc?: Maybe<Scalars['String']['output']>;
  accessorycategory?: Maybe<Scalars['String']['output']>;
  excludes?: Maybe<Scalars['String']['output']>;
  includes?: Maybe<Scalars['String']['output']>;
  isadded?: Maybe<Scalars['Int']['output']>;
  isincluded?: Maybe<Scalars['Int']['output']>;
  loan?: Maybe<Scalars['Int']['output']>;
  retail?: Maybe<Scalars['Int']['output']>;
  tradein?: Maybe<Scalars['Int']['output']>;
};

export type JdpVehicleAccessoriesInput = {
  acccode?: InputMaybe<Scalars['String']['input']>;
  accdesc?: InputMaybe<Scalars['String']['input']>;
  accessorycategory?: InputMaybe<Scalars['String']['input']>;
  excludes?: InputMaybe<Scalars['String']['input']>;
  includes?: InputMaybe<Scalars['String']['input']>;
  isadded?: InputMaybe<Scalars['Int']['input']>;
  isincluded?: InputMaybe<Scalars['Int']['input']>;
  loan?: InputMaybe<Scalars['Int']['input']>;
  retail?: InputMaybe<Scalars['Int']['input']>;
  tradein?: InputMaybe<Scalars['Int']['input']>;
};

export type JdpVehicleAccessoriesObject = {
  __typename?: 'jdpVehicleAccessoriesObject';
  vehicle_accessories?: Maybe<Array<Maybe<JdpVehicleAccessories>>>;
};

export type JdpVehicleAccessoriesObjectInput = {
  vehicle_accessories?: InputMaybe<Array<InputMaybe<JdpVehicleAccessoriesInput>>>;
};

export type KbbConfigType = {
  action?: InputMaybe<Scalars['String']['input']>;
  optionId?: InputMaybe<Scalars['Int']['input']>;
};

export type KbbOption = {
  __typename?: 'kbbOption';
  categoryGroup?: Maybe<Scalars['String']['output']>;
  hasRelationships?: Maybe<Scalars['Boolean']['output']>;
  isConfigurable?: Maybe<Scalars['Boolean']['output']>;
  isConsumer?: Maybe<Scalars['Boolean']['output']>;
  isTypical?: Maybe<Scalars['Boolean']['output']>;
  isVinDecoded?: Maybe<Scalars['Boolean']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  optionType?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
  vehicleOptionId?: Maybe<Scalars['Int']['output']>;
};

export type KbbOptionInput = {
  categoryGroup?: InputMaybe<Scalars['String']['input']>;
  hasRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  isConfigurable?: InputMaybe<Scalars['Boolean']['input']>;
  isConsumer?: InputMaybe<Scalars['Boolean']['input']>;
  isTypical?: InputMaybe<Scalars['Boolean']['input']>;
  isVinDecoded?: InputMaybe<Scalars['Boolean']['input']>;
  optionName?: InputMaybe<Scalars['String']['input']>;
  optionType?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vehicleOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type KbbSelectedOptionsType = {
  __typename?: 'kbbSelectedOptionsType';
  categoryGroup?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lendingOptionPrice?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  retailOptionPrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type KbbValuesDataType = {
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>>>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  vehicleOptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type KbbValuesResult = {
  __typename?: 'kbbValuesResult';
  kbbSelectedOptions?: Maybe<Array<Maybe<KbbSelectedOptionsType>>>;
  lending?: Maybe<Scalars['Float']['output']>;
  lendingMileageAdjustment?: Maybe<Scalars['Float']['output']>;
  lendingOptionAdjustment?: Maybe<Scalars['Float']['output']>;
  lendingOptionPrices?: Maybe<Scalars['JSON']['output']>;
  retail?: Maybe<Scalars['Float']['output']>;
  retailMileageAdjustment?: Maybe<Scalars['Float']['output']>;
  retailOptionAdjustment?: Maybe<Scalars['Float']['output']>;
  retailOptionPrices?: Maybe<Scalars['JSON']['output']>;
  valuationDate?: Maybe<Scalars['String']['output']>;
};

export type KbbVinObjectResult = {
  __typename?: 'kbbVinObjectResult';
  vinResults?: Maybe<Array<Maybe<KbbVinResult>>>;
  warning?: Maybe<Scalars['Boolean']['output']>;
};

export type KbbVinResult = {
  __typename?: 'kbbVinResult';
  makeName?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  trimName?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['Int']['output']>;
  vehicleName?: Maybe<Scalars['String']['output']>;
  vehicleOptions?: Maybe<Array<Maybe<KbbOption>>>;
  yearId?: Maybe<Scalars['String']['output']>;
};

export type KeyMetric = {
  __typename?: 'keyMetric';
  keyMetric?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Value>;
};

export type LaneKeyMetric = {
  __typename?: 'laneKeyMetric';
  day_count?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type LeaderboardSetterStats = {
  __typename?: 'leaderboardSetterStats';
  numApps?: Maybe<Scalars['Int']['output']>;
  repId?: Maybe<Scalars['String']['output']>;
  repName?: Maybe<Scalars['String']['output']>;
  teamType?: Maybe<TeamType>;
};

export type LenderStructuredRequirement = {
  __typename?: 'lenderStructuredRequirement';
  backend_limits?: Maybe<BackendLimits>;
  contract_funding_rules?: Maybe<ContractFundingRules>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_decision_id?: Maybe<Scalars['Int']['output']>;
  documentation_requirements?: Maybe<DocumentationRequirements>;
  gap_limits?: Maybe<GapLimits>;
  id?: Maybe<Scalars['ID']['output']>;
  loan_limits?: Maybe<LoanLimits>;
  other?: Maybe<Other>;
  payment_limits?: Maybe<PaymentLimits>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle_use_requirements?: Maybe<VehicleUseRequirements>;
  vsc_limits?: Maybe<VscLimits>;
};

export type Lending_Tree_Decision_Response = {
  __typename?: 'lending_tree_decision_response';
  offers?: Maybe<Array<Maybe<Lending_Tree_Offer>>>;
  partnerDecision?: Maybe<Scalars['String']['output']>;
};

export type Lending_Tree_Decision_Response_Input = {
  offers?: InputMaybe<Array<InputMaybe<Lending_Tree_Offer_Input>>>;
  partnerDecision?: InputMaybe<Scalars['String']['input']>;
};

export type Lending_Tree_Offer = {
  __typename?: 'lending_tree_offer';
  amount?: Maybe<Scalars['Float']['output']>;
  apr?: Maybe<Scalars['Float']['output']>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  offerUrl?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
};

export type Lending_Tree_Offer_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  apr?: InputMaybe<Scalars['Float']['input']>;
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>;
  offerUrl?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

export enum MaritalStatusEnum {
  Married = 'married',
  NotMarried = 'not_married',
  Separated = 'separated',
  Widowed = 'widowed',
}

export type MarketPrequalification = {
  __typename?: 'marketPrequalification';
  creditScoreTier: Scalars['String']['output'];
  prequalId: Scalars['ID']['output'];
};

export type MediaListData = {
  __typename?: 'mediaListData';
  contentType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MediaListDataInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MediaListInputObj = {
  data?: InputMaybe<Array<InputMaybe<MediaListDataInput>>>;
};

export type MediaListObj = {
  __typename?: 'mediaListObj';
  data?: Maybe<Array<Maybe<MediaListData>>>;
};

export type MediaUploadUrl = {
  __typename?: 'mediaUploadUrl';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'message';
  body?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateCreatedTz?: Maybe<Scalars['String']['output']>;
  deals?: Maybe<Array<Maybe<Deal>>>;
  from?: Maybe<Scalars['String']['output']>;
  fromCustomer?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mediaListObj?: Maybe<MediaListObj>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  senderName?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
};

export type MessageDetail = {
  __typename?: 'messageDetail';
  dealIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  dealStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MessagesDbPaginated = {
  __typename?: 'messagesDbPaginated';
  hasMoreMessages: Scalars['Boolean']['output'];
  messages: Array<Maybe<Message>>;
};

export type MessagesWithErrors = {
  __typename?: 'messagesWithErrors';
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<Message>>>;
};

export type MetricsPages = {
  __typename?: 'metricsPages';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  iframe_url?: Maybe<Scalars['String']['output']>;
  link_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permission_name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type MmrResult = {
  __typename?: 'mmrResult';
  average?: Maybe<Scalars['Int']['output']>;
};

export type NewEstimateCustomerInput = {
  address?: InputMaybe<AddressInput>;
  /** Deprecated. Legacy contact identifier retained for backward compatibility. */
  contact_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dashboard_visited?: InputMaybe<Scalars['Boolean']['input']>;
  dl_expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  dl_number?: InputMaybe<Scalars['String']['input']>;
  /** Driver license sex marker when provided. Expected values: M, F. */
  dl_sex?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** Embedded Insurance lead identifier used for EI API and webhook correlation. */
  ei_lead_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<EmploymentInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** True when a full SSN is on file; false when only partial or no SSN is stored. */
  has_full_ssn?: InputMaybe<Scalars['Boolean']['input']>;
  /** True when the customer uses an ITIN instead of an SSN. */
  has_itin?: InputMaybe<Scalars['Boolean']['input']>;
  home_phone_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated. Last authenticated route in COM lease buyout flow. */
  last_authenticated_route?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer marital status used for lender/credit workflows. Expected values: not_married, married, separated, widowed. */
  marital_status?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** Customer name suffix when present. Expected values: JR, SR, I, II, III, IV, V. */
  name_suffix?: InputMaybe<Scalars['String']['input']>;
  password_is_temp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Timestamp when a payoff-related customer email was sent. */
  payoff_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  /** True once the account/invite email has been sent to the customer. */
  sent_account_email?: InputMaybe<Scalars['Boolean']['input']>;
  /** Timestamp when the finalized email was sent. */
  sent_finalized_email?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamp when the review email was sent. */
  sent_review_email?: InputMaybe<Scalars['DateTime']['input']>;
  /** Timestamp when the sent-to-processor email was sent. */
  sent_to_processor_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Reference ID for the customer's secure SSN record in LeaseEnd. */
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
  /** Timestamp when the title-received email was sent. */
  title_received_email_sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag to determine if user has verified SSN prior to signing on COM. If false, they cannot sign. */
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewEstimateFileInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type NewEstimateFinancialInfoInput = {
  /** Final realized reserve amount in USD. */
  actual_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Total financed principal amount in USD. */
  amount_financed?: InputMaybe<Scalars['Float']['input']>;
  /** Selected lender name for the deal. Expected values: America First Credit Union, Ally Financial, Capital One Auto Finance, JPMorgan Chase Bank, N.A., Exeter Finance, Fifth Third Bank NA, First Interstate Bank, Global Lending Services, Idaho Central Credit Union, Lentegrity Auto Finance, Lookout Credit Union, Mechanics Bank, Mountain America FCU, PNC Bank, NA, Prestige Financial Services, Santander Consumer USA, TD Bank N.A., Upgrade Inc., Wells Fargo Auto, Westlake Financial Services, Wings Credit Union, Oregon Community Credit Union, Consumer Portfolio Services, Arra Finance, InnoFi Auto Finance LLC, Santander Consumer Inc.. */
  bank?: InputMaybe<Scalars['String']['input']>;
  bank_fees?: InputMaybe<Scalars['Float']['input']>;
  /** True when a user chose the bank directly (manuallySelectBank) rather than it being seeded on deal creation or set by a credit decision selection. */
  bank_selected_manually?: InputMaybe<Scalars['Boolean']['input']>;
  base_tax_amount?: InputMaybe<Scalars['Float']['input']>;
  /** Lender buy-rate APR as a percentage value before markup. */
  buy_rate?: InputMaybe<Scalars['Float']['input']>;
  buyer_not_lessee?: InputMaybe<Scalars['Boolean']['input']>;
  closer_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Markup between sell_rate and buy_rate in percentage points. */
  com_rate_markup?: InputMaybe<Scalars['Float']['input']>;
  /** Profit amount eligible for commission in USD. */
  commissionable_profit?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credit_card_payment_amount_limit?: InputMaybe<Scalars['Float']['input']>;
  /** Days until first payment due (typically 30, 45, 60, or 90). */
  days_to_payment?: InputMaybe<Scalars['Int']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  doc_fee?: InputMaybe<Scalars['Float']['input']>;
  down_payment_status?: InputMaybe<DownPaymentStatus>;
  /** Fee processor/source returned by the taxes-and-fees provider response. */
  fee_processor?: InputMaybe<Scalars['String']['input']>;
  first_payment_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  money_down?: InputMaybe<Scalars['Float']['input']>;
  needs_temporary_registration_tags?: InputMaybe<Scalars['Boolean']['input']>;
  new_registration_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Protection package selection used for pricing and taxes. Expected values: vscPlusGap, vsc, gap, noProducts. */
  option_type?: InputMaybe<Scalars['String']['input']>;
  /** Estimated monthly payment amount in USD. */
  payment?: InputMaybe<Scalars['Float']['input']>;
  plate_transfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Titling/registration processor selection. Expected values: ATC, VITU, DLRdmv, Plateman, State DMV, The Title Girl, WKLS, Other (leave note). */
  processor?: InputMaybe<Scalars['String']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  quick_notes?: InputMaybe<Scalars['String']['input']>;
  registration_transfer_fee?: InputMaybe<Scalars['Float']['input']>;
  /** Calculated reserve amount in USD. */
  reserve?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_rate?: InputMaybe<Scalars['Float']['input']>;
  selected_credit_decision_id?: InputMaybe<Scalars['ID']['input']>;
  /** APR presented to the customer as a percentage value. */
  sell_rate?: InputMaybe<Scalars['Float']['input']>;
  setter_commission?: InputMaybe<Scalars['Float']['input']>;
  /** Tax processor/source returned by the taxes-and-fees provider response. */
  tax_processor?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  title_fee?: InputMaybe<Scalars['Float']['input']>;
  title_registration_option?: InputMaybe<TitleRegistrationOption>;
  tt_transaction_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Manual reserve override amount in USD. */
  user_entered_reserve?: InputMaybe<Scalars['Float']['input']>;
  /** Tax collected on the selected warranty products in USD, summed from deal_products.tax_amount. */
  warranty_tax_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type NewEstimateUpsertInput = {
  called_by_financial_specialist?: InputMaybe<Scalars['DateTime']['input']>;
  car?: InputMaybe<CarInput>;
  closer_id?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  creation_date_tz?: InputMaybe<Scalars['String']['input']>;
  creation_date_utc?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<NewEstimateCustomerInput>;
  financial_info?: InputMaybe<NewEstimateFinancialInfoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  needs_electronic_signature_verification?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  referral_source?: InputMaybe<ReferralSourceInput>;
  request_boot?: InputMaybe<Scalars['Boolean']['input']>;
  second_turn_financial_specialist_id?: InputMaybe<Scalars['String']['input']>;
  selected_dealer_id?: InputMaybe<Scalars['Int']['input']>;
  setter_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DealType>;
};

export type Note = {
  __typename?: 'note';
  author?: Maybe<User>;
  author_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creation_date_tz?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Classification for the note event type. Expected values: manual, system, text_outgoing, text_incoming, call_outgoing, call_incoming. */
  note_type?: Maybe<Scalars['String']['output']>;
  notification_id?: Maybe<Scalars['ID']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  recordingid?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type NoteInput = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  creation_date_tz?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Classification for the note event type. Expected values: manual, system, text_outgoing, text_incoming, call_outgoing, call_incoming. */
  note_type?: InputMaybe<Scalars['String']['input']>;
  notification_id?: InputMaybe<Scalars['ID']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  recordingid?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Notification = {
  __typename?: 'notification';
  call_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  deal?: Maybe<Deal>;
  deal_contact_id?: Maybe<Scalars['ID']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Deprecated. Human-readable notification text shown in UI; not guaranteed to equal NotificationType enum keys. Alerts will replace this field. */
  message?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  original_lessee_id?: Maybe<Scalars['ID']['output']>;
  text_message?: Maybe<TextMessage>;
  text_message_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<Array<Maybe<NotificationUser>>>;
};

export type NotificationInput = {
  call_id?: InputMaybe<Scalars['ID']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  customer_id?: InputMaybe<Scalars['ID']['input']>;
  deal?: InputMaybe<DealInput>;
  deal_contact_id?: InputMaybe<Scalars['ID']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Deprecated. Human-readable notification text shown in UI; not guaranteed to equal NotificationType enum keys. Alerts will replace this field. */
  message?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<InputMaybe<NoteInput>>>;
  original_lessee_id?: InputMaybe<Scalars['ID']['input']>;
  text_message?: InputMaybe<TextMessageInput>;
  text_message_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<InputMaybe<NotificationUserInput>>>;
};

export type OnMissedSipCall = {
  __typename?: 'onMissedSipCall';
  callInfo?: Maybe<Call>;
  calledUserId?: Maybe<Scalars['String']['output']>;
};

export type OnSipRegistrationFailure = {
  __typename?: 'onSipRegistrationFailure';
  callerNumber?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OnWaitingQueue = {
  __typename?: 'onWaitingQueue';
  data?: Maybe<Array<Maybe<WaitingCall>>>;
  hunt_group_slug?: Maybe<Scalars['String']['output']>;
};

export type OperatingHoursTimeSlots = {
  __typename?: 'operatingHoursTimeSlots';
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  utcTimeSlots?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
};

export type OptEvent = {
  __typename?: 'optEvent';
  action?: Maybe<OptEventTypeEnum>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  opt_in_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<OptEventSourceEnum>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OptEventInput = {
  action?: InputMaybe<OptEventTypeEnum>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  opt_in_at?: InputMaybe<Scalars['DateTime']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<OptEventSourceEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum OptEventSourceEnum {
  Com = 'com',
  HubspotMigration = 'hubspot_migration',
  LendingTree = 'lending_tree',
  PreFlowPaymentCalculator = 'pre_flow_payment_calculator',
  ReOptDateSelected = 're_opt_date_selected',
  SmsOptIn = 'sms_opt_in',
  Verse = 'verse',
}

export enum OptEventTypeEnum {
  OptIn = 'opt_in',
  OptOut = 'opt_out',
}

export enum OverallConditionEnumType {
  LikeNew = 'like_new',
  NeedsWork = 'needs_work',
  SlightlyUsed = 'slightly_used',
}

export type Payment = {
  __typename?: 'payment';
  amount?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<PaymentState>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentEstimate = {
  __typename?: 'paymentEstimate';
  estimatedAnnualPercentageRate: Scalars['Float']['output'];
  estimatedTaxesAndFees: Scalars['Float']['output'];
  feeDetails: PaymentEstimateFeeDetails;
  paymentEstimateHigh: Scalars['Float']['output'];
  paymentEstimateLow: Scalars['Float']['output'];
  totalEstimatedLoan: Scalars['Float']['output'];
};

export type PaymentEstimateFeeDetails = {
  __typename?: 'paymentEstimateFeeDetails';
  baseTaxAmount: Scalars['Float']['output'];
  docFee: Scalars['Float']['output'];
  docFeeTaxAmount: Scalars['Float']['output'];
  registrationFee: Scalars['Float']['output'];
  titleFee: Scalars['Float']['output'];
  warrantyTaxAmount: Scalars['Float']['output'];
};

export type PaymentEstimateInput = {
  creditScore: CreditScore;
  feesInputFromDD?: InputMaybe<TtFeesInput>;
  financialInfoId?: InputMaybe<Scalars['ID']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  moneyDown: Scalars['Float']['input'];
  payoff: Scalars['Float']['input'];
  term: Scalars['Int']['input'];
  ttGetFeesSource?: InputMaybe<TtGetFeesSourceType>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export enum PaymentInstrumentType {
  All = 'ALL',
  BankAccount = 'BANK_ACCOUNT',
  PaymentCard = 'PAYMENT_CARD',
}

export enum PaymentMethod {
  BankAccount = 'BANK_ACCOUNT',
  Credit = 'CREDIT',
  CreditDebit = 'CREDIT_DEBIT',
  Debit = 'DEBIT',
}

export type PaymentOptions = {
  __typename?: 'paymentOptions';
  gap?: Maybe<PaymentOptionsGqlTypes>;
  noProducts?: Maybe<PaymentOptionsGqlTypes>;
  vsc?: Maybe<PaymentOptionsGqlTypes>;
  vscPlusGap?: Maybe<PaymentOptionsGqlTypes>;
};

export type PaymentOptionsGqlTypes = {
  __typename?: 'paymentOptionsGQLTypes';
  amountFinanced?: Maybe<Scalars['Float']['output']>;
  buyPayment?: Maybe<Scalars['Float']['output']>;
  closerCommission?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  profit?: Maybe<Scalars['Float']['output']>;
  reserve?: Maybe<Scalars['Float']['output']>;
  sellPayment?: Maybe<Scalars['Float']['output']>;
  setterCommission?: Maybe<Scalars['Float']['output']>;
};

export type PaymentOptionsV2 = {
  __typename?: 'paymentOptionsV2';
  creditDecisions?: Maybe<Array<Maybe<CreditDecision>>>;
  dealId: Scalars['Int']['output'];
  gap: PaymentOptionsGqlTypes;
  noProducts: PaymentOptionsGqlTypes;
  packages: Array<PaymentOptionsPackageV2>;
  retailBookValue?: Maybe<Scalars['Float']['output']>;
  selectedPackageSlotIndex?: Maybe<Scalars['Int']['output']>;
  vsc: PaymentOptionsGqlTypes;
  vscPlusGap: PaymentOptionsGqlTypes;
};

export enum PaymentState {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Returned = 'RETURNED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN',
}

export type Payoff = {
  __typename?: 'payoff';
  account_number?: Maybe<Scalars['String']['output']>;
  cap_cost?: Maybe<Scalars['Float']['output']>;
  cap_reduction?: Maybe<Scalars['Float']['output']>;
  car_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Deprecated. Legacy estimated payoff field retained for backward compatibility. */
  estimated_payoff?: Maybe<Scalars['Float']['output']>;
  /** Date through which the payoff quote is valid. */
  good_through_date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Original lease term length in months. */
  lease_term?: Maybe<Scalars['Float']['output']>;
  lender_name?: Maybe<Scalars['String']['output']>;
  /** Canonical lienholder display name. Expected values: Acura Financial Services, Ally Financial, Audi Financial Services, Bentley Financial Services, Bethpage Federal Credit Union, BMW Financial Services, Cal Automotive, Centennial Lending, Chase Auto Finance, Chrysler Capital (CCAP), D&M Auto Leasing, Fifth Third Bank, Ford Motor Credit, Fusion Auto Finance, Genesis Finance, GM Financial, Honda Financial Services, Hudson Valley Credit Union, Huntington National Bank, Hyundai Motor Finance, Kia Finance, Land Rover Financial Group, Lexus Financial Services, Mazda Financial Services, Mercedes-Benz Financial Services, McLaren Financial Services, Metro Credit Union, Michigan State University Federal Credit Union, Mini Financial Services, NBT Bank, Nissan Finance, Porsche Payment Center, Rockland Federal Credit Union, Santander Consumer USA, Southeast Toyota Financial, Stellantis Financial Services Inc, Subaru Motor Finance, Teachers Federal Credit Union, Tesla Finance, Toyota Financial, U.S. Bank, Visions Federal Credit Union, Volvo Car Financial Services, Volkswagen Credit, Westlake Financial, Other. */
  lienholder_name?: Maybe<Scalars['String']['output']>;
  /** Canonical lienholder slug. Expected values: acura_financial_services, ally, audi_financial_services, bentley_financial_services, bethpage_fcu, bmw_fs, cal_automotive, centennial_lending, chase_auto_finance, chrystler_capital_ccap, dm_auto_leasing, fifth_third_bank, ford_motor_credit, fusion_auto_finance, genesis_finance, gm_financial, honda_financial_services, hudson_valley_cu, huntington_national_bank, hyundai_motor_finance, kia_finance, land_rover_fg, lexus_financial_services, mazda_financial_services, mclaren_financial_services, mercedes_benz_fs, metro_cu, michigan_state_university_fcu, mini_fs, nbt, nissan_finance, other, porche_payment_center, rockland_fcu, santander_consumer_usa, se_toyota, stellantis_financial_services_inc, subaru_motor_finance, teachers_fcu, tesla_finance, toyota, us_bank, visions_fcu, volkswagen_credit, volvo_car_fs, westlake. */
  lienholder_slug?: Maybe<Scalars['String']['output']>;
  /** Lease maturity or contract end date. */
  maturity_date?: Maybe<Scalars['Date']['output']>;
  money_down?: Maybe<Scalars['Float']['output']>;
  money_factor?: Maybe<Scalars['Float']['output']>;
  msrp?: Maybe<Scalars['Float']['output']>;
  /** Next scheduled payment due date from lender payoff data. */
  next_payment_date?: Maybe<Scalars['Date']['output']>;
  old_lease_payment?: Maybe<Scalars['Float']['output']>;
  payoff_changes?: Maybe<Array<Maybe<PayoffChange>>>;
  /** True when the stored payoff total is believed to already include sales tax. Payoff Intelligence can set false positives, so this flag may still require review. */
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']['output']>;
  /** Number of payments remaining at time of quote. */
  remaining_payments?: Maybe<Scalars['Float']['output']>;
  residual_amount?: Maybe<Scalars['Float']['output']>;
  residual_percentage?: Maybe<Scalars['Float']['output']>;
  sales_price?: Maybe<Scalars['Float']['output']>;
  /** Sales-tax component extracted from payoff amount in USD. */
  sales_tax_from_payoff?: Maybe<Scalars['Float']['output']>;
  /** True when sales_tax_from_payoff was manually entered instead of auto-derived. */
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']['output']>;
  set_by_label?: Maybe<Scalars['String']['output']>;
  set_by_source?: Maybe<PayoffSetBySource>;
  set_by_user_id?: Maybe<Scalars['String']['output']>;
  termination_fees?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** All-in total payoff amount in USD. Despite the column name, this may be populated by automated sources and is not limited to manual user entry. */
  user_entered_total_payoff?: Maybe<Scalars['Float']['output']>;
  /** Current payoff amount in USD from lender quote or user entry. */
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
  /** Payoff verification lifecycle status. Expected values: customer_provided, edited, sales_tax_review_needed, verified, verified_by_sales_rep. */
  verification_status?: Maybe<PayoffVerificationStatus>;
};

export type PayoffCountMake = {
  __typename?: 'payoffCountMake';
  total?: Maybe<Scalars['Float']['output']>;
};

export type PayoffCountModel = {
  __typename?: 'payoffCountModel';
  total?: Maybe<Scalars['Float']['output']>;
};

export type PayoffDashboard = {
  __typename?: 'payoffDashboard';
  payoffRequests?: Maybe<Array<Maybe<PayoffRequestPopulated>>>;
};

export type PayoffInput = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  cap_cost?: InputMaybe<Scalars['Float']['input']>;
  cap_reduction?: InputMaybe<Scalars['Float']['input']>;
  car_id?: InputMaybe<Scalars['ID']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Deprecated. Legacy estimated payoff field retained for backward compatibility. */
  estimated_payoff?: InputMaybe<Scalars['Float']['input']>;
  /** Date through which the payoff quote is valid. */
  good_through_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Original lease term length in months. */
  lease_term?: InputMaybe<Scalars['Float']['input']>;
  lender_name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical lienholder display name. Expected values: Acura Financial Services, Ally Financial, Audi Financial Services, Bentley Financial Services, Bethpage Federal Credit Union, BMW Financial Services, Cal Automotive, Centennial Lending, Chase Auto Finance, Chrysler Capital (CCAP), D&M Auto Leasing, Fifth Third Bank, Ford Motor Credit, Fusion Auto Finance, Genesis Finance, GM Financial, Honda Financial Services, Hudson Valley Credit Union, Huntington National Bank, Hyundai Motor Finance, Kia Finance, Land Rover Financial Group, Lexus Financial Services, Mazda Financial Services, Mercedes-Benz Financial Services, McLaren Financial Services, Metro Credit Union, Michigan State University Federal Credit Union, Mini Financial Services, NBT Bank, Nissan Finance, Porsche Payment Center, Rockland Federal Credit Union, Santander Consumer USA, Southeast Toyota Financial, Stellantis Financial Services Inc, Subaru Motor Finance, Teachers Federal Credit Union, Tesla Finance, Toyota Financial, U.S. Bank, Visions Federal Credit Union, Volvo Car Financial Services, Volkswagen Credit, Westlake Financial, Other. */
  lienholder_name?: InputMaybe<Scalars['String']['input']>;
  /** Canonical lienholder slug. Expected values: acura_financial_services, ally, audi_financial_services, bentley_financial_services, bethpage_fcu, bmw_fs, cal_automotive, centennial_lending, chase_auto_finance, chrystler_capital_ccap, dm_auto_leasing, fifth_third_bank, ford_motor_credit, fusion_auto_finance, genesis_finance, gm_financial, honda_financial_services, hudson_valley_cu, huntington_national_bank, hyundai_motor_finance, kia_finance, land_rover_fg, lexus_financial_services, mazda_financial_services, mclaren_financial_services, mercedes_benz_fs, metro_cu, michigan_state_university_fcu, mini_fs, nbt, nissan_finance, other, porche_payment_center, rockland_fcu, santander_consumer_usa, se_toyota, stellantis_financial_services_inc, subaru_motor_finance, teachers_fcu, tesla_finance, toyota, us_bank, visions_fcu, volkswagen_credit, volvo_car_fs, westlake. */
  lienholder_slug?: InputMaybe<Scalars['String']['input']>;
  /** Lease maturity or contract end date. */
  maturity_date?: InputMaybe<Scalars['Date']['input']>;
  money_down?: InputMaybe<Scalars['Float']['input']>;
  money_factor?: InputMaybe<Scalars['Float']['input']>;
  msrp?: InputMaybe<Scalars['Float']['input']>;
  /** Next scheduled payment due date from lender payoff data. */
  next_payment_date?: InputMaybe<Scalars['Date']['input']>;
  old_lease_payment?: InputMaybe<Scalars['Float']['input']>;
  payoff_changes?: InputMaybe<Array<InputMaybe<PayoffChangeInput>>>;
  /** True when the stored payoff total is believed to already include sales tax. Payoff Intelligence can set false positives, so this flag may still require review. */
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of payments remaining at time of quote. */
  remaining_payments?: InputMaybe<Scalars['Float']['input']>;
  residual_amount?: InputMaybe<Scalars['Float']['input']>;
  residual_percentage?: InputMaybe<Scalars['Float']['input']>;
  sales_price?: InputMaybe<Scalars['Float']['input']>;
  /** Sales-tax component extracted from payoff amount in USD. */
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']['input']>;
  /** True when sales_tax_from_payoff was manually entered instead of auto-derived. */
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']['input']>;
  termination_fees?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** All-in total payoff amount in USD. Despite the column name, this may be populated by automated sources and is not limited to manual user entry. */
  user_entered_total_payoff?: InputMaybe<Scalars['Float']['input']>;
  /** Current payoff amount in USD from lender quote or user entry. */
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
  /** Payoff verification lifecycle status. Expected values: customer_provided, edited, sales_tax_review_needed, verified, verified_by_sales_rep. */
  verification_status?: InputMaybe<PayoffVerificationStatus>;
};

export type PayoffRequest = {
  __typename?: 'payoffRequest';
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  fail_reason?: Maybe<Scalars['JSONObject']['output']>;
  good_through_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']['output']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']['output']>;
  payoff_clerk_id?: Maybe<Scalars['String']['output']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']['output']>;
  requestor_id?: Maybe<Scalars['String']['output']>;
  sales_tax?: Maybe<Scalars['Float']['output']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
};

export type PayoffRequestConfirmInput = {
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  double_tax_applied?: InputMaybe<Scalars['Boolean']['input']>;
  fail_reason?: InputMaybe<Scalars['JSONObject']['input']>;
  good_through_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_payoff_intelligence?: InputMaybe<Scalars['Boolean']['input']>;
  needs_payoff_documents?: InputMaybe<Scalars['Boolean']['input']>;
  payoff_clerk_id?: InputMaybe<Scalars['String']['input']>;
  payoff_documents_uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']['input']>;
  requestor_id?: InputMaybe<Scalars['String']['input']>;
  sales_tax?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']['input']>;
  self_serve_submitted_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PayoffRequestStatus>;
  temporary_info_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_entered_total_payoff?: InputMaybe<Scalars['Float']['input']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
};

export type PayoffRequestInput = {
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  fail_reason?: InputMaybe<Scalars['JSONObject']['input']>;
  good_through_date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_payoff_intelligence?: InputMaybe<Scalars['Boolean']['input']>;
  needs_payoff_documents?: InputMaybe<Scalars['Boolean']['input']>;
  payoff_clerk_id?: InputMaybe<Scalars['String']['input']>;
  payoff_documents_uploaded?: InputMaybe<Scalars['Boolean']['input']>;
  requestor_id?: InputMaybe<Scalars['String']['input']>;
  sales_tax?: InputMaybe<Scalars['Float']['input']>;
  self_serve_submitted_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PayoffRequestStatus>;
  temporary_info_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
};

export type PayoffRequestPopulated = {
  __typename?: 'payoffRequestPopulated';
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  fail_reason?: Maybe<Scalars['JSONObject']['output']>;
  good_through_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']['output']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']['output']>;
  payoff_clerk?: Maybe<User>;
  payoff_clerk_id?: Maybe<Scalars['String']['output']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']['output']>;
  requestor?: Maybe<User>;
  requestor_id?: Maybe<Scalars['String']['output']>;
  sales_tax?: Maybe<Scalars['Float']['output']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info?: Maybe<TemporaryInfo>;
  temporary_info_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
};

export enum PayoffRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailureRequested = 'FAILURE_REQUESTED',
  Fetching = 'FETCHING',
  Pending = 'PENDING',
}

export type PayoffRequestStatusUpdate = {
  __typename?: 'payoffRequestStatusUpdate';
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal?: Maybe<Deal>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  fail_reason?: Maybe<Scalars['JSONObject']['output']>;
  good_through_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_payoff_intelligence?: Maybe<Scalars['Boolean']['output']>;
  needs_payoff_documents?: Maybe<Scalars['Boolean']['output']>;
  payoff_clerk_id?: Maybe<Scalars['String']['output']>;
  payoff_documents_uploaded?: Maybe<Scalars['Boolean']['output']>;
  requestor_id?: Maybe<Scalars['String']['output']>;
  sales_tax?: Maybe<Scalars['Float']['output']>;
  self_serve_submitted_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PayoffRequestStatus>;
  temporary_info_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
};

export type PayoffRequestStatusUpdateWithMessage = {
  __typename?: 'payoffRequestStatusUpdateWithMessage';
  message?: Maybe<Scalars['String']['output']>;
  payoffRequest: PayoffRequestStatusUpdate;
};

export enum PayoffSetBySource {
  Manual = 'manual',
  PayoffIntelligence = 'payoff_intelligence',
  PayoffRequest = 'payoff_request',
}

export type PayoffStatsMakeModel = {
  __typename?: 'payoffStatsMakeModel';
  avg_payoff?: Maybe<Scalars['Float']['output']>;
  max_payoff?: Maybe<Scalars['Float']['output']>;
  min_payoff?: Maybe<Scalars['Float']['output']>;
};

export enum PayoffVerificationStatus {
  CustomerProvided = 'customer_provided',
  Edited = 'edited',
  SalesTaxReviewNeeded = 'sales_tax_review_needed',
  Verified = 'verified',
  VerifiedBySalesRep = 'verified_by_sales_rep',
}

export type Pod = {
  __typename?: 'pod';
  active_reps_override?: Maybe<Scalars['Int']['output']>;
  active_reps_override_set_at?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assign_overnight_deals?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_deals?: Maybe<Scalars['Boolean']['output']>;
  child_pods?: Maybe<Array<Maybe<BasePod>>>;
  closer_commission_rate?: Maybe<Scalars['Float']['output']>;
  closer_commission_type?: Maybe<CommissionType>;
  color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  fundingClerks?: Maybe<Array<Maybe<BaseUser>>>;
  hours?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  leads?: Maybe<Array<Maybe<BaseUser>>>;
  manager_commission_rate?: Maybe<Scalars['Float']['output']>;
  manager_commission_type?: Maybe<CommissionType>;
  managers?: Maybe<Array<Maybe<BaseUser>>>;
  name?: Maybe<Scalars['String']['output']>;
  parent_pod?: Maybe<BasePod>;
  parent_pod_id?: Maybe<Scalars['ID']['output']>;
  pause_auto_assign?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pod_users?: Maybe<Array<Maybe<PodUser>>>;
  problem_solver?: Maybe<Scalars['Boolean']['output']>;
  setter_commission_rate?: Maybe<Scalars['Float']['output']>;
  setter_commission_type?: Maybe<CommissionType>;
  special_commission_rate?: Maybe<Scalars['Float']['output']>;
  special_commission_type?: Maybe<CommissionType>;
  team_type?: Maybe<TeamType>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  us_states_object?: Maybe<UsStatesObject>;
  usersWithoutTeamRole?: Maybe<Array<Maybe<BaseUser>>>;
};

export type PodHours = {
  __typename?: 'podHours';
  beginTime?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type PodInput = {
  active_reps_override?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assign_overnight_deals?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']['input']>;
  child_pods?: InputMaybe<Array<InputMaybe<BasePodInput>>>;
  closer_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  closer_commission_type?: InputMaybe<CommissionType>;
  color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  fundingClerks?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  hours?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  leads?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  manager_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  manager_commission_type?: InputMaybe<CommissionType>;
  managers?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_pod?: InputMaybe<BasePodInput>;
  parent_pod_id?: InputMaybe<Scalars['ID']['input']>;
  pause_auto_assign?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pod_users?: InputMaybe<Array<InputMaybe<PodUserInput>>>;
  problem_solver?: InputMaybe<Scalars['Boolean']['input']>;
  setter_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  setter_commission_type?: InputMaybe<CommissionType>;
  special_commission_rate?: InputMaybe<Scalars['Float']['input']>;
  special_commission_type?: InputMaybe<CommissionType>;
  team_type?: InputMaybe<TeamType>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  us_states_object?: InputMaybe<UsStatesInputObject>;
  users?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
  usersWithoutTeamRole?: InputMaybe<Array<InputMaybe<BaseUserInput>>>;
};

export type PodUser = {
  __typename?: 'podUser';
  id?: Maybe<Scalars['ID']['output']>;
  pod_id?: Maybe<Scalars['Int']['output']>;
  team_role?: Maybe<TeamRole>;
  user?: Maybe<BaseUser>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type PodUserInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pod_id?: InputMaybe<Scalars['Int']['input']>;
  team_role?: InputMaybe<TeamRole>;
  user?: InputMaybe<BaseUserInput>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum PotentialRoleEnumType {
  Closer = 'closer',
  NotAssigned = 'not_assigned',
  Setter = 'setter',
  SetterLead = 'setter_lead',
}

export type PotentialUser = {
  __typename?: 'potentialUser';
  added_to_testflight: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  email_created: Scalars['Boolean']['output'];
  employment_status: EmploymentEnumType;
  hired: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  interview_scheduled: Scalars['Boolean']['output'];
  login_created: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  potential_role: PotentialRoleEnumType;
  reached_out: Scalars['Boolean']['output'];
  referral_code?: Maybe<Scalars['String']['output']>;
  signup_date: Scalars['DateTime']['output'];
  slack_created: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  zip: Scalars['Int']['output'];
};

export type PotentialUserInput = {
  email: Scalars['String']['input'];
  employment_status: EmploymentEnumType;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referral_code?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['Int']['input'];
};

export type Prequalification = {
  __typename?: 'prequalification';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credit_score?: Maybe<Scalars['Int']['output']>;
  credit_score_tier?: Maybe<CreditScoreTierEnumType>;
  customer_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  input?: Maybe<PrequalificationRequest>;
  lease_monthly_payment?: Maybe<Scalars['Float']['output']>;
  ltv?: Maybe<Scalars['Float']['output']>;
  output?: Maybe<ExperianOutput>;
  payment_to_income?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type Product = {
  __typename?: 'product';
  gap_selected?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
  provider_dealer_code_name?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
  selected_package?: Maybe<Scalars['String']['output']>;
};

export type ProofOfInsurance = {
  __typename?: 'proofOfInsurance';
  company_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  expires?: Maybe<Scalars['DateTime']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  policy_number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ProofOfInsuranceInput = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  policy_number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Provider = {
  __typename?: 'provider';
  name?: Maybe<Scalars['String']['output']>;
  provider_id?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'purchaseOrder';
  files?: Maybe<Array<Maybe<File>>>;
};

export type R1CreditDecisionData = {
  __typename?: 'r1CreditDecisionData';
  applicationNumber?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<CreditDecisionStatusEnum>;
  applicationStatusDetail?: Maybe<Scalars['String']['output']>;
  contractTerm?: Maybe<ContractTerm>;
  decision?: Maybe<Decision>;
};

export type Rate = {
  __typename?: 'rate';
  coverage_name?: Maybe<Scalars['String']['output']>;
  deductible?: Maybe<Deductible>;
  form_id?: Maybe<Scalars['Int']['output']>;
  form_name?: Maybe<Scalars['String']['output']>;
  form_number?: Maybe<Scalars['String']['output']>;
  product_type?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  term_miles?: Maybe<Scalars['String']['output']>;
  term_months?: Maybe<Scalars['String']['output']>;
};

export type RateInput = {
  apr?: InputMaybe<Scalars['Float']['input']>;
  financeTerms?: InputMaybe<Scalars['Int']['input']>;
  financeTermsMileage?: InputMaybe<Scalars['Int']['input']>;
  financedAmount?: InputMaybe<Scalars['Float']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  msrp?: InputMaybe<Scalars['Float']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferralSource = {
  __typename?: 'referralSource';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  other_source_description?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<ReferralSourceEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralSourceInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  other_source_description?: InputMaybe<Scalars['String']['input']>;
  source_name?: InputMaybe<ReferralSourceEnum>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum RelationToBuyerEnum {
  Child = 'child',
  Other = 'other',
  Parent = 'parent',
  ResidesWith = 'resides_with',
  Spouse = 'spouse',
}

export type ResultAddParticipant = {
  __typename?: 'resultAddParticipant';
  call_already_answered?: Maybe<Scalars['Boolean']['output']>;
  call_already_ended?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ResultHandleThunderOutboundCall = {
  __typename?: 'resultHandleThunderOutboundCall';
  call_already_answered?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Review = {
  __typename?: 'review';
  com_visible?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ReviewInput = {
  com_visible?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SecureLink = {
  __typename?: 'secureLink';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<Customer>;
  customer_id: Scalars['ID']['output'];
  expiration_date: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  link: Scalars['String']['output'];
  notified: Scalars['Boolean']['output'];
  sender?: Maybe<User>;
  sender_id?: Maybe<Scalars['ID']['output']>;
  status: SecureLinkStatus;
  token: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SigningAuditDocumentViewedEvent = {
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  document_id?: InputMaybe<Scalars['String']['input']>;
  document_name?: InputMaybe<Scalars['String']['input']>;
  is_cobuyer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SigningError = {
  __typename?: 'signingError';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deal_id?: Maybe<Scalars['ID']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  error_type?: Maybe<SigningErrorEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SigningErrorDetail = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentName?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  signatureFieldName?: InputMaybe<Scalars['String']['input']>;
};

export type SigningErrorInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  deal_id?: InputMaybe<Scalars['ID']['input']>;
  error_details?: InputMaybe<SigningErrorDetail>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_type?: InputMaybe<SigningErrorEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SmartPayoff = {
  __typename?: 'smartPayoff';
  message?: Maybe<Scalars['String']['output']>;
  payoff?: Maybe<Scalars['Float']['output']>;
  retail_value?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SmartPayoffAffiliate = {
  __typename?: 'smartPayoffAffiliate';
  message?: Maybe<Scalars['String']['output']>;
  payoff?: Maybe<Scalars['Float']['output']>;
  retail_value?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Surcharge = {
  __typename?: 'surcharge';
  car_status?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum TeamRole {
  FundingClerk = 'funding_clerk',
  Lead = 'lead',
  Manager = 'manager',
}

export enum TeamType {
  D2d = 'd2d',
  FinancialSpecialist = 'financial_specialist',
  Inbound = 'inbound',
  Outbound = 'outbound',
  Region = 'region',
  Titling = 'titling',
}

export type TemporaryData = {
  __typename?: 'temporaryData';
  address_line?: Maybe<Scalars['String']['output']>;
  address_line_2?: Maybe<Scalars['String']['output']>;
  affiliate_external_id?: Maybe<Scalars['String']['output']>;
  affiliate_note?: Maybe<Scalars['String']['output']>;
  affiliate_provider_name?: Maybe<Scalars['String']['output']>;
  assistant_note?: Maybe<Scalars['String']['output']>;
  automatic_equity_note?: Maybe<Scalars['String']['output']>;
  automatically_fetched_payoff?: Maybe<Scalars['Boolean']['output']>;
  book_value?: Maybe<Scalars['Float']['output']>;
  cash_to_customer?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cobuyer_address_line?: Maybe<Scalars['String']['output']>;
  cobuyer_address_line_2?: Maybe<Scalars['String']['output']>;
  cobuyer_city?: Maybe<Scalars['String']['output']>;
  cobuyer_county?: Maybe<Scalars['String']['output']>;
  cobuyer_dob?: Maybe<Scalars['DateTime']['output']>;
  cobuyer_email?: Maybe<Scalars['String']['output']>;
  cobuyer_employer_name?: Maybe<Scalars['String']['output']>;
  cobuyer_employer_phone_number?: Maybe<Scalars['String']['output']>;
  cobuyer_employment_status?: Maybe<Scalars['String']['output']>;
  cobuyer_first_name?: Maybe<Scalars['String']['output']>;
  cobuyer_job_title?: Maybe<Scalars['String']['output']>;
  cobuyer_last_name?: Maybe<Scalars['String']['output']>;
  cobuyer_marital_status?: Maybe<MaritalStatusEnum>;
  cobuyer_months_at_job?: Maybe<Scalars['Int']['output']>;
  cobuyer_pay_frequency?: Maybe<Scalars['String']['output']>;
  cobuyer_phone_number?: Maybe<Scalars['String']['output']>;
  cobuyer_prequalification_errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cobuyer_previous_address_line?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_address_line_2?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_city?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_county?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_employer_name?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_employer_phone_number?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_job_title?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_months_at_job?: Maybe<Scalars['Int']['output']>;
  cobuyer_previous_state?: Maybe<Scalars['String']['output']>;
  cobuyer_previous_years_at_job?: Maybe<Scalars['Int']['output']>;
  cobuyer_previous_zip?: Maybe<Scalars['String']['output']>;
  cobuyer_primary_residence_monthly_payment?: Maybe<Scalars['Float']['output']>;
  cobuyer_primary_residence_months?: Maybe<Scalars['Int']['output']>;
  cobuyer_primary_residence_type?: Maybe<Scalars['String']['output']>;
  cobuyer_primary_residence_years?: Maybe<Scalars['Int']['output']>;
  cobuyer_relation_to_buyer?: Maybe<RelationToBuyerEnum>;
  cobuyer_salary?: Maybe<Scalars['Float']['output']>;
  cobuyer_secondary_residence_months?: Maybe<Scalars['Int']['output']>;
  cobuyer_secondary_residence_years?: Maybe<Scalars['Int']['output']>;
  cobuyer_ssn_id?: Maybe<Scalars['ID']['output']>;
  cobuyer_state?: Maybe<Scalars['String']['output']>;
  cobuyer_years_at_job?: Maybe<Scalars['Int']['output']>;
  cobuyer_zip?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  condition_report?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']['output']>;
  credit_score?: Maybe<Scalars['Int']['output']>;
  current_accordion_panel?: Maybe<Scalars['String']['output']>;
  dev_prequal_credit_score?: Maybe<Scalars['Int']['output']>;
  dev_prequal_override?: Maybe<Scalars['Boolean']['output']>;
  device_type?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['DateTime']['output']>;
  doc_fee?: Maybe<Scalars['Float']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employer_name?: Maybe<Scalars['String']['output']>;
  employer_phone_number?: Maybe<Scalars['String']['output']>;
  employment_status?: Maybe<Scalars['String']['output']>;
  estimated_dealer_fees?: Maybe<Scalars['Float']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  good_through_date?: Maybe<Scalars['DateTime']['output']>;
  has_full_ssn?: Maybe<Scalars['Boolean']['output']>;
  high_ltv_ratio?: Maybe<Scalars['Boolean']['output']>;
  include_cobuyer?: Maybe<Scalars['Boolean']['output']>;
  is_chat?: Maybe<Scalars['Boolean']['output']>;
  is_hard_pull?: Maybe<Scalars['Boolean']['output']>;
  is_methodfi_flow?: Maybe<Scalars['Boolean']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  kbb_all_options?: Maybe<Scalars['JSON']['output']>;
  kbb_lending_mileage_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_lending_option_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_retail_mileage_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_retail_option_adjustment?: Maybe<Scalars['Float']['output']>;
  kbb_selected_options?: Maybe<Scalars['JSON']['output']>;
  kbb_trim_name?: Maybe<Scalars['String']['output']>;
  kbb_valuation_date?: Maybe<Scalars['String']['output']>;
  kbb_vehicle_id?: Maybe<Scalars['Int']['output']>;
  kbb_vehicle_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_url?: Maybe<Scalars['String']['output']>;
  lh_account_number?: Maybe<Scalars['String']['output']>;
  license_plate_number?: Maybe<Scalars['String']['output']>;
  license_plate_state?: Maybe<Scalars['String']['output']>;
  lienholder?: Maybe<Scalars['String']['output']>;
  lienholderLogo?: Maybe<Scalars['String']['output']>;
  lienholder_slug?: Maybe<Scalars['String']['output']>;
  likely_address_accepted?: Maybe<Scalars['Boolean']['output']>;
  likely_address_address_line?: Maybe<Scalars['String']['output']>;
  likely_address_address_line_2?: Maybe<Scalars['String']['output']>;
  likely_address_city?: Maybe<Scalars['String']['output']>;
  likely_address_county?: Maybe<Scalars['String']['output']>;
  likely_address_query_run?: Maybe<Scalars['Boolean']['output']>;
  likely_address_query_success?: Maybe<Scalars['Boolean']['output']>;
  likely_address_state?: Maybe<Scalars['String']['output']>;
  likely_address_zip?: Maybe<Scalars['String']['output']>;
  lives_with_other_buyer?: Maybe<Scalars['Boolean']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  manual_entry?: Maybe<Scalars['Boolean']['output']>;
  marital_status?: Maybe<MaritalStatusEnum>;
  methodfi_flow_variation?: Maybe<Scalars['Int']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  mmr_value?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  months_at_job?: Maybe<Scalars['Int']['output']>;
  moved_states?: Maybe<Scalars['Boolean']['output']>;
  odometer_status?: Maybe<OdometerStatus>;
  old_lease_payment?: Maybe<Scalars['Float']['output']>;
  other_lienholder?: Maybe<Scalars['String']['output']>;
  pay_frequency?: Maybe<Scalars['String']['output']>;
  payment_estimate_high?: Maybe<Scalars['Float']['output']>;
  payment_estimate_low?: Maybe<Scalars['Float']['output']>;
  payoff_duration_time_ms?: Maybe<Scalars['Int']['output']>;
  payoff_includes_sales_tax?: Maybe<Scalars['Boolean']['output']>;
  payoff_initiated_time?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  prequal_id?: Maybe<Scalars['ID']['output']>;
  prequalification_errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  prequalification_success?: Maybe<Scalars['Boolean']['output']>;
  previous_address_line?: Maybe<Scalars['String']['output']>;
  previous_address_line_2?: Maybe<Scalars['String']['output']>;
  previous_city?: Maybe<Scalars['String']['output']>;
  previous_county?: Maybe<Scalars['String']['output']>;
  previous_employer_name?: Maybe<Scalars['String']['output']>;
  previous_employer_phone_number?: Maybe<Scalars['String']['output']>;
  previous_job_title?: Maybe<Scalars['String']['output']>;
  previous_months_at_job?: Maybe<Scalars['Int']['output']>;
  previous_state?: Maybe<Scalars['String']['output']>;
  previous_years_at_job?: Maybe<Scalars['Int']['output']>;
  previous_zip?: Maybe<Scalars['String']['output']>;
  primary_residence_monthly_payment?: Maybe<Scalars['Float']['output']>;
  primary_residence_months?: Maybe<Scalars['Int']['output']>;
  primary_residence_type?: Maybe<Scalars['String']['output']>;
  primary_residence_years?: Maybe<Scalars['Int']['output']>;
  query_params?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  retail_book_value?: Maybe<Scalars['Float']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  sales_tax_from_payoff?: Maybe<Scalars['Float']['output']>;
  sales_tax_from_payoff_entered_manually?: Maybe<Scalars['Boolean']['output']>;
  scheduled_call_datetime?: Maybe<Scalars['DateTime']['output']>;
  scheduled_call_datetime_tz?: Maybe<Scalars['String']['output']>;
  secondary_residence_months?: Maybe<Scalars['Int']['output']>;
  secondary_residence_years?: Maybe<Scalars['Int']['output']>;
  sell_timeline?: Maybe<Scalars['String']['output']>;
  shopping_cart?: Maybe<TemporaryShoppingCartData>;
  ssn_id?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stress_test_payoff_requested?: Maybe<Scalars['Boolean']['output']>;
  taxes?: Maybe<Scalars['Decimal']['output']>;
  taxes_fees?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  title_only?: Maybe<Scalars['Boolean']['output']>;
  trade_in_preference?: Maybe<Scalars['String']['output']>;
  uploaded_files?: Maybe<Scalars['JSON']['output']>;
  user_entered_total_payoff?: Maybe<Scalars['Float']['output']>;
  vehicle_offer?: Maybe<Scalars['Float']['output']>;
  vehicle_payoff?: Maybe<Scalars['Float']['output']>;
  vehicle_registration_fee?: Maybe<Scalars['Float']['output']>;
  vehicle_type?: Maybe<Scalars['String']['output']>;
  verified_phone_number?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  wants_to_sell?: Maybe<Scalars['Boolean']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  years_at_job?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type TemporaryDataInput = {
  address_line?: InputMaybe<Scalars['String']['input']>;
  address_line_2?: InputMaybe<Scalars['String']['input']>;
  affiliate_external_id?: InputMaybe<Scalars['String']['input']>;
  affiliate_note?: InputMaybe<Scalars['String']['input']>;
  affiliate_provider_name?: InputMaybe<Scalars['String']['input']>;
  assistant_note?: InputMaybe<Scalars['String']['input']>;
  automatic_equity_note?: InputMaybe<Scalars['String']['input']>;
  automatically_fetched_payoff?: InputMaybe<Scalars['Boolean']['input']>;
  book_value?: InputMaybe<Scalars['Float']['input']>;
  cash_to_customer?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cobuyer_address_line?: InputMaybe<Scalars['String']['input']>;
  cobuyer_address_line_2?: InputMaybe<Scalars['String']['input']>;
  cobuyer_city?: InputMaybe<Scalars['String']['input']>;
  cobuyer_county?: InputMaybe<Scalars['String']['input']>;
  cobuyer_dob?: InputMaybe<Scalars['DateTime']['input']>;
  cobuyer_email?: InputMaybe<Scalars['String']['input']>;
  cobuyer_employer_name?: InputMaybe<Scalars['String']['input']>;
  cobuyer_employer_phone_number?: InputMaybe<Scalars['String']['input']>;
  cobuyer_employment_status?: InputMaybe<Scalars['String']['input']>;
  cobuyer_first_name?: InputMaybe<Scalars['String']['input']>;
  cobuyer_job_title?: InputMaybe<Scalars['String']['input']>;
  cobuyer_last_name?: InputMaybe<Scalars['String']['input']>;
  cobuyer_marital_status?: InputMaybe<MaritalStatusEnum>;
  cobuyer_months_at_job?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_pay_frequency?: InputMaybe<Scalars['String']['input']>;
  cobuyer_phone_number?: InputMaybe<Scalars['String']['input']>;
  cobuyer_prequalification_errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cobuyer_previous_address_line?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_address_line_2?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_city?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_county?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_employer_name?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_employer_phone_number?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_job_title?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_months_at_job?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_previous_state?: InputMaybe<Scalars['String']['input']>;
  cobuyer_previous_years_at_job?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_previous_zip?: InputMaybe<Scalars['String']['input']>;
  cobuyer_primary_residence_monthly_payment?: InputMaybe<Scalars['Float']['input']>;
  cobuyer_primary_residence_months?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_primary_residence_type?: InputMaybe<Scalars['String']['input']>;
  cobuyer_primary_residence_years?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_relation_to_buyer?: InputMaybe<RelationToBuyerEnum>;
  cobuyer_salary?: InputMaybe<Scalars['Float']['input']>;
  cobuyer_secondary_residence_months?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_secondary_residence_years?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_ssn_id?: InputMaybe<Scalars['ID']['input']>;
  cobuyer_state?: InputMaybe<Scalars['String']['input']>;
  cobuyer_years_at_job?: InputMaybe<Scalars['Int']['input']>;
  cobuyer_zip?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  condition_report?: InputMaybe<Scalars['JSON']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  credit_score?: InputMaybe<Scalars['Int']['input']>;
  current_accordion_panel?: InputMaybe<Scalars['String']['input']>;
  dev_prequal_credit_score?: InputMaybe<Scalars['Int']['input']>;
  dev_prequal_override?: InputMaybe<Scalars['Boolean']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  doc_fee?: InputMaybe<Scalars['Float']['input']>;
  down_payment?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employer_name?: InputMaybe<Scalars['String']['input']>;
  employer_phone_number?: InputMaybe<Scalars['String']['input']>;
  employment_status?: InputMaybe<Scalars['String']['input']>;
  estimated_dealer_fees?: InputMaybe<Scalars['Float']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  good_through_date?: InputMaybe<Scalars['DateTime']['input']>;
  has_full_ssn?: InputMaybe<Scalars['Boolean']['input']>;
  high_ltv_ratio?: InputMaybe<Scalars['Boolean']['input']>;
  include_cobuyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_chat?: InputMaybe<Scalars['Boolean']['input']>;
  is_hard_pull?: InputMaybe<Scalars['Boolean']['input']>;
  is_methodfi_flow?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  kbb_all_options?: InputMaybe<Scalars['JSON']['input']>;
  kbb_lending_mileage_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_lending_option_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_retail_mileage_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_retail_option_adjustment?: InputMaybe<Scalars['Float']['input']>;
  kbb_selected_options?: InputMaybe<Scalars['JSON']['input']>;
  kbb_trim_name?: InputMaybe<Scalars['String']['input']>;
  kbb_valuation_date?: InputMaybe<Scalars['String']['input']>;
  kbb_vehicle_id?: InputMaybe<Scalars['Int']['input']>;
  kbb_vehicle_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_url?: InputMaybe<Scalars['String']['input']>;
  lh_account_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  lienholder?: InputMaybe<Scalars['String']['input']>;
  lienholderLogo?: InputMaybe<Scalars['String']['input']>;
  lienholder_slug?: InputMaybe<Scalars['String']['input']>;
  likely_address_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  likely_address_address_line?: InputMaybe<Scalars['String']['input']>;
  likely_address_address_line_2?: InputMaybe<Scalars['String']['input']>;
  likely_address_city?: InputMaybe<Scalars['String']['input']>;
  likely_address_county?: InputMaybe<Scalars['String']['input']>;
  likely_address_query_run?: InputMaybe<Scalars['Boolean']['input']>;
  likely_address_query_success?: InputMaybe<Scalars['Boolean']['input']>;
  likely_address_state?: InputMaybe<Scalars['String']['input']>;
  likely_address_zip?: InputMaybe<Scalars['String']['input']>;
  lives_with_other_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  manual_entry?: InputMaybe<Scalars['Boolean']['input']>;
  marital_status?: InputMaybe<MaritalStatusEnum>;
  methodfi_flow_variation?: InputMaybe<Scalars['Int']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  mmr_value?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  months_at_job?: InputMaybe<Scalars['Int']['input']>;
  moved_states?: InputMaybe<Scalars['Boolean']['input']>;
  odometer_status?: InputMaybe<OdometerStatus>;
  old_lease_payment?: InputMaybe<Scalars['Float']['input']>;
  other_lienholder?: InputMaybe<Scalars['String']['input']>;
  pay_frequency?: InputMaybe<Scalars['String']['input']>;
  payment_estimate_high?: InputMaybe<Scalars['Float']['input']>;
  payment_estimate_low?: InputMaybe<Scalars['Float']['input']>;
  payoff_duration_time_ms?: InputMaybe<Scalars['Int']['input']>;
  payoff_includes_sales_tax?: InputMaybe<Scalars['Boolean']['input']>;
  payoff_initiated_time?: InputMaybe<Scalars['DateTime']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  prequal_id?: InputMaybe<Scalars['ID']['input']>;
  prequalification_errors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prequalification_success?: InputMaybe<Scalars['Boolean']['input']>;
  previous_address_line?: InputMaybe<Scalars['String']['input']>;
  previous_address_line_2?: InputMaybe<Scalars['String']['input']>;
  previous_city?: InputMaybe<Scalars['String']['input']>;
  previous_county?: InputMaybe<Scalars['String']['input']>;
  previous_employer_name?: InputMaybe<Scalars['String']['input']>;
  previous_employer_phone_number?: InputMaybe<Scalars['String']['input']>;
  previous_job_title?: InputMaybe<Scalars['String']['input']>;
  previous_months_at_job?: InputMaybe<Scalars['Int']['input']>;
  previous_state?: InputMaybe<Scalars['String']['input']>;
  previous_years_at_job?: InputMaybe<Scalars['Int']['input']>;
  previous_zip?: InputMaybe<Scalars['String']['input']>;
  primary_residence_monthly_payment?: InputMaybe<Scalars['Float']['input']>;
  primary_residence_months?: InputMaybe<Scalars['Int']['input']>;
  primary_residence_type?: InputMaybe<Scalars['String']['input']>;
  primary_residence_years?: InputMaybe<Scalars['Int']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  retail_book_value?: InputMaybe<Scalars['Float']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_from_payoff?: InputMaybe<Scalars['Float']['input']>;
  sales_tax_from_payoff_entered_manually?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_call_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduled_call_datetime_tz?: InputMaybe<Scalars['String']['input']>;
  secondary_residence_months?: InputMaybe<Scalars['Int']['input']>;
  secondary_residence_years?: InputMaybe<Scalars['Int']['input']>;
  sell_timeline?: InputMaybe<Scalars['String']['input']>;
  shopping_cart?: InputMaybe<TemporaryShoppingCartDataInput>;
  ssn_id?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stress_test_payoff_requested?: InputMaybe<Scalars['Boolean']['input']>;
  taxes?: InputMaybe<Scalars['Decimal']['input']>;
  taxes_fees?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
  title_only?: InputMaybe<Scalars['Boolean']['input']>;
  trade_in_preference?: InputMaybe<Scalars['String']['input']>;
  uploaded_files?: InputMaybe<Scalars['JSON']['input']>;
  user_entered_total_payoff?: InputMaybe<Scalars['Float']['input']>;
  vehicle_offer?: InputMaybe<Scalars['Float']['input']>;
  vehicle_payoff?: InputMaybe<Scalars['Float']['input']>;
  vehicle_registration_fee?: InputMaybe<Scalars['Float']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  verified_phone_number?: InputMaybe<Scalars['String']['input']>;
  vin?: InputMaybe<Scalars['String']['input']>;
  wants_to_sell?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  years_at_job?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type TemporaryInfo = {
  __typename?: 'temporaryInfo';
  affiliate_id?: Maybe<Scalars['ID']['output']>;
  consents?: Maybe<Array<Maybe<Consent>>>;
  data: TemporaryData;
  deal_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<TemporaryInfoStatusEnumType>;
};

export type TemporaryInfoInput = {
  data: TemporaryDataInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TemporaryInfoStatusEnumType>;
};

export enum TemporaryInfoStatusEnumType {
  Duplicate = 'duplicate',
  Imported = 'imported',
}

export type TemporaryShoppingCartData = {
  __typename?: 'temporaryShoppingCartData';
  buyout?: Maybe<Scalars['Float']['output']>;
  credit_score?: Maybe<Scalars['Int']['output']>;
  down_payment?: Maybe<Scalars['Float']['output']>;
  estimated_fees?: Maybe<Scalars['Float']['output']>;
  loan_term?: Maybe<Scalars['Int']['output']>;
  payment_estimate_high?: Maybe<Scalars['Float']['output']>;
  payment_estimate_low?: Maybe<Scalars['Float']['output']>;
};

export type TemporaryShoppingCartDataInput = {
  buyout?: InputMaybe<Scalars['Float']['input']>;
  credit_score?: InputMaybe<Scalars['Int']['input']>;
  down_payment?: InputMaybe<Scalars['Float']['input']>;
  estimated_fees?: InputMaybe<Scalars['Float']['input']>;
  loan_term?: InputMaybe<Scalars['Int']['input']>;
  payment_estimate_high?: InputMaybe<Scalars['Float']['input']>;
  payment_estimate_low?: InputMaybe<Scalars['Float']['input']>;
};

export type TextMessage = {
  __typename?: 'textMessage';
  account_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  date_created?: Maybe<Scalars['String']['output']>;
  date_sent?: Maybe<Scalars['String']['output']>;
  date_updated?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<Scalars['String']['output']>;
  media_list_object?: Maybe<MediaListObj>;
  message?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  recipient_phone_number?: Maybe<Scalars['String']['output']>;
  resolved_media?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type TextMessageInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  date_created?: InputMaybe<Scalars['String']['input']>;
  date_sent?: InputMaybe<Scalars['String']['input']>;
  date_updated?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['String']['input']>;
  media_list_object?: InputMaybe<MediaListInputObj>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
  recipient_phone_number?: InputMaybe<Scalars['String']['input']>;
  resolved_media?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserInput>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum TiresEnumType {
  Fine = 'fine',
  NeedReplacing = 'need_replacing',
  New = 'new',
}

export enum TransformType {
  AcquisitionNotApproved = 'ACQUISITION_NOT_APPROVED',
  Affiliate = 'AFFILIATE',
  AffiliateAutomatic = 'AFFILIATE_AUTOMATIC',
  AffiliateInactivityImport = 'AFFILIATE_INACTIVITY_IMPORT',
  AutomaticAssistant = 'AUTOMATIC_ASSISTANT',
  AutomaticEquity = 'AUTOMATIC_EQUITY',
  AutomaticPayment = 'AUTOMATIC_PAYMENT',
  AutoStructureBegin = 'AUTO_STRUCTURE_BEGIN',
  Canada = 'CANADA',
  FrozenOrLockedCredit = 'FROZEN_OR_LOCKED_CREDIT',
  InactivityImport = 'INACTIVITY_IMPORT',
  LienholderNotApproved = 'LIENHOLDER_NOT_APPROVED',
  ManualImportPostSoftPull = 'MANUAL_IMPORT_POST_SOFT_PULL',
  ManualImportPreSoftPull = 'MANUAL_IMPORT_PRE_SOFT_PULL',
  MarketingNurture = 'MARKETING_NURTURE',
  MarketingNurturePaymentCalculator = 'MARKETING_NURTURE_PAYMENT_CALCULATOR',
  NoKbbFailure = 'NO_KBB_FAILURE',
  OtherLienholder = 'OTHER_LIENHOLDER',
  PayoffRequestFailure = 'PAYOFF_REQUEST_FAILURE',
  PayoffRequestInProgress = 'PAYOFF_REQUEST_IN_PROGRESS',
  PayoffRequestSuccess = 'PAYOFF_REQUEST_SUCCESS',
  PiUnavailable = 'PI_UNAVAILABLE',
  SoftPullFailure = 'SOFT_PULL_FAILURE',
  SoftPullFailureAutoImport = 'SOFT_PULL_FAILURE_AUTO_IMPORT',
  SoftPullSuccessAutoImport = 'SOFT_PULL_SUCCESS_AUTO_IMPORT',
}

export type TwilioNumber = {
  __typename?: 'twilioNumber';
  friendlyName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type UsStatesInputObject = {
  states?: InputMaybe<Array<InputMaybe<StateAbbreviation>>>;
};

export type UsStatesObject = {
  __typename?: 'usStatesObject';
  states?: Maybe<Array<Maybe<StateAbbreviation>>>;
};

export type User = {
  __typename?: 'user';
  assignment_mode?: Maybe<AssignmentMode>;
  auth0_roles?: Maybe<UserRoles>;
  autoAssignEligibility?: Maybe<UserAutoAssignEligibility>;
  auto_assign_deals?: Maybe<Scalars['Boolean']['output']>;
  auto_assign_marketplace_deals?: Maybe<Scalars['Boolean']['output']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: Maybe<Scalars['String']['output']>;
  can_claim_as_closer?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frequency_minutes?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  huntGroups?: Maybe<Array<Maybe<HuntGroup>>>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  max_auto_assign_deals?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  on_vacation?: Maybe<Scalars['Boolean']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  pods?: Maybe<Array<Maybe<Pod>>>;
  recruiter_id?: Maybe<Scalars['String']['output']>;
  titlingPods?: Maybe<Array<Maybe<Pod>>>;
  twilio_number?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<UserType>;
};

export type UserAutoAssignEligibility = {
  __typename?: 'userAutoAssignEligibility';
  accept_ai_touched_deals: Scalars['Boolean']['output'];
  accept_overnight_deals: Scalars['Boolean']['output'];
  accept_unseen_deals: Scalars['Boolean']['output'];
  accept_with_upcoming_appointment: Scalars['Boolean']['output'];
  deals_with_bank_fees: Scalars['Boolean']['output'];
  deals_with_direct_pay: Scalars['Boolean']['output'];
  deals_with_double_tax: Scalars['Boolean']['output'];
  deals_with_down_payment: Scalars['Boolean']['output'];
  deals_with_gap: Scalars['Boolean']['output'];
  deals_with_stipulations: Scalars['Boolean']['output'];
  deals_with_vsc: Scalars['Boolean']['output'];
  user_id: Scalars['String']['output'];
};

export type UserInput = {
  assignment_mode?: InputMaybe<AssignmentMode>;
  auto_assign_deals?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_marketplace_deals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current call handling status for the user. Expected values: active, inactive. */
  call_status?: InputMaybe<Scalars['String']['input']>;
  can_claim_as_closer?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  frequency_minutes?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationType>;
  max_auto_assign_deals?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  on_vacation?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  pods?: InputMaybe<Array<InputMaybe<PodInput>>>;
  recruiter_id?: InputMaybe<Scalars['String']['input']>;
  titlingPods?: InputMaybe<Array<InputMaybe<PodInput>>>;
  twilio_number?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<UserType>;
};

export type Value = {
  __typename?: 'value';
  buyout?: Maybe<Scalars['Float']['output']>;
  refi?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type VisibleArticles = {
  __typename?: 'visibleArticles';
  results?: Maybe<Array<Maybe<Article>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type VscRateOption = {
  __typename?: 'vscRateOption';
  cost: Scalars['Float']['output'];
  coverageName: Scalars['String']['output'];
  formName: Scalars['String']['output'];
  penFormId: Scalars['Int']['output'];
  penRateId: Scalars['Int']['output'];
  penSessionId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  retailPrice: Scalars['Float']['output'];
  termMiles: Scalars['Int']['output'];
  termMonths: Scalars['Int']['output'];
};

export type WaitingCall = {
  __typename?: 'waitingCall';
  conference_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  deal_id?: Maybe<Scalars['Int']['output']>;
  deal_state?: Maybe<Scalars['String']['output']>;
  deal_type?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  hunt_group_slug?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_thunder?: Maybe<Scalars['Boolean']['output']>;
  partner_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  processing_started_at?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  thunder_data?: Maybe<Scalars['JSONObject']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  transferred_from?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ValidZipQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;

export type ValidZipQuery = { __typename?: 'Query'; validZip?: boolean | null | undefined };

export type AddressDetailQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddressDetailQuery = {
  __typename?: 'Query';
  addressDetail?:
    | {
        __typename?: 'AddressDetail';
        city?: string | null | undefined;
        county?: string | null | undefined;
        state?: string | null | undefined;
      }
    | null
    | undefined;
};

export type AffiliateDetailsQueryVariables = Exact<{
  affiliateExternalId?: InputMaybe<Scalars['String']['input']>;
}>;

export type AffiliateDetailsQuery = {
  __typename?: 'Query';
  affiliateDetails?:
    | {
        __typename?: 'affiliate';
        external_id?: string | null | undefined;
        decision_accepted?: boolean | null | undefined;
        affiliate_provider?:
          | {
              __typename?: 'affiliate_provider';
              id?: string | null | undefined;
              slug?: AffiliateProviderSlug | null | undefined;
              name?: string | null | undefined;
            }
          | null
          | undefined;
        decision_response?:
          | {
              __typename?: 'lending_tree_decision_response';
              offers?:
                | Array<
                    | {
                        __typename?: 'lending_tree_offer';
                        amount?: number | null | undefined;
                        term?: number | null | undefined;
                        apr?: number | null | undefined;
                        monthlyPayment?: number | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CheckAffiliateDealExistsQueryVariables = Exact<{
  affiliateExternalId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CheckAffiliateDealExistsQuery = {
  __typename?: 'Query';
  checkAffiliateDealExists?: boolean | null | undefined;
};

export type ResetPasswordAndSendEmailMutationVariables = Exact<{
  password?: InputMaybe<Scalars['String']['input']>;
}>;

export type ResetPasswordAndSendEmailMutation = {
  __typename?: 'RootMutationType';
  resetPasswordAndSendEmail?: any | null | undefined;
};

export type CheckExistingAccountByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type CheckExistingAccountByEmailQuery = {
  __typename?: 'Query';
  checkExistingAccountByEmail?: boolean | null | undefined;
};

export type CheckExistingAccountHasPasswordQueryVariables = Exact<{ [key: string]: never }>;

export type CheckExistingAccountHasPasswordQuery = {
  __typename?: 'Query';
  checkExistingAccountHasPassword?: boolean | null | undefined;
};

export type CheckFlowStatusQueryVariables = Exact<{
  guid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CheckFlowStatusQuery = {
  __typename?: 'Query';
  checkFlowStatus?:
    | {
        __typename?: 'flowStatus';
        inFlow?: boolean | null | undefined;
        guid?: string | null | undefined;
        url?: string | null | undefined;
        dealId?: string | null | undefined;
        customerId?: string | null | undefined;
        car?:
          | {
              __typename?: 'car';
              id?: string | null | undefined;
              make?: string | null | undefined;
              model?: string | null | undefined;
              year?: string | null | undefined;
              mileage?: number | null | undefined;
              vin?: string | null | undefined;
              vehicle_type?: string | null | undefined;
              color?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type BankLogoQueryVariables = Exact<{
  bank_name: Scalars['String']['input'];
}>;

export type BankLogoQuery = { __typename?: 'Query'; bankLogo?: string | null | undefined };

export type GetExternalAutoStructureBankLogosQueryVariables = Exact<{ [key: string]: never }>;

export type GetExternalAutoStructureBankLogosQuery = {
  __typename?: 'Query';
  getExternalAutoStructureBankLogos?:
    | Array<
        | {
            __typename?: 'AutoStructureBankLogo';
            bank_name?: string | null | undefined;
            bank_slug?: TtNewBankEnum | null | undefined;
            logo_url?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type GetRandomVinFromProdQueryVariables = Exact<{ [key: string]: never }>;

export type GetRandomVinFromProdQuery = {
  __typename?: 'Query';
  getRandomVin?: string | null | undefined;
};

export type RecordConsentDecisionMutationVariables = Exact<{
  decision: ConsentDecisionInput;
}>;

export type RecordConsentDecisionMutation = {
  __typename?: 'RootMutationType';
  recordConsentDecision: string;
};

export type ConsentOptOutLookupQueryVariables = Exact<{
  identifiers: Array<ConsentIdentifierInput> | ConsentIdentifierInput;
}>;

export type ConsentOptOutLookupQuery = {
  __typename?: 'Query';
  consentOptOutLookup: Array<ConsentBasis>;
};

export type LinkIdentifiersToOptOutsMutationVariables = Exact<{
  identifiers: Array<ConsentIdentifierInput> | ConsentIdentifierInput;
  howLinked: ConsentHowLinked;
}>;

export type LinkIdentifiersToOptOutsMutation = {
  __typename?: 'RootMutationType';
  linkIdentifiersToOptOuts: boolean;
};

export type CurrentConsentAgreementTextQueryVariables = Exact<{
  agreementType: ConsentAgreementTypeEnum;
  version?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CurrentConsentAgreementTextQuery = {
  __typename?: 'Query';
  currentConsentAgreementText?:
    | {
        __typename?: 'consentAgreement';
        id?: string | null | undefined;
        text?: string | null | undefined;
        version?: number | null | undefined;
        updated_at?: any | null | undefined;
      }
    | null
    | undefined;
};

export type SaveConsentMutationVariables = Exact<{
  type: ConsentNameEnumType;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SaveConsentMutation = {
  __typename?: 'RootMutationType';
  saveConsent: {
    __typename?: 'SaveConsent';
    consent?: { __typename?: 'consent'; id?: string | null | undefined } | null | undefined;
  };
};

export type ExternalCustomerUpdateMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  customer?: InputMaybe<ExternalCustomerInput>;
}>;

export type ExternalCustomerUpdateMutation = {
  __typename?: 'RootMutationType';
  externalCustomerUpdate?:
    | { __typename?: 'customer'; id?: string | null | undefined }
    | null
    | undefined;
};

export type GetByAuth0IdQueryVariables = Exact<{ [key: string]: never }>;

export type GetByAuth0IdQuery = {
  __typename?: 'Query';
  getByAuth0Id?:
    | {
        __typename?: 'customer';
        first_name?: string | null | undefined;
        last_name?: string | null | undefined;
        full_name?: string | null | undefined;
        email?: string | null | undefined;
      }
    | null
    | undefined;
};

export type VerifyAccountMutationVariables = Exact<{
  ssn_last_4: Scalars['String']['input'];
  deal_id: Scalars['ID']['input'];
  is_cobuyer?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VerifyAccountMutation = {
  __typename?: 'RootMutationType';
  verifyAccount?: any | null | undefined;
};

export type AuthenticateAnonymousCustomerMutationVariables = Exact<{
  tempInfoId: Scalars['String']['input'];
}>;

export type AuthenticateAnonymousCustomerMutation = {
  __typename?: 'RootMutationType';
  authenticateAnonymousCustomer: string;
};

export type CustomerNotificationsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type CustomerNotificationsQuery = {
  __typename?: 'Query';
  customerNotifications?:
    | Array<
        | {
            __typename?: 'customerNotification';
            id?: string | null | undefined;
            content: string;
            customer_id: string;
            deal_id: string;
            seen_at?: any | null | undefined;
            dismissed_at?: any | null | undefined;
            auto_mark_as_seen: boolean;
            created_at?: any | null | undefined;
            call_to_actions?:
              | Array<
                  | {
                      __typename?: 'customerNotificationCallToAction';
                      label: string;
                      action: CustomerNotificationCallToActions;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type DismissCustomerNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type DismissCustomerNotificationMutation = {
  __typename?: 'RootMutationType';
  dismissCustomerNotification?:
    | Array<
        | {
            __typename?: 'customerNotification';
            id?: string | null | undefined;
            content: string;
            customer_id: string;
            deal_id: string;
            seen_at?: any | null | undefined;
            dismissed_at?: any | null | undefined;
            auto_mark_as_seen: boolean;
            created_at?: any | null | undefined;
            call_to_actions?:
              | Array<
                  | {
                      __typename?: 'customerNotificationCallToAction';
                      label: string;
                      action: CustomerNotificationCallToActions;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type MarkCustomerNotificationsAsSeenMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type MarkCustomerNotificationsAsSeenMutation = {
  __typename?: 'RootMutationType';
  markCustomerNotificationsAsSeen?:
    | Array<
        | {
            __typename?: 'customerNotification';
            id?: string | null | undefined;
            content: string;
            customer_id: string;
            deal_id: string;
            seen_at?: any | null | undefined;
            dismissed_at?: any | null | undefined;
            auto_mark_as_seen: boolean;
            created_at?: any | null | undefined;
            call_to_actions?:
              | Array<
                  | {
                      __typename?: 'customerNotificationCallToAction';
                      label: string;
                      action: CustomerNotificationCallToActions;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type MarkCustomerNotificationAsSeenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  dealId: Scalars['ID']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type MarkCustomerNotificationAsSeenMutation = {
  __typename?: 'RootMutationType';
  markCustomerNotificationAsSeen?:
    | Array<
        | {
            __typename?: 'customerNotification';
            id?: string | null | undefined;
            content: string;
            customer_id: string;
            deal_id: string;
            seen_at?: any | null | undefined;
            dismissed_at?: any | null | undefined;
            auto_mark_as_seen: boolean;
            created_at?: any | null | undefined;
            call_to_actions?:
              | Array<
                  | {
                      __typename?: 'customerNotificationCallToAction';
                      label: string;
                      action: CustomerNotificationCallToActions;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ExternalUpdateDealMutationVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']['input']>;
  tempInfoId?: InputMaybe<Scalars['ID']['input']>;
  data: ExternalDealInputType;
}>;

export type ExternalUpdateDealMutation = {
  __typename?: 'RootMutationType';
  externalUpdateDeal?: { __typename?: 'deal'; id?: string | null | undefined } | null | undefined;
};

export type DealAdvisorsQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DealAdvisorsQuery = {
  __typename?: 'Query';
  dealAdvisors?:
    | {
        __typename?: 'deal';
        setter?: { __typename?: 'user'; name?: string | null | undefined } | null | undefined;
        closer?:
          | {
              __typename?: 'user';
              id?: string | null | undefined;
              name?: string | null | undefined;
              photo_url?: string | null | undefined;
            }
          | null
          | undefined;
        funding_clerk?:
          | {
              __typename?: 'user';
              name?: string | null | undefined;
              photo_url?: string | null | undefined;
            }
          | null
          | undefined;
        title_clerk?:
          | {
              __typename?: 'user';
              name?: string | null | undefined;
              photo_url?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type TotalCompletedDealsQueryVariables = Exact<{ [key: string]: never }>;

export type TotalCompletedDealsQuery = {
  __typename?: 'Query';
  totalCompletedDeals?: number | null | undefined;
};

export type InsertDevAffiliateFromTempInfoMutationVariables = Exact<{
  externalId: Scalars['ID']['input'];
  tempInfoId: Scalars['ID']['input'];
}>;

export type InsertDevAffiliateFromTempInfoMutation = {
  __typename?: 'RootMutationType';
  insertDevAffiliateFromTempInfo?: string | null | undefined;
};

export type RunAutoStructureCronsMutationVariables = Exact<{ [key: string]: never }>;

export type RunAutoStructureCronsMutation = {
  __typename?: 'RootMutationType';
  runAutoStructureCrons?: any | null | undefined;
};

export type SendDevAffiliateToThunderMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;

export type SendDevAffiliateToThunderMutation = {
  __typename?: 'RootMutationType';
  sendDevAffiliateToThunder?: any | null | undefined;
};

export type CreateDownPaymentLinkMutationVariables = Exact<{ [key: string]: never }>;

export type CreateDownPaymentLinkMutation = {
  __typename?: 'RootMutationType';
  createDownPaymentLink?: string | null | undefined;
};

export type ExecuteDownPaymentMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  bank: Scalars['String']['input'];
  plaidAccountId: Scalars['String']['input'];
  plaidToken: Scalars['String']['input'];
  fraudSessionId: Scalars['String']['input'];
  idempotencyId: Scalars['String']['input'];
  dealId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ExecuteDownPaymentMutation = {
  __typename?: 'RootMutationType';
  executeDownPayment?:
    | {
        __typename?: 'finixTransfer';
        id?: string | null | undefined;
        amount?: number | null | undefined;
      }
    | null
    | undefined;
};

export type ExecuteCardDownPaymentMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  fraudSessionId: Scalars['String']['input'];
  idempotencyId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  dealId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod: PaymentMethod;
}>;

export type ExecuteCardDownPaymentMutation = {
  __typename?: 'RootMutationType';
  executeCardDownPayment?:
    | {
        __typename?: 'finixTransfer';
        id?: string | null | undefined;
        amount?: number | null | undefined;
        cardBrand?: string | null | undefined;
        cardType?: CardType | null | undefined;
        failureCode?: string | null | undefined;
        maskedNumber?: string | null | undefined;
        state?: PaymentState | null | undefined;
      }
    | null
    | undefined;
};

export type GetDownPaymentAmountByMethodQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  paymentType: PaymentInstrumentType;
}>;

export type GetDownPaymentAmountByMethodQuery = {
  __typename?: 'Query';
  getDownPaymentAmountByMethod?: number | null | undefined;
};

export type EiRedirectMutationVariables = Exact<{
  leadId: Scalars['String']['input'];
}>;

export type EiRedirectMutation = {
  __typename?: 'RootMutationType';
  eiRedirect?:
    | { __typename?: 'eiRedirectGraphQLType'; url?: string | null | undefined }
    | null
    | undefined;
};

export type EmployerPhoneLookupMutationVariables = Exact<{
  input: EmployerPhoneLookupInput;
}>;

export type EmployerPhoneLookupMutation = {
  __typename?: 'RootMutationType';
  employerPhoneLookup: {
    __typename?: 'EmployerPhoneLookupResult';
    phoneNumber?: string | null | undefined;
    source: EmployerPhoneLookupSource;
  };
};

export type CreateFeedbackMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  improvements: Scalars['String']['input'];
  deal_id: Scalars['ID']['input'];
}>;

export type CreateFeedbackMutation = {
  __typename?: 'RootMutationType';
  createFeedback?: any | null | undefined;
};

export type TemporaryDataFragment = {
  __typename?: 'temporaryData';
  vin?: string | null | undefined;
  license_plate_number?: string | null | undefined;
  license_plate_state?: string | null | undefined;
  year?: string | null | undefined;
  make?: string | null | undefined;
  model?: string | null | undefined;
  fuel_type?: string | null | undefined;
  vehicle_type?: string | null | undefined;
  color?: string | null | undefined;
  mileage?: number | null | undefined;
  vehicle_payoff?: number | null | undefined;
  automatically_fetched_payoff?: boolean | null | undefined;
  user_entered_total_payoff?: number | null | undefined;
  phone_number?: string | null | undefined;
  email?: string | null | undefined;
  current_accordion_panel?: string | null | undefined;
  lienholder?: string | null | undefined;
  lienholder_slug?: string | null | undefined;
  other_lienholder?: string | null | undefined;
  lienholderLogo?: string | null | undefined;
  first_name?: string | null | undefined;
  middle_name?: string | null | undefined;
  last_name?: string | null | undefined;
  address_line?: string | null | undefined;
  address_line_2?: string | null | undefined;
  city?: string | null | undefined;
  state?: string | null | undefined;
  country?: Country | null | undefined;
  county?: string | null | undefined;
  zip?: string | null | undefined;
  taxes?: any | null | undefined;
  vehicle_registration_fee?: number | null | undefined;
  doc_fee?: number | null | undefined;
  has_full_ssn?: boolean | null | undefined;
  previous_address_line?: string | null | undefined;
  previous_address_line_2?: string | null | undefined;
  previous_city?: string | null | undefined;
  previous_state?: string | null | undefined;
  previous_zip?: string | null | undefined;
  previous_county?: string | null | undefined;
  scheduled_call_datetime?: any | null | undefined;
  scheduled_call_datetime_tz?: string | null | undefined;
  primary_residence_type?: string | null | undefined;
  primary_residence_years?: number | null | undefined;
  primary_residence_months?: number | null | undefined;
  primary_residence_monthly_payment?: number | null | undefined;
  lives_with_other_buyer?: boolean | null | undefined;
  secondary_residence_years?: number | null | undefined;
  secondary_residence_months?: number | null | undefined;
  dob?: any | null | undefined;
  employment_status?: string | null | undefined;
  employer_name?: string | null | undefined;
  job_title?: string | null | undefined;
  employer_phone_number?: string | null | undefined;
  years_at_job?: number | null | undefined;
  months_at_job?: number | null | undefined;
  salary?: number | null | undefined;
  pay_frequency?: string | null | undefined;
  previous_employer_name?: string | null | undefined;
  previous_job_title?: string | null | undefined;
  previous_employer_phone_number?: string | null | undefined;
  previous_years_at_job?: number | null | undefined;
  previous_months_at_job?: number | null | undefined;
  retail_book_value?: number | null | undefined;
  kbb_retail_mileage_adjustment?: number | null | undefined;
  kbb_retail_option_adjustment?: number | null | undefined;
  book_value?: number | null | undefined;
  kbb_lending_mileage_adjustment?: number | null | undefined;
  kbb_lending_option_adjustment?: number | null | undefined;
  kbb_valuation_date?: string | null | undefined;
  kbb_vehicle_name?: string | null | undefined;
  kbb_vehicle_id?: number | null | undefined;
  kbb_all_options?: any | null | undefined;
  kbb_trim_name?: string | null | undefined;
  kbb_selected_options?: any | null | undefined;
  good_through_date?: any | null | undefined;
  credit_score?: number | null | undefined;
  term?: number | null | undefined;
  rate?: number | null | undefined;
  down_payment?: number | null | undefined;
  taxes_fees?: number | null | undefined;
  payment_estimate_low?: number | null | undefined;
  payment_estimate_high?: number | null | undefined;
  payoff_includes_sales_tax?: boolean | null | undefined;
  lh_account_number?: string | null | undefined;
  include_cobuyer?: boolean | null | undefined;
  cobuyer_first_name?: string | null | undefined;
  cobuyer_last_name?: string | null | undefined;
  cobuyer_employment_status?: string | null | undefined;
  cobuyer_employer_name?: string | null | undefined;
  cobuyer_employer_phone_number?: string | null | undefined;
  cobuyer_job_title?: string | null | undefined;
  cobuyer_years_at_job?: number | null | undefined;
  cobuyer_months_at_job?: number | null | undefined;
  cobuyer_salary?: number | null | undefined;
  cobuyer_pay_frequency?: string | null | undefined;
  cobuyer_previous_employer_name?: string | null | undefined;
  cobuyer_previous_employer_phone_number?: string | null | undefined;
  cobuyer_previous_job_title?: string | null | undefined;
  cobuyer_previous_years_at_job?: number | null | undefined;
  cobuyer_previous_months_at_job?: number | null | undefined;
  cobuyer_phone_number?: string | null | undefined;
  cobuyer_email?: string | null | undefined;
  cobuyer_dob?: any | null | undefined;
  cobuyer_address_line?: string | null | undefined;
  cobuyer_address_line_2?: string | null | undefined;
  cobuyer_city?: string | null | undefined;
  cobuyer_state?: string | null | undefined;
  cobuyer_zip?: string | null | undefined;
  cobuyer_county?: string | null | undefined;
  cobuyer_primary_residence_monthly_payment?: number | null | undefined;
  cobuyer_primary_residence_type?: string | null | undefined;
  cobuyer_primary_residence_years?: number | null | undefined;
  cobuyer_primary_residence_months?: number | null | undefined;
  cobuyer_previous_address_line?: string | null | undefined;
  cobuyer_previous_address_line_2?: string | null | undefined;
  cobuyer_previous_city?: string | null | undefined;
  cobuyer_previous_state?: string | null | undefined;
  cobuyer_previous_zip?: string | null | undefined;
  cobuyer_previous_county?: string | null | undefined;
  cobuyer_secondary_residence_years?: number | null | undefined;
  cobuyer_secondary_residence_months?: number | null | undefined;
  cobuyer_relation_to_buyer?: RelationToBuyerEnum | null | undefined;
  cobuyer_marital_status?: MaritalStatusEnum | null | undefined;
  old_lease_payment?: number | null | undefined;
  vehicle_offer?: number | null | undefined;
  estimated_dealer_fees?: number | null | undefined;
  condition_report?: any | null | undefined;
  mmr_value?: number | null | undefined;
  marital_status?: MaritalStatusEnum | null | undefined;
  sales_tax_from_payoff?: number | null | undefined;
  last_url?: string | null | undefined;
  query_params?: string | null | undefined;
  manual_entry?: boolean | null | undefined;
  uploaded_files?: any | null | undefined;
  prequalification_success?: boolean | null | undefined;
  is_hard_pull?: boolean | null | undefined;
  prequalification_errors?: Array<string | null | undefined> | null | undefined;
  cobuyer_prequalification_errors?: Array<string | null | undefined> | null | undefined;
  prequal_id?: string | null | undefined;
  affiliate_external_id?: string | null | undefined;
  likely_address_query_run?: boolean | null | undefined;
  likely_address_query_success?: boolean | null | undefined;
  likely_address_accepted?: boolean | null | undefined;
  likely_address_address_line?: string | null | undefined;
  likely_address_address_line_2?: string | null | undefined;
  likely_address_city?: string | null | undefined;
  likely_address_state?: string | null | undefined;
  likely_address_zip?: string | null | undefined;
  likely_address_county?: string | null | undefined;
  wants_to_sell?: boolean | null | undefined;
  trade_in_preference?: string | null | undefined;
  sell_timeline?: string | null | undefined;
  verified_phone_number?: string | null | undefined;
  dev_prequal_override?: boolean | null | undefined;
  dev_prequal_credit_score?: number | null | undefined;
  stress_test_payoff_requested?: boolean | null | undefined;
  ssn_id?: string | null | undefined;
  cobuyer_ssn_id?: string | null | undefined;
  is_methodfi_flow?: boolean | null | undefined;
  methodfi_flow_variation?: number | null | undefined;
  shopping_cart?:
    | {
        __typename?: 'temporaryShoppingCartData';
        buyout?: number | null | undefined;
        credit_score?: number | null | undefined;
        down_payment?: number | null | undefined;
        loan_term?: number | null | undefined;
        payment_estimate_low?: number | null | undefined;
        payment_estimate_high?: number | null | undefined;
        estimated_fees?: number | null | undefined;
      }
    | null
    | undefined;
};

export type TemporaryInfoUpdateMutationVariables = Exact<{
  info?: InputMaybe<TemporaryInfoInput>;
}>;

export type TemporaryInfoUpdateMutation = {
  __typename?: 'RootMutationType';
  temporaryInfoUpdate?:
    | {
        __typename?: 'temporaryInfo';
        id?: string | null | undefined;
        status?: TemporaryInfoStatusEnumType | null | undefined;
        data: {
          __typename?: 'temporaryData';
          vin?: string | null | undefined;
          license_plate_number?: string | null | undefined;
          license_plate_state?: string | null | undefined;
          year?: string | null | undefined;
          make?: string | null | undefined;
          model?: string | null | undefined;
          fuel_type?: string | null | undefined;
          vehicle_type?: string | null | undefined;
          color?: string | null | undefined;
          mileage?: number | null | undefined;
          vehicle_payoff?: number | null | undefined;
          automatically_fetched_payoff?: boolean | null | undefined;
          user_entered_total_payoff?: number | null | undefined;
          phone_number?: string | null | undefined;
          email?: string | null | undefined;
          current_accordion_panel?: string | null | undefined;
          lienholder?: string | null | undefined;
          lienholder_slug?: string | null | undefined;
          other_lienholder?: string | null | undefined;
          lienholderLogo?: string | null | undefined;
          first_name?: string | null | undefined;
          middle_name?: string | null | undefined;
          last_name?: string | null | undefined;
          address_line?: string | null | undefined;
          address_line_2?: string | null | undefined;
          city?: string | null | undefined;
          state?: string | null | undefined;
          country?: Country | null | undefined;
          county?: string | null | undefined;
          zip?: string | null | undefined;
          taxes?: any | null | undefined;
          vehicle_registration_fee?: number | null | undefined;
          doc_fee?: number | null | undefined;
          has_full_ssn?: boolean | null | undefined;
          previous_address_line?: string | null | undefined;
          previous_address_line_2?: string | null | undefined;
          previous_city?: string | null | undefined;
          previous_state?: string | null | undefined;
          previous_zip?: string | null | undefined;
          previous_county?: string | null | undefined;
          scheduled_call_datetime?: any | null | undefined;
          scheduled_call_datetime_tz?: string | null | undefined;
          primary_residence_type?: string | null | undefined;
          primary_residence_years?: number | null | undefined;
          primary_residence_months?: number | null | undefined;
          primary_residence_monthly_payment?: number | null | undefined;
          lives_with_other_buyer?: boolean | null | undefined;
          secondary_residence_years?: number | null | undefined;
          secondary_residence_months?: number | null | undefined;
          dob?: any | null | undefined;
          employment_status?: string | null | undefined;
          employer_name?: string | null | undefined;
          job_title?: string | null | undefined;
          employer_phone_number?: string | null | undefined;
          years_at_job?: number | null | undefined;
          months_at_job?: number | null | undefined;
          salary?: number | null | undefined;
          pay_frequency?: string | null | undefined;
          previous_employer_name?: string | null | undefined;
          previous_job_title?: string | null | undefined;
          previous_employer_phone_number?: string | null | undefined;
          previous_years_at_job?: number | null | undefined;
          previous_months_at_job?: number | null | undefined;
          retail_book_value?: number | null | undefined;
          kbb_retail_mileage_adjustment?: number | null | undefined;
          kbb_retail_option_adjustment?: number | null | undefined;
          book_value?: number | null | undefined;
          kbb_lending_mileage_adjustment?: number | null | undefined;
          kbb_lending_option_adjustment?: number | null | undefined;
          kbb_valuation_date?: string | null | undefined;
          kbb_vehicle_name?: string | null | undefined;
          kbb_vehicle_id?: number | null | undefined;
          kbb_all_options?: any | null | undefined;
          kbb_trim_name?: string | null | undefined;
          kbb_selected_options?: any | null | undefined;
          good_through_date?: any | null | undefined;
          credit_score?: number | null | undefined;
          term?: number | null | undefined;
          rate?: number | null | undefined;
          down_payment?: number | null | undefined;
          taxes_fees?: number | null | undefined;
          payment_estimate_low?: number | null | undefined;
          payment_estimate_high?: number | null | undefined;
          payoff_includes_sales_tax?: boolean | null | undefined;
          lh_account_number?: string | null | undefined;
          include_cobuyer?: boolean | null | undefined;
          cobuyer_first_name?: string | null | undefined;
          cobuyer_last_name?: string | null | undefined;
          cobuyer_employment_status?: string | null | undefined;
          cobuyer_employer_name?: string | null | undefined;
          cobuyer_employer_phone_number?: string | null | undefined;
          cobuyer_job_title?: string | null | undefined;
          cobuyer_years_at_job?: number | null | undefined;
          cobuyer_months_at_job?: number | null | undefined;
          cobuyer_salary?: number | null | undefined;
          cobuyer_pay_frequency?: string | null | undefined;
          cobuyer_previous_employer_name?: string | null | undefined;
          cobuyer_previous_employer_phone_number?: string | null | undefined;
          cobuyer_previous_job_title?: string | null | undefined;
          cobuyer_previous_years_at_job?: number | null | undefined;
          cobuyer_previous_months_at_job?: number | null | undefined;
          cobuyer_phone_number?: string | null | undefined;
          cobuyer_email?: string | null | undefined;
          cobuyer_dob?: any | null | undefined;
          cobuyer_address_line?: string | null | undefined;
          cobuyer_address_line_2?: string | null | undefined;
          cobuyer_city?: string | null | undefined;
          cobuyer_state?: string | null | undefined;
          cobuyer_zip?: string | null | undefined;
          cobuyer_county?: string | null | undefined;
          cobuyer_primary_residence_monthly_payment?: number | null | undefined;
          cobuyer_primary_residence_type?: string | null | undefined;
          cobuyer_primary_residence_years?: number | null | undefined;
          cobuyer_primary_residence_months?: number | null | undefined;
          cobuyer_previous_address_line?: string | null | undefined;
          cobuyer_previous_address_line_2?: string | null | undefined;
          cobuyer_previous_city?: string | null | undefined;
          cobuyer_previous_state?: string | null | undefined;
          cobuyer_previous_zip?: string | null | undefined;
          cobuyer_previous_county?: string | null | undefined;
          cobuyer_secondary_residence_years?: number | null | undefined;
          cobuyer_secondary_residence_months?: number | null | undefined;
          cobuyer_relation_to_buyer?: RelationToBuyerEnum | null | undefined;
          cobuyer_marital_status?: MaritalStatusEnum | null | undefined;
          old_lease_payment?: number | null | undefined;
          vehicle_offer?: number | null | undefined;
          estimated_dealer_fees?: number | null | undefined;
          condition_report?: any | null | undefined;
          mmr_value?: number | null | undefined;
          marital_status?: MaritalStatusEnum | null | undefined;
          sales_tax_from_payoff?: number | null | undefined;
          last_url?: string | null | undefined;
          query_params?: string | null | undefined;
          manual_entry?: boolean | null | undefined;
          uploaded_files?: any | null | undefined;
          prequalification_success?: boolean | null | undefined;
          is_hard_pull?: boolean | null | undefined;
          prequalification_errors?: Array<string | null | undefined> | null | undefined;
          cobuyer_prequalification_errors?: Array<string | null | undefined> | null | undefined;
          prequal_id?: string | null | undefined;
          affiliate_external_id?: string | null | undefined;
          likely_address_query_run?: boolean | null | undefined;
          likely_address_query_success?: boolean | null | undefined;
          likely_address_accepted?: boolean | null | undefined;
          likely_address_address_line?: string | null | undefined;
          likely_address_address_line_2?: string | null | undefined;
          likely_address_city?: string | null | undefined;
          likely_address_state?: string | null | undefined;
          likely_address_zip?: string | null | undefined;
          likely_address_county?: string | null | undefined;
          wants_to_sell?: boolean | null | undefined;
          trade_in_preference?: string | null | undefined;
          sell_timeline?: string | null | undefined;
          verified_phone_number?: string | null | undefined;
          dev_prequal_override?: boolean | null | undefined;
          dev_prequal_credit_score?: number | null | undefined;
          stress_test_payoff_requested?: boolean | null | undefined;
          ssn_id?: string | null | undefined;
          cobuyer_ssn_id?: string | null | undefined;
          is_methodfi_flow?: boolean | null | undefined;
          methodfi_flow_variation?: number | null | undefined;
          shopping_cart?:
            | {
                __typename?: 'temporaryShoppingCartData';
                buyout?: number | null | undefined;
                credit_score?: number | null | undefined;
                down_payment?: number | null | undefined;
                loan_term?: number | null | undefined;
                payment_estimate_low?: number | null | undefined;
                payment_estimate_high?: number | null | undefined;
                estimated_fees?: number | null | undefined;
              }
            | null
            | undefined;
        };
      }
    | null
    | undefined;
};

export type TemporaryInfoSsnUpdateMutationVariables = Exact<{
  tempInfoId: Scalars['ID']['input'];
  ssn: Scalars['String']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type TemporaryInfoSsnUpdateMutation = {
  __typename?: 'RootMutationType';
  temporaryInfoSsnUpdate?:
    | { __typename?: 'temporaryInfo'; id?: string | null | undefined }
    | null
    | undefined;
};

export type DecryptTempInfoSsnQueryVariables = Exact<{
  tempInfoId: Scalars['ID']['input'];
}>;

export type DecryptTempInfoSsnQuery = {
  __typename?: 'Query';
  decryptTempInfoSSN?: string | null | undefined;
};

export type CreateTemporaryInfoMutationVariables = Exact<{
  vin?: InputMaybe<Scalars['String']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  extra_input?: InputMaybe<ExtraTempInfoInputType>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']['input']>;
  is_methodfi_flow?: InputMaybe<Scalars['Boolean']['input']>;
  methodfi_flow_variation?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreateTemporaryInfoMutation = {
  __typename?: 'RootMutationType';
  createTemporaryInfo?:
    | {
        __typename?: 'temporaryInfo';
        id?: string | null | undefined;
        data: {
          __typename?: 'temporaryData';
          vin?: string | null | undefined;
          license_plate_number?: string | null | undefined;
          license_plate_state?: string | null | undefined;
          year?: string | null | undefined;
          make?: string | null | undefined;
          model?: string | null | undefined;
          fuel_type?: string | null | undefined;
          vehicle_type?: string | null | undefined;
          device_type?: string | null | undefined;
          zip?: string | null | undefined;
        };
      }
    | null
    | undefined;
};

export type CreateManualEntryTemporaryInfoMutationVariables = Exact<{
  license_plate?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vin: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  vehicle_type?: InputMaybe<Scalars['String']['input']>;
  kbb_trim_name?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  extra_input?: InputMaybe<ExtraTempInfoInputType>;
  query_params?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateManualEntryTemporaryInfoMutation = {
  __typename?: 'RootMutationType';
  createManualEntryTemporaryInfo?:
    | {
        __typename?: 'temporaryInfo';
        id?: string | null | undefined;
        data: {
          __typename?: 'temporaryData';
          vin?: string | null | undefined;
          license_plate_number?: string | null | undefined;
          license_plate_state?: string | null | undefined;
          year?: string | null | undefined;
          make?: string | null | undefined;
          model?: string | null | undefined;
          fuel_type?: string | null | undefined;
          vehicle_type?: string | null | undefined;
          device_type?: string | null | undefined;
          zip?: string | null | undefined;
          kbb_trim_name?: string | null | undefined;
        };
      }
    | null
    | undefined;
};

export type CreateAffiliateTemporaryInfoMutationVariables = Exact<{
  device_type?: InputMaybe<Scalars['String']['input']>;
  query_params?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
}>;

export type CreateAffiliateTemporaryInfoMutation = {
  __typename?: 'RootMutationType';
  createAffiliateTemporaryInfo?:
    | {
        __typename?: 'temporaryInfo';
        id?: string | null | undefined;
        data: {
          __typename?: 'temporaryData';
          vin?: string | null | undefined;
          license_plate_number?: string | null | undefined;
          license_plate_state?: string | null | undefined;
          year?: string | null | undefined;
          make?: string | null | undefined;
          model?: string | null | undefined;
          fuel_type?: string | null | undefined;
          vehicle_type?: string | null | undefined;
          color?: string | null | undefined;
          mileage?: number | null | undefined;
          vehicle_payoff?: number | null | undefined;
          automatically_fetched_payoff?: boolean | null | undefined;
          user_entered_total_payoff?: number | null | undefined;
          phone_number?: string | null | undefined;
          email?: string | null | undefined;
          current_accordion_panel?: string | null | undefined;
          lienholder?: string | null | undefined;
          lienholder_slug?: string | null | undefined;
          other_lienholder?: string | null | undefined;
          lienholderLogo?: string | null | undefined;
          first_name?: string | null | undefined;
          middle_name?: string | null | undefined;
          last_name?: string | null | undefined;
          address_line?: string | null | undefined;
          address_line_2?: string | null | undefined;
          city?: string | null | undefined;
          state?: string | null | undefined;
          country?: Country | null | undefined;
          county?: string | null | undefined;
          zip?: string | null | undefined;
          taxes?: any | null | undefined;
          vehicle_registration_fee?: number | null | undefined;
          doc_fee?: number | null | undefined;
          has_full_ssn?: boolean | null | undefined;
          previous_address_line?: string | null | undefined;
          previous_address_line_2?: string | null | undefined;
          previous_city?: string | null | undefined;
          previous_state?: string | null | undefined;
          previous_zip?: string | null | undefined;
          previous_county?: string | null | undefined;
          scheduled_call_datetime?: any | null | undefined;
          scheduled_call_datetime_tz?: string | null | undefined;
          primary_residence_type?: string | null | undefined;
          primary_residence_years?: number | null | undefined;
          primary_residence_months?: number | null | undefined;
          primary_residence_monthly_payment?: number | null | undefined;
          lives_with_other_buyer?: boolean | null | undefined;
          secondary_residence_years?: number | null | undefined;
          secondary_residence_months?: number | null | undefined;
          dob?: any | null | undefined;
          employment_status?: string | null | undefined;
          employer_name?: string | null | undefined;
          job_title?: string | null | undefined;
          employer_phone_number?: string | null | undefined;
          years_at_job?: number | null | undefined;
          months_at_job?: number | null | undefined;
          salary?: number | null | undefined;
          pay_frequency?: string | null | undefined;
          previous_employer_name?: string | null | undefined;
          previous_job_title?: string | null | undefined;
          previous_employer_phone_number?: string | null | undefined;
          previous_years_at_job?: number | null | undefined;
          previous_months_at_job?: number | null | undefined;
          retail_book_value?: number | null | undefined;
          kbb_retail_mileage_adjustment?: number | null | undefined;
          kbb_retail_option_adjustment?: number | null | undefined;
          book_value?: number | null | undefined;
          kbb_lending_mileage_adjustment?: number | null | undefined;
          kbb_lending_option_adjustment?: number | null | undefined;
          kbb_valuation_date?: string | null | undefined;
          kbb_vehicle_name?: string | null | undefined;
          kbb_vehicle_id?: number | null | undefined;
          kbb_all_options?: any | null | undefined;
          kbb_trim_name?: string | null | undefined;
          kbb_selected_options?: any | null | undefined;
          good_through_date?: any | null | undefined;
          credit_score?: number | null | undefined;
          term?: number | null | undefined;
          rate?: number | null | undefined;
          down_payment?: number | null | undefined;
          taxes_fees?: number | null | undefined;
          payment_estimate_low?: number | null | undefined;
          payment_estimate_high?: number | null | undefined;
          payoff_includes_sales_tax?: boolean | null | undefined;
          lh_account_number?: string | null | undefined;
          include_cobuyer?: boolean | null | undefined;
          cobuyer_first_name?: string | null | undefined;
          cobuyer_last_name?: string | null | undefined;
          cobuyer_employment_status?: string | null | undefined;
          cobuyer_employer_name?: string | null | undefined;
          cobuyer_employer_phone_number?: string | null | undefined;
          cobuyer_job_title?: string | null | undefined;
          cobuyer_years_at_job?: number | null | undefined;
          cobuyer_months_at_job?: number | null | undefined;
          cobuyer_salary?: number | null | undefined;
          cobuyer_pay_frequency?: string | null | undefined;
          cobuyer_previous_employer_name?: string | null | undefined;
          cobuyer_previous_employer_phone_number?: string | null | undefined;
          cobuyer_previous_job_title?: string | null | undefined;
          cobuyer_previous_years_at_job?: number | null | undefined;
          cobuyer_previous_months_at_job?: number | null | undefined;
          cobuyer_phone_number?: string | null | undefined;
          cobuyer_email?: string | null | undefined;
          cobuyer_dob?: any | null | undefined;
          cobuyer_address_line?: string | null | undefined;
          cobuyer_address_line_2?: string | null | undefined;
          cobuyer_city?: string | null | undefined;
          cobuyer_state?: string | null | undefined;
          cobuyer_zip?: string | null | undefined;
          cobuyer_county?: string | null | undefined;
          cobuyer_primary_residence_monthly_payment?: number | null | undefined;
          cobuyer_primary_residence_type?: string | null | undefined;
          cobuyer_primary_residence_years?: number | null | undefined;
          cobuyer_primary_residence_months?: number | null | undefined;
          cobuyer_previous_address_line?: string | null | undefined;
          cobuyer_previous_address_line_2?: string | null | undefined;
          cobuyer_previous_city?: string | null | undefined;
          cobuyer_previous_state?: string | null | undefined;
          cobuyer_previous_zip?: string | null | undefined;
          cobuyer_previous_county?: string | null | undefined;
          cobuyer_secondary_residence_years?: number | null | undefined;
          cobuyer_secondary_residence_months?: number | null | undefined;
          cobuyer_relation_to_buyer?: RelationToBuyerEnum | null | undefined;
          cobuyer_marital_status?: MaritalStatusEnum | null | undefined;
          old_lease_payment?: number | null | undefined;
          vehicle_offer?: number | null | undefined;
          estimated_dealer_fees?: number | null | undefined;
          condition_report?: any | null | undefined;
          mmr_value?: number | null | undefined;
          marital_status?: MaritalStatusEnum | null | undefined;
          sales_tax_from_payoff?: number | null | undefined;
          last_url?: string | null | undefined;
          query_params?: string | null | undefined;
          manual_entry?: boolean | null | undefined;
          uploaded_files?: any | null | undefined;
          prequalification_success?: boolean | null | undefined;
          is_hard_pull?: boolean | null | undefined;
          prequalification_errors?: Array<string | null | undefined> | null | undefined;
          cobuyer_prequalification_errors?: Array<string | null | undefined> | null | undefined;
          prequal_id?: string | null | undefined;
          affiliate_external_id?: string | null | undefined;
          likely_address_query_run?: boolean | null | undefined;
          likely_address_query_success?: boolean | null | undefined;
          likely_address_accepted?: boolean | null | undefined;
          likely_address_address_line?: string | null | undefined;
          likely_address_address_line_2?: string | null | undefined;
          likely_address_city?: string | null | undefined;
          likely_address_state?: string | null | undefined;
          likely_address_zip?: string | null | undefined;
          likely_address_county?: string | null | undefined;
          wants_to_sell?: boolean | null | undefined;
          trade_in_preference?: string | null | undefined;
          sell_timeline?: string | null | undefined;
          verified_phone_number?: string | null | undefined;
          dev_prequal_override?: boolean | null | undefined;
          dev_prequal_credit_score?: number | null | undefined;
          stress_test_payoff_requested?: boolean | null | undefined;
          ssn_id?: string | null | undefined;
          cobuyer_ssn_id?: string | null | undefined;
          is_methodfi_flow?: boolean | null | undefined;
          methodfi_flow_variation?: number | null | undefined;
          shopping_cart?:
            | {
                __typename?: 'temporaryShoppingCartData';
                buyout?: number | null | undefined;
                credit_score?: number | null | undefined;
                down_payment?: number | null | undefined;
                loan_term?: number | null | undefined;
                payment_estimate_low?: number | null | undefined;
                payment_estimate_high?: number | null | undefined;
                estimated_fees?: number | null | undefined;
              }
            | null
            | undefined;
        };
      }
    | null
    | undefined;
};

export type DecodeAffiliateCarDetailsQueryVariables = Exact<{
  vin?: InputMaybe<Scalars['String']['input']>;
  license_plate_number?: InputMaybe<Scalars['String']['input']>;
  license_plate_state?: InputMaybe<Scalars['String']['input']>;
  ignore_existing_deal?: InputMaybe<Scalars['Boolean']['input']>;
  temp_info_id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DecodeAffiliateCarDetailsQuery = {
  __typename?: 'Query';
  decodeAffiliateCarDetails?:
    | {
        __typename?: 'temporaryData';
        license_plate_number?: string | null | undefined;
        license_plate_state?: string | null | undefined;
        vin?: string | null | undefined;
        year?: string | null | undefined;
        make?: string | null | undefined;
        model?: string | null | undefined;
        fuel_type?: string | null | undefined;
        vehicle_type?: string | null | undefined;
        kbb_trim_name?: string | null | undefined;
      }
    | null
    | undefined;
};

export type TemporaryInfoImportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  transformType: TransformType;
  importType?: InputMaybe<ImportType>;
}>;

export type TemporaryInfoImportMutation = {
  __typename?: 'RootMutationType';
  temporaryInfoImport?:
    | {
        __typename?: 'deal';
        id?: string | null | undefined;
        customer?: { __typename?: 'customer'; id?: string | null | undefined } | null | undefined;
      }
    | null
    | undefined;
};

export type UnlinkTemporaryInfoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnlinkTemporaryInfoMutation = {
  __typename?: 'RootMutationType';
  unlinkTemporaryInfo?:
    | { __typename?: 'temporaryInfo'; id?: string | null | undefined }
    | null
    | undefined;
};

export type TemporaryInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  allowImported?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type TemporaryInfoQuery = {
  __typename?: 'Query';
  temporaryInfo?:
    | {
        __typename?: 'temporaryInfo';
        id?: string | null | undefined;
        affiliate_id?: string | null | undefined;
        data: {
          __typename?: 'temporaryData';
          vin?: string | null | undefined;
          license_plate_number?: string | null | undefined;
          license_plate_state?: string | null | undefined;
          year?: string | null | undefined;
          make?: string | null | undefined;
          model?: string | null | undefined;
          fuel_type?: string | null | undefined;
          vehicle_type?: string | null | undefined;
          color?: string | null | undefined;
          mileage?: number | null | undefined;
          vehicle_payoff?: number | null | undefined;
          automatically_fetched_payoff?: boolean | null | undefined;
          user_entered_total_payoff?: number | null | undefined;
          phone_number?: string | null | undefined;
          email?: string | null | undefined;
          current_accordion_panel?: string | null | undefined;
          lienholder?: string | null | undefined;
          lienholder_slug?: string | null | undefined;
          other_lienholder?: string | null | undefined;
          lienholderLogo?: string | null | undefined;
          first_name?: string | null | undefined;
          middle_name?: string | null | undefined;
          last_name?: string | null | undefined;
          address_line?: string | null | undefined;
          address_line_2?: string | null | undefined;
          city?: string | null | undefined;
          state?: string | null | undefined;
          country?: Country | null | undefined;
          county?: string | null | undefined;
          zip?: string | null | undefined;
          taxes?: any | null | undefined;
          vehicle_registration_fee?: number | null | undefined;
          doc_fee?: number | null | undefined;
          has_full_ssn?: boolean | null | undefined;
          previous_address_line?: string | null | undefined;
          previous_address_line_2?: string | null | undefined;
          previous_city?: string | null | undefined;
          previous_state?: string | null | undefined;
          previous_zip?: string | null | undefined;
          previous_county?: string | null | undefined;
          scheduled_call_datetime?: any | null | undefined;
          scheduled_call_datetime_tz?: string | null | undefined;
          primary_residence_type?: string | null | undefined;
          primary_residence_years?: number | null | undefined;
          primary_residence_months?: number | null | undefined;
          primary_residence_monthly_payment?: number | null | undefined;
          lives_with_other_buyer?: boolean | null | undefined;
          secondary_residence_years?: number | null | undefined;
          secondary_residence_months?: number | null | undefined;
          dob?: any | null | undefined;
          employment_status?: string | null | undefined;
          employer_name?: string | null | undefined;
          job_title?: string | null | undefined;
          employer_phone_number?: string | null | undefined;
          years_at_job?: number | null | undefined;
          months_at_job?: number | null | undefined;
          salary?: number | null | undefined;
          pay_frequency?: string | null | undefined;
          previous_employer_name?: string | null | undefined;
          previous_job_title?: string | null | undefined;
          previous_employer_phone_number?: string | null | undefined;
          previous_years_at_job?: number | null | undefined;
          previous_months_at_job?: number | null | undefined;
          retail_book_value?: number | null | undefined;
          kbb_retail_mileage_adjustment?: number | null | undefined;
          kbb_retail_option_adjustment?: number | null | undefined;
          book_value?: number | null | undefined;
          kbb_lending_mileage_adjustment?: number | null | undefined;
          kbb_lending_option_adjustment?: number | null | undefined;
          kbb_valuation_date?: string | null | undefined;
          kbb_vehicle_name?: string | null | undefined;
          kbb_vehicle_id?: number | null | undefined;
          kbb_all_options?: any | null | undefined;
          kbb_trim_name?: string | null | undefined;
          kbb_selected_options?: any | null | undefined;
          good_through_date?: any | null | undefined;
          credit_score?: number | null | undefined;
          term?: number | null | undefined;
          rate?: number | null | undefined;
          down_payment?: number | null | undefined;
          taxes_fees?: number | null | undefined;
          payment_estimate_low?: number | null | undefined;
          payment_estimate_high?: number | null | undefined;
          payoff_includes_sales_tax?: boolean | null | undefined;
          lh_account_number?: string | null | undefined;
          include_cobuyer?: boolean | null | undefined;
          cobuyer_first_name?: string | null | undefined;
          cobuyer_last_name?: string | null | undefined;
          cobuyer_employment_status?: string | null | undefined;
          cobuyer_employer_name?: string | null | undefined;
          cobuyer_employer_phone_number?: string | null | undefined;
          cobuyer_job_title?: string | null | undefined;
          cobuyer_years_at_job?: number | null | undefined;
          cobuyer_months_at_job?: number | null | undefined;
          cobuyer_salary?: number | null | undefined;
          cobuyer_pay_frequency?: string | null | undefined;
          cobuyer_previous_employer_name?: string | null | undefined;
          cobuyer_previous_employer_phone_number?: string | null | undefined;
          cobuyer_previous_job_title?: string | null | undefined;
          cobuyer_previous_years_at_job?: number | null | undefined;
          cobuyer_previous_months_at_job?: number | null | undefined;
          cobuyer_phone_number?: string | null | undefined;
          cobuyer_email?: string | null | undefined;
          cobuyer_dob?: any | null | undefined;
          cobuyer_address_line?: string | null | undefined;
          cobuyer_address_line_2?: string | null | undefined;
          cobuyer_city?: string | null | undefined;
          cobuyer_state?: string | null | undefined;
          cobuyer_zip?: string | null | undefined;
          cobuyer_county?: string | null | undefined;
          cobuyer_primary_residence_monthly_payment?: number | null | undefined;
          cobuyer_primary_residence_type?: string | null | undefined;
          cobuyer_primary_residence_years?: number | null | undefined;
          cobuyer_primary_residence_months?: number | null | undefined;
          cobuyer_previous_address_line?: string | null | undefined;
          cobuyer_previous_address_line_2?: string | null | undefined;
          cobuyer_previous_city?: string | null | undefined;
          cobuyer_previous_state?: string | null | undefined;
          cobuyer_previous_zip?: string | null | undefined;
          cobuyer_previous_county?: string | null | undefined;
          cobuyer_secondary_residence_years?: number | null | undefined;
          cobuyer_secondary_residence_months?: number | null | undefined;
          cobuyer_relation_to_buyer?: RelationToBuyerEnum | null | undefined;
          cobuyer_marital_status?: MaritalStatusEnum | null | undefined;
          old_lease_payment?: number | null | undefined;
          vehicle_offer?: number | null | undefined;
          estimated_dealer_fees?: number | null | undefined;
          condition_report?: any | null | undefined;
          mmr_value?: number | null | undefined;
          marital_status?: MaritalStatusEnum | null | undefined;
          sales_tax_from_payoff?: number | null | undefined;
          last_url?: string | null | undefined;
          query_params?: string | null | undefined;
          manual_entry?: boolean | null | undefined;
          uploaded_files?: any | null | undefined;
          prequalification_success?: boolean | null | undefined;
          is_hard_pull?: boolean | null | undefined;
          prequalification_errors?: Array<string | null | undefined> | null | undefined;
          cobuyer_prequalification_errors?: Array<string | null | undefined> | null | undefined;
          prequal_id?: string | null | undefined;
          affiliate_external_id?: string | null | undefined;
          likely_address_query_run?: boolean | null | undefined;
          likely_address_query_success?: boolean | null | undefined;
          likely_address_accepted?: boolean | null | undefined;
          likely_address_address_line?: string | null | undefined;
          likely_address_address_line_2?: string | null | undefined;
          likely_address_city?: string | null | undefined;
          likely_address_state?: string | null | undefined;
          likely_address_zip?: string | null | undefined;
          likely_address_county?: string | null | undefined;
          wants_to_sell?: boolean | null | undefined;
          trade_in_preference?: string | null | undefined;
          sell_timeline?: string | null | undefined;
          verified_phone_number?: string | null | undefined;
          dev_prequal_override?: boolean | null | undefined;
          dev_prequal_credit_score?: number | null | undefined;
          stress_test_payoff_requested?: boolean | null | undefined;
          ssn_id?: string | null | undefined;
          cobuyer_ssn_id?: string | null | undefined;
          is_methodfi_flow?: boolean | null | undefined;
          methodfi_flow_variation?: number | null | undefined;
          shopping_cart?:
            | {
                __typename?: 'temporaryShoppingCartData';
                buyout?: number | null | undefined;
                credit_score?: number | null | undefined;
                down_payment?: number | null | undefined;
                loan_term?: number | null | undefined;
                payment_estimate_low?: number | null | undefined;
                payment_estimate_high?: number | null | undefined;
                estimated_fees?: number | null | undefined;
              }
            | null
            | undefined;
        };
      }
    | null
    | undefined;
};

export type LikelyAddressQueryVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type LikelyAddressQuery = {
  __typename?: 'Query';
  likelyAddress?:
    | {
        __typename?: 'LikelyAddress';
        address_line: string;
        address_line_2: string;
        city: string;
        state: string;
        zip: string;
        county: string;
      }
    | null
    | undefined;
};

export type KbbVinQueryVariables = Exact<{
  vin: Scalars['String']['input'];
}>;

export type KbbVinQuery = {
  __typename?: 'Query';
  kbbVin?:
    | {
        __typename?: 'kbbVinObjectResult';
        warning?: boolean | null | undefined;
        vinResults?:
          | Array<
              | {
                  __typename?: 'kbbVinResult';
                  vehicleId?: number | null | undefined;
                  modelName?: string | null | undefined;
                  trimName?: string | null | undefined;
                  makeName?: string | null | undefined;
                  yearId?: string | null | undefined;
                  vehicleName?: string | null | undefined;
                  vehicleOptions?:
                    | Array<
                        | {
                            __typename?: 'kbbOption';
                            categoryGroup?: string | null | undefined;
                            hasRelationships?: boolean | null | undefined;
                            isConfigurable?: boolean | null | undefined;
                            isConsumer?: boolean | null | undefined;
                            isTypical?: boolean | null | undefined;
                            isVinDecoded?: boolean | null | undefined;
                            optionName?: string | null | undefined;
                            optionType?: string | null | undefined;
                            sortOrder?: number | null | undefined;
                            vehicleId?: number | null | undefined;
                            vehicleOptionId?: number | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type KbbValuesQueryVariables = Exact<{
  data: KbbValuesDataType;
}>;

export type KbbValuesQuery = {
  __typename?: 'Query';
  kbbValues?:
    | {
        __typename?: 'kbbValuesResult';
        retail?: number | null | undefined;
        retailMileageAdjustment?: number | null | undefined;
        retailOptionAdjustment?: number | null | undefined;
        retailOptionPrices?: any | null | undefined;
        lending?: number | null | undefined;
        lendingMileageAdjustment?: number | null | undefined;
        lendingOptionAdjustment?: number | null | undefined;
        lendingOptionPrices?: any | null | undefined;
        valuationDate?: string | null | undefined;
        kbbSelectedOptions?:
          | Array<
              | {
                  __typename?: 'kbbSelectedOptionsType';
                  id?: string | null | undefined;
                  name?: string | null | undefined;
                  type?: string | null | undefined;
                  removed?: boolean | null | undefined;
                  lendingOptionPrice?: number | null | undefined;
                  retailOptionPrice?: number | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CalculateOptionsQueryVariables = Exact<{
  vehicleId?: InputMaybe<Scalars['Int']['input']>;
  allKbbVehicleOptions?: InputMaybe<Array<InputMaybe<KbbOptionInput>> | InputMaybe<KbbOptionInput>>;
  startingVehicleOptions?: InputMaybe<
    Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
  >;
  configToModify?: InputMaybe<Array<InputMaybe<KbbConfigType>> | InputMaybe<KbbConfigType>>;
  vin: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
}>;

export type CalculateOptionsQuery = {
  __typename?: 'Query';
  calculateOptions?:
    | Array<
        | {
            __typename?: 'kbbOption';
            vehicleOptionId?: number | null | undefined;
            optionName?: string | null | undefined;
            optionType?: string | null | undefined;
            categoryGroup?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type LienholderTrackRecordQueryVariables = Exact<{
  lienholderSlug?: InputMaybe<Scalars['String']['input']>;
}>;

export type LienholderTrackRecordQuery = {
  __typename?: 'Query';
  lienholderTrackRecord?:
    | {
        __typename?: 'LienholderTrackRecord';
        lienholderFundedCount?: number | null | undefined;
        allTimeFundedCount?: number | null | undefined;
      }
    | null
    | undefined;
};

export type CreateExternalTempInfoUploadUrlMutationVariables = Exact<{
  guid: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  fileDescription: Scalars['String']['input'];
}>;

export type CreateExternalTempInfoUploadUrlMutation = {
  __typename?: 'RootMutationType';
  createExternalTempInfoUploadUrl?:
    | { __typename?: 'externalTempInfoUploadUrl'; url?: string | null | undefined }
    | null
    | undefined;
};

export type CreateExternalDealUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileDescription: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
}>;

export type CreateExternalDealUploadUrlMutation = {
  __typename?: 'RootMutationType';
  createExternalDealUploadUrl?:
    | {
        __typename?: 'externalDealUploadUrl';
        key?: string | null | undefined;
        url?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteComFlowFileMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type DeleteComFlowFileMutation = {
  __typename?: 'RootMutationType';
  deleteComFlowFile?: any | null | undefined;
};

export type CreateFetchUrlsFromComQueryVariables = Exact<{
  keys: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;

export type CreateFetchUrlsFromComQuery = {
  __typename?: 'Query';
  createFetchUrlsFromCom: Array<string>;
};

export type MediaDeleteFromComMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
}>;

export type MediaDeleteFromComMutation = {
  __typename?: 'RootMutationType';
  mediaDeleteFromCom?: boolean | null | undefined;
};

export type MediaInsertComMutationVariables = Exact<{
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
}>;

export type MediaInsertComMutation = {
  __typename?: 'RootMutationType';
  mediaInsertCom?:
    | {
        __typename?: 'dealMedia';
        id?: string | null | undefined;
        deal_id?: string | null | undefined;
        key?: string | null | undefined;
        signed_url?: string | null | undefined;
        type?: DealMediaTypeEnum | null | undefined;
      }
    | null
    | undefined;
};

export type MediaFromComQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MediaFromComQuery = {
  __typename?: 'Query';
  mediaFromCom?:
    | Array<{
        __typename?: 'dealMedia';
        id?: string | null | undefined;
        deal_id?: string | null | undefined;
        key?: string | null | undefined;
        signed_url?: string | null | undefined;
        type?: DealMediaTypeEnum | null | undefined;
        uploaded_via_com?: boolean | null | undefined;
        created_at?: any | null | undefined;
      }>
    | null
    | undefined;
};

export type MediaUpdateComMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  oldKey: Scalars['String']['input'];
  newFileName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type MediaUpdateComMutation = {
  __typename?: 'RootMutationType';
  mediaUpdateCom?:
    | {
        __typename?: 'dealMedia';
        id?: string | null | undefined;
        deal_id?: string | null | undefined;
        key?: string | null | undefined;
        signed_url?: string | null | undefined;
        type?: DealMediaTypeEnum | null | undefined;
      }
    | null
    | undefined;
};

export type GetBase64StringFromS3ObjectQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type GetBase64StringFromS3ObjectQuery = {
  __typename?: 'Query';
  getBase64StringFromS3Object?: string | null | undefined;
};

export type CreateMethodFiIndividualEntityMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type CreateMethodFiIndividualEntityMutation = {
  __typename?: 'RootMutationType';
  createIndividualEntity?:
    | {
        __typename?: 'MethodFiEntity';
        id: string;
        type?: string | null | undefined;
        status?: string | null | undefined;
        products?: Array<string | null | undefined> | null | undefined;
      }
    | null
    | undefined;
};

export type CreateMethodFiVerificationSessionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;

export type CreateMethodFiVerificationSessionMutation = {
  __typename?: 'RootMutationType';
  createVerificationSession?:
    | {
        __typename?: 'MethodFiVerificationSession';
        id: string;
        entity_id: string;
        status?: string | null | undefined;
        type?: string | null | undefined;
        method?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateVerificationSessionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  verificationSessionId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type UpdateVerificationSessionMutation = {
  __typename?: 'RootMutationType';
  updateVerificationSession?:
    | {
        __typename?: 'MethodFiVerificationSession';
        id: string;
        entity_id: string;
        status?: string | null | undefined;
        type?: string | null | undefined;
        method?: string | null | undefined;
      }
    | null
    | undefined;
};

export type GetEntityQueryVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;

export type GetEntityQuery = {
  __typename?: 'Query';
  getEntity?:
    | {
        __typename?: 'MethodFiEntity';
        id: string;
        type?: string | null | undefined;
        status?: string | null | undefined;
        products?: Array<string | null | undefined> | null | undefined;
        verification?:
          | {
              __typename?: 'MethodFiEntityVerification';
              identity?:
                | {
                    __typename?: 'MethodFiEntityVerificationIdentity';
                    verified?: boolean | null | undefined;
                  }
                | null
                | undefined;
              phone?:
                | {
                    __typename?: 'MethodFiEntityVerificationPhone';
                    verified?: boolean | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetMethodFiSessionStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetMethodFiSessionStateQuery = {
  __typename?: 'Query';
  getMethodFiSessionState?:
    | {
        __typename?: 'MethodFiSessionState';
        entityId: string;
        entity?:
          | {
              __typename?: 'MethodFiEntity';
              id: string;
              status?: string | null | undefined;
              verification?:
                | {
                    __typename?: 'MethodFiEntityVerification';
                    identity?:
                      | {
                          __typename?: 'MethodFiEntityVerificationIdentity';
                          verified?: boolean | null | undefined;
                        }
                      | null
                      | undefined;
                    phone?:
                      | {
                          __typename?: 'MethodFiEntityVerificationPhone';
                          verified?: boolean | null | undefined;
                        }
                      | null
                      | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        vehicles?:
          | Array<
              | {
                  __typename?: 'MethodFiVehicle';
                  vin?: string | null | undefined;
                  year?: string | null | undefined;
                  make?: string | null | undefined;
                  model?: string | null | undefined;
                  series?: string | null | undefined;
                  major_color?: string | null | undefined;
                  style?: string | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        identities?:
          | Array<
              | {
                  __typename?: 'MethodFiIdentity';
                  dob?: string | null | undefined;
                  phone?: string | null | undefined;
                  address?:
                    | {
                        __typename?: 'MethodFiIdentityAddress';
                        address?: string | null | undefined;
                        city?: string | null | undefined;
                        state?: string | null | undefined;
                        postal_code?: string | null | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        tempInfoFormattedData?:
          | {
              __typename?: 'MethodFiTempInfoFormattedData';
              dob?: string | null | undefined;
              address_line?: string | null | undefined;
              address_line_2?: string | null | undefined;
              city?: string | null | undefined;
              state?: string | null | undefined;
              zip?: string | null | undefined;
              county?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateKyoVerificationMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;

export type CreateKyoVerificationMutation = {
  __typename?: 'RootMutationType';
  createKyoVerification?:
    | {
        __typename?: 'MethodFiVerificationSession';
        id: string;
        entity_id: string;
        status?: string | null | undefined;
        type?: string | null | undefined;
        method?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ConnectAndRetrieveEntityDataMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  devOldCarOverride?: InputMaybe<Scalars['Boolean']['input']>;
  separateIdentityCall?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ConnectAndRetrieveEntityDataMutation = {
  __typename?: 'RootMutationType';
  connectAndRetrieveEntityData?:
    | {
        __typename?: 'MethodFiConnectAndRetrieveData';
        entity?:
          | { __typename?: 'MethodFiEntity'; id: string; status?: string | null | undefined }
          | null
          | undefined;
        vehicles?:
          | Array<
              | {
                  __typename?: 'MethodFiVehicle';
                  vin?: string | null | undefined;
                  year?: string | null | undefined;
                  make?: string | null | undefined;
                  model?: string | null | undefined;
                  series?: string | null | undefined;
                  major_color?: string | null | undefined;
                  style?: string | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RetrieveEntityIdentitiesMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;

export type RetrieveEntityIdentitiesMutation = {
  __typename?: 'RootMutationType';
  retrieveEntityIdentities?:
    | {
        __typename?: 'MethodFiRetrieveIdentitiesData';
        ssnId?: string | null | undefined;
        entity?:
          | { __typename?: 'MethodFiEntity'; id: string; status?: string | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type HasNpsSurveyResultQueryVariables = Exact<{
  dealId: Scalars['Int']['input'];
}>;

export type HasNpsSurveyResultQuery = {
  __typename?: 'Query';
  hasNpsSurveyResult?: boolean | null | undefined;
};

export type CreateNpsSurveyResultMutationVariables = Exact<{
  input: NpsSurveyResultInput;
}>;

export type CreateNpsSurveyResultMutation = {
  __typename?: 'RootMutationType';
  createNpsSurveyResult?: boolean | null | undefined;
};

export type GetOperatingHoursAndTimeSlotsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOperatingHoursAndTimeSlotsQuery = {
  __typename?: 'Query';
  getOperatingHoursAndTimeSlots?:
    | {
        __typename?: 'operatingHoursTimeSlots';
        isOpen?: boolean | null | undefined;
        utcTimeSlots?: Array<any | null | undefined> | null | undefined;
      }
    | null
    | undefined;
};

export type CheckSupportedLienholderQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CheckSupportedLienholderQuery = {
  __typename?: 'Query';
  checkSupportedLienholder: {
    __typename?: 'SupportedLienholderResponse';
    isSupported: boolean;
    requirementsMet: boolean;
    requiredFields: Array<LienholderRequirement>;
    missingRequiredFields: Array<LienholderRequirement>;
  };
};

export type AcquirePayoffMutationVariables = Exact<{
  payloadFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type AcquirePayoffMutation = {
  __typename?: 'RootMutationType';
  acquirePayoffForTemporaryInfo: { __typename?: 'AcquirePayoffResponse'; received: boolean };
};

export type ExternalAcquirePayoffForDealMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  fields: ExternalPayoffIntelligenceFieldsInput;
  payloadFields: Array<LienholderRequirement> | LienholderRequirement;
}>;

export type ExternalAcquirePayoffForDealMutation = {
  __typename?: 'RootMutationType';
  externalAcquirePayoffForDeal: { __typename?: 'AcquirePayoffResponse'; received: boolean };
};

export type CancelPayoffRequestByTemporaryInfoIdMutationVariables = Exact<{
  temporaryInfoId: Scalars['ID']['input'];
}>;

export type CancelPayoffRequestByTemporaryInfoIdMutation = {
  __typename?: 'RootMutationType';
  cancelPayoffRequestByTemporaryInfoId?:
    | {
        __typename?: 'payoffRequest';
        id?: string | null | undefined;
        status?: PayoffRequestStatus | null | undefined;
      }
    | null
    | undefined;
};

export type ExternalUserPayoffRequestQueryVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ExternalUserPayoffRequestQuery = {
  __typename?: 'Query';
  externalUserPayoffRequest?:
    | {
        __typename?: 'payoffRequest';
        id?: string | null | undefined;
        status?: PayoffRequestStatus | null | undefined;
        vehicle_payoff?: number | null | undefined;
        good_through_date?: any | null | undefined;
        is_payoff_intelligence?: boolean | null | undefined;
        self_serve_submitted_at?: any | null | undefined;
      }
    | null
    | undefined;
};

export type OnPayoffRequestStatusUpdateSubscriptionVariables = Exact<{
  dealId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type OnPayoffRequestStatusUpdateSubscription = {
  __typename?: 'RootSubscriptionType';
  onPayoffRequestStatusUpdate?:
    | {
        __typename?: 'payoffRequestStatusUpdateWithMessage';
        message?: string | null | undefined;
        payoffRequest: {
          __typename?: 'payoffRequestStatusUpdate';
          id?: string | null | undefined;
          status?: PayoffRequestStatus | null | undefined;
          vehicle_payoff?: number | null | undefined;
          good_through_date?: any | null | undefined;
          is_payoff_intelligence?: boolean | null | undefined;
        };
      }
    | null
    | undefined;
};

export type SubmitAfterHoursSelfServePayoffMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  vehiclePayoff: Scalars['Float']['input'];
  goodThroughDate: Scalars['DateTime']['input'];
}>;

export type SubmitAfterHoursSelfServePayoffMutation = {
  __typename?: 'RootMutationType';
  submitAfterHoursSelfServePayoff?:
    | {
        __typename?: 'payoffRequest';
        id?: string | null | undefined;
        status?: PayoffRequestStatus | null | undefined;
        vehicle_payoff?: number | null | undefined;
        good_through_date?: any | null | undefined;
        is_payoff_intelligence?: boolean | null | undefined;
        self_serve_submitted_at?: any | null | undefined;
      }
    | null
    | undefined;
};

export type SubmitMarketplaceSelfServePayoffMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  vehiclePayoff: Scalars['Float']['input'];
  goodThroughDate: Scalars['DateTime']['input'];
}>;

export type SubmitMarketplaceSelfServePayoffMutation = {
  __typename?: 'RootMutationType';
  submitMarketplaceSelfServePayoff?:
    | { __typename?: 'deal'; id?: string | null | undefined }
    | null
    | undefined;
};

export type CreateManualPayoffRequestMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;

export type CreateManualPayoffRequestMutation = {
  __typename?: 'RootMutationType';
  createManualPayoffRequest?:
    | {
        __typename?: 'payoffRequest';
        id?: string | null | undefined;
        status?: PayoffRequestStatus | null | undefined;
      }
    | null
    | undefined;
};

export type ValidatePhotoTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ValidatePhotoTokenQuery = {
  __typename?: 'Query';
  validatePhotoToken?:
    | { __typename?: 'PhotoTokenValidationResult'; authToken: string; dealId: string }
    | null
    | undefined;
};

export type GeneratePhotoTokenMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;

export type GeneratePhotoTokenMutation = {
  __typename?: 'RootMutationType';
  generatePhotoToken?:
    | {
        __typename?: 'PhotoToken';
        id?: string | null | undefined;
        token: string;
        deal_id: string;
        expires_at: any;
      }
    | null
    | undefined;
};

export type GetPodHoursQueryVariables = Exact<{ [key: string]: never }>;

export type GetPodHoursQuery = {
  __typename?: 'Query';
  podHours?:
    | Array<
        | {
            __typename?: 'podHours';
            id?: number | null | undefined;
            label?: string | null | undefined;
            day?: string | null | undefined;
            beginTime?: string | null | undefined;
            endTime?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ExecuteExternalSoftPullMutationVariables = Exact<{
  paymentEstimateInput: PaymentEstimateInput;
  isHardPull: Scalars['Boolean']['input'];
}>;

export type ExecuteExternalSoftPullMutation = {
  __typename?: 'RootMutationType';
  executeExternalSoftPull?: boolean | null | undefined;
};

export type CreateReferralQueryVariables = Exact<{
  referrer_id: Scalars['Int']['input'];
  temporary_info_id?: InputMaybe<Scalars['String']['input']>;
  deal_id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreateReferralQuery = {
  __typename?: 'Query';
  createReferral?:
    | {
        __typename?: 'CreateReferralPayload';
        id?: number | null | undefined;
        ok?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type SendReferralLinkEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;

export type SendReferralLinkEmailQuery = {
  __typename?: 'Query';
  sendReferralLinkEmail?:
    | { __typename?: 'SendReferralLinkPayload'; ok?: boolean | null | undefined }
    | null
    | undefined;
};

export type SendOwnerReferralLinkEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;

export type SendOwnerReferralLinkEmailQuery = {
  __typename?: 'Query';
  sendOwnerReferralLinkEmail?:
    | { __typename?: 'SendReferralLinkPayload'; ok?: boolean | null | undefined }
    | null
    | undefined;
};

export type SendReferralLinkSmsQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;

export type SendReferralLinkSmsQuery = {
  __typename?: 'Query';
  sendReferralLinkSms?:
    | { __typename?: 'SendReferralLinkPayload'; ok?: boolean | null | undefined }
    | null
    | undefined;
};

export type SendOwnerReferralLinkSmsQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;

export type SendOwnerReferralLinkSmsQuery = {
  __typename?: 'Query';
  sendOwnerReferralLinkSms?:
    | { __typename?: 'SendReferralLinkPayload'; ok?: boolean | null | undefined }
    | null
    | undefined;
};

export type GetReferrerByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetReferrerByIdQuery = {
  __typename?: 'Query';
  getReferrerById?:
    | {
        __typename?: 'ReferrerGraphQLType';
        id?: string | null | undefined;
        code?: string | null | undefined;
        customer_id?: number | null | undefined;
        url_views?: number | null | undefined;
        flow_starts?: number | null | undefined;
        customer_first_name?: string | null | undefined;
        customer_last_name?: string | null | undefined;
        opted_in_at?: string | null | undefined;
        finix_identity?: string | null | undefined;
        finix_instrument?: string | null | undefined;
        finix_verify?: string | null | undefined;
        finix_merchant?: string | null | undefined;
        instrument_type?: string | null | undefined;
        instrument_brand?: string | null | undefined;
        instrument_last_four?: string | null | undefined;
        instrument_exp_mo?: string | null | undefined;
        instrument_exp_yr?: string | null | undefined;
      }
    | null
    | undefined;
};

export type GetReferrerByCustomerIdQueryVariables = Exact<{
  customer_id: Scalars['Int']['input'];
}>;

export type GetReferrerByCustomerIdQuery = {
  __typename?: 'Query';
  getReferrerByCustomerId?:
    | {
        __typename?: 'ReferrerGraphQLType';
        id?: string | null | undefined;
        code?: string | null | undefined;
        customer_id?: number | null | undefined;
        url_views?: number | null | undefined;
        flow_starts?: number | null | undefined;
        customer_first_name?: string | null | undefined;
        customer_last_name?: string | null | undefined;
        opted_in_at?: string | null | undefined;
        finix_identity?: string | null | undefined;
        finix_instrument?: string | null | undefined;
        finix_verify?: string | null | undefined;
        finix_merchant?: string | null | undefined;
        instrument_type?: string | null | undefined;
        instrument_brand?: string | null | undefined;
        instrument_last_four?: string | null | undefined;
        instrument_exp_mo?: string | null | undefined;
        instrument_exp_yr?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreateReferrerQueryVariables = Exact<{
  customer_id: Scalars['Int']['input'];
}>;

export type CreateReferrerQuery = {
  __typename?: 'Query';
  createReferrer?:
    | {
        __typename?: 'CreateReferrerGraphQLType';
        id?: string | null | undefined;
        code?: string | null | undefined;
        customer_id?: number | null | undefined;
        url_views?: number | null | undefined;
        flow_starts?: number | null | undefined;
        opted_in_at?: string | null | undefined;
        finix_identity?: string | null | undefined;
        finix_instrument?: string | null | undefined;
        finix_verify?: string | null | undefined;
        finix_merchant?: string | null | undefined;
        instrument_type?: string | null | undefined;
        instrument_brand?: string | null | undefined;
        instrument_last_four?: string | null | undefined;
        instrument_exp_mo?: string | null | undefined;
        instrument_exp_yr?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateReferrerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: ReferrerUpdateInput;
}>;

export type UpdateReferrerMutation = {
  __typename?: 'RootMutationType';
  updateReferrer?:
    | {
        __typename?: 'ReferrerGraphQLType';
        code?: string | null | undefined;
        url_views?: number | null | undefined;
        flow_starts?: number | null | undefined;
        opted_in_at?: string | null | undefined;
        finix_identity?: string | null | undefined;
        finix_instrument?: string | null | undefined;
        finix_verify?: string | null | undefined;
        finix_merchant?: string | null | undefined;
        instrument_type?: string | null | undefined;
        instrument_brand?: string | null | undefined;
        instrument_last_four?: string | null | undefined;
        instrument_exp_mo?: string | null | undefined;
        instrument_exp_yr?: string | null | undefined;
      }
    | null
    | undefined;
};

export type EnsureFinixIdentityMutationVariables = Exact<{
  referrer_id: Scalars['Int']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  address_line_1: Scalars['String']['input'];
  address_city: Scalars['String']['input'];
  address_state: Scalars['String']['input'];
  address_postal_code: Scalars['String']['input'];
}>;

export type EnsureFinixIdentityMutation = {
  __typename?: 'RootMutationType';
  ensureFinixIdentity?: string | null | undefined;
};

export type CreateFinixPaymentInstrumentTokenResolverMutationVariables = Exact<{
  identity: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;

export type CreateFinixPaymentInstrumentTokenResolverMutation = {
  __typename?: 'RootMutationType';
  createFinixPaymentInstrumentTokenResolver?:
    | {
        __typename?: 'CreateFinixIdentityGraphQLType';
        id?: string | null | undefined;
        pi_t?: string | null | undefined;
        pi_b?: string | null | undefined;
        pi_lf?: string | null | undefined;
        pi_em?: string | null | undefined;
        pi_ey?: string | null | undefined;
      }
    | null
    | undefined;
};

export type VerifyFinixPaymentInstrumentResolverMutationVariables = Exact<{
  identity: Scalars['String']['input'];
  instrument: Scalars['String']['input'];
}>;

export type VerifyFinixPaymentInstrumentResolverMutation = {
  __typename?: 'RootMutationType';
  verifyFinixPaymentInstrumentResolver?:
    | { __typename?: 'VerifyFinixInstrumentGraphQLType'; id?: string | null | undefined }
    | null
    | undefined;
};

export type CreateFinixPaymentMerchantResolverMutationVariables = Exact<{
  identity: Scalars['String']['input'];
}>;

export type CreateFinixPaymentMerchantResolverMutation = {
  __typename?: 'RootMutationType';
  createFinixPaymentMerchantResolver?:
    | { __typename?: 'CreateFinixMerchantGraphQLType'; id?: string | null | undefined }
    | null
    | undefined;
};

export type DisableFinixPaymentInstrumentResolverMutationVariables = Exact<{
  identity: Scalars['String']['input'];
  instrument: Scalars['String']['input'];
}>;

export type DisableFinixPaymentInstrumentResolverMutation = {
  __typename?: 'RootMutationType';
  disableFinixPaymentInstrumentResolver?:
    | { __typename?: 'DeleteFinixInstrumentGraphQLType'; ok?: boolean | null | undefined }
    | null
    | undefined;
};

export type ExternalCustomerSetTempPasswordMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;

export type ExternalCustomerSetTempPasswordMutation = {
  __typename?: 'RootMutationType';
  externalCustomerSetTempPassword?:
    | { __typename?: 'customer'; id?: string | null | undefined }
    | null
    | undefined;
};

export type GetOwedAsRefereeQueryVariables = Exact<{
  customer_id: Scalars['Int']['input'];
}>;

export type GetOwedAsRefereeQuery = {
  __typename?: 'Query';
  getOwedAsReferee?: number | null | undefined;
};

export type GetReferrerAggregateQueryVariables = Exact<{
  referrer_id: Scalars['Int']['input'];
}>;

export type GetReferrerAggregateQuery = {
  __typename?: 'Query';
  getReferrerAggregate?:
    | {
        __typename?: 'ReferrerAggregateGraphQLType';
        total_referrals?: number | null | undefined;
        paid_referrals?: number | null | undefined;
        owed_referrals?: number | null | undefined;
        pending_referrals?: number | null | undefined;
      }
    | null
    | undefined;
};

export type GetVisibleReviewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetVisibleReviewsQuery = {
  __typename?: 'Query';
  visibleReviews?:
    | Array<
        | {
            __typename?: 'review';
            id?: string | null | undefined;
            customer_name?: string | null | undefined;
            review?: string | null | undefined;
            created_at?: any | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type SecureLinkCustomerUpdateMutationVariables = Exact<{
  ssn: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;

export type SecureLinkCustomerUpdateMutation = {
  __typename?: 'RootMutationType';
  secureLinkCustomerUpdate?: any | null | undefined;
};

export type ValidateSecureLinkQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ValidateSecureLinkQuery = {
  __typename?: 'Query';
  validateSecureLink?: boolean | null | undefined;
};

export type GetR1CustomerCopyQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  includeExtraPDFBinaries: Scalars['Boolean']['input'];
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type GetR1CustomerCopyQuery = {
  __typename?: 'Query';
  getR1CustomerCopy?:
    | Array<
        | {
            __typename?: 'DealDocument';
            dealJacketId?: string | null | undefined;
            documentId?: string | null | undefined;
            documentName?: string | null | undefined;
            displayName?: string | null | undefined;
            documentType?: string | null | undefined;
            mimeType?: string | null | undefined;
            wetSignature?: boolean | null | undefined;
            docStatCode?: string | null | undefined;
            data?: string | null | undefined;
            signAttributes?:
              | Array<
                  | {
                      __typename?: 'DealDocumentSignAttribute';
                      signRequired?: boolean | null | undefined;
                      initialsType?: boolean | null | undefined;
                      signCaptureTms?: string | null | undefined;
                      actorName?: string | null | undefined;
                      actorType?: ActorType | null | undefined;
                      dateFieldName?: string | null | undefined;
                      signFieldName?: string | null | undefined;
                      signPadText?: string | null | undefined;
                      dateCoordinates?:
                        | {
                            __typename?: 'Coordinate';
                            width?: number | null | undefined;
                            height?: number | null | undefined;
                            pageNumber?: number | null | undefined;
                            xPosition?: number | null | undefined;
                            yPosition?: number | null | undefined;
                          }
                        | null
                        | undefined;
                      signatureCoordinates?:
                        | {
                            __typename?: 'Coordinate';
                            height?: number | null | undefined;
                            pageNumber?: number | null | undefined;
                            width?: number | null | undefined;
                            xPosition?: number | null | undefined;
                            yPosition?: number | null | undefined;
                          }
                        | null
                        | undefined;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type GetR1DealDocumentQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  documentID: Scalars['String']['input'];
  includePdfBinary?: InputMaybe<Scalars['Boolean']['input']>;
  isCobuyer: Scalars['Boolean']['input'];
}>;

export type GetR1DealDocumentQuery = {
  __typename?: 'Query';
  getR1DealDocument?:
    | {
        __typename?: 'DealDocument';
        dealJacketId?: string | null | undefined;
        documentId?: string | null | undefined;
        documentName?: string | null | undefined;
        displayName?: string | null | undefined;
        documentType?: string | null | undefined;
        mimeType?: string | null | undefined;
        wetSignature?: boolean | null | undefined;
        docStatCode?: string | null | undefined;
        data?: string | null | undefined;
        signAttributes?:
          | Array<
              | {
                  __typename?: 'DealDocumentSignAttribute';
                  signRequired?: boolean | null | undefined;
                  initialsType?: boolean | null | undefined;
                  signCaptureTms?: string | null | undefined;
                  actorName?: string | null | undefined;
                  actorType?: ActorType | null | undefined;
                  dateFieldName?: string | null | undefined;
                  signFieldName?: string | null | undefined;
                  signPadText?: string | null | undefined;
                  dateCoordinates?:
                    | {
                        __typename?: 'Coordinate';
                        width?: number | null | undefined;
                        height?: number | null | undefined;
                        pageNumber?: number | null | undefined;
                        xPosition?: number | null | undefined;
                        yPosition?: number | null | undefined;
                      }
                    | null
                    | undefined;
                  signatureCoordinates?:
                    | {
                        __typename?: 'Coordinate';
                        height?: number | null | undefined;
                        pageNumber?: number | null | undefined;
                        width?: number | null | undefined;
                        xPosition?: number | null | undefined;
                        yPosition?: number | null | undefined;
                      }
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GenerateTestDocumentsQueryVariables = Exact<{
  update_deal_id: Scalars['ID']['input'];
}>;

export type GenerateTestDocumentsQuery = {
  __typename?: 'Query';
  generateTestDocuments?: boolean | null | undefined;
};

export type ApplyDocumentSignatureMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
  documentID: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  signatureFieldName: Scalars['String']['input'];
  signatureData: Scalars['String']['input'];
  isLastSignature?: InputMaybe<Scalars['Boolean']['input']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ApplyDocumentSignatureMutation = {
  __typename?: 'RootMutationType';
  applyDocumentSignature?: any | null | undefined;
};

export type FinalizeR1SigningMutationVariables = Exact<{
  dealId: Scalars['ID']['input'];
  dealJacketID: Scalars['String']['input'];
}>;

export type FinalizeR1SigningMutation = {
  __typename?: 'RootMutationType';
  finalizeR1Signing?: any | null | undefined;
};

export type StoreSignatureDataMutationVariables = Exact<{
  customer_id: Scalars['ID']['input'];
  signature_data_url?: InputMaybe<Scalars['String']['input']>;
  signature_strokes?: InputMaybe<Scalars['String']['input']>;
  initials_data_url?: InputMaybe<Scalars['String']['input']>;
  initials_strokes?: InputMaybe<Scalars['String']['input']>;
}>;

export type StoreSignatureDataMutation = {
  __typename?: 'RootMutationType';
  storeSignatureData?: boolean | null | undefined;
};

export type GetSignDataQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;

export type GetSignDataQuery = {
  __typename?: 'Query';
  retrieveDealDocsUploadedToR1?:
    | Array<
        | {
            __typename?: 'DealDocument';
            documentId?: string | null | undefined;
            docStatCode?: string | null | undefined;
            signAttributes?:
              | Array<
                  | {
                      __typename?: 'DealDocumentSignAttribute';
                      signFieldName?: string | null | undefined;
                      signRequired?: boolean | null | undefined;
                      initialsType?: boolean | null | undefined;
                      signCaptureTms?: string | null | undefined;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type LogViewedDocumentEventMutationVariables = Exact<{
  documentViewedEvent: SigningAuditDocumentViewedEvent;
}>;

export type LogViewedDocumentEventMutation = {
  __typename?: 'RootMutationType';
  logViewedDocumentEvent?: any | null | undefined;
};

export type LogSigningErrorMutationVariables = Exact<{
  error: SigningErrorInput;
}>;

export type LogSigningErrorMutation = {
  __typename?: 'RootMutationType';
  logSigningError?:
    | { __typename?: 'signingError'; id?: string | null | undefined }
    | null
    | undefined;
};

export type SocialProofStatsQueryVariables = Exact<{
  dealId: Scalars['ID']['input'];
}>;

export type SocialProofStatsQuery = {
  __typename?: 'Query';
  socialProofStats?:
    | {
        __typename?: 'SocialProofStats';
        customerCountByState?: number | null | undefined;
        customerState?: string | null | undefined;
        allTimeFundedCount?: number | null | undefined;
        nationalBrandCount?: number | null | undefined;
        vehicleBrand?: string | null | undefined;
        trustpilotRating?: number | null | undefined;
        trustpilotReviewCount?: number | null | undefined;
      }
    | null
    | undefined;
};

export type GetTtJurisdictionQueryVariables = Exact<{
  state: StateAbbreviation;
  types: Array<TtProductType> | TtProductType;
  conditions?: InputMaybe<TtConditionFilterInput>;
}>;

export type GetTtJurisdictionQuery = {
  __typename?: 'Query';
  jurisdiction?:
    | {
        __typename?: 'TTJurisdiction';
        id?: string | null | undefined;
        hasRegistrationOnly?: boolean | null | undefined;
        hasTitleOnly?: boolean | null | undefined;
        hasTitleAndRegistration?: boolean | null | undefined;
        allowPlateTransfer?: boolean | null | undefined;
        requireWalkIn?: boolean | null | undefined;
        products?:
          | {
              __typename?: 'TTTTProductFieldsConnection';
              count?: number | null | undefined;
              pageInfo?:
                | {
                    __typename?: 'TTPageInfo';
                    startCursor?: string | null | undefined;
                    endCursor?: string | null | undefined;
                  }
                | null
                | undefined;
              items?:
                | Array<
                    | {
                        __typename?: 'TTProductFields';
                        type?: TtProductType | null | undefined;
                        validations?:
                          | Array<
                              | {
                                  __typename?: 'TTValidation';
                                  name?: string | null | undefined;
                                  description?: string | null | undefined;
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined;
                        documents?:
                          | {
                              __typename?: 'TTTTDocumentFieldsConnection';
                              count?: number | null | undefined;
                              items?:
                                | Array<
                                    | {
                                        __typename?: 'TTDocumentFields';
                                        supportsImageExtraction?: boolean | null | undefined;
                                        productId?: string | null | undefined;
                                        documentTypeId?: string | null | undefined;
                                        type?:
                                          | {
                                              __typename?: 'TTDocumentTypeFields';
                                              name?: string | null | undefined;
                                              parameters?:
                                                | Array<
                                                    | {
                                                        __typename?: 'TTParameterFields';
                                                        name?: string | null | undefined;
                                                        description?: string | null | undefined;
                                                        type?: string | null | undefined;
                                                      }
                                                    | null
                                                    | undefined
                                                  >
                                                | null
                                                | undefined;
                                            }
                                          | null
                                          | undefined;
                                        conditions?:
                                          | Array<
                                              | {
                                                  __typename?: 'TTDocumentConditionsFields';
                                                  description?: string | null | undefined;
                                                  variables?:
                                                    | Array<string | null | undefined>
                                                    | null
                                                    | undefined;
                                                }
                                              | null
                                              | undefined
                                            >
                                          | null
                                          | undefined;
                                        validations?:
                                          | Array<
                                              | {
                                                  __typename?: 'TTValidation';
                                                  name?: string | null | undefined;
                                                  description?: string | null | undefined;
                                                }
                                              | null
                                              | undefined
                                            >
                                          | null
                                          | undefined;
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined;
                            }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UploadDocumentMutationVariables = Exact<{
  bytes: Scalars['String']['input'];
  documentType: TtDocumentName;
}>;

export type UploadDocumentMutation = {
  __typename?: 'RootMutationType';
  uploadDocument?:
    | {
        __typename?: 'ExtractedDocumentGQL';
        documentName?: string | null | undefined;
        key?: string | null | undefined;
        fields?:
          | Array<
              | {
                  __typename?: 'ExtractedField';
                  confidence?: number | null | undefined;
                  name?: string | null | undefined;
                  value?: string | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UploadDriversLicenseMutationVariables = Exact<{
  bytes: Scalars['String']['input'];
  includeGender?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UploadDriversLicenseMutation = {
  __typename?: 'RootMutationType';
  uploadDriversLicense?:
    | {
        __typename?: 'DriversLicenseGQL';
        firstName?: string | null | undefined;
        middleName?: string | null | undefined;
        lastName?: string | null | undefined;
        address?: string | null | undefined;
        city?: string | null | undefined;
        state?: string | null | undefined;
        zip?: string | null | undefined;
        expirationDate?: any | null | undefined;
        sex?: string | null | undefined;
        documentNumber?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UserDealQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  isCobuyer?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UserDealQuery = {
  __typename?: 'Query';
  userDeal?:
    | {
        __typename?: 'externalDeal';
        id?: string | null | undefined;
        type?: DealType | null | undefined;
        state?: string | null | undefined;
        import_type?: ImportType | null | undefined;
        paperwork_type?: PaperworkType | null | undefined;
        request_boot?: boolean | null | undefined;
        sales_visibility?: boolean | null | undefined;
        after_hours_held_at?: any | null | undefined;
        funding_jacket_id?: string | null | undefined;
        r1_contract_generation_date_utc?: any | null | undefined;
        signing_on_com?: boolean | null | undefined;
        document_progress_status?: string | null | undefined;
        isCobuyer?: boolean | null | undefined;
        closer_id?: string | null | undefined;
        came_from_marketplace?: boolean | null | undefined;
        setter_id?: string | null | undefined;
        car?:
          | {
              __typename?: 'car';
              id?: string | null | undefined;
              vin?: string | null | undefined;
              year?: string | null | undefined;
              make?: string | null | undefined;
              model?: string | null | undefined;
              mileage?: number | null | undefined;
              color?: string | null | undefined;
              book_value?: number | null | undefined;
              retail_book_value?: number | null | undefined;
              registration_expiration?: any | null | undefined;
              vehicle_type?: string | null | undefined;
              fuel_type?: string | null | undefined;
              kbb_trim_name?: string | null | undefined;
              mmr?: number | null | undefined;
              payoff?:
                | {
                    __typename?: 'payoff';
                    id?: string | null | undefined;
                    lienholder_name?: string | null | undefined;
                    lienholder_slug?: string | null | undefined;
                    account_number?: string | null | undefined;
                    vehicle_payoff?: number | null | undefined;
                    lease_term?: number | null | undefined;
                    remaining_payments?: number | null | undefined;
                    msrp?: number | null | undefined;
                    residual_percentage?: number | null | undefined;
                    sales_price?: number | null | undefined;
                    cap_reduction?: number | null | undefined;
                    money_down?: number | null | undefined;
                    money_factor?: number | null | undefined;
                    termination_fees?: number | null | undefined;
                    cap_cost?: number | null | undefined;
                    residual_amount?: number | null | undefined;
                    estimated_payoff?: number | null | undefined;
                    old_lease_payment?: number | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        customer?:
          | {
              __typename?: 'externalCustomer';
              id?: string | null | undefined;
              first_name?: string | null | undefined;
              middle_name?: string | null | undefined;
              last_name?: string | null | undefined;
              phone_number?: string | null | undefined;
              email?: string | null | undefined;
              dob?: any | null | undefined;
              dashboard_visited?: boolean | null | undefined;
              verified?: boolean | null | undefined;
              finished_signing?: boolean | null | undefined;
              prequalification?:
                | {
                    __typename?: 'externalPrequalification';
                    id?: string | null | undefined;
                    created_at?: any | null | undefined;
                    updated_at?: any | null | undefined;
                    ltv?: number | null | undefined;
                    payment_to_income?: number | null | undefined;
                    prequalification_errors?: Array<string | null | undefined> | null | undefined;
                  }
                | null
                | undefined;
              address?:
                | {
                    __typename?: 'address';
                    id?: string | null | undefined;
                    city?: string | null | undefined;
                    state?: string | null | undefined;
                    zip?: string | null | undefined;
                    county?: string | null | undefined;
                    address_line?: string | null | undefined;
                    residence_type?: string | null | undefined;
                    years_at_home?: number | null | undefined;
                    months_at_home?: number | null | undefined;
                    monthly_payment?: number | null | undefined;
                    moved_states?: boolean | null | undefined;
                  }
                | null
                | undefined;
              drivers_license_address?:
                | {
                    __typename?: 'address';
                    id?: string | null | undefined;
                    city?: string | null | undefined;
                    state?: string | null | undefined;
                    zip?: string | null | undefined;
                    county?: string | null | undefined;
                    address_line?: string | null | undefined;
                    residence_type?: string | null | undefined;
                    years_at_home?: number | null | undefined;
                    months_at_home?: number | null | undefined;
                    monthly_payment?: number | null | undefined;
                    moved_states?: boolean | null | undefined;
                  }
                | null
                | undefined;
              prev_address?:
                | {
                    __typename?: 'address';
                    id?: string | null | undefined;
                    city?: string | null | undefined;
                    state?: string | null | undefined;
                    zip?: string | null | undefined;
                    county?: string | null | undefined;
                    address_line?: string | null | undefined;
                    residence_type?: string | null | undefined;
                    years_at_home?: number | null | undefined;
                    months_at_home?: number | null | undefined;
                    monthly_payment?: number | null | undefined;
                  }
                | null
                | undefined;
              employment?:
                | {
                    __typename?: 'employment';
                    id?: string | null | undefined;
                    name?: string | null | undefined;
                    job_title?: string | null | undefined;
                    phone_number?: string | null | undefined;
                    years_at_job?: number | null | undefined;
                    months_at_job?: number | null | undefined;
                    gross_income?: number | null | undefined;
                    pay_frequency?: IncomeIntervalEnum | null | undefined;
                  }
                | null
                | undefined;
              prev_employment?:
                | {
                    __typename?: 'employment';
                    id?: string | null | undefined;
                    name?: string | null | undefined;
                    job_title?: string | null | undefined;
                    phone_number?: string | null | undefined;
                    years_at_job?: number | null | undefined;
                    months_at_job?: number | null | undefined;
                    gross_income?: number | null | undefined;
                    pay_frequency?: IncomeIntervalEnum | null | undefined;
                  }
                | null
                | undefined;
              signature_data?:
                | {
                    __typename?: 'SignatureData';
                    signature_data_url?: string | null | undefined;
                    signature_strokes?: string | null | undefined;
                    initials_data_url?: string | null | undefined;
                    initials_strokes?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        cobuyer?:
          | {
              __typename?: 'externalCustomer';
              id?: string | null | undefined;
              first_name?: string | null | undefined;
              middle_name?: string | null | undefined;
              last_name?: string | null | undefined;
              phone_number?: string | null | undefined;
              email?: string | null | undefined;
              dob?: any | null | undefined;
              dashboard_visited?: boolean | null | undefined;
              verified?: boolean | null | undefined;
              finished_signing?: boolean | null | undefined;
              prequalification?:
                | {
                    __typename?: 'externalPrequalification';
                    id?: string | null | undefined;
                    created_at?: any | null | undefined;
                    updated_at?: any | null | undefined;
                    ltv?: number | null | undefined;
                    payment_to_income?: number | null | undefined;
                    prequalification_errors?: Array<string | null | undefined> | null | undefined;
                  }
                | null
                | undefined;
              address?:
                | {
                    __typename?: 'address';
                    id?: string | null | undefined;
                    city?: string | null | undefined;
                    state?: string | null | undefined;
                    zip?: string | null | undefined;
                    county?: string | null | undefined;
                    address_line?: string | null | undefined;
                    residence_type?: string | null | undefined;
                    years_at_home?: number | null | undefined;
                    months_at_home?: number | null | undefined;
                    monthly_payment?: number | null | undefined;
                  }
                | null
                | undefined;
              prev_address?:
                | {
                    __typename?: 'address';
                    id?: string | null | undefined;
                    city?: string | null | undefined;
                    state?: string | null | undefined;
                    zip?: string | null | undefined;
                    county?: string | null | undefined;
                    address_line?: string | null | undefined;
                    residence_type?: string | null | undefined;
                    years_at_home?: number | null | undefined;
                    months_at_home?: number | null | undefined;
                    monthly_payment?: number | null | undefined;
                  }
                | null
                | undefined;
              employment?:
                | {
                    __typename?: 'employment';
                    id?: string | null | undefined;
                    name?: string | null | undefined;
                    job_title?: string | null | undefined;
                    phone_number?: string | null | undefined;
                    years_at_job?: number | null | undefined;
                    months_at_job?: number | null | undefined;
                    gross_income?: number | null | undefined;
                    pay_frequency?: IncomeIntervalEnum | null | undefined;
                  }
                | null
                | undefined;
              prev_employment?:
                | {
                    __typename?: 'employment';
                    id?: string | null | undefined;
                    name?: string | null | undefined;
                    job_title?: string | null | undefined;
                    phone_number?: string | null | undefined;
                    years_at_job?: number | null | undefined;
                    months_at_job?: number | null | undefined;
                    gross_income?: number | null | undefined;
                    pay_frequency?: IncomeIntervalEnum | null | undefined;
                  }
                | null
                | undefined;
              signature_data?:
                | {
                    __typename?: 'SignatureData';
                    signature_data_url?: string | null | undefined;
                    signature_strokes?: string | null | undefined;
                    initials_data_url?: string | null | undefined;
                    initials_strokes?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        financial_info?:
          | {
              __typename?: 'financialInfo';
              id?: string | null | undefined;
              deal_id?: string | null | undefined;
              money_down?: number | null | undefined;
              base_tax_amount?: number | null | undefined;
              warranty_tax_amount?: number | null | undefined;
              title_registration_option?: TitleRegistrationOption | null | undefined;
              title_fee?: number | null | undefined;
              new_registration_fee?: number | null | undefined;
              registration_transfer_fee?: number | null | undefined;
              doc_fee?: number | null | undefined;
              sales_tax_rate?: number | null | undefined;
              days_to_payment?: number | null | undefined;
              first_payment_date?: any | null | undefined;
              sell_rate?: number | null | undefined;
              buy_rate?: number | null | undefined;
              term?: number | null | undefined;
              bank?: string | null | undefined;
              bank_slug?: TtNewBankEnum | null | undefined;
              payment?: number | null | undefined;
              amount_financed?: number | null | undefined;
              profit?: number | null | undefined;
              setter_commission?: number | null | undefined;
              closer_commission?: number | null | undefined;
              option_type?: string | null | undefined;
              plate_transfer?: boolean | null | undefined;
              credit_debit_payment_amount_allowed?: number | null | undefined;
              credit_payment_amount_allowed?: number | null | undefined;
              debit_payment_amount_allowed?: number | null | undefined;
              credit_payment_amount_limit?: number | null | undefined;
              debit_payment_amount_limit?: number | null | undefined;
            }
          | null
          | undefined;
        financial_info_acquisition?:
          | {
              __typename?: 'financialInfoAcquisition';
              id?: string | null | undefined;
              deal_id?: string | null | undefined;
              kbb_lending?: number | null | undefined;
              appraised_value?: number | null | undefined;
              max_cash_to_customer?: number | null | undefined;
              max_total_cost?: number | null | undefined;
              cash_to_customer?: number | null | undefined;
              is_approved?: boolean | null | undefined;
              auction_fees?: number | null | undefined;
              transport_cost?: number | null | undefined;
              total_cost?: number | null | undefined;
              auction_id?: string | null | undefined;
              gross_profit?: number | null | undefined;
              sell_price?: number | null | undefined;
              offer?: number | null | undefined;
            }
          | null
          | undefined;
        condition_report?:
          | {
              __typename?: 'conditionReport';
              id?: string | null | undefined;
              deal_id?: string | null | undefined;
              accidents?: AccidentsEnumType | null | undefined;
              tires?: TiresEnumType | null | undefined;
              exterior?: Array<ExteriorEnumType | null | undefined> | null | undefined;
              interior?: Array<InteriorEnumType | null | undefined> | null | undefined;
              smoked_in?: boolean | null | undefined;
              lights_on_dash?: boolean | null | undefined;
              overall_condition?: OverallConditionEnumType | null | undefined;
              score?: number | null | undefined;
            }
          | null
          | undefined;
        document_info?:
          | { __typename?: 'DocumentInfo'; adobe_agreement_id?: string | null | undefined }
          | null
          | undefined;
        product?:
          | {
              __typename?: 'product';
              selected_package?: string | null | undefined;
              gap_selected?: boolean | null | undefined;
            }
          | null
          | undefined;
        deal_states?:
          | Array<
              | {
                  __typename?: 'dealState';
                  state?: string | null | undefined;
                  updated_date_utc?: any | null | undefined;
                  created_at?: any | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UserDealsQueryVariables = Exact<{ [key: string]: never }>;

export type UserDealsQuery = {
  __typename?: 'Query';
  userDeals?:
    | Array<
        | {
            __typename?: 'deals';
            id?: string | null | undefined;
            sales_visibility?: boolean | null | undefined;
            after_hours_held_at?: any | null | undefined;
            type?: DealType | null | undefined;
            isCobuyer?: boolean | null | undefined;
            car?:
              | {
                  __typename?: 'car';
                  id?: string | null | undefined;
                  vin?: string | null | undefined;
                  year?: string | null | undefined;
                  make?: string | null | undefined;
                  model?: string | null | undefined;
                  mileage?: number | null | undefined;
                  color?: string | null | undefined;
                  book_value?: number | null | undefined;
                  retail_book_value?: number | null | undefined;
                  registration_expiration?: any | null | undefined;
                  vehicle_type?: string | null | undefined;
                  fuel_type?: string | null | undefined;
                  kbb_trim_name?: string | null | undefined;
                  mmr?: number | null | undefined;
                }
              | null
              | undefined;
            customer?:
              | {
                  __typename?: 'customer';
                  full_name?: string | null | undefined;
                  email?: string | null | undefined;
                }
              | null
              | undefined;
            cobuyer?:
              | {
                  __typename?: 'customer';
                  full_name?: string | null | undefined;
                  email?: string | null | undefined;
                }
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type HasAnyDealQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type HasAnyDealQuery = { __typename?: 'Query'; hasAnyDeal?: boolean | null | undefined };

export const TemporaryDataFragmentDoc = gql`
  fragment TemporaryData on temporaryData {
    vin
    license_plate_number
    license_plate_state
    year
    make
    model
    fuel_type
    vehicle_type
    color
    mileage
    vehicle_payoff
    automatically_fetched_payoff
    user_entered_total_payoff
    phone_number
    email
    current_accordion_panel
    lienholder
    lienholder_slug
    other_lienholder
    lienholderLogo
    first_name
    middle_name
    last_name
    address_line
    address_line_2
    city
    state
    country
    county
    zip
    taxes
    vehicle_registration_fee
    doc_fee
    has_full_ssn
    previous_address_line
    previous_address_line_2
    previous_city
    previous_state
    previous_zip
    previous_county
    scheduled_call_datetime
    scheduled_call_datetime_tz
    primary_residence_type
    primary_residence_years
    primary_residence_months
    primary_residence_monthly_payment
    lives_with_other_buyer
    secondary_residence_years
    secondary_residence_months
    dob
    employment_status
    employer_name
    job_title
    employer_phone_number
    years_at_job
    months_at_job
    salary
    pay_frequency
    previous_employer_name
    previous_job_title
    previous_employer_phone_number
    previous_years_at_job
    previous_months_at_job
    retail_book_value
    kbb_retail_mileage_adjustment
    kbb_retail_option_adjustment
    book_value
    kbb_lending_mileage_adjustment
    kbb_lending_option_adjustment
    kbb_valuation_date
    kbb_vehicle_name
    kbb_vehicle_id
    kbb_all_options
    kbb_trim_name
    kbb_selected_options
    good_through_date
    credit_score
    term
    rate
    down_payment
    taxes_fees
    payment_estimate_low
    payment_estimate_high
    payoff_includes_sales_tax
    lh_account_number
    include_cobuyer
    cobuyer_first_name
    cobuyer_last_name
    cobuyer_employment_status
    cobuyer_employer_name
    cobuyer_employer_phone_number
    cobuyer_job_title
    cobuyer_years_at_job
    cobuyer_months_at_job
    cobuyer_salary
    cobuyer_pay_frequency
    cobuyer_previous_employer_name
    cobuyer_previous_employer_phone_number
    cobuyer_previous_job_title
    cobuyer_previous_years_at_job
    cobuyer_previous_months_at_job
    cobuyer_phone_number
    cobuyer_email
    cobuyer_dob
    cobuyer_address_line
    cobuyer_address_line_2
    cobuyer_city
    cobuyer_state
    cobuyer_zip
    cobuyer_county
    cobuyer_primary_residence_monthly_payment
    cobuyer_primary_residence_type
    cobuyer_primary_residence_years
    cobuyer_primary_residence_months
    cobuyer_previous_address_line
    cobuyer_previous_address_line_2
    cobuyer_previous_city
    cobuyer_previous_state
    cobuyer_previous_zip
    cobuyer_previous_county
    cobuyer_secondary_residence_years
    cobuyer_secondary_residence_months
    cobuyer_relation_to_buyer
    cobuyer_marital_status
    old_lease_payment
    vehicle_offer
    estimated_dealer_fees
    condition_report
    mmr_value
    shopping_cart {
      buyout
      credit_score
      down_payment
      loan_term
      payment_estimate_low
      payment_estimate_high
      estimated_fees
    }
    marital_status
    sales_tax_from_payoff
    last_url
    query_params
    manual_entry
    uploaded_files
    prequalification_success
    is_hard_pull
    prequalification_errors
    cobuyer_prequalification_errors
    prequal_id
    affiliate_external_id
    likely_address_query_run
    likely_address_query_success
    likely_address_accepted
    likely_address_address_line
    likely_address_address_line_2
    likely_address_city
    likely_address_state
    likely_address_zip
    likely_address_county
    wants_to_sell
    trade_in_preference
    sell_timeline
    verified_phone_number
    dev_prequal_override
    dev_prequal_credit_score
    stress_test_payoff_requested
    ssn_id
    cobuyer_ssn_id
    is_methodfi_flow
    methodfi_flow_variation
  }
`;
export const ValidZipDocument = gql`
  query validZip($zipCode: String!) {
    validZip(zipCode: $zipCode)
  }
`;

/**
 * __useValidZipQuery__
 *
 * To run a query within a React component, call `useValidZipQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidZipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidZipQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useValidZipQuery(
  baseOptions: Apollo.QueryHookOptions<ValidZipQuery, ValidZipQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidZipQuery, ValidZipQueryVariables>(ValidZipDocument, options);
}
export function useValidZipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ValidZipQuery, ValidZipQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidZipQuery, ValidZipQueryVariables>(ValidZipDocument, options);
}
export type ValidZipQueryHookResult = ReturnType<typeof useValidZipQuery>;
export type ValidZipLazyQueryHookResult = ReturnType<typeof useValidZipLazyQuery>;
export type ValidZipQueryResult = Apollo.QueryResult<ValidZipQuery, ValidZipQueryVariables>;
export const AddressDetailDocument = gql`
  query addressDetail($address: String, $zipCode: String) {
    addressDetail(address: $address, zipCode: $zipCode) {
      city
      county
      state
    }
  }
`;

/**
 * __useAddressDetailQuery__
 *
 * To run a query within a React component, call `useAddressDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressDetailQuery({
 *   variables: {
 *      address: // value for 'address'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useAddressDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AddressDetailQuery, AddressDetailQueryVariables>(
    AddressDetailDocument,
    options,
  );
}
export function useAddressDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AddressDetailQuery, AddressDetailQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AddressDetailQuery, AddressDetailQueryVariables>(
    AddressDetailDocument,
    options,
  );
}
export type AddressDetailQueryHookResult = ReturnType<typeof useAddressDetailQuery>;
export type AddressDetailLazyQueryHookResult = ReturnType<typeof useAddressDetailLazyQuery>;
export type AddressDetailQueryResult = Apollo.QueryResult<
  AddressDetailQuery,
  AddressDetailQueryVariables
>;
export const AffiliateDetailsDocument = gql`
  query affiliateDetails($affiliateExternalId: String) {
    affiliateDetails(affiliateExternalId: $affiliateExternalId) {
      external_id
      decision_accepted
      affiliate_provider {
        id
        slug
        name
      }
      decision_response {
        offers {
          amount
          term
          apr
          monthlyPayment
        }
      }
    }
  }
`;

/**
 * __useAffiliateDetailsQuery__
 *
 * To run a query within a React component, call `useAffiliateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateDetailsQuery({
 *   variables: {
 *      affiliateExternalId: // value for 'affiliateExternalId'
 *   },
 * });
 */
export function useAffiliateDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<AffiliateDetailsQuery, AffiliateDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AffiliateDetailsQuery, AffiliateDetailsQueryVariables>(
    AffiliateDetailsDocument,
    options,
  );
}
export function useAffiliateDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AffiliateDetailsQuery, AffiliateDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AffiliateDetailsQuery, AffiliateDetailsQueryVariables>(
    AffiliateDetailsDocument,
    options,
  );
}
export type AffiliateDetailsQueryHookResult = ReturnType<typeof useAffiliateDetailsQuery>;
export type AffiliateDetailsLazyQueryHookResult = ReturnType<typeof useAffiliateDetailsLazyQuery>;
export type AffiliateDetailsQueryResult = Apollo.QueryResult<
  AffiliateDetailsQuery,
  AffiliateDetailsQueryVariables
>;
export const CheckAffiliateDealExistsDocument = gql`
  query checkAffiliateDealExists($affiliateExternalId: String) {
    checkAffiliateDealExists(affiliateExternalId: $affiliateExternalId)
  }
`;

/**
 * __useCheckAffiliateDealExistsQuery__
 *
 * To run a query within a React component, call `useCheckAffiliateDealExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAffiliateDealExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAffiliateDealExistsQuery({
 *   variables: {
 *      affiliateExternalId: // value for 'affiliateExternalId'
 *   },
 * });
 */
export function useCheckAffiliateDealExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckAffiliateDealExistsQuery,
    CheckAffiliateDealExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckAffiliateDealExistsQuery, CheckAffiliateDealExistsQueryVariables>(
    CheckAffiliateDealExistsDocument,
    options,
  );
}
export function useCheckAffiliateDealExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckAffiliateDealExistsQuery,
    CheckAffiliateDealExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckAffiliateDealExistsQuery, CheckAffiliateDealExistsQueryVariables>(
    CheckAffiliateDealExistsDocument,
    options,
  );
}
export type CheckAffiliateDealExistsQueryHookResult = ReturnType<
  typeof useCheckAffiliateDealExistsQuery
>;
export type CheckAffiliateDealExistsLazyQueryHookResult = ReturnType<
  typeof useCheckAffiliateDealExistsLazyQuery
>;
export type CheckAffiliateDealExistsQueryResult = Apollo.QueryResult<
  CheckAffiliateDealExistsQuery,
  CheckAffiliateDealExistsQueryVariables
>;
export const ResetPasswordAndSendEmailDocument = gql`
  mutation resetPasswordAndSendEmail($password: String) {
    resetPasswordAndSendEmail(password: $password)
  }
`;
export type ResetPasswordAndSendEmailMutationFn = Apollo.MutationFunction<
  ResetPasswordAndSendEmailMutation,
  ResetPasswordAndSendEmailMutationVariables
>;

/**
 * __useResetPasswordAndSendEmailMutation__
 *
 * To run a mutation, you first call `useResetPasswordAndSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordAndSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordAndSendEmailMutation, { data, loading, error }] = useResetPasswordAndSendEmailMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordAndSendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordAndSendEmailMutation,
    ResetPasswordAndSendEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordAndSendEmailMutation,
    ResetPasswordAndSendEmailMutationVariables
  >(ResetPasswordAndSendEmailDocument, options);
}
export type ResetPasswordAndSendEmailMutationHookResult = ReturnType<
  typeof useResetPasswordAndSendEmailMutation
>;
export type ResetPasswordAndSendEmailMutationResult =
  Apollo.MutationResult<ResetPasswordAndSendEmailMutation>;
export type ResetPasswordAndSendEmailMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordAndSendEmailMutation,
  ResetPasswordAndSendEmailMutationVariables
>;
export const CheckExistingAccountByEmailDocument = gql`
  query checkExistingAccountByEmail($email: String!) {
    checkExistingAccountByEmail(email: $email)
  }
`;

/**
 * __useCheckExistingAccountByEmailQuery__
 *
 * To run a query within a React component, call `useCheckExistingAccountByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingAccountByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingAccountByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckExistingAccountByEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckExistingAccountByEmailQuery,
    CheckExistingAccountByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckExistingAccountByEmailQuery,
    CheckExistingAccountByEmailQueryVariables
  >(CheckExistingAccountByEmailDocument, options);
}
export function useCheckExistingAccountByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckExistingAccountByEmailQuery,
    CheckExistingAccountByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckExistingAccountByEmailQuery,
    CheckExistingAccountByEmailQueryVariables
  >(CheckExistingAccountByEmailDocument, options);
}
export type CheckExistingAccountByEmailQueryHookResult = ReturnType<
  typeof useCheckExistingAccountByEmailQuery
>;
export type CheckExistingAccountByEmailLazyQueryHookResult = ReturnType<
  typeof useCheckExistingAccountByEmailLazyQuery
>;
export type CheckExistingAccountByEmailQueryResult = Apollo.QueryResult<
  CheckExistingAccountByEmailQuery,
  CheckExistingAccountByEmailQueryVariables
>;
export const CheckExistingAccountHasPasswordDocument = gql`
  query checkExistingAccountHasPassword {
    checkExistingAccountHasPassword
  }
`;

/**
 * __useCheckExistingAccountHasPasswordQuery__
 *
 * To run a query within a React component, call `useCheckExistingAccountHasPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingAccountHasPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingAccountHasPasswordQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckExistingAccountHasPasswordQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckExistingAccountHasPasswordQuery,
    CheckExistingAccountHasPasswordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckExistingAccountHasPasswordQuery,
    CheckExistingAccountHasPasswordQueryVariables
  >(CheckExistingAccountHasPasswordDocument, options);
}
export function useCheckExistingAccountHasPasswordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckExistingAccountHasPasswordQuery,
    CheckExistingAccountHasPasswordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckExistingAccountHasPasswordQuery,
    CheckExistingAccountHasPasswordQueryVariables
  >(CheckExistingAccountHasPasswordDocument, options);
}
export type CheckExistingAccountHasPasswordQueryHookResult = ReturnType<
  typeof useCheckExistingAccountHasPasswordQuery
>;
export type CheckExistingAccountHasPasswordLazyQueryHookResult = ReturnType<
  typeof useCheckExistingAccountHasPasswordLazyQuery
>;
export type CheckExistingAccountHasPasswordQueryResult = Apollo.QueryResult<
  CheckExistingAccountHasPasswordQuery,
  CheckExistingAccountHasPasswordQueryVariables
>;
export const CheckFlowStatusDocument = gql`
  query checkFlowStatus($guid: String) {
    checkFlowStatus(guid: $guid) {
      inFlow
      guid
      url
      car {
        id
        make
        model
        year
        mileage
        vin
        vehicle_type
        color
      }
      dealId
      customerId
    }
  }
`;

/**
 * __useCheckFlowStatusQuery__
 *
 * To run a query within a React component, call `useCheckFlowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckFlowStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckFlowStatusQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useCheckFlowStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<CheckFlowStatusQuery, CheckFlowStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckFlowStatusQuery, CheckFlowStatusQueryVariables>(
    CheckFlowStatusDocument,
    options,
  );
}
export function useCheckFlowStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckFlowStatusQuery, CheckFlowStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckFlowStatusQuery, CheckFlowStatusQueryVariables>(
    CheckFlowStatusDocument,
    options,
  );
}
export type CheckFlowStatusQueryHookResult = ReturnType<typeof useCheckFlowStatusQuery>;
export type CheckFlowStatusLazyQueryHookResult = ReturnType<typeof useCheckFlowStatusLazyQuery>;
export type CheckFlowStatusQueryResult = Apollo.QueryResult<
  CheckFlowStatusQuery,
  CheckFlowStatusQueryVariables
>;
export const BankLogoDocument = gql`
  query bankLogo($bank_name: String!) {
    bankLogo(bank_name: $bank_name)
  }
`;

/**
 * __useBankLogoQuery__
 *
 * To run a query within a React component, call `useBankLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankLogoQuery({
 *   variables: {
 *      bank_name: // value for 'bank_name'
 *   },
 * });
 */
export function useBankLogoQuery(
  baseOptions: Apollo.QueryHookOptions<BankLogoQuery, BankLogoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BankLogoQuery, BankLogoQueryVariables>(BankLogoDocument, options);
}
export function useBankLogoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BankLogoQuery, BankLogoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BankLogoQuery, BankLogoQueryVariables>(BankLogoDocument, options);
}
export type BankLogoQueryHookResult = ReturnType<typeof useBankLogoQuery>;
export type BankLogoLazyQueryHookResult = ReturnType<typeof useBankLogoLazyQuery>;
export type BankLogoQueryResult = Apollo.QueryResult<BankLogoQuery, BankLogoQueryVariables>;
export const GetExternalAutoStructureBankLogosDocument = gql`
  query getExternalAutoStructureBankLogos {
    getExternalAutoStructureBankLogos {
      bank_name
      bank_slug
      logo_url
    }
  }
`;

/**
 * __useGetExternalAutoStructureBankLogosQuery__
 *
 * To run a query within a React component, call `useGetExternalAutoStructureBankLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalAutoStructureBankLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalAutoStructureBankLogosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalAutoStructureBankLogosQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetExternalAutoStructureBankLogosQuery,
    GetExternalAutoStructureBankLogosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetExternalAutoStructureBankLogosQuery,
    GetExternalAutoStructureBankLogosQueryVariables
  >(GetExternalAutoStructureBankLogosDocument, options);
}
export function useGetExternalAutoStructureBankLogosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExternalAutoStructureBankLogosQuery,
    GetExternalAutoStructureBankLogosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetExternalAutoStructureBankLogosQuery,
    GetExternalAutoStructureBankLogosQueryVariables
  >(GetExternalAutoStructureBankLogosDocument, options);
}
export type GetExternalAutoStructureBankLogosQueryHookResult = ReturnType<
  typeof useGetExternalAutoStructureBankLogosQuery
>;
export type GetExternalAutoStructureBankLogosLazyQueryHookResult = ReturnType<
  typeof useGetExternalAutoStructureBankLogosLazyQuery
>;
export type GetExternalAutoStructureBankLogosQueryResult = Apollo.QueryResult<
  GetExternalAutoStructureBankLogosQuery,
  GetExternalAutoStructureBankLogosQueryVariables
>;
export const GetRandomVinFromProdDocument = gql`
  query getRandomVinFromProd @api(name: le_prod) {
    getRandomVin
  }
`;

/**
 * __useGetRandomVinFromProdQuery__
 *
 * To run a query within a React component, call `useGetRandomVinFromProdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomVinFromProdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomVinFromProdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRandomVinFromProdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRandomVinFromProdQuery,
    GetRandomVinFromProdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRandomVinFromProdQuery, GetRandomVinFromProdQueryVariables>(
    GetRandomVinFromProdDocument,
    options,
  );
}
export function useGetRandomVinFromProdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRandomVinFromProdQuery,
    GetRandomVinFromProdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRandomVinFromProdQuery, GetRandomVinFromProdQueryVariables>(
    GetRandomVinFromProdDocument,
    options,
  );
}
export type GetRandomVinFromProdQueryHookResult = ReturnType<typeof useGetRandomVinFromProdQuery>;
export type GetRandomVinFromProdLazyQueryHookResult = ReturnType<
  typeof useGetRandomVinFromProdLazyQuery
>;
export type GetRandomVinFromProdQueryResult = Apollo.QueryResult<
  GetRandomVinFromProdQuery,
  GetRandomVinFromProdQueryVariables
>;
export const RecordConsentDecisionDocument = gql`
  mutation recordConsentDecision($decision: ConsentDecisionInput!) {
    recordConsentDecision(decision: $decision)
  }
`;
export type RecordConsentDecisionMutationFn = Apollo.MutationFunction<
  RecordConsentDecisionMutation,
  RecordConsentDecisionMutationVariables
>;

/**
 * __useRecordConsentDecisionMutation__
 *
 * To run a mutation, you first call `useRecordConsentDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordConsentDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordConsentDecisionMutation, { data, loading, error }] = useRecordConsentDecisionMutation({
 *   variables: {
 *      decision: // value for 'decision'
 *   },
 * });
 */
export function useRecordConsentDecisionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordConsentDecisionMutation,
    RecordConsentDecisionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecordConsentDecisionMutation, RecordConsentDecisionMutationVariables>(
    RecordConsentDecisionDocument,
    options,
  );
}
export type RecordConsentDecisionMutationHookResult = ReturnType<
  typeof useRecordConsentDecisionMutation
>;
export type RecordConsentDecisionMutationResult =
  Apollo.MutationResult<RecordConsentDecisionMutation>;
export type RecordConsentDecisionMutationOptions = Apollo.BaseMutationOptions<
  RecordConsentDecisionMutation,
  RecordConsentDecisionMutationVariables
>;
export const ConsentOptOutLookupDocument = gql`
  query consentOptOutLookup($identifiers: [ConsentIdentifierInput!]!) {
    consentOptOutLookup(identifiers: $identifiers)
  }
`;

/**
 * __useConsentOptOutLookupQuery__
 *
 * To run a query within a React component, call `useConsentOptOutLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsentOptOutLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsentOptOutLookupQuery({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useConsentOptOutLookupQuery(
  baseOptions: Apollo.QueryHookOptions<ConsentOptOutLookupQuery, ConsentOptOutLookupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConsentOptOutLookupQuery, ConsentOptOutLookupQueryVariables>(
    ConsentOptOutLookupDocument,
    options,
  );
}
export function useConsentOptOutLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConsentOptOutLookupQuery,
    ConsentOptOutLookupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConsentOptOutLookupQuery, ConsentOptOutLookupQueryVariables>(
    ConsentOptOutLookupDocument,
    options,
  );
}
export type ConsentOptOutLookupQueryHookResult = ReturnType<typeof useConsentOptOutLookupQuery>;
export type ConsentOptOutLookupLazyQueryHookResult = ReturnType<
  typeof useConsentOptOutLookupLazyQuery
>;
export type ConsentOptOutLookupQueryResult = Apollo.QueryResult<
  ConsentOptOutLookupQuery,
  ConsentOptOutLookupQueryVariables
>;
export const LinkIdentifiersToOptOutsDocument = gql`
  mutation linkIdentifiersToOptOuts(
    $identifiers: [ConsentIdentifierInput!]!
    $howLinked: ConsentHowLinked!
  ) {
    linkIdentifiersToOptOuts(identifiers: $identifiers, howLinked: $howLinked)
  }
`;
export type LinkIdentifiersToOptOutsMutationFn = Apollo.MutationFunction<
  LinkIdentifiersToOptOutsMutation,
  LinkIdentifiersToOptOutsMutationVariables
>;

/**
 * __useLinkIdentifiersToOptOutsMutation__
 *
 * To run a mutation, you first call `useLinkIdentifiersToOptOutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkIdentifiersToOptOutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkIdentifiersToOptOutsMutation, { data, loading, error }] = useLinkIdentifiersToOptOutsMutation({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *      howLinked: // value for 'howLinked'
 *   },
 * });
 */
export function useLinkIdentifiersToOptOutsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkIdentifiersToOptOutsMutation,
    LinkIdentifiersToOptOutsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LinkIdentifiersToOptOutsMutation,
    LinkIdentifiersToOptOutsMutationVariables
  >(LinkIdentifiersToOptOutsDocument, options);
}
export type LinkIdentifiersToOptOutsMutationHookResult = ReturnType<
  typeof useLinkIdentifiersToOptOutsMutation
>;
export type LinkIdentifiersToOptOutsMutationResult =
  Apollo.MutationResult<LinkIdentifiersToOptOutsMutation>;
export type LinkIdentifiersToOptOutsMutationOptions = Apollo.BaseMutationOptions<
  LinkIdentifiersToOptOutsMutation,
  LinkIdentifiersToOptOutsMutationVariables
>;
export const CurrentConsentAgreementTextDocument = gql`
  query currentConsentAgreementText($agreementType: consentAgreementTypeEnum!, $version: Int) {
    currentConsentAgreementText(agreementType: $agreementType, version: $version) {
      id
      text
      version
      updated_at
    }
  }
`;

/**
 * __useCurrentConsentAgreementTextQuery__
 *
 * To run a query within a React component, call `useCurrentConsentAgreementTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentConsentAgreementTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentConsentAgreementTextQuery({
 *   variables: {
 *      agreementType: // value for 'agreementType'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCurrentConsentAgreementTextQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurrentConsentAgreementTextQuery,
    CurrentConsentAgreementTextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CurrentConsentAgreementTextQuery,
    CurrentConsentAgreementTextQueryVariables
  >(CurrentConsentAgreementTextDocument, options);
}
export function useCurrentConsentAgreementTextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentConsentAgreementTextQuery,
    CurrentConsentAgreementTextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrentConsentAgreementTextQuery,
    CurrentConsentAgreementTextQueryVariables
  >(CurrentConsentAgreementTextDocument, options);
}
export type CurrentConsentAgreementTextQueryHookResult = ReturnType<
  typeof useCurrentConsentAgreementTextQuery
>;
export type CurrentConsentAgreementTextLazyQueryHookResult = ReturnType<
  typeof useCurrentConsentAgreementTextLazyQuery
>;
export type CurrentConsentAgreementTextQueryResult = Apollo.QueryResult<
  CurrentConsentAgreementTextQuery,
  CurrentConsentAgreementTextQueryVariables
>;
export const SaveConsentDocument = gql`
  mutation saveConsent($type: consentNameEnumType!, $dealId: ID, $version: Int) {
    saveConsent(type: $type, dealId: $dealId, version: $version) {
      consent {
        id
      }
    }
  }
`;
export type SaveConsentMutationFn = Apollo.MutationFunction<
  SaveConsentMutation,
  SaveConsentMutationVariables
>;

/**
 * __useSaveConsentMutation__
 *
 * To run a mutation, you first call `useSaveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConsentMutation, { data, loading, error }] = useSaveConsentMutation({
 *   variables: {
 *      type: // value for 'type'
 *      dealId: // value for 'dealId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveConsentMutation, SaveConsentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveConsentMutation, SaveConsentMutationVariables>(
    SaveConsentDocument,
    options,
  );
}
export type SaveConsentMutationHookResult = ReturnType<typeof useSaveConsentMutation>;
export type SaveConsentMutationResult = Apollo.MutationResult<SaveConsentMutation>;
export type SaveConsentMutationOptions = Apollo.BaseMutationOptions<
  SaveConsentMutation,
  SaveConsentMutationVariables
>;
export const ExternalCustomerUpdateDocument = gql`
  mutation externalCustomerUpdate($customerId: ID!, $customer: ExternalCustomerInput) {
    externalCustomerUpdate(customerId: $customerId, customer: $customer) {
      id
    }
  }
`;
export type ExternalCustomerUpdateMutationFn = Apollo.MutationFunction<
  ExternalCustomerUpdateMutation,
  ExternalCustomerUpdateMutationVariables
>;

/**
 * __useExternalCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useExternalCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalCustomerUpdateMutation, { data, loading, error }] = useExternalCustomerUpdateMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useExternalCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExternalCustomerUpdateMutation,
    ExternalCustomerUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExternalCustomerUpdateMutation,
    ExternalCustomerUpdateMutationVariables
  >(ExternalCustomerUpdateDocument, options);
}
export type ExternalCustomerUpdateMutationHookResult = ReturnType<
  typeof useExternalCustomerUpdateMutation
>;
export type ExternalCustomerUpdateMutationResult =
  Apollo.MutationResult<ExternalCustomerUpdateMutation>;
export type ExternalCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  ExternalCustomerUpdateMutation,
  ExternalCustomerUpdateMutationVariables
>;
export const GetByAuth0IdDocument = gql`
  query getByAuth0Id {
    getByAuth0Id {
      first_name
      last_name
      full_name
      email
    }
  }
`;

/**
 * __useGetByAuth0IdQuery__
 *
 * To run a query within a React component, call `useGetByAuth0IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetByAuth0IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetByAuth0IdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetByAuth0IdQuery(
  baseOptions?: Apollo.QueryHookOptions<GetByAuth0IdQuery, GetByAuth0IdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetByAuth0IdQuery, GetByAuth0IdQueryVariables>(
    GetByAuth0IdDocument,
    options,
  );
}
export function useGetByAuth0IdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetByAuth0IdQuery, GetByAuth0IdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetByAuth0IdQuery, GetByAuth0IdQueryVariables>(
    GetByAuth0IdDocument,
    options,
  );
}
export type GetByAuth0IdQueryHookResult = ReturnType<typeof useGetByAuth0IdQuery>;
export type GetByAuth0IdLazyQueryHookResult = ReturnType<typeof useGetByAuth0IdLazyQuery>;
export type GetByAuth0IdQueryResult = Apollo.QueryResult<
  GetByAuth0IdQuery,
  GetByAuth0IdQueryVariables
>;
export const VerifyAccountDocument = gql`
  mutation verifyAccount($ssn_last_4: String!, $deal_id: ID!, $is_cobuyer: Boolean) {
    verifyAccount(ssn_last_4: $ssn_last_4, deal_id: $deal_id, is_cobuyer: $is_cobuyer)
  }
`;
export type VerifyAccountMutationFn = Apollo.MutationFunction<
  VerifyAccountMutation,
  VerifyAccountMutationVariables
>;

/**
 * __useVerifyAccountMutation__
 *
 * To run a mutation, you first call `useVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountMutation, { data, loading, error }] = useVerifyAccountMutation({
 *   variables: {
 *      ssn_last_4: // value for 'ssn_last_4'
 *      deal_id: // value for 'deal_id'
 *      is_cobuyer: // value for 'is_cobuyer'
 *   },
 * });
 */
export function useVerifyAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyAccountMutation, VerifyAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyAccountMutation, VerifyAccountMutationVariables>(
    VerifyAccountDocument,
    options,
  );
}
export type VerifyAccountMutationHookResult = ReturnType<typeof useVerifyAccountMutation>;
export type VerifyAccountMutationResult = Apollo.MutationResult<VerifyAccountMutation>;
export type VerifyAccountMutationOptions = Apollo.BaseMutationOptions<
  VerifyAccountMutation,
  VerifyAccountMutationVariables
>;
export const AuthenticateAnonymousCustomerDocument = gql`
  mutation authenticateAnonymousCustomer($tempInfoId: String!) {
    authenticateAnonymousCustomer(tempInfoId: $tempInfoId)
  }
`;
export type AuthenticateAnonymousCustomerMutationFn = Apollo.MutationFunction<
  AuthenticateAnonymousCustomerMutation,
  AuthenticateAnonymousCustomerMutationVariables
>;

/**
 * __useAuthenticateAnonymousCustomerMutation__
 *
 * To run a mutation, you first call `useAuthenticateAnonymousCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateAnonymousCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateAnonymousCustomerMutation, { data, loading, error }] = useAuthenticateAnonymousCustomerMutation({
 *   variables: {
 *      tempInfoId: // value for 'tempInfoId'
 *   },
 * });
 */
export function useAuthenticateAnonymousCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthenticateAnonymousCustomerMutation,
    AuthenticateAnonymousCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthenticateAnonymousCustomerMutation,
    AuthenticateAnonymousCustomerMutationVariables
  >(AuthenticateAnonymousCustomerDocument, options);
}
export type AuthenticateAnonymousCustomerMutationHookResult = ReturnType<
  typeof useAuthenticateAnonymousCustomerMutation
>;
export type AuthenticateAnonymousCustomerMutationResult =
  Apollo.MutationResult<AuthenticateAnonymousCustomerMutation>;
export type AuthenticateAnonymousCustomerMutationOptions = Apollo.BaseMutationOptions<
  AuthenticateAnonymousCustomerMutation,
  AuthenticateAnonymousCustomerMutationVariables
>;
export const CustomerNotificationsDocument = gql`
  query customerNotifications($dealId: ID!, $isCobuyer: Boolean!) {
    customerNotifications(dealId: $dealId, isCobuyer: $isCobuyer) {
      id
      content
      customer_id
      deal_id
      seen_at
      dismissed_at
      call_to_actions {
        label
        action
      }
      auto_mark_as_seen
      created_at
    }
  }
`;

/**
 * __useCustomerNotificationsQuery__
 *
 * To run a query within a React component, call `useCustomerNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerNotificationsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useCustomerNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomerNotificationsQuery,
    CustomerNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerNotificationsQuery, CustomerNotificationsQueryVariables>(
    CustomerNotificationsDocument,
    options,
  );
}
export function useCustomerNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerNotificationsQuery,
    CustomerNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerNotificationsQuery, CustomerNotificationsQueryVariables>(
    CustomerNotificationsDocument,
    options,
  );
}
export type CustomerNotificationsQueryHookResult = ReturnType<typeof useCustomerNotificationsQuery>;
export type CustomerNotificationsLazyQueryHookResult = ReturnType<
  typeof useCustomerNotificationsLazyQuery
>;
export type CustomerNotificationsQueryResult = Apollo.QueryResult<
  CustomerNotificationsQuery,
  CustomerNotificationsQueryVariables
>;
export const DismissCustomerNotificationDocument = gql`
  mutation dismissCustomerNotification($id: ID!, $dealId: ID!, $isCobuyer: Boolean!) {
    dismissCustomerNotification(id: $id, dealId: $dealId, isCobuyer: $isCobuyer) {
      id
      content
      customer_id
      deal_id
      seen_at
      dismissed_at
      call_to_actions {
        label
        action
      }
      auto_mark_as_seen
      created_at
    }
  }
`;
export type DismissCustomerNotificationMutationFn = Apollo.MutationFunction<
  DismissCustomerNotificationMutation,
  DismissCustomerNotificationMutationVariables
>;

/**
 * __useDismissCustomerNotificationMutation__
 *
 * To run a mutation, you first call `useDismissCustomerNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissCustomerNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissCustomerNotificationMutation, { data, loading, error }] = useDismissCustomerNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dealId: // value for 'dealId'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useDismissCustomerNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissCustomerNotificationMutation,
    DismissCustomerNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissCustomerNotificationMutation,
    DismissCustomerNotificationMutationVariables
  >(DismissCustomerNotificationDocument, options);
}
export type DismissCustomerNotificationMutationHookResult = ReturnType<
  typeof useDismissCustomerNotificationMutation
>;
export type DismissCustomerNotificationMutationResult =
  Apollo.MutationResult<DismissCustomerNotificationMutation>;
export type DismissCustomerNotificationMutationOptions = Apollo.BaseMutationOptions<
  DismissCustomerNotificationMutation,
  DismissCustomerNotificationMutationVariables
>;
export const MarkCustomerNotificationsAsSeenDocument = gql`
  mutation markCustomerNotificationsAsSeen($dealId: ID!, $isCobuyer: Boolean!) {
    markCustomerNotificationsAsSeen(dealId: $dealId, isCobuyer: $isCobuyer) {
      id
      content
      customer_id
      deal_id
      seen_at
      dismissed_at
      call_to_actions {
        label
        action
      }
      auto_mark_as_seen
      created_at
    }
  }
`;
export type MarkCustomerNotificationsAsSeenMutationFn = Apollo.MutationFunction<
  MarkCustomerNotificationsAsSeenMutation,
  MarkCustomerNotificationsAsSeenMutationVariables
>;

/**
 * __useMarkCustomerNotificationsAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkCustomerNotificationsAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomerNotificationsAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomerNotificationsAsSeenMutation, { data, loading, error }] = useMarkCustomerNotificationsAsSeenMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useMarkCustomerNotificationsAsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkCustomerNotificationsAsSeenMutation,
    MarkCustomerNotificationsAsSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkCustomerNotificationsAsSeenMutation,
    MarkCustomerNotificationsAsSeenMutationVariables
  >(MarkCustomerNotificationsAsSeenDocument, options);
}
export type MarkCustomerNotificationsAsSeenMutationHookResult = ReturnType<
  typeof useMarkCustomerNotificationsAsSeenMutation
>;
export type MarkCustomerNotificationsAsSeenMutationResult =
  Apollo.MutationResult<MarkCustomerNotificationsAsSeenMutation>;
export type MarkCustomerNotificationsAsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkCustomerNotificationsAsSeenMutation,
  MarkCustomerNotificationsAsSeenMutationVariables
>;
export const MarkCustomerNotificationAsSeenDocument = gql`
  mutation markCustomerNotificationAsSeen($id: ID!, $dealId: ID!, $isCobuyer: Boolean!) {
    markCustomerNotificationAsSeen(id: $id, dealId: $dealId, isCobuyer: $isCobuyer) {
      id
      content
      customer_id
      deal_id
      seen_at
      dismissed_at
      call_to_actions {
        label
        action
      }
      auto_mark_as_seen
      created_at
    }
  }
`;
export type MarkCustomerNotificationAsSeenMutationFn = Apollo.MutationFunction<
  MarkCustomerNotificationAsSeenMutation,
  MarkCustomerNotificationAsSeenMutationVariables
>;

/**
 * __useMarkCustomerNotificationAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkCustomerNotificationAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomerNotificationAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomerNotificationAsSeenMutation, { data, loading, error }] = useMarkCustomerNotificationAsSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dealId: // value for 'dealId'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useMarkCustomerNotificationAsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkCustomerNotificationAsSeenMutation,
    MarkCustomerNotificationAsSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkCustomerNotificationAsSeenMutation,
    MarkCustomerNotificationAsSeenMutationVariables
  >(MarkCustomerNotificationAsSeenDocument, options);
}
export type MarkCustomerNotificationAsSeenMutationHookResult = ReturnType<
  typeof useMarkCustomerNotificationAsSeenMutation
>;
export type MarkCustomerNotificationAsSeenMutationResult =
  Apollo.MutationResult<MarkCustomerNotificationAsSeenMutation>;
export type MarkCustomerNotificationAsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkCustomerNotificationAsSeenMutation,
  MarkCustomerNotificationAsSeenMutationVariables
>;
export const ExternalUpdateDealDocument = gql`
  mutation externalUpdateDeal($dealId: ID, $tempInfoId: ID, $data: ExternalDealInputType!) {
    externalUpdateDeal(dealId: $dealId, tempInfoId: $tempInfoId, data: $data) {
      id
    }
  }
`;
export type ExternalUpdateDealMutationFn = Apollo.MutationFunction<
  ExternalUpdateDealMutation,
  ExternalUpdateDealMutationVariables
>;

/**
 * __useExternalUpdateDealMutation__
 *
 * To run a mutation, you first call `useExternalUpdateDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalUpdateDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalUpdateDealMutation, { data, loading, error }] = useExternalUpdateDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      tempInfoId: // value for 'tempInfoId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExternalUpdateDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExternalUpdateDealMutation,
    ExternalUpdateDealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExternalUpdateDealMutation, ExternalUpdateDealMutationVariables>(
    ExternalUpdateDealDocument,
    options,
  );
}
export type ExternalUpdateDealMutationHookResult = ReturnType<typeof useExternalUpdateDealMutation>;
export type ExternalUpdateDealMutationResult = Apollo.MutationResult<ExternalUpdateDealMutation>;
export type ExternalUpdateDealMutationOptions = Apollo.BaseMutationOptions<
  ExternalUpdateDealMutation,
  ExternalUpdateDealMutationVariables
>;
export const DealAdvisorsDocument = gql`
  query dealAdvisors($dealId: ID) {
    dealAdvisors(dealId: $dealId) {
      setter {
        name
      }
      closer {
        id
        name
        photo_url
      }
      funding_clerk {
        name
        photo_url
      }
      title_clerk {
        name
        photo_url
      }
    }
  }
`;

/**
 * __useDealAdvisorsQuery__
 *
 * To run a query within a React component, call `useDealAdvisorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealAdvisorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealAdvisorsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useDealAdvisorsQuery(
  baseOptions?: Apollo.QueryHookOptions<DealAdvisorsQuery, DealAdvisorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DealAdvisorsQuery, DealAdvisorsQueryVariables>(
    DealAdvisorsDocument,
    options,
  );
}
export function useDealAdvisorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DealAdvisorsQuery, DealAdvisorsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DealAdvisorsQuery, DealAdvisorsQueryVariables>(
    DealAdvisorsDocument,
    options,
  );
}
export type DealAdvisorsQueryHookResult = ReturnType<typeof useDealAdvisorsQuery>;
export type DealAdvisorsLazyQueryHookResult = ReturnType<typeof useDealAdvisorsLazyQuery>;
export type DealAdvisorsQueryResult = Apollo.QueryResult<
  DealAdvisorsQuery,
  DealAdvisorsQueryVariables
>;
export const TotalCompletedDealsDocument = gql`
  query totalCompletedDeals {
    totalCompletedDeals
  }
`;

/**
 * __useTotalCompletedDealsQuery__
 *
 * To run a query within a React component, call `useTotalCompletedDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalCompletedDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalCompletedDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalCompletedDealsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TotalCompletedDealsQuery,
    TotalCompletedDealsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalCompletedDealsQuery, TotalCompletedDealsQueryVariables>(
    TotalCompletedDealsDocument,
    options,
  );
}
export function useTotalCompletedDealsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalCompletedDealsQuery,
    TotalCompletedDealsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalCompletedDealsQuery, TotalCompletedDealsQueryVariables>(
    TotalCompletedDealsDocument,
    options,
  );
}
export type TotalCompletedDealsQueryHookResult = ReturnType<typeof useTotalCompletedDealsQuery>;
export type TotalCompletedDealsLazyQueryHookResult = ReturnType<
  typeof useTotalCompletedDealsLazyQuery
>;
export type TotalCompletedDealsQueryResult = Apollo.QueryResult<
  TotalCompletedDealsQuery,
  TotalCompletedDealsQueryVariables
>;
export const InsertDevAffiliateFromTempInfoDocument = gql`
  mutation insertDevAffiliateFromTempInfo($externalId: ID!, $tempInfoId: ID!) {
    insertDevAffiliateFromTempInfo(externalId: $externalId, tempInfoId: $tempInfoId)
  }
`;
export type InsertDevAffiliateFromTempInfoMutationFn = Apollo.MutationFunction<
  InsertDevAffiliateFromTempInfoMutation,
  InsertDevAffiliateFromTempInfoMutationVariables
>;

/**
 * __useInsertDevAffiliateFromTempInfoMutation__
 *
 * To run a mutation, you first call `useInsertDevAffiliateFromTempInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDevAffiliateFromTempInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDevAffiliateFromTempInfoMutation, { data, loading, error }] = useInsertDevAffiliateFromTempInfoMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      tempInfoId: // value for 'tempInfoId'
 *   },
 * });
 */
export function useInsertDevAffiliateFromTempInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InsertDevAffiliateFromTempInfoMutation,
    InsertDevAffiliateFromTempInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InsertDevAffiliateFromTempInfoMutation,
    InsertDevAffiliateFromTempInfoMutationVariables
  >(InsertDevAffiliateFromTempInfoDocument, options);
}
export type InsertDevAffiliateFromTempInfoMutationHookResult = ReturnType<
  typeof useInsertDevAffiliateFromTempInfoMutation
>;
export type InsertDevAffiliateFromTempInfoMutationResult =
  Apollo.MutationResult<InsertDevAffiliateFromTempInfoMutation>;
export type InsertDevAffiliateFromTempInfoMutationOptions = Apollo.BaseMutationOptions<
  InsertDevAffiliateFromTempInfoMutation,
  InsertDevAffiliateFromTempInfoMutationVariables
>;
export const RunAutoStructureCronsDocument = gql`
  mutation runAutoStructureCrons {
    runAutoStructureCrons
  }
`;
export type RunAutoStructureCronsMutationFn = Apollo.MutationFunction<
  RunAutoStructureCronsMutation,
  RunAutoStructureCronsMutationVariables
>;

/**
 * __useRunAutoStructureCronsMutation__
 *
 * To run a mutation, you first call `useRunAutoStructureCronsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAutoStructureCronsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAutoStructureCronsMutation, { data, loading, error }] = useRunAutoStructureCronsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunAutoStructureCronsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunAutoStructureCronsMutation,
    RunAutoStructureCronsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAutoStructureCronsMutation, RunAutoStructureCronsMutationVariables>(
    RunAutoStructureCronsDocument,
    options,
  );
}
export type RunAutoStructureCronsMutationHookResult = ReturnType<
  typeof useRunAutoStructureCronsMutation
>;
export type RunAutoStructureCronsMutationResult =
  Apollo.MutationResult<RunAutoStructureCronsMutation>;
export type RunAutoStructureCronsMutationOptions = Apollo.BaseMutationOptions<
  RunAutoStructureCronsMutation,
  RunAutoStructureCronsMutationVariables
>;
export const SendDevAffiliateToThunderDocument = gql`
  mutation sendDevAffiliateToThunder($externalId: String!) {
    sendDevAffiliateToThunder(externalId: $externalId)
  }
`;
export type SendDevAffiliateToThunderMutationFn = Apollo.MutationFunction<
  SendDevAffiliateToThunderMutation,
  SendDevAffiliateToThunderMutationVariables
>;

/**
 * __useSendDevAffiliateToThunderMutation__
 *
 * To run a mutation, you first call `useSendDevAffiliateToThunderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDevAffiliateToThunderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDevAffiliateToThunderMutation, { data, loading, error }] = useSendDevAffiliateToThunderMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useSendDevAffiliateToThunderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendDevAffiliateToThunderMutation,
    SendDevAffiliateToThunderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendDevAffiliateToThunderMutation,
    SendDevAffiliateToThunderMutationVariables
  >(SendDevAffiliateToThunderDocument, options);
}
export type SendDevAffiliateToThunderMutationHookResult = ReturnType<
  typeof useSendDevAffiliateToThunderMutation
>;
export type SendDevAffiliateToThunderMutationResult =
  Apollo.MutationResult<SendDevAffiliateToThunderMutation>;
export type SendDevAffiliateToThunderMutationOptions = Apollo.BaseMutationOptions<
  SendDevAffiliateToThunderMutation,
  SendDevAffiliateToThunderMutationVariables
>;
export const CreateDownPaymentLinkDocument = gql`
  mutation createDownPaymentLink {
    createDownPaymentLink
  }
`;
export type CreateDownPaymentLinkMutationFn = Apollo.MutationFunction<
  CreateDownPaymentLinkMutation,
  CreateDownPaymentLinkMutationVariables
>;

/**
 * __useCreateDownPaymentLinkMutation__
 *
 * To run a mutation, you first call `useCreateDownPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownPaymentLinkMutation, { data, loading, error }] = useCreateDownPaymentLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDownPaymentLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDownPaymentLinkMutation,
    CreateDownPaymentLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDownPaymentLinkMutation, CreateDownPaymentLinkMutationVariables>(
    CreateDownPaymentLinkDocument,
    options,
  );
}
export type CreateDownPaymentLinkMutationHookResult = ReturnType<
  typeof useCreateDownPaymentLinkMutation
>;
export type CreateDownPaymentLinkMutationResult =
  Apollo.MutationResult<CreateDownPaymentLinkMutation>;
export type CreateDownPaymentLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateDownPaymentLinkMutation,
  CreateDownPaymentLinkMutationVariables
>;
export const ExecuteDownPaymentDocument = gql`
  mutation executeDownPayment(
    $firstName: String!
    $lastName: String!
    $email: String!
    $amount: Float!
    $phoneNumber: String
    $bank: String!
    $plaidAccountId: String!
    $plaidToken: String!
    $fraudSessionId: String!
    $idempotencyId: String!
    $dealId: ID
  ) {
    executeDownPayment(
      firstName: $firstName
      lastName: $lastName
      email: $email
      amount: $amount
      phoneNumber: $phoneNumber
      bank: $bank
      plaidAccountId: $plaidAccountId
      plaidToken: $plaidToken
      fraudSessionId: $fraudSessionId
      idempotencyId: $idempotencyId
      dealId: $dealId
    ) {
      id
      amount
    }
  }
`;
export type ExecuteDownPaymentMutationFn = Apollo.MutationFunction<
  ExecuteDownPaymentMutation,
  ExecuteDownPaymentMutationVariables
>;

/**
 * __useExecuteDownPaymentMutation__
 *
 * To run a mutation, you first call `useExecuteDownPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDownPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDownPaymentMutation, { data, loading, error }] = useExecuteDownPaymentMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      amount: // value for 'amount'
 *      phoneNumber: // value for 'phoneNumber'
 *      bank: // value for 'bank'
 *      plaidAccountId: // value for 'plaidAccountId'
 *      plaidToken: // value for 'plaidToken'
 *      fraudSessionId: // value for 'fraudSessionId'
 *      idempotencyId: // value for 'idempotencyId'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useExecuteDownPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteDownPaymentMutation,
    ExecuteDownPaymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExecuteDownPaymentMutation, ExecuteDownPaymentMutationVariables>(
    ExecuteDownPaymentDocument,
    options,
  );
}
export type ExecuteDownPaymentMutationHookResult = ReturnType<typeof useExecuteDownPaymentMutation>;
export type ExecuteDownPaymentMutationResult = Apollo.MutationResult<ExecuteDownPaymentMutation>;
export type ExecuteDownPaymentMutationOptions = Apollo.BaseMutationOptions<
  ExecuteDownPaymentMutation,
  ExecuteDownPaymentMutationVariables
>;
export const ExecuteCardDownPaymentDocument = gql`
  mutation executeCardDownPayment(
    $firstName: String!
    $lastName: String!
    $email: String!
    $amount: Float!
    $phoneNumber: String
    $fraudSessionId: String!
    $idempotencyId: String!
    $token: String!
    $dealId: ID
    $paymentMethod: paymentMethod!
  ) {
    executeCardDownPayment(
      firstName: $firstName
      lastName: $lastName
      email: $email
      amount: $amount
      phoneNumber: $phoneNumber
      fraudSessionId: $fraudSessionId
      idempotencyId: $idempotencyId
      token: $token
      dealId: $dealId
      paymentMethod: $paymentMethod
    ) {
      id
      amount
      cardBrand
      cardType
      failureCode
      maskedNumber
      state
    }
  }
`;
export type ExecuteCardDownPaymentMutationFn = Apollo.MutationFunction<
  ExecuteCardDownPaymentMutation,
  ExecuteCardDownPaymentMutationVariables
>;

/**
 * __useExecuteCardDownPaymentMutation__
 *
 * To run a mutation, you first call `useExecuteCardDownPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCardDownPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCardDownPaymentMutation, { data, loading, error }] = useExecuteCardDownPaymentMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      amount: // value for 'amount'
 *      phoneNumber: // value for 'phoneNumber'
 *      fraudSessionId: // value for 'fraudSessionId'
 *      idempotencyId: // value for 'idempotencyId'
 *      token: // value for 'token'
 *      dealId: // value for 'dealId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useExecuteCardDownPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteCardDownPaymentMutation,
    ExecuteCardDownPaymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExecuteCardDownPaymentMutation,
    ExecuteCardDownPaymentMutationVariables
  >(ExecuteCardDownPaymentDocument, options);
}
export type ExecuteCardDownPaymentMutationHookResult = ReturnType<
  typeof useExecuteCardDownPaymentMutation
>;
export type ExecuteCardDownPaymentMutationResult =
  Apollo.MutationResult<ExecuteCardDownPaymentMutation>;
export type ExecuteCardDownPaymentMutationOptions = Apollo.BaseMutationOptions<
  ExecuteCardDownPaymentMutation,
  ExecuteCardDownPaymentMutationVariables
>;
export const GetDownPaymentAmountByMethodDocument = gql`
  query getDownPaymentAmountByMethod($dealId: ID!, $paymentType: paymentInstrumentType!) {
    getDownPaymentAmountByMethod(dealId: $dealId, paymentType: $paymentType)
  }
`;

/**
 * __useGetDownPaymentAmountByMethodQuery__
 *
 * To run a query within a React component, call `useGetDownPaymentAmountByMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownPaymentAmountByMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownPaymentAmountByMethodQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      paymentType: // value for 'paymentType'
 *   },
 * });
 */
export function useGetDownPaymentAmountByMethodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDownPaymentAmountByMethodQuery,
    GetDownPaymentAmountByMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDownPaymentAmountByMethodQuery,
    GetDownPaymentAmountByMethodQueryVariables
  >(GetDownPaymentAmountByMethodDocument, options);
}
export function useGetDownPaymentAmountByMethodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDownPaymentAmountByMethodQuery,
    GetDownPaymentAmountByMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDownPaymentAmountByMethodQuery,
    GetDownPaymentAmountByMethodQueryVariables
  >(GetDownPaymentAmountByMethodDocument, options);
}
export type GetDownPaymentAmountByMethodQueryHookResult = ReturnType<
  typeof useGetDownPaymentAmountByMethodQuery
>;
export type GetDownPaymentAmountByMethodLazyQueryHookResult = ReturnType<
  typeof useGetDownPaymentAmountByMethodLazyQuery
>;
export type GetDownPaymentAmountByMethodQueryResult = Apollo.QueryResult<
  GetDownPaymentAmountByMethodQuery,
  GetDownPaymentAmountByMethodQueryVariables
>;
export const EiRedirectDocument = gql`
  mutation eiRedirect($leadId: String!) {
    eiRedirect(leadId: $leadId) {
      url
    }
  }
`;
export type EiRedirectMutationFn = Apollo.MutationFunction<
  EiRedirectMutation,
  EiRedirectMutationVariables
>;

/**
 * __useEiRedirectMutation__
 *
 * To run a mutation, you first call `useEiRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEiRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eiRedirectMutation, { data, loading, error }] = useEiRedirectMutation({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useEiRedirectMutation(
  baseOptions?: Apollo.MutationHookOptions<EiRedirectMutation, EiRedirectMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EiRedirectMutation, EiRedirectMutationVariables>(
    EiRedirectDocument,
    options,
  );
}
export type EiRedirectMutationHookResult = ReturnType<typeof useEiRedirectMutation>;
export type EiRedirectMutationResult = Apollo.MutationResult<EiRedirectMutation>;
export type EiRedirectMutationOptions = Apollo.BaseMutationOptions<
  EiRedirectMutation,
  EiRedirectMutationVariables
>;
export const EmployerPhoneLookupDocument = gql`
  mutation employerPhoneLookup($input: EmployerPhoneLookupInput!) {
    employerPhoneLookup(input: $input) {
      phoneNumber
      source
    }
  }
`;
export type EmployerPhoneLookupMutationFn = Apollo.MutationFunction<
  EmployerPhoneLookupMutation,
  EmployerPhoneLookupMutationVariables
>;

/**
 * __useEmployerPhoneLookupMutation__
 *
 * To run a mutation, you first call `useEmployerPhoneLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerPhoneLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerPhoneLookupMutation, { data, loading, error }] = useEmployerPhoneLookupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployerPhoneLookupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EmployerPhoneLookupMutation,
    EmployerPhoneLookupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EmployerPhoneLookupMutation, EmployerPhoneLookupMutationVariables>(
    EmployerPhoneLookupDocument,
    options,
  );
}
export type EmployerPhoneLookupMutationHookResult = ReturnType<
  typeof useEmployerPhoneLookupMutation
>;
export type EmployerPhoneLookupMutationResult = Apollo.MutationResult<EmployerPhoneLookupMutation>;
export type EmployerPhoneLookupMutationOptions = Apollo.BaseMutationOptions<
  EmployerPhoneLookupMutation,
  EmployerPhoneLookupMutationVariables
>;
export const CreateFeedbackDocument = gql`
  mutation createFeedback(
    $name: String!
    $email: String!
    $rating: Int!
    $improvements: String!
    $deal_id: ID!
  ) {
    createFeedback(
      name: $name
      email: $email
      rating: $rating
      improvements: $improvements
      deal_id: $deal_id
    )
  }
`;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<
  CreateFeedbackMutation,
  CreateFeedbackMutationVariables
>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      rating: // value for 'rating'
 *      improvements: // value for 'improvements'
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useCreateFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(
    CreateFeedbackDocument,
    options,
  );
}
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<
  CreateFeedbackMutation,
  CreateFeedbackMutationVariables
>;
export const TemporaryInfoUpdateDocument = gql`
  mutation temporaryInfoUpdate($info: temporaryInfoInput) {
    temporaryInfoUpdate(info: $info) {
      id
      data {
        ...TemporaryData
      }
      status
    }
  }
  ${TemporaryDataFragmentDoc}
`;
export type TemporaryInfoUpdateMutationFn = Apollo.MutationFunction<
  TemporaryInfoUpdateMutation,
  TemporaryInfoUpdateMutationVariables
>;

/**
 * __useTemporaryInfoUpdateMutation__
 *
 * To run a mutation, you first call `useTemporaryInfoUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryInfoUpdateMutation, { data, loading, error }] = useTemporaryInfoUpdateMutation({
 *   variables: {
 *      info: // value for 'info'
 *   },
 * });
 */
export function useTemporaryInfoUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TemporaryInfoUpdateMutation,
    TemporaryInfoUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TemporaryInfoUpdateMutation, TemporaryInfoUpdateMutationVariables>(
    TemporaryInfoUpdateDocument,
    options,
  );
}
export type TemporaryInfoUpdateMutationHookResult = ReturnType<
  typeof useTemporaryInfoUpdateMutation
>;
export type TemporaryInfoUpdateMutationResult = Apollo.MutationResult<TemporaryInfoUpdateMutation>;
export type TemporaryInfoUpdateMutationOptions = Apollo.BaseMutationOptions<
  TemporaryInfoUpdateMutation,
  TemporaryInfoUpdateMutationVariables
>;
export const TemporaryInfoSsnUpdateDocument = gql`
  mutation temporaryInfoSsnUpdate($tempInfoId: ID!, $ssn: String!, $isCobuyer: Boolean!) {
    temporaryInfoSsnUpdate(tempInfoId: $tempInfoId, ssn: $ssn, isCobuyer: $isCobuyer) {
      id
    }
  }
`;
export type TemporaryInfoSsnUpdateMutationFn = Apollo.MutationFunction<
  TemporaryInfoSsnUpdateMutation,
  TemporaryInfoSsnUpdateMutationVariables
>;

/**
 * __useTemporaryInfoSsnUpdateMutation__
 *
 * To run a mutation, you first call `useTemporaryInfoSsnUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoSsnUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryInfoSsnUpdateMutation, { data, loading, error }] = useTemporaryInfoSsnUpdateMutation({
 *   variables: {
 *      tempInfoId: // value for 'tempInfoId'
 *      ssn: // value for 'ssn'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useTemporaryInfoSsnUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TemporaryInfoSsnUpdateMutation,
    TemporaryInfoSsnUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TemporaryInfoSsnUpdateMutation,
    TemporaryInfoSsnUpdateMutationVariables
  >(TemporaryInfoSsnUpdateDocument, options);
}
export type TemporaryInfoSsnUpdateMutationHookResult = ReturnType<
  typeof useTemporaryInfoSsnUpdateMutation
>;
export type TemporaryInfoSsnUpdateMutationResult =
  Apollo.MutationResult<TemporaryInfoSsnUpdateMutation>;
export type TemporaryInfoSsnUpdateMutationOptions = Apollo.BaseMutationOptions<
  TemporaryInfoSsnUpdateMutation,
  TemporaryInfoSsnUpdateMutationVariables
>;
export const DecryptTempInfoSsnDocument = gql`
  query decryptTempInfoSSN($tempInfoId: ID!) {
    decryptTempInfoSSN(tempInfoId: $tempInfoId)
  }
`;

/**
 * __useDecryptTempInfoSsnQuery__
 *
 * To run a query within a React component, call `useDecryptTempInfoSsnQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecryptTempInfoSsnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecryptTempInfoSsnQuery({
 *   variables: {
 *      tempInfoId: // value for 'tempInfoId'
 *   },
 * });
 */
export function useDecryptTempInfoSsnQuery(
  baseOptions: Apollo.QueryHookOptions<DecryptTempInfoSsnQuery, DecryptTempInfoSsnQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DecryptTempInfoSsnQuery, DecryptTempInfoSsnQueryVariables>(
    DecryptTempInfoSsnDocument,
    options,
  );
}
export function useDecryptTempInfoSsnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DecryptTempInfoSsnQuery,
    DecryptTempInfoSsnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DecryptTempInfoSsnQuery, DecryptTempInfoSsnQueryVariables>(
    DecryptTempInfoSsnDocument,
    options,
  );
}
export type DecryptTempInfoSsnQueryHookResult = ReturnType<typeof useDecryptTempInfoSsnQuery>;
export type DecryptTempInfoSsnLazyQueryHookResult = ReturnType<
  typeof useDecryptTempInfoSsnLazyQuery
>;
export type DecryptTempInfoSsnQueryResult = Apollo.QueryResult<
  DecryptTempInfoSsnQuery,
  DecryptTempInfoSsnQueryVariables
>;
export const CreateTemporaryInfoDocument = gql`
  mutation createTemporaryInfo(
    $vin: String
    $license_plate_number: String
    $license_plate_state: String
    $device_type: String
    $extra_input: extraTempInfoInputType
    $query_params: String
    $ignore_existing_deal: Boolean
    $is_methodfi_flow: Boolean
    $methodfi_flow_variation: Int
  ) {
    createTemporaryInfo(
      vin: $vin
      license_plate_number: $license_plate_number
      license_plate_state: $license_plate_state
      device_type: $device_type
      extra_info: $extra_input
      query_params: $query_params
      ignore_existing_deal: $ignore_existing_deal
      is_methodfi_flow: $is_methodfi_flow
      methodfi_flow_variation: $methodfi_flow_variation
    ) {
      id
      data {
        vin
        license_plate_number
        license_plate_state
        year
        make
        model
        fuel_type
        vehicle_type
        device_type
        zip
      }
    }
  }
`;
export type CreateTemporaryInfoMutationFn = Apollo.MutationFunction<
  CreateTemporaryInfoMutation,
  CreateTemporaryInfoMutationVariables
>;

/**
 * __useCreateTemporaryInfoMutation__
 *
 * To run a mutation, you first call `useCreateTemporaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporaryInfoMutation, { data, loading, error }] = useCreateTemporaryInfoMutation({
 *   variables: {
 *      vin: // value for 'vin'
 *      license_plate_number: // value for 'license_plate_number'
 *      license_plate_state: // value for 'license_plate_state'
 *      device_type: // value for 'device_type'
 *      extra_input: // value for 'extra_input'
 *      query_params: // value for 'query_params'
 *      ignore_existing_deal: // value for 'ignore_existing_deal'
 *      is_methodfi_flow: // value for 'is_methodfi_flow'
 *      methodfi_flow_variation: // value for 'methodfi_flow_variation'
 *   },
 * });
 */
export function useCreateTemporaryInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTemporaryInfoMutation,
    CreateTemporaryInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTemporaryInfoMutation, CreateTemporaryInfoMutationVariables>(
    CreateTemporaryInfoDocument,
    options,
  );
}
export type CreateTemporaryInfoMutationHookResult = ReturnType<
  typeof useCreateTemporaryInfoMutation
>;
export type CreateTemporaryInfoMutationResult = Apollo.MutationResult<CreateTemporaryInfoMutation>;
export type CreateTemporaryInfoMutationOptions = Apollo.BaseMutationOptions<
  CreateTemporaryInfoMutation,
  CreateTemporaryInfoMutationVariables
>;
export const CreateManualEntryTemporaryInfoDocument = gql`
  mutation createManualEntryTemporaryInfo(
    $license_plate: String
    $state: String
    $vin: String!
    $year: String
    $make: String
    $model: String
    $fuel_type: String
    $vehicle_type: String
    $kbb_trim_name: String
    $device_type: String
    $extra_input: extraTempInfoInputType
    $query_params: String
  ) {
    createManualEntryTemporaryInfo(
      license_plate: $license_plate
      state: $state
      vin: $vin
      year: $year
      make: $make
      model: $model
      fuel_type: $fuel_type
      vehicle_type: $vehicle_type
      kbb_trim_name: $kbb_trim_name
      device_type: $device_type
      extra_info: $extra_input
      query_params: $query_params
    ) {
      id
      data {
        vin
        license_plate_number
        license_plate_state
        year
        make
        model
        fuel_type
        vehicle_type
        device_type
        zip
        kbb_trim_name
      }
    }
  }
`;
export type CreateManualEntryTemporaryInfoMutationFn = Apollo.MutationFunction<
  CreateManualEntryTemporaryInfoMutation,
  CreateManualEntryTemporaryInfoMutationVariables
>;

/**
 * __useCreateManualEntryTemporaryInfoMutation__
 *
 * To run a mutation, you first call `useCreateManualEntryTemporaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualEntryTemporaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualEntryTemporaryInfoMutation, { data, loading, error }] = useCreateManualEntryTemporaryInfoMutation({
 *   variables: {
 *      license_plate: // value for 'license_plate'
 *      state: // value for 'state'
 *      vin: // value for 'vin'
 *      year: // value for 'year'
 *      make: // value for 'make'
 *      model: // value for 'model'
 *      fuel_type: // value for 'fuel_type'
 *      vehicle_type: // value for 'vehicle_type'
 *      kbb_trim_name: // value for 'kbb_trim_name'
 *      device_type: // value for 'device_type'
 *      extra_input: // value for 'extra_input'
 *      query_params: // value for 'query_params'
 *   },
 * });
 */
export function useCreateManualEntryTemporaryInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateManualEntryTemporaryInfoMutation,
    CreateManualEntryTemporaryInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateManualEntryTemporaryInfoMutation,
    CreateManualEntryTemporaryInfoMutationVariables
  >(CreateManualEntryTemporaryInfoDocument, options);
}
export type CreateManualEntryTemporaryInfoMutationHookResult = ReturnType<
  typeof useCreateManualEntryTemporaryInfoMutation
>;
export type CreateManualEntryTemporaryInfoMutationResult =
  Apollo.MutationResult<CreateManualEntryTemporaryInfoMutation>;
export type CreateManualEntryTemporaryInfoMutationOptions = Apollo.BaseMutationOptions<
  CreateManualEntryTemporaryInfoMutation,
  CreateManualEntryTemporaryInfoMutationVariables
>;
export const CreateAffiliateTemporaryInfoDocument = gql`
  mutation createAffiliateTemporaryInfo(
    $device_type: String
    $query_params: String
    $country: Country
  ) {
    createAffiliateTemporaryInfo(
      device_type: $device_type
      query_params: $query_params
      country: $country
    ) {
      id
      data {
        ...TemporaryData
      }
    }
  }
  ${TemporaryDataFragmentDoc}
`;
export type CreateAffiliateTemporaryInfoMutationFn = Apollo.MutationFunction<
  CreateAffiliateTemporaryInfoMutation,
  CreateAffiliateTemporaryInfoMutationVariables
>;

/**
 * __useCreateAffiliateTemporaryInfoMutation__
 *
 * To run a mutation, you first call `useCreateAffiliateTemporaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliateTemporaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliateTemporaryInfoMutation, { data, loading, error }] = useCreateAffiliateTemporaryInfoMutation({
 *   variables: {
 *      device_type: // value for 'device_type'
 *      query_params: // value for 'query_params'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCreateAffiliateTemporaryInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAffiliateTemporaryInfoMutation,
    CreateAffiliateTemporaryInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAffiliateTemporaryInfoMutation,
    CreateAffiliateTemporaryInfoMutationVariables
  >(CreateAffiliateTemporaryInfoDocument, options);
}
export type CreateAffiliateTemporaryInfoMutationHookResult = ReturnType<
  typeof useCreateAffiliateTemporaryInfoMutation
>;
export type CreateAffiliateTemporaryInfoMutationResult =
  Apollo.MutationResult<CreateAffiliateTemporaryInfoMutation>;
export type CreateAffiliateTemporaryInfoMutationOptions = Apollo.BaseMutationOptions<
  CreateAffiliateTemporaryInfoMutation,
  CreateAffiliateTemporaryInfoMutationVariables
>;
export const DecodeAffiliateCarDetailsDocument = gql`
  query decodeAffiliateCarDetails(
    $vin: String
    $license_plate_number: String
    $license_plate_state: String
    $ignore_existing_deal: Boolean
    $temp_info_id: ID
  ) {
    decodeAffiliateCarDetails(
      vin: $vin
      license_plate_number: $license_plate_number
      license_plate_state: $license_plate_state
      ignore_existing_deal: $ignore_existing_deal
      temp_info_id: $temp_info_id
    ) {
      license_plate_number
      license_plate_state
      vin
      year
      make
      model
      fuel_type
      vehicle_type
      kbb_trim_name
    }
  }
`;

/**
 * __useDecodeAffiliateCarDetailsQuery__
 *
 * To run a query within a React component, call `useDecodeAffiliateCarDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecodeAffiliateCarDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeAffiliateCarDetailsQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *      license_plate_number: // value for 'license_plate_number'
 *      license_plate_state: // value for 'license_plate_state'
 *      ignore_existing_deal: // value for 'ignore_existing_deal'
 *      temp_info_id: // value for 'temp_info_id'
 *   },
 * });
 */
export function useDecodeAffiliateCarDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DecodeAffiliateCarDetailsQuery,
    DecodeAffiliateCarDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DecodeAffiliateCarDetailsQuery, DecodeAffiliateCarDetailsQueryVariables>(
    DecodeAffiliateCarDetailsDocument,
    options,
  );
}
export function useDecodeAffiliateCarDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DecodeAffiliateCarDetailsQuery,
    DecodeAffiliateCarDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DecodeAffiliateCarDetailsQuery,
    DecodeAffiliateCarDetailsQueryVariables
  >(DecodeAffiliateCarDetailsDocument, options);
}
export type DecodeAffiliateCarDetailsQueryHookResult = ReturnType<
  typeof useDecodeAffiliateCarDetailsQuery
>;
export type DecodeAffiliateCarDetailsLazyQueryHookResult = ReturnType<
  typeof useDecodeAffiliateCarDetailsLazyQuery
>;
export type DecodeAffiliateCarDetailsQueryResult = Apollo.QueryResult<
  DecodeAffiliateCarDetailsQuery,
  DecodeAffiliateCarDetailsQueryVariables
>;
export const TemporaryInfoImportDocument = gql`
  mutation temporaryInfoImport($id: ID!, $transformType: transformType!, $importType: ImportType) {
    temporaryInfoImport(id: $id, transformType: $transformType, importType: $importType) {
      id
      customer {
        id
      }
    }
  }
`;
export type TemporaryInfoImportMutationFn = Apollo.MutationFunction<
  TemporaryInfoImportMutation,
  TemporaryInfoImportMutationVariables
>;

/**
 * __useTemporaryInfoImportMutation__
 *
 * To run a mutation, you first call `useTemporaryInfoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [temporaryInfoImportMutation, { data, loading, error }] = useTemporaryInfoImportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      transformType: // value for 'transformType'
 *      importType: // value for 'importType'
 *   },
 * });
 */
export function useTemporaryInfoImportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TemporaryInfoImportMutation,
    TemporaryInfoImportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TemporaryInfoImportMutation, TemporaryInfoImportMutationVariables>(
    TemporaryInfoImportDocument,
    options,
  );
}
export type TemporaryInfoImportMutationHookResult = ReturnType<
  typeof useTemporaryInfoImportMutation
>;
export type TemporaryInfoImportMutationResult = Apollo.MutationResult<TemporaryInfoImportMutation>;
export type TemporaryInfoImportMutationOptions = Apollo.BaseMutationOptions<
  TemporaryInfoImportMutation,
  TemporaryInfoImportMutationVariables
>;
export const UnlinkTemporaryInfoDocument = gql`
  mutation unlinkTemporaryInfo($id: ID!) {
    unlinkTemporaryInfo(id: $id) {
      id
    }
  }
`;
export type UnlinkTemporaryInfoMutationFn = Apollo.MutationFunction<
  UnlinkTemporaryInfoMutation,
  UnlinkTemporaryInfoMutationVariables
>;

/**
 * __useUnlinkTemporaryInfoMutation__
 *
 * To run a mutation, you first call `useUnlinkTemporaryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTemporaryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTemporaryInfoMutation, { data, loading, error }] = useUnlinkTemporaryInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkTemporaryInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlinkTemporaryInfoMutation,
    UnlinkTemporaryInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnlinkTemporaryInfoMutation, UnlinkTemporaryInfoMutationVariables>(
    UnlinkTemporaryInfoDocument,
    options,
  );
}
export type UnlinkTemporaryInfoMutationHookResult = ReturnType<
  typeof useUnlinkTemporaryInfoMutation
>;
export type UnlinkTemporaryInfoMutationResult = Apollo.MutationResult<UnlinkTemporaryInfoMutation>;
export type UnlinkTemporaryInfoMutationOptions = Apollo.BaseMutationOptions<
  UnlinkTemporaryInfoMutation,
  UnlinkTemporaryInfoMutationVariables
>;
export const TemporaryInfoDocument = gql`
  query temporaryInfo($id: ID!, $allowImported: Boolean) {
    temporaryInfo(id: $id, allowImported: $allowImported) {
      id
      affiliate_id
      data {
        ...TemporaryData
      }
    }
  }
  ${TemporaryDataFragmentDoc}
`;

/**
 * __useTemporaryInfoQuery__
 *
 * To run a query within a React component, call `useTemporaryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      allowImported: // value for 'allowImported'
 *   },
 * });
 */
export function useTemporaryInfoQuery(
  baseOptions: Apollo.QueryHookOptions<TemporaryInfoQuery, TemporaryInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TemporaryInfoQuery, TemporaryInfoQueryVariables>(
    TemporaryInfoDocument,
    options,
  );
}
export function useTemporaryInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TemporaryInfoQuery, TemporaryInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TemporaryInfoQuery, TemporaryInfoQueryVariables>(
    TemporaryInfoDocument,
    options,
  );
}
export type TemporaryInfoQueryHookResult = ReturnType<typeof useTemporaryInfoQuery>;
export type TemporaryInfoLazyQueryHookResult = ReturnType<typeof useTemporaryInfoLazyQuery>;
export type TemporaryInfoQueryResult = Apollo.QueryResult<
  TemporaryInfoQuery,
  TemporaryInfoQueryVariables
>;
export const LikelyAddressDocument = gql`
  query likelyAddress($phoneNumber: String) {
    likelyAddress(phoneNumber: $phoneNumber) {
      address_line
      address_line_2
      city
      state
      zip
      county
    }
  }
`;

/**
 * __useLikelyAddressQuery__
 *
 * To run a query within a React component, call `useLikelyAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useLikelyAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLikelyAddressQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useLikelyAddressQuery(
  baseOptions?: Apollo.QueryHookOptions<LikelyAddressQuery, LikelyAddressQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LikelyAddressQuery, LikelyAddressQueryVariables>(
    LikelyAddressDocument,
    options,
  );
}
export function useLikelyAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LikelyAddressQuery, LikelyAddressQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LikelyAddressQuery, LikelyAddressQueryVariables>(
    LikelyAddressDocument,
    options,
  );
}
export type LikelyAddressQueryHookResult = ReturnType<typeof useLikelyAddressQuery>;
export type LikelyAddressLazyQueryHookResult = ReturnType<typeof useLikelyAddressLazyQuery>;
export type LikelyAddressQueryResult = Apollo.QueryResult<
  LikelyAddressQuery,
  LikelyAddressQueryVariables
>;
export const KbbVinDocument = gql`
  query kbbVin($vin: String!) {
    kbbVin(vin: $vin) {
      warning
      vinResults {
        vehicleId
        vehicleOptions {
          categoryGroup
          hasRelationships
          isConfigurable
          isConsumer
          isTypical
          isVinDecoded
          optionName
          optionType
          sortOrder
          vehicleId
          vehicleOptionId
        }
        modelName
        trimName
        makeName
        yearId
        vehicleName
      }
    }
  }
`;

/**
 * __useKbbVinQuery__
 *
 * To run a query within a React component, call `useKbbVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useKbbVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKbbVinQuery({
 *   variables: {
 *      vin: // value for 'vin'
 *   },
 * });
 */
export function useKbbVinQuery(
  baseOptions: Apollo.QueryHookOptions<KbbVinQuery, KbbVinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<KbbVinQuery, KbbVinQueryVariables>(KbbVinDocument, options);
}
export function useKbbVinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KbbVinQuery, KbbVinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<KbbVinQuery, KbbVinQueryVariables>(KbbVinDocument, options);
}
export type KbbVinQueryHookResult = ReturnType<typeof useKbbVinQuery>;
export type KbbVinLazyQueryHookResult = ReturnType<typeof useKbbVinLazyQuery>;
export type KbbVinQueryResult = Apollo.QueryResult<KbbVinQuery, KbbVinQueryVariables>;
export const KbbValuesDocument = gql`
  query kbbValues($data: kbbValuesDataType!) {
    kbbValues(data: $data) {
      retail
      retailMileageAdjustment
      retailOptionAdjustment
      retailOptionPrices
      lending
      lendingMileageAdjustment
      lendingOptionAdjustment
      lendingOptionPrices
      valuationDate
      kbbSelectedOptions {
        id
        name
        type
        removed
        lendingOptionPrice
        retailOptionPrice
      }
    }
  }
`;

/**
 * __useKbbValuesQuery__
 *
 * To run a query within a React component, call `useKbbValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKbbValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKbbValuesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useKbbValuesQuery(
  baseOptions: Apollo.QueryHookOptions<KbbValuesQuery, KbbValuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<KbbValuesQuery, KbbValuesQueryVariables>(KbbValuesDocument, options);
}
export function useKbbValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KbbValuesQuery, KbbValuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<KbbValuesQuery, KbbValuesQueryVariables>(KbbValuesDocument, options);
}
export type KbbValuesQueryHookResult = ReturnType<typeof useKbbValuesQuery>;
export type KbbValuesLazyQueryHookResult = ReturnType<typeof useKbbValuesLazyQuery>;
export type KbbValuesQueryResult = Apollo.QueryResult<KbbValuesQuery, KbbValuesQueryVariables>;
export const CalculateOptionsDocument = gql`
  query calculateOptions(
    $vehicleId: Int
    $allKbbVehicleOptions: [kbbOptionInput]
    $startingVehicleOptions: [Int]
    $configToModify: [kbbConfigType]
    $vin: String!
    $color: String
  ) {
    calculateOptions(
      vehicleId: $vehicleId
      allKbbVehicleOptions: $allKbbVehicleOptions
      startingVehicleOptions: $startingVehicleOptions
      configToModify: $configToModify
      vin: $vin
      color: $color
    ) {
      vehicleOptionId
      optionName
      optionType
      categoryGroup
    }
  }
`;

/**
 * __useCalculateOptionsQuery__
 *
 * To run a query within a React component, call `useCalculateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateOptionsQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      allKbbVehicleOptions: // value for 'allKbbVehicleOptions'
 *      startingVehicleOptions: // value for 'startingVehicleOptions'
 *      configToModify: // value for 'configToModify'
 *      vin: // value for 'vin'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useCalculateOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<CalculateOptionsQuery, CalculateOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CalculateOptionsQuery, CalculateOptionsQueryVariables>(
    CalculateOptionsDocument,
    options,
  );
}
export function useCalculateOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CalculateOptionsQuery, CalculateOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CalculateOptionsQuery, CalculateOptionsQueryVariables>(
    CalculateOptionsDocument,
    options,
  );
}
export type CalculateOptionsQueryHookResult = ReturnType<typeof useCalculateOptionsQuery>;
export type CalculateOptionsLazyQueryHookResult = ReturnType<typeof useCalculateOptionsLazyQuery>;
export type CalculateOptionsQueryResult = Apollo.QueryResult<
  CalculateOptionsQuery,
  CalculateOptionsQueryVariables
>;
export const LienholderTrackRecordDocument = gql`
  query lienholderTrackRecord($lienholderSlug: String) {
    lienholderTrackRecord(lienholderSlug: $lienholderSlug) {
      lienholderFundedCount
      allTimeFundedCount
    }
  }
`;

/**
 * __useLienholderTrackRecordQuery__
 *
 * To run a query within a React component, call `useLienholderTrackRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useLienholderTrackRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLienholderTrackRecordQuery({
 *   variables: {
 *      lienholderSlug: // value for 'lienholderSlug'
 *   },
 * });
 */
export function useLienholderTrackRecordQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LienholderTrackRecordQuery,
    LienholderTrackRecordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LienholderTrackRecordQuery, LienholderTrackRecordQueryVariables>(
    LienholderTrackRecordDocument,
    options,
  );
}
export function useLienholderTrackRecordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LienholderTrackRecordQuery,
    LienholderTrackRecordQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LienholderTrackRecordQuery, LienholderTrackRecordQueryVariables>(
    LienholderTrackRecordDocument,
    options,
  );
}
export type LienholderTrackRecordQueryHookResult = ReturnType<typeof useLienholderTrackRecordQuery>;
export type LienholderTrackRecordLazyQueryHookResult = ReturnType<
  typeof useLienholderTrackRecordLazyQuery
>;
export type LienholderTrackRecordQueryResult = Apollo.QueryResult<
  LienholderTrackRecordQuery,
  LienholderTrackRecordQueryVariables
>;
export const CreateExternalTempInfoUploadUrlDocument = gql`
  mutation createExternalTempInfoUploadUrl(
    $guid: ID!
    $fileName: String!
    $fileDescription: String!
  ) {
    createExternalTempInfoUploadUrl(
      guid: $guid
      fileName: $fileName
      fileDescription: $fileDescription
    ) {
      url
    }
  }
`;
export type CreateExternalTempInfoUploadUrlMutationFn = Apollo.MutationFunction<
  CreateExternalTempInfoUploadUrlMutation,
  CreateExternalTempInfoUploadUrlMutationVariables
>;

/**
 * __useCreateExternalTempInfoUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateExternalTempInfoUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalTempInfoUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalTempInfoUploadUrlMutation, { data, loading, error }] = useCreateExternalTempInfoUploadUrlMutation({
 *   variables: {
 *      guid: // value for 'guid'
 *      fileName: // value for 'fileName'
 *      fileDescription: // value for 'fileDescription'
 *   },
 * });
 */
export function useCreateExternalTempInfoUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExternalTempInfoUploadUrlMutation,
    CreateExternalTempInfoUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExternalTempInfoUploadUrlMutation,
    CreateExternalTempInfoUploadUrlMutationVariables
  >(CreateExternalTempInfoUploadUrlDocument, options);
}
export type CreateExternalTempInfoUploadUrlMutationHookResult = ReturnType<
  typeof useCreateExternalTempInfoUploadUrlMutation
>;
export type CreateExternalTempInfoUploadUrlMutationResult =
  Apollo.MutationResult<CreateExternalTempInfoUploadUrlMutation>;
export type CreateExternalTempInfoUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  CreateExternalTempInfoUploadUrlMutation,
  CreateExternalTempInfoUploadUrlMutationVariables
>;
export const CreateExternalDealUploadUrlDocument = gql`
  mutation createExternalDealUploadUrl(
    $fileName: String!
    $fileDescription: String!
    $dealId: ID!
  ) {
    createExternalDealUploadUrl(
      fileName: $fileName
      fileDescription: $fileDescription
      dealId: $dealId
    ) {
      key
      url
    }
  }
`;
export type CreateExternalDealUploadUrlMutationFn = Apollo.MutationFunction<
  CreateExternalDealUploadUrlMutation,
  CreateExternalDealUploadUrlMutationVariables
>;

/**
 * __useCreateExternalDealUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateExternalDealUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalDealUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalDealUploadUrlMutation, { data, loading, error }] = useCreateExternalDealUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      fileDescription: // value for 'fileDescription'
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCreateExternalDealUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExternalDealUploadUrlMutation,
    CreateExternalDealUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExternalDealUploadUrlMutation,
    CreateExternalDealUploadUrlMutationVariables
  >(CreateExternalDealUploadUrlDocument, options);
}
export type CreateExternalDealUploadUrlMutationHookResult = ReturnType<
  typeof useCreateExternalDealUploadUrlMutation
>;
export type CreateExternalDealUploadUrlMutationResult =
  Apollo.MutationResult<CreateExternalDealUploadUrlMutation>;
export type CreateExternalDealUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  CreateExternalDealUploadUrlMutation,
  CreateExternalDealUploadUrlMutationVariables
>;
export const DeleteComFlowFileDocument = gql`
  mutation deleteComFlowFile($key: String!) {
    deleteComFlowFile(key: $key)
  }
`;
export type DeleteComFlowFileMutationFn = Apollo.MutationFunction<
  DeleteComFlowFileMutation,
  DeleteComFlowFileMutationVariables
>;

/**
 * __useDeleteComFlowFileMutation__
 *
 * To run a mutation, you first call `useDeleteComFlowFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComFlowFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComFlowFileMutation, { data, loading, error }] = useDeleteComFlowFileMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteComFlowFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteComFlowFileMutation,
    DeleteComFlowFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteComFlowFileMutation, DeleteComFlowFileMutationVariables>(
    DeleteComFlowFileDocument,
    options,
  );
}
export type DeleteComFlowFileMutationHookResult = ReturnType<typeof useDeleteComFlowFileMutation>;
export type DeleteComFlowFileMutationResult = Apollo.MutationResult<DeleteComFlowFileMutation>;
export type DeleteComFlowFileMutationOptions = Apollo.BaseMutationOptions<
  DeleteComFlowFileMutation,
  DeleteComFlowFileMutationVariables
>;
export const CreateFetchUrlsFromComDocument = gql`
  query createFetchUrlsFromCom($keys: [String]!) {
    createFetchUrlsFromCom(keys: $keys)
  }
`;

/**
 * __useCreateFetchUrlsFromComQuery__
 *
 * To run a query within a React component, call `useCreateFetchUrlsFromComQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateFetchUrlsFromComQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateFetchUrlsFromComQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useCreateFetchUrlsFromComQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateFetchUrlsFromComQuery,
    CreateFetchUrlsFromComQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateFetchUrlsFromComQuery, CreateFetchUrlsFromComQueryVariables>(
    CreateFetchUrlsFromComDocument,
    options,
  );
}
export function useCreateFetchUrlsFromComLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateFetchUrlsFromComQuery,
    CreateFetchUrlsFromComQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateFetchUrlsFromComQuery, CreateFetchUrlsFromComQueryVariables>(
    CreateFetchUrlsFromComDocument,
    options,
  );
}
export type CreateFetchUrlsFromComQueryHookResult = ReturnType<
  typeof useCreateFetchUrlsFromComQuery
>;
export type CreateFetchUrlsFromComLazyQueryHookResult = ReturnType<
  typeof useCreateFetchUrlsFromComLazyQuery
>;
export type CreateFetchUrlsFromComQueryResult = Apollo.QueryResult<
  CreateFetchUrlsFromComQuery,
  CreateFetchUrlsFromComQueryVariables
>;
export const MediaDeleteFromComDocument = gql`
  mutation mediaDeleteFromCom($dealId: ID!, $filePath: String!) {
    mediaDeleteFromCom(dealId: $dealId, filePath: $filePath)
  }
`;
export type MediaDeleteFromComMutationFn = Apollo.MutationFunction<
  MediaDeleteFromComMutation,
  MediaDeleteFromComMutationVariables
>;

/**
 * __useMediaDeleteFromComMutation__
 *
 * To run a mutation, you first call `useMediaDeleteFromComMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaDeleteFromComMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaDeleteFromComMutation, { data, loading, error }] = useMediaDeleteFromComMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useMediaDeleteFromComMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MediaDeleteFromComMutation,
    MediaDeleteFromComMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MediaDeleteFromComMutation, MediaDeleteFromComMutationVariables>(
    MediaDeleteFromComDocument,
    options,
  );
}
export type MediaDeleteFromComMutationHookResult = ReturnType<typeof useMediaDeleteFromComMutation>;
export type MediaDeleteFromComMutationResult = Apollo.MutationResult<MediaDeleteFromComMutation>;
export type MediaDeleteFromComMutationOptions = Apollo.BaseMutationOptions<
  MediaDeleteFromComMutation,
  MediaDeleteFromComMutationVariables
>;
export const MediaInsertComDocument = gql`
  mutation mediaInsertCom($key: String!, $type: String!, $dealId: ID!, $metadata: JSONObject) {
    mediaInsertCom(key: $key, type: $type, dealId: $dealId, metadata: $metadata) {
      id
      deal_id
      key
      signed_url
      type
    }
  }
`;
export type MediaInsertComMutationFn = Apollo.MutationFunction<
  MediaInsertComMutation,
  MediaInsertComMutationVariables
>;

/**
 * __useMediaInsertComMutation__
 *
 * To run a mutation, you first call `useMediaInsertComMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaInsertComMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaInsertComMutation, { data, loading, error }] = useMediaInsertComMutation({
 *   variables: {
 *      key: // value for 'key'
 *      type: // value for 'type'
 *      dealId: // value for 'dealId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useMediaInsertComMutation(
  baseOptions?: Apollo.MutationHookOptions<MediaInsertComMutation, MediaInsertComMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MediaInsertComMutation, MediaInsertComMutationVariables>(
    MediaInsertComDocument,
    options,
  );
}
export type MediaInsertComMutationHookResult = ReturnType<typeof useMediaInsertComMutation>;
export type MediaInsertComMutationResult = Apollo.MutationResult<MediaInsertComMutation>;
export type MediaInsertComMutationOptions = Apollo.BaseMutationOptions<
  MediaInsertComMutation,
  MediaInsertComMutationVariables
>;
export const MediaFromComDocument = gql`
  query mediaFromCom($dealId: ID) {
    mediaFromCom(dealId: $dealId) {
      id
      deal_id
      key
      signed_url
      type
      uploaded_via_com
      created_at
    }
  }
`;

/**
 * __useMediaFromComQuery__
 *
 * To run a query within a React component, call `useMediaFromComQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaFromComQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaFromComQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useMediaFromComQuery(
  baseOptions?: Apollo.QueryHookOptions<MediaFromComQuery, MediaFromComQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MediaFromComQuery, MediaFromComQueryVariables>(
    MediaFromComDocument,
    options,
  );
}
export function useMediaFromComLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MediaFromComQuery, MediaFromComQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MediaFromComQuery, MediaFromComQueryVariables>(
    MediaFromComDocument,
    options,
  );
}
export type MediaFromComQueryHookResult = ReturnType<typeof useMediaFromComQuery>;
export type MediaFromComLazyQueryHookResult = ReturnType<typeof useMediaFromComLazyQuery>;
export type MediaFromComQueryResult = Apollo.QueryResult<
  MediaFromComQuery,
  MediaFromComQueryVariables
>;
export const MediaUpdateComDocument = gql`
  mutation mediaUpdateCom($dealId: ID!, $oldKey: String!, $newFileName: String, $type: String) {
    mediaUpdateCom(dealId: $dealId, oldKey: $oldKey, newFileName: $newFileName, type: $type) {
      id
      deal_id
      key
      signed_url
      type
    }
  }
`;
export type MediaUpdateComMutationFn = Apollo.MutationFunction<
  MediaUpdateComMutation,
  MediaUpdateComMutationVariables
>;

/**
 * __useMediaUpdateComMutation__
 *
 * To run a mutation, you first call `useMediaUpdateComMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaUpdateComMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaUpdateComMutation, { data, loading, error }] = useMediaUpdateComMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      oldKey: // value for 'oldKey'
 *      newFileName: // value for 'newFileName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMediaUpdateComMutation(
  baseOptions?: Apollo.MutationHookOptions<MediaUpdateComMutation, MediaUpdateComMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MediaUpdateComMutation, MediaUpdateComMutationVariables>(
    MediaUpdateComDocument,
    options,
  );
}
export type MediaUpdateComMutationHookResult = ReturnType<typeof useMediaUpdateComMutation>;
export type MediaUpdateComMutationResult = Apollo.MutationResult<MediaUpdateComMutation>;
export type MediaUpdateComMutationOptions = Apollo.BaseMutationOptions<
  MediaUpdateComMutation,
  MediaUpdateComMutationVariables
>;
export const GetBase64StringFromS3ObjectDocument = gql`
  query getBase64StringFromS3Object($key: String!) {
    getBase64StringFromS3Object(key: $key)
  }
`;

/**
 * __useGetBase64StringFromS3ObjectQuery__
 *
 * To run a query within a React component, call `useGetBase64StringFromS3ObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBase64StringFromS3ObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBase64StringFromS3ObjectQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetBase64StringFromS3ObjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBase64StringFromS3ObjectQuery,
    GetBase64StringFromS3ObjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBase64StringFromS3ObjectQuery,
    GetBase64StringFromS3ObjectQueryVariables
  >(GetBase64StringFromS3ObjectDocument, options);
}
export function useGetBase64StringFromS3ObjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBase64StringFromS3ObjectQuery,
    GetBase64StringFromS3ObjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBase64StringFromS3ObjectQuery,
    GetBase64StringFromS3ObjectQueryVariables
  >(GetBase64StringFromS3ObjectDocument, options);
}
export type GetBase64StringFromS3ObjectQueryHookResult = ReturnType<
  typeof useGetBase64StringFromS3ObjectQuery
>;
export type GetBase64StringFromS3ObjectLazyQueryHookResult = ReturnType<
  typeof useGetBase64StringFromS3ObjectLazyQuery
>;
export type GetBase64StringFromS3ObjectQueryResult = Apollo.QueryResult<
  GetBase64StringFromS3ObjectQuery,
  GetBase64StringFromS3ObjectQueryVariables
>;
export const CreateMethodFiIndividualEntityDocument = gql`
  mutation createMethodFiIndividualEntity(
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
  ) {
    createIndividualEntity(firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber) {
      id
      type
      status
      products
    }
  }
`;
export type CreateMethodFiIndividualEntityMutationFn = Apollo.MutationFunction<
  CreateMethodFiIndividualEntityMutation,
  CreateMethodFiIndividualEntityMutationVariables
>;

/**
 * __useCreateMethodFiIndividualEntityMutation__
 *
 * To run a mutation, you first call `useCreateMethodFiIndividualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMethodFiIndividualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMethodFiIndividualEntityMutation, { data, loading, error }] = useCreateMethodFiIndividualEntityMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useCreateMethodFiIndividualEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMethodFiIndividualEntityMutation,
    CreateMethodFiIndividualEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMethodFiIndividualEntityMutation,
    CreateMethodFiIndividualEntityMutationVariables
  >(CreateMethodFiIndividualEntityDocument, options);
}
export type CreateMethodFiIndividualEntityMutationHookResult = ReturnType<
  typeof useCreateMethodFiIndividualEntityMutation
>;
export type CreateMethodFiIndividualEntityMutationResult =
  Apollo.MutationResult<CreateMethodFiIndividualEntityMutation>;
export type CreateMethodFiIndividualEntityMutationOptions = Apollo.BaseMutationOptions<
  CreateMethodFiIndividualEntityMutation,
  CreateMethodFiIndividualEntityMutationVariables
>;
export const CreateMethodFiVerificationSessionDocument = gql`
  mutation createMethodFiVerificationSession($entityId: String!) {
    createVerificationSession(entityId: $entityId) {
      id
      entity_id
      status
      type
      method
    }
  }
`;
export type CreateMethodFiVerificationSessionMutationFn = Apollo.MutationFunction<
  CreateMethodFiVerificationSessionMutation,
  CreateMethodFiVerificationSessionMutationVariables
>;

/**
 * __useCreateMethodFiVerificationSessionMutation__
 *
 * To run a mutation, you first call `useCreateMethodFiVerificationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMethodFiVerificationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMethodFiVerificationSessionMutation, { data, loading, error }] = useCreateMethodFiVerificationSessionMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCreateMethodFiVerificationSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMethodFiVerificationSessionMutation,
    CreateMethodFiVerificationSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMethodFiVerificationSessionMutation,
    CreateMethodFiVerificationSessionMutationVariables
  >(CreateMethodFiVerificationSessionDocument, options);
}
export type CreateMethodFiVerificationSessionMutationHookResult = ReturnType<
  typeof useCreateMethodFiVerificationSessionMutation
>;
export type CreateMethodFiVerificationSessionMutationResult =
  Apollo.MutationResult<CreateMethodFiVerificationSessionMutation>;
export type CreateMethodFiVerificationSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateMethodFiVerificationSessionMutation,
  CreateMethodFiVerificationSessionMutationVariables
>;
export const UpdateVerificationSessionDocument = gql`
  mutation updateVerificationSession(
    $entityId: String!
    $verificationSessionId: String!
    $code: String!
  ) {
    updateVerificationSession(
      entityId: $entityId
      verificationSessionId: $verificationSessionId
      code: $code
    ) {
      id
      entity_id
      status
      type
      method
    }
  }
`;
export type UpdateVerificationSessionMutationFn = Apollo.MutationFunction<
  UpdateVerificationSessionMutation,
  UpdateVerificationSessionMutationVariables
>;

/**
 * __useUpdateVerificationSessionMutation__
 *
 * To run a mutation, you first call `useUpdateVerificationSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVerificationSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVerificationSessionMutation, { data, loading, error }] = useUpdateVerificationSessionMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      verificationSessionId: // value for 'verificationSessionId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateVerificationSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVerificationSessionMutation,
    UpdateVerificationSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateVerificationSessionMutation,
    UpdateVerificationSessionMutationVariables
  >(UpdateVerificationSessionDocument, options);
}
export type UpdateVerificationSessionMutationHookResult = ReturnType<
  typeof useUpdateVerificationSessionMutation
>;
export type UpdateVerificationSessionMutationResult =
  Apollo.MutationResult<UpdateVerificationSessionMutation>;
export type UpdateVerificationSessionMutationOptions = Apollo.BaseMutationOptions<
  UpdateVerificationSessionMutation,
  UpdateVerificationSessionMutationVariables
>;
export const GetEntityDocument = gql`
  query getEntity($entityId: String!) {
    getEntity(entityId: $entityId) {
      id
      type
      status
      products
      verification {
        identity {
          verified
        }
        phone {
          verified
        }
      }
    }
  }
`;

/**
 * __useGetEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityQuery(
  baseOptions: Apollo.QueryHookOptions<GetEntityQuery, GetEntityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEntityQuery, GetEntityQueryVariables>(GetEntityDocument, options);
}
export function useGetEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEntityQuery, GetEntityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEntityQuery, GetEntityQueryVariables>(GetEntityDocument, options);
}
export type GetEntityQueryHookResult = ReturnType<typeof useGetEntityQuery>;
export type GetEntityLazyQueryHookResult = ReturnType<typeof useGetEntityLazyQuery>;
export type GetEntityQueryResult = Apollo.QueryResult<GetEntityQuery, GetEntityQueryVariables>;
export const GetMethodFiSessionStateDocument = gql`
  query getMethodFiSessionState {
    getMethodFiSessionState {
      entityId
      entity {
        id
        status
        verification {
          identity {
            verified
          }
          phone {
            verified
          }
        }
      }
      vehicles {
        vin
        year
        make
        model
        series
        major_color
        style
      }
      identities {
        dob
        phone
        address {
          address
          city
          state
          postal_code
        }
      }
      tempInfoFormattedData {
        dob
        address_line
        address_line_2
        city
        state
        zip
        county
      }
    }
  }
`;

/**
 * __useGetMethodFiSessionStateQuery__
 *
 * To run a query within a React component, call `useGetMethodFiSessionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMethodFiSessionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMethodFiSessionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMethodFiSessionStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMethodFiSessionStateQuery,
    GetMethodFiSessionStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMethodFiSessionStateQuery, GetMethodFiSessionStateQueryVariables>(
    GetMethodFiSessionStateDocument,
    options,
  );
}
export function useGetMethodFiSessionStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMethodFiSessionStateQuery,
    GetMethodFiSessionStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMethodFiSessionStateQuery, GetMethodFiSessionStateQueryVariables>(
    GetMethodFiSessionStateDocument,
    options,
  );
}
export type GetMethodFiSessionStateQueryHookResult = ReturnType<
  typeof useGetMethodFiSessionStateQuery
>;
export type GetMethodFiSessionStateLazyQueryHookResult = ReturnType<
  typeof useGetMethodFiSessionStateLazyQuery
>;
export type GetMethodFiSessionStateQueryResult = Apollo.QueryResult<
  GetMethodFiSessionStateQuery,
  GetMethodFiSessionStateQueryVariables
>;
export const CreateKyoVerificationDocument = gql`
  mutation createKyoVerification($entityId: String!) {
    createKyoVerification(entityId: $entityId) {
      id
      entity_id
      status
      type
      method
    }
  }
`;
export type CreateKyoVerificationMutationFn = Apollo.MutationFunction<
  CreateKyoVerificationMutation,
  CreateKyoVerificationMutationVariables
>;

/**
 * __useCreateKyoVerificationMutation__
 *
 * To run a mutation, you first call `useCreateKyoVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKyoVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKyoVerificationMutation, { data, loading, error }] = useCreateKyoVerificationMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useCreateKyoVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateKyoVerificationMutation,
    CreateKyoVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateKyoVerificationMutation, CreateKyoVerificationMutationVariables>(
    CreateKyoVerificationDocument,
    options,
  );
}
export type CreateKyoVerificationMutationHookResult = ReturnType<
  typeof useCreateKyoVerificationMutation
>;
export type CreateKyoVerificationMutationResult =
  Apollo.MutationResult<CreateKyoVerificationMutation>;
export type CreateKyoVerificationMutationOptions = Apollo.BaseMutationOptions<
  CreateKyoVerificationMutation,
  CreateKyoVerificationMutationVariables
>;
export const ConnectAndRetrieveEntityDataDocument = gql`
  mutation connectAndRetrieveEntityData(
    $entityId: String!
    $devOldCarOverride: Boolean
    $separateIdentityCall: Boolean
  ) {
    connectAndRetrieveEntityData(
      entityId: $entityId
      devOldCarOverride: $devOldCarOverride
      separateIdentityCall: $separateIdentityCall
    ) {
      entity {
        id
        status
      }
      vehicles {
        vin
        year
        make
        model
        series
        major_color
        style
      }
    }
  }
`;
export type ConnectAndRetrieveEntityDataMutationFn = Apollo.MutationFunction<
  ConnectAndRetrieveEntityDataMutation,
  ConnectAndRetrieveEntityDataMutationVariables
>;

/**
 * __useConnectAndRetrieveEntityDataMutation__
 *
 * To run a mutation, you first call `useConnectAndRetrieveEntityDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectAndRetrieveEntityDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectAndRetrieveEntityDataMutation, { data, loading, error }] = useConnectAndRetrieveEntityDataMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      devOldCarOverride: // value for 'devOldCarOverride'
 *      separateIdentityCall: // value for 'separateIdentityCall'
 *   },
 * });
 */
export function useConnectAndRetrieveEntityDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConnectAndRetrieveEntityDataMutation,
    ConnectAndRetrieveEntityDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConnectAndRetrieveEntityDataMutation,
    ConnectAndRetrieveEntityDataMutationVariables
  >(ConnectAndRetrieveEntityDataDocument, options);
}
export type ConnectAndRetrieveEntityDataMutationHookResult = ReturnType<
  typeof useConnectAndRetrieveEntityDataMutation
>;
export type ConnectAndRetrieveEntityDataMutationResult =
  Apollo.MutationResult<ConnectAndRetrieveEntityDataMutation>;
export type ConnectAndRetrieveEntityDataMutationOptions = Apollo.BaseMutationOptions<
  ConnectAndRetrieveEntityDataMutation,
  ConnectAndRetrieveEntityDataMutationVariables
>;
export const RetrieveEntityIdentitiesDocument = gql`
  mutation retrieveEntityIdentities($entityId: String!) {
    retrieveEntityIdentities(entityId: $entityId) {
      entity {
        id
        status
      }
      ssnId
    }
  }
`;
export type RetrieveEntityIdentitiesMutationFn = Apollo.MutationFunction<
  RetrieveEntityIdentitiesMutation,
  RetrieveEntityIdentitiesMutationVariables
>;

/**
 * __useRetrieveEntityIdentitiesMutation__
 *
 * To run a mutation, you first call `useRetrieveEntityIdentitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveEntityIdentitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveEntityIdentitiesMutation, { data, loading, error }] = useRetrieveEntityIdentitiesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRetrieveEntityIdentitiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetrieveEntityIdentitiesMutation,
    RetrieveEntityIdentitiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetrieveEntityIdentitiesMutation,
    RetrieveEntityIdentitiesMutationVariables
  >(RetrieveEntityIdentitiesDocument, options);
}
export type RetrieveEntityIdentitiesMutationHookResult = ReturnType<
  typeof useRetrieveEntityIdentitiesMutation
>;
export type RetrieveEntityIdentitiesMutationResult =
  Apollo.MutationResult<RetrieveEntityIdentitiesMutation>;
export type RetrieveEntityIdentitiesMutationOptions = Apollo.BaseMutationOptions<
  RetrieveEntityIdentitiesMutation,
  RetrieveEntityIdentitiesMutationVariables
>;
export const HasNpsSurveyResultDocument = gql`
  query hasNpsSurveyResult($dealId: Int!) {
    hasNpsSurveyResult(dealId: $dealId)
  }
`;

/**
 * __useHasNpsSurveyResultQuery__
 *
 * To run a query within a React component, call `useHasNpsSurveyResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNpsSurveyResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNpsSurveyResultQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useHasNpsSurveyResultQuery(
  baseOptions: Apollo.QueryHookOptions<HasNpsSurveyResultQuery, HasNpsSurveyResultQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HasNpsSurveyResultQuery, HasNpsSurveyResultQueryVariables>(
    HasNpsSurveyResultDocument,
    options,
  );
}
export function useHasNpsSurveyResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasNpsSurveyResultQuery,
    HasNpsSurveyResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HasNpsSurveyResultQuery, HasNpsSurveyResultQueryVariables>(
    HasNpsSurveyResultDocument,
    options,
  );
}
export type HasNpsSurveyResultQueryHookResult = ReturnType<typeof useHasNpsSurveyResultQuery>;
export type HasNpsSurveyResultLazyQueryHookResult = ReturnType<
  typeof useHasNpsSurveyResultLazyQuery
>;
export type HasNpsSurveyResultQueryResult = Apollo.QueryResult<
  HasNpsSurveyResultQuery,
  HasNpsSurveyResultQueryVariables
>;
export const CreateNpsSurveyResultDocument = gql`
  mutation createNpsSurveyResult($input: NPSSurveyResultInput!) {
    createNpsSurveyResult(input: $input)
  }
`;
export type CreateNpsSurveyResultMutationFn = Apollo.MutationFunction<
  CreateNpsSurveyResultMutation,
  CreateNpsSurveyResultMutationVariables
>;

/**
 * __useCreateNpsSurveyResultMutation__
 *
 * To run a mutation, you first call `useCreateNpsSurveyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNpsSurveyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNpsSurveyResultMutation, { data, loading, error }] = useCreateNpsSurveyResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNpsSurveyResultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNpsSurveyResultMutation,
    CreateNpsSurveyResultMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNpsSurveyResultMutation, CreateNpsSurveyResultMutationVariables>(
    CreateNpsSurveyResultDocument,
    options,
  );
}
export type CreateNpsSurveyResultMutationHookResult = ReturnType<
  typeof useCreateNpsSurveyResultMutation
>;
export type CreateNpsSurveyResultMutationResult =
  Apollo.MutationResult<CreateNpsSurveyResultMutation>;
export type CreateNpsSurveyResultMutationOptions = Apollo.BaseMutationOptions<
  CreateNpsSurveyResultMutation,
  CreateNpsSurveyResultMutationVariables
>;
export const GetOperatingHoursAndTimeSlotsDocument = gql`
  query getOperatingHoursAndTimeSlots {
    getOperatingHoursAndTimeSlots {
      isOpen
      utcTimeSlots
    }
  }
`;

/**
 * __useGetOperatingHoursAndTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetOperatingHoursAndTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatingHoursAndTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatingHoursAndTimeSlotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOperatingHoursAndTimeSlotsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOperatingHoursAndTimeSlotsQuery,
    GetOperatingHoursAndTimeSlotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOperatingHoursAndTimeSlotsQuery,
    GetOperatingHoursAndTimeSlotsQueryVariables
  >(GetOperatingHoursAndTimeSlotsDocument, options);
}
export function useGetOperatingHoursAndTimeSlotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOperatingHoursAndTimeSlotsQuery,
    GetOperatingHoursAndTimeSlotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOperatingHoursAndTimeSlotsQuery,
    GetOperatingHoursAndTimeSlotsQueryVariables
  >(GetOperatingHoursAndTimeSlotsDocument, options);
}
export type GetOperatingHoursAndTimeSlotsQueryHookResult = ReturnType<
  typeof useGetOperatingHoursAndTimeSlotsQuery
>;
export type GetOperatingHoursAndTimeSlotsLazyQueryHookResult = ReturnType<
  typeof useGetOperatingHoursAndTimeSlotsLazyQuery
>;
export type GetOperatingHoursAndTimeSlotsQueryResult = Apollo.QueryResult<
  GetOperatingHoursAndTimeSlotsQuery,
  GetOperatingHoursAndTimeSlotsQueryVariables
>;
export const CheckSupportedLienholderDocument = gql`
  query checkSupportedLienholder($dealId: Int) {
    checkSupportedLienholder(dealId: $dealId) {
      isSupported
      requirementsMet
      requiredFields
      missingRequiredFields
    }
  }
`;

/**
 * __useCheckSupportedLienholderQuery__
 *
 * To run a query within a React component, call `useCheckSupportedLienholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSupportedLienholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSupportedLienholderQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCheckSupportedLienholderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckSupportedLienholderQuery,
    CheckSupportedLienholderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>(
    CheckSupportedLienholderDocument,
    options,
  );
}
export function useCheckSupportedLienholderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckSupportedLienholderQuery,
    CheckSupportedLienholderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckSupportedLienholderQuery, CheckSupportedLienholderQueryVariables>(
    CheckSupportedLienholderDocument,
    options,
  );
}
export type CheckSupportedLienholderQueryHookResult = ReturnType<
  typeof useCheckSupportedLienholderQuery
>;
export type CheckSupportedLienholderLazyQueryHookResult = ReturnType<
  typeof useCheckSupportedLienholderLazyQuery
>;
export type CheckSupportedLienholderQueryResult = Apollo.QueryResult<
  CheckSupportedLienholderQuery,
  CheckSupportedLienholderQueryVariables
>;
export const AcquirePayoffDocument = gql`
  mutation acquirePayoff($payloadFields: [String!]!) {
    acquirePayoffForTemporaryInfo(payloadFields: $payloadFields) {
      received
    }
  }
`;
export type AcquirePayoffMutationFn = Apollo.MutationFunction<
  AcquirePayoffMutation,
  AcquirePayoffMutationVariables
>;

/**
 * __useAcquirePayoffMutation__
 *
 * To run a mutation, you first call `useAcquirePayoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcquirePayoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acquirePayoffMutation, { data, loading, error }] = useAcquirePayoffMutation({
 *   variables: {
 *      payloadFields: // value for 'payloadFields'
 *   },
 * });
 */
export function useAcquirePayoffMutation(
  baseOptions?: Apollo.MutationHookOptions<AcquirePayoffMutation, AcquirePayoffMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcquirePayoffMutation, AcquirePayoffMutationVariables>(
    AcquirePayoffDocument,
    options,
  );
}
export type AcquirePayoffMutationHookResult = ReturnType<typeof useAcquirePayoffMutation>;
export type AcquirePayoffMutationResult = Apollo.MutationResult<AcquirePayoffMutation>;
export type AcquirePayoffMutationOptions = Apollo.BaseMutationOptions<
  AcquirePayoffMutation,
  AcquirePayoffMutationVariables
>;
export const ExternalAcquirePayoffForDealDocument = gql`
  mutation externalAcquirePayoffForDeal(
    $dealId: ID!
    $fields: ExternalPayoffIntelligenceFieldsInput!
    $payloadFields: [LienholderRequirement!]!
  ) {
    externalAcquirePayoffForDeal(dealId: $dealId, fields: $fields, payloadFields: $payloadFields) {
      received
    }
  }
`;
export type ExternalAcquirePayoffForDealMutationFn = Apollo.MutationFunction<
  ExternalAcquirePayoffForDealMutation,
  ExternalAcquirePayoffForDealMutationVariables
>;

/**
 * __useExternalAcquirePayoffForDealMutation__
 *
 * To run a mutation, you first call `useExternalAcquirePayoffForDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalAcquirePayoffForDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalAcquirePayoffForDealMutation, { data, loading, error }] = useExternalAcquirePayoffForDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fields: // value for 'fields'
 *      payloadFields: // value for 'payloadFields'
 *   },
 * });
 */
export function useExternalAcquirePayoffForDealMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExternalAcquirePayoffForDealMutation,
    ExternalAcquirePayoffForDealMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExternalAcquirePayoffForDealMutation,
    ExternalAcquirePayoffForDealMutationVariables
  >(ExternalAcquirePayoffForDealDocument, options);
}
export type ExternalAcquirePayoffForDealMutationHookResult = ReturnType<
  typeof useExternalAcquirePayoffForDealMutation
>;
export type ExternalAcquirePayoffForDealMutationResult =
  Apollo.MutationResult<ExternalAcquirePayoffForDealMutation>;
export type ExternalAcquirePayoffForDealMutationOptions = Apollo.BaseMutationOptions<
  ExternalAcquirePayoffForDealMutation,
  ExternalAcquirePayoffForDealMutationVariables
>;
export const CancelPayoffRequestByTemporaryInfoIdDocument = gql`
  mutation cancelPayoffRequestByTemporaryInfoId($temporaryInfoId: ID!) {
    cancelPayoffRequestByTemporaryInfoId(temporaryInfoId: $temporaryInfoId) {
      id
      status
    }
  }
`;
export type CancelPayoffRequestByTemporaryInfoIdMutationFn = Apollo.MutationFunction<
  CancelPayoffRequestByTemporaryInfoIdMutation,
  CancelPayoffRequestByTemporaryInfoIdMutationVariables
>;

/**
 * __useCancelPayoffRequestByTemporaryInfoIdMutation__
 *
 * To run a mutation, you first call `useCancelPayoffRequestByTemporaryInfoIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPayoffRequestByTemporaryInfoIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPayoffRequestByTemporaryInfoIdMutation, { data, loading, error }] = useCancelPayoffRequestByTemporaryInfoIdMutation({
 *   variables: {
 *      temporaryInfoId: // value for 'temporaryInfoId'
 *   },
 * });
 */
export function useCancelPayoffRequestByTemporaryInfoIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelPayoffRequestByTemporaryInfoIdMutation,
    CancelPayoffRequestByTemporaryInfoIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelPayoffRequestByTemporaryInfoIdMutation,
    CancelPayoffRequestByTemporaryInfoIdMutationVariables
  >(CancelPayoffRequestByTemporaryInfoIdDocument, options);
}
export type CancelPayoffRequestByTemporaryInfoIdMutationHookResult = ReturnType<
  typeof useCancelPayoffRequestByTemporaryInfoIdMutation
>;
export type CancelPayoffRequestByTemporaryInfoIdMutationResult =
  Apollo.MutationResult<CancelPayoffRequestByTemporaryInfoIdMutation>;
export type CancelPayoffRequestByTemporaryInfoIdMutationOptions = Apollo.BaseMutationOptions<
  CancelPayoffRequestByTemporaryInfoIdMutation,
  CancelPayoffRequestByTemporaryInfoIdMutationVariables
>;
export const ExternalUserPayoffRequestDocument = gql`
  query externalUserPayoffRequest($dealId: ID) {
    externalUserPayoffRequest(dealId: $dealId) {
      id
      status
      vehicle_payoff
      good_through_date
      is_payoff_intelligence
      self_serve_submitted_at
    }
  }
`;

/**
 * __useExternalUserPayoffRequestQuery__
 *
 * To run a query within a React component, call `useExternalUserPayoffRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalUserPayoffRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalUserPayoffRequestQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useExternalUserPayoffRequestQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExternalUserPayoffRequestQuery,
    ExternalUserPayoffRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExternalUserPayoffRequestQuery, ExternalUserPayoffRequestQueryVariables>(
    ExternalUserPayoffRequestDocument,
    options,
  );
}
export function useExternalUserPayoffRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExternalUserPayoffRequestQuery,
    ExternalUserPayoffRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExternalUserPayoffRequestQuery,
    ExternalUserPayoffRequestQueryVariables
  >(ExternalUserPayoffRequestDocument, options);
}
export type ExternalUserPayoffRequestQueryHookResult = ReturnType<
  typeof useExternalUserPayoffRequestQuery
>;
export type ExternalUserPayoffRequestLazyQueryHookResult = ReturnType<
  typeof useExternalUserPayoffRequestLazyQuery
>;
export type ExternalUserPayoffRequestQueryResult = Apollo.QueryResult<
  ExternalUserPayoffRequestQuery,
  ExternalUserPayoffRequestQueryVariables
>;
export const OnPayoffRequestStatusUpdateDocument = gql`
  subscription onPayoffRequestStatusUpdate($dealId: ID) {
    onPayoffRequestStatusUpdate(dealId: $dealId) {
      message
      payoffRequest {
        id
        status
        vehicle_payoff
        good_through_date
        is_payoff_intelligence
      }
    }
  }
`;

/**
 * __useOnPayoffRequestStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useOnPayoffRequestStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPayoffRequestStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPayoffRequestStatusUpdateSubscription({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useOnPayoffRequestStatusUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    OnPayoffRequestStatusUpdateSubscription,
    OnPayoffRequestStatusUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnPayoffRequestStatusUpdateSubscription,
    OnPayoffRequestStatusUpdateSubscriptionVariables
  >(OnPayoffRequestStatusUpdateDocument, options);
}
export type OnPayoffRequestStatusUpdateSubscriptionHookResult = ReturnType<
  typeof useOnPayoffRequestStatusUpdateSubscription
>;
export type OnPayoffRequestStatusUpdateSubscriptionResult =
  Apollo.SubscriptionResult<OnPayoffRequestStatusUpdateSubscription>;
export const SubmitAfterHoursSelfServePayoffDocument = gql`
  mutation submitAfterHoursSelfServePayoff(
    $dealId: ID!
    $vehiclePayoff: Float!
    $goodThroughDate: DateTime!
  ) {
    submitAfterHoursSelfServePayoff(
      dealId: $dealId
      vehiclePayoff: $vehiclePayoff
      goodThroughDate: $goodThroughDate
    ) {
      id
      status
      vehicle_payoff
      good_through_date
      is_payoff_intelligence
      self_serve_submitted_at
    }
  }
`;
export type SubmitAfterHoursSelfServePayoffMutationFn = Apollo.MutationFunction<
  SubmitAfterHoursSelfServePayoffMutation,
  SubmitAfterHoursSelfServePayoffMutationVariables
>;

/**
 * __useSubmitAfterHoursSelfServePayoffMutation__
 *
 * To run a mutation, you first call `useSubmitAfterHoursSelfServePayoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAfterHoursSelfServePayoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAfterHoursSelfServePayoffMutation, { data, loading, error }] = useSubmitAfterHoursSelfServePayoffMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      vehiclePayoff: // value for 'vehiclePayoff'
 *      goodThroughDate: // value for 'goodThroughDate'
 *   },
 * });
 */
export function useSubmitAfterHoursSelfServePayoffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitAfterHoursSelfServePayoffMutation,
    SubmitAfterHoursSelfServePayoffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitAfterHoursSelfServePayoffMutation,
    SubmitAfterHoursSelfServePayoffMutationVariables
  >(SubmitAfterHoursSelfServePayoffDocument, options);
}
export type SubmitAfterHoursSelfServePayoffMutationHookResult = ReturnType<
  typeof useSubmitAfterHoursSelfServePayoffMutation
>;
export type SubmitAfterHoursSelfServePayoffMutationResult =
  Apollo.MutationResult<SubmitAfterHoursSelfServePayoffMutation>;
export type SubmitAfterHoursSelfServePayoffMutationOptions = Apollo.BaseMutationOptions<
  SubmitAfterHoursSelfServePayoffMutation,
  SubmitAfterHoursSelfServePayoffMutationVariables
>;
export const SubmitMarketplaceSelfServePayoffDocument = gql`
  mutation submitMarketplaceSelfServePayoff(
    $dealId: ID!
    $vehiclePayoff: Float!
    $goodThroughDate: DateTime!
  ) {
    submitMarketplaceSelfServePayoff(
      dealId: $dealId
      vehiclePayoff: $vehiclePayoff
      goodThroughDate: $goodThroughDate
    ) {
      id
    }
  }
`;
export type SubmitMarketplaceSelfServePayoffMutationFn = Apollo.MutationFunction<
  SubmitMarketplaceSelfServePayoffMutation,
  SubmitMarketplaceSelfServePayoffMutationVariables
>;

/**
 * __useSubmitMarketplaceSelfServePayoffMutation__
 *
 * To run a mutation, you first call `useSubmitMarketplaceSelfServePayoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMarketplaceSelfServePayoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMarketplaceSelfServePayoffMutation, { data, loading, error }] = useSubmitMarketplaceSelfServePayoffMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      vehiclePayoff: // value for 'vehiclePayoff'
 *      goodThroughDate: // value for 'goodThroughDate'
 *   },
 * });
 */
export function useSubmitMarketplaceSelfServePayoffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitMarketplaceSelfServePayoffMutation,
    SubmitMarketplaceSelfServePayoffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitMarketplaceSelfServePayoffMutation,
    SubmitMarketplaceSelfServePayoffMutationVariables
  >(SubmitMarketplaceSelfServePayoffDocument, options);
}
export type SubmitMarketplaceSelfServePayoffMutationHookResult = ReturnType<
  typeof useSubmitMarketplaceSelfServePayoffMutation
>;
export type SubmitMarketplaceSelfServePayoffMutationResult =
  Apollo.MutationResult<SubmitMarketplaceSelfServePayoffMutation>;
export type SubmitMarketplaceSelfServePayoffMutationOptions = Apollo.BaseMutationOptions<
  SubmitMarketplaceSelfServePayoffMutation,
  SubmitMarketplaceSelfServePayoffMutationVariables
>;
export const CreateManualPayoffRequestDocument = gql`
  mutation createManualPayoffRequest($dealId: ID!) {
    createManualPayoffRequest(dealId: $dealId) {
      id
      status
    }
  }
`;
export type CreateManualPayoffRequestMutationFn = Apollo.MutationFunction<
  CreateManualPayoffRequestMutation,
  CreateManualPayoffRequestMutationVariables
>;

/**
 * __useCreateManualPayoffRequestMutation__
 *
 * To run a mutation, you first call `useCreateManualPayoffRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualPayoffRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualPayoffRequestMutation, { data, loading, error }] = useCreateManualPayoffRequestMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useCreateManualPayoffRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateManualPayoffRequestMutation,
    CreateManualPayoffRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateManualPayoffRequestMutation,
    CreateManualPayoffRequestMutationVariables
  >(CreateManualPayoffRequestDocument, options);
}
export type CreateManualPayoffRequestMutationHookResult = ReturnType<
  typeof useCreateManualPayoffRequestMutation
>;
export type CreateManualPayoffRequestMutationResult =
  Apollo.MutationResult<CreateManualPayoffRequestMutation>;
export type CreateManualPayoffRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateManualPayoffRequestMutation,
  CreateManualPayoffRequestMutationVariables
>;
export const ValidatePhotoTokenDocument = gql`
  query validatePhotoToken($token: String!) {
    validatePhotoToken(token: $token) {
      authToken
      dealId
    }
  }
`;

/**
 * __useValidatePhotoTokenQuery__
 *
 * To run a query within a React component, call `useValidatePhotoTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePhotoTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePhotoTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePhotoTokenQuery(
  baseOptions: Apollo.QueryHookOptions<ValidatePhotoTokenQuery, ValidatePhotoTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidatePhotoTokenQuery, ValidatePhotoTokenQueryVariables>(
    ValidatePhotoTokenDocument,
    options,
  );
}
export function useValidatePhotoTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidatePhotoTokenQuery,
    ValidatePhotoTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidatePhotoTokenQuery, ValidatePhotoTokenQueryVariables>(
    ValidatePhotoTokenDocument,
    options,
  );
}
export type ValidatePhotoTokenQueryHookResult = ReturnType<typeof useValidatePhotoTokenQuery>;
export type ValidatePhotoTokenLazyQueryHookResult = ReturnType<
  typeof useValidatePhotoTokenLazyQuery
>;
export type ValidatePhotoTokenQueryResult = Apollo.QueryResult<
  ValidatePhotoTokenQuery,
  ValidatePhotoTokenQueryVariables
>;
export const GeneratePhotoTokenDocument = gql`
  mutation generatePhotoToken($dealId: ID!) {
    generatePhotoToken(dealId: $dealId) {
      id
      token
      deal_id
      expires_at
    }
  }
`;
export type GeneratePhotoTokenMutationFn = Apollo.MutationFunction<
  GeneratePhotoTokenMutation,
  GeneratePhotoTokenMutationVariables
>;

/**
 * __useGeneratePhotoTokenMutation__
 *
 * To run a mutation, you first call `useGeneratePhotoTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePhotoTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePhotoTokenMutation, { data, loading, error }] = useGeneratePhotoTokenMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGeneratePhotoTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GeneratePhotoTokenMutation,
    GeneratePhotoTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GeneratePhotoTokenMutation, GeneratePhotoTokenMutationVariables>(
    GeneratePhotoTokenDocument,
    options,
  );
}
export type GeneratePhotoTokenMutationHookResult = ReturnType<typeof useGeneratePhotoTokenMutation>;
export type GeneratePhotoTokenMutationResult = Apollo.MutationResult<GeneratePhotoTokenMutation>;
export type GeneratePhotoTokenMutationOptions = Apollo.BaseMutationOptions<
  GeneratePhotoTokenMutation,
  GeneratePhotoTokenMutationVariables
>;
export const GetPodHoursDocument = gql`
  query getPodHours {
    podHours {
      id
      label
      day
      beginTime
      endTime
    }
  }
`;

/**
 * __useGetPodHoursQuery__
 *
 * To run a query within a React component, call `useGetPodHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodHoursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPodHoursQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPodHoursQuery, GetPodHoursQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPodHoursQuery, GetPodHoursQueryVariables>(GetPodHoursDocument, options);
}
export function useGetPodHoursLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPodHoursQuery, GetPodHoursQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPodHoursQuery, GetPodHoursQueryVariables>(
    GetPodHoursDocument,
    options,
  );
}
export type GetPodHoursQueryHookResult = ReturnType<typeof useGetPodHoursQuery>;
export type GetPodHoursLazyQueryHookResult = ReturnType<typeof useGetPodHoursLazyQuery>;
export type GetPodHoursQueryResult = Apollo.QueryResult<
  GetPodHoursQuery,
  GetPodHoursQueryVariables
>;
export const ExecuteExternalSoftPullDocument = gql`
  mutation executeExternalSoftPull(
    $paymentEstimateInput: paymentEstimateInput!
    $isHardPull: Boolean!
  ) {
    executeExternalSoftPull(paymentEstimateInput: $paymentEstimateInput, isHardPull: $isHardPull)
  }
`;
export type ExecuteExternalSoftPullMutationFn = Apollo.MutationFunction<
  ExecuteExternalSoftPullMutation,
  ExecuteExternalSoftPullMutationVariables
>;

/**
 * __useExecuteExternalSoftPullMutation__
 *
 * To run a mutation, you first call `useExecuteExternalSoftPullMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteExternalSoftPullMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeExternalSoftPullMutation, { data, loading, error }] = useExecuteExternalSoftPullMutation({
 *   variables: {
 *      paymentEstimateInput: // value for 'paymentEstimateInput'
 *      isHardPull: // value for 'isHardPull'
 *   },
 * });
 */
export function useExecuteExternalSoftPullMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteExternalSoftPullMutation,
    ExecuteExternalSoftPullMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExecuteExternalSoftPullMutation,
    ExecuteExternalSoftPullMutationVariables
  >(ExecuteExternalSoftPullDocument, options);
}
export type ExecuteExternalSoftPullMutationHookResult = ReturnType<
  typeof useExecuteExternalSoftPullMutation
>;
export type ExecuteExternalSoftPullMutationResult =
  Apollo.MutationResult<ExecuteExternalSoftPullMutation>;
export type ExecuteExternalSoftPullMutationOptions = Apollo.BaseMutationOptions<
  ExecuteExternalSoftPullMutation,
  ExecuteExternalSoftPullMutationVariables
>;
export const CreateReferralDocument = gql`
  query createReferral($referrer_id: Int!, $temporary_info_id: String, $deal_id: Int) {
    createReferral(
      referrer_id: $referrer_id
      temporary_info_id: $temporary_info_id
      deal_id: $deal_id
    ) {
      id
      ok
    }
  }
`;

/**
 * __useCreateReferralQuery__
 *
 * To run a query within a React component, call `useCreateReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateReferralQuery({
 *   variables: {
 *      referrer_id: // value for 'referrer_id'
 *      temporary_info_id: // value for 'temporary_info_id'
 *      deal_id: // value for 'deal_id'
 *   },
 * });
 */
export function useCreateReferralQuery(
  baseOptions: Apollo.QueryHookOptions<CreateReferralQuery, CreateReferralQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateReferralQuery, CreateReferralQueryVariables>(
    CreateReferralDocument,
    options,
  );
}
export function useCreateReferralLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CreateReferralQuery, CreateReferralQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateReferralQuery, CreateReferralQueryVariables>(
    CreateReferralDocument,
    options,
  );
}
export type CreateReferralQueryHookResult = ReturnType<typeof useCreateReferralQuery>;
export type CreateReferralLazyQueryHookResult = ReturnType<typeof useCreateReferralLazyQuery>;
export type CreateReferralQueryResult = Apollo.QueryResult<
  CreateReferralQuery,
  CreateReferralQueryVariables
>;
export const SendReferralLinkEmailDocument = gql`
  query sendReferralLinkEmail(
    $email: String!
    $url: String!
    $firstName: String!
    $lastName: String!
  ) {
    sendReferralLinkEmail(email: $email, url: $url, firstName: $firstName, lastName: $lastName) {
      ok
    }
  }
`;

/**
 * __useSendReferralLinkEmailQuery__
 *
 * To run a query within a React component, call `useSendReferralLinkEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendReferralLinkEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendReferralLinkEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      url: // value for 'url'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useSendReferralLinkEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendReferralLinkEmailQuery,
    SendReferralLinkEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendReferralLinkEmailQuery, SendReferralLinkEmailQueryVariables>(
    SendReferralLinkEmailDocument,
    options,
  );
}
export function useSendReferralLinkEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendReferralLinkEmailQuery,
    SendReferralLinkEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SendReferralLinkEmailQuery, SendReferralLinkEmailQueryVariables>(
    SendReferralLinkEmailDocument,
    options,
  );
}
export type SendReferralLinkEmailQueryHookResult = ReturnType<typeof useSendReferralLinkEmailQuery>;
export type SendReferralLinkEmailLazyQueryHookResult = ReturnType<
  typeof useSendReferralLinkEmailLazyQuery
>;
export type SendReferralLinkEmailQueryResult = Apollo.QueryResult<
  SendReferralLinkEmailQuery,
  SendReferralLinkEmailQueryVariables
>;
export const SendOwnerReferralLinkEmailDocument = gql`
  query sendOwnerReferralLinkEmail($email: String!, $url: String!) {
    sendOwnerReferralLinkEmail(email: $email, url: $url) {
      ok
    }
  }
`;

/**
 * __useSendOwnerReferralLinkEmailQuery__
 *
 * To run a query within a React component, call `useSendOwnerReferralLinkEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendOwnerReferralLinkEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendOwnerReferralLinkEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSendOwnerReferralLinkEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendOwnerReferralLinkEmailQuery,
    SendOwnerReferralLinkEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendOwnerReferralLinkEmailQuery, SendOwnerReferralLinkEmailQueryVariables>(
    SendOwnerReferralLinkEmailDocument,
    options,
  );
}
export function useSendOwnerReferralLinkEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendOwnerReferralLinkEmailQuery,
    SendOwnerReferralLinkEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SendOwnerReferralLinkEmailQuery,
    SendOwnerReferralLinkEmailQueryVariables
  >(SendOwnerReferralLinkEmailDocument, options);
}
export type SendOwnerReferralLinkEmailQueryHookResult = ReturnType<
  typeof useSendOwnerReferralLinkEmailQuery
>;
export type SendOwnerReferralLinkEmailLazyQueryHookResult = ReturnType<
  typeof useSendOwnerReferralLinkEmailLazyQuery
>;
export type SendOwnerReferralLinkEmailQueryResult = Apollo.QueryResult<
  SendOwnerReferralLinkEmailQuery,
  SendOwnerReferralLinkEmailQueryVariables
>;
export const SendReferralLinkSmsDocument = gql`
  query sendReferralLinkSms(
    $phone: String!
    $url: String!
    $firstName: String!
    $lastName: String!
  ) {
    sendReferralLinkSms(phone: $phone, url: $url, firstName: $firstName, lastName: $lastName) {
      ok
    }
  }
`;

/**
 * __useSendReferralLinkSmsQuery__
 *
 * To run a query within a React component, call `useSendReferralLinkSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendReferralLinkSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendReferralLinkSmsQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      url: // value for 'url'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useSendReferralLinkSmsQuery(
  baseOptions: Apollo.QueryHookOptions<SendReferralLinkSmsQuery, SendReferralLinkSmsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendReferralLinkSmsQuery, SendReferralLinkSmsQueryVariables>(
    SendReferralLinkSmsDocument,
    options,
  );
}
export function useSendReferralLinkSmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendReferralLinkSmsQuery,
    SendReferralLinkSmsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SendReferralLinkSmsQuery, SendReferralLinkSmsQueryVariables>(
    SendReferralLinkSmsDocument,
    options,
  );
}
export type SendReferralLinkSmsQueryHookResult = ReturnType<typeof useSendReferralLinkSmsQuery>;
export type SendReferralLinkSmsLazyQueryHookResult = ReturnType<
  typeof useSendReferralLinkSmsLazyQuery
>;
export type SendReferralLinkSmsQueryResult = Apollo.QueryResult<
  SendReferralLinkSmsQuery,
  SendReferralLinkSmsQueryVariables
>;
export const SendOwnerReferralLinkSmsDocument = gql`
  query sendOwnerReferralLinkSms($phone: String!, $url: String!) {
    sendOwnerReferralLinkSms(phone: $phone, url: $url) {
      ok
    }
  }
`;

/**
 * __useSendOwnerReferralLinkSmsQuery__
 *
 * To run a query within a React component, call `useSendOwnerReferralLinkSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendOwnerReferralLinkSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendOwnerReferralLinkSmsQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useSendOwnerReferralLinkSmsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SendOwnerReferralLinkSmsQuery,
    SendOwnerReferralLinkSmsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendOwnerReferralLinkSmsQuery, SendOwnerReferralLinkSmsQueryVariables>(
    SendOwnerReferralLinkSmsDocument,
    options,
  );
}
export function useSendOwnerReferralLinkSmsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendOwnerReferralLinkSmsQuery,
    SendOwnerReferralLinkSmsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SendOwnerReferralLinkSmsQuery, SendOwnerReferralLinkSmsQueryVariables>(
    SendOwnerReferralLinkSmsDocument,
    options,
  );
}
export type SendOwnerReferralLinkSmsQueryHookResult = ReturnType<
  typeof useSendOwnerReferralLinkSmsQuery
>;
export type SendOwnerReferralLinkSmsLazyQueryHookResult = ReturnType<
  typeof useSendOwnerReferralLinkSmsLazyQuery
>;
export type SendOwnerReferralLinkSmsQueryResult = Apollo.QueryResult<
  SendOwnerReferralLinkSmsQuery,
  SendOwnerReferralLinkSmsQueryVariables
>;
export const GetReferrerByIdDocument = gql`
  query getReferrerById($id: Int!) {
    getReferrerById(id: $id) {
      id
      code
      customer_id
      url_views
      flow_starts
      customer_first_name
      customer_last_name
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

/**
 * __useGetReferrerByIdQuery__
 *
 * To run a query within a React component, call `useGetReferrerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferrerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferrerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReferrerByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetReferrerByIdQuery, GetReferrerByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReferrerByIdQuery, GetReferrerByIdQueryVariables>(
    GetReferrerByIdDocument,
    options,
  );
}
export function useGetReferrerByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReferrerByIdQuery, GetReferrerByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReferrerByIdQuery, GetReferrerByIdQueryVariables>(
    GetReferrerByIdDocument,
    options,
  );
}
export type GetReferrerByIdQueryHookResult = ReturnType<typeof useGetReferrerByIdQuery>;
export type GetReferrerByIdLazyQueryHookResult = ReturnType<typeof useGetReferrerByIdLazyQuery>;
export type GetReferrerByIdQueryResult = Apollo.QueryResult<
  GetReferrerByIdQuery,
  GetReferrerByIdQueryVariables
>;
export const GetReferrerByCustomerIdDocument = gql`
  query getReferrerByCustomerId($customer_id: Int!) {
    getReferrerByCustomerId(customer_id: $customer_id) {
      id
      code
      customer_id
      url_views
      flow_starts
      customer_first_name
      customer_last_name
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

/**
 * __useGetReferrerByCustomerIdQuery__
 *
 * To run a query within a React component, call `useGetReferrerByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferrerByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferrerByCustomerIdQuery({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *   },
 * });
 */
export function useGetReferrerByCustomerIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReferrerByCustomerIdQuery,
    GetReferrerByCustomerIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReferrerByCustomerIdQuery, GetReferrerByCustomerIdQueryVariables>(
    GetReferrerByCustomerIdDocument,
    options,
  );
}
export function useGetReferrerByCustomerIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReferrerByCustomerIdQuery,
    GetReferrerByCustomerIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReferrerByCustomerIdQuery, GetReferrerByCustomerIdQueryVariables>(
    GetReferrerByCustomerIdDocument,
    options,
  );
}
export type GetReferrerByCustomerIdQueryHookResult = ReturnType<
  typeof useGetReferrerByCustomerIdQuery
>;
export type GetReferrerByCustomerIdLazyQueryHookResult = ReturnType<
  typeof useGetReferrerByCustomerIdLazyQuery
>;
export type GetReferrerByCustomerIdQueryResult = Apollo.QueryResult<
  GetReferrerByCustomerIdQuery,
  GetReferrerByCustomerIdQueryVariables
>;
export const CreateReferrerDocument = gql`
  query CreateReferrer($customer_id: Int!) {
    createReferrer(customer_id: $customer_id) {
      id
      code
      customer_id
      url_views
      flow_starts
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;

/**
 * __useCreateReferrerQuery__
 *
 * To run a query within a React component, call `useCreateReferrerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateReferrerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateReferrerQuery({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *   },
 * });
 */
export function useCreateReferrerQuery(
  baseOptions: Apollo.QueryHookOptions<CreateReferrerQuery, CreateReferrerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CreateReferrerQuery, CreateReferrerQueryVariables>(
    CreateReferrerDocument,
    options,
  );
}
export function useCreateReferrerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CreateReferrerQuery, CreateReferrerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CreateReferrerQuery, CreateReferrerQueryVariables>(
    CreateReferrerDocument,
    options,
  );
}
export type CreateReferrerQueryHookResult = ReturnType<typeof useCreateReferrerQuery>;
export type CreateReferrerLazyQueryHookResult = ReturnType<typeof useCreateReferrerLazyQuery>;
export type CreateReferrerQueryResult = Apollo.QueryResult<
  CreateReferrerQuery,
  CreateReferrerQueryVariables
>;
export const UpdateReferrerDocument = gql`
  mutation updateReferrer($id: Int!, $data: ReferrerUpdateInput!) {
    updateReferrer(id: $id, data: $data) {
      code
      url_views
      flow_starts
      opted_in_at
      finix_identity
      finix_instrument
      finix_verify
      finix_merchant
      instrument_type
      instrument_brand
      instrument_last_four
      instrument_exp_mo
      instrument_exp_yr
    }
  }
`;
export type UpdateReferrerMutationFn = Apollo.MutationFunction<
  UpdateReferrerMutation,
  UpdateReferrerMutationVariables
>;

/**
 * __useUpdateReferrerMutation__
 *
 * To run a mutation, you first call `useUpdateReferrerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferrerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferrerMutation, { data, loading, error }] = useUpdateReferrerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReferrerMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateReferrerMutation, UpdateReferrerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateReferrerMutation, UpdateReferrerMutationVariables>(
    UpdateReferrerDocument,
    options,
  );
}
export type UpdateReferrerMutationHookResult = ReturnType<typeof useUpdateReferrerMutation>;
export type UpdateReferrerMutationResult = Apollo.MutationResult<UpdateReferrerMutation>;
export type UpdateReferrerMutationOptions = Apollo.BaseMutationOptions<
  UpdateReferrerMutation,
  UpdateReferrerMutationVariables
>;
export const EnsureFinixIdentityDocument = gql`
  mutation ensureFinixIdentity(
    $referrer_id: Int!
    $first_name: String!
    $last_name: String!
    $email: String!
    $phone_number: String!
    $address_line_1: String!
    $address_city: String!
    $address_state: String!
    $address_postal_code: String!
  ) {
    ensureFinixIdentity(
      referrer_id: $referrer_id
      first_name: $first_name
      last_name: $last_name
      email: $email
      phone_number: $phone_number
      address_line_1: $address_line_1
      address_city: $address_city
      address_state: $address_state
      address_postal_code: $address_postal_code
    )
  }
`;
export type EnsureFinixIdentityMutationFn = Apollo.MutationFunction<
  EnsureFinixIdentityMutation,
  EnsureFinixIdentityMutationVariables
>;

/**
 * __useEnsureFinixIdentityMutation__
 *
 * To run a mutation, you first call `useEnsureFinixIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureFinixIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureFinixIdentityMutation, { data, loading, error }] = useEnsureFinixIdentityMutation({
 *   variables: {
 *      referrer_id: // value for 'referrer_id'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      email: // value for 'email'
 *      phone_number: // value for 'phone_number'
 *      address_line_1: // value for 'address_line_1'
 *      address_city: // value for 'address_city'
 *      address_state: // value for 'address_state'
 *      address_postal_code: // value for 'address_postal_code'
 *   },
 * });
 */
export function useEnsureFinixIdentityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnsureFinixIdentityMutation,
    EnsureFinixIdentityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EnsureFinixIdentityMutation, EnsureFinixIdentityMutationVariables>(
    EnsureFinixIdentityDocument,
    options,
  );
}
export type EnsureFinixIdentityMutationHookResult = ReturnType<
  typeof useEnsureFinixIdentityMutation
>;
export type EnsureFinixIdentityMutationResult = Apollo.MutationResult<EnsureFinixIdentityMutation>;
export type EnsureFinixIdentityMutationOptions = Apollo.BaseMutationOptions<
  EnsureFinixIdentityMutation,
  EnsureFinixIdentityMutationVariables
>;
export const CreateFinixPaymentInstrumentTokenResolverDocument = gql`
  mutation createFinixPaymentInstrumentTokenResolver($identity: String!, $token: String!) {
    createFinixPaymentInstrumentTokenResolver(identity: $identity, token: $token) {
      id
      pi_t
      pi_b
      pi_lf
      pi_em
      pi_ey
    }
  }
`;
export type CreateFinixPaymentInstrumentTokenResolverMutationFn = Apollo.MutationFunction<
  CreateFinixPaymentInstrumentTokenResolverMutation,
  CreateFinixPaymentInstrumentTokenResolverMutationVariables
>;

/**
 * __useCreateFinixPaymentInstrumentTokenResolverMutation__
 *
 * To run a mutation, you first call `useCreateFinixPaymentInstrumentTokenResolverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinixPaymentInstrumentTokenResolverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinixPaymentInstrumentTokenResolverMutation, { data, loading, error }] = useCreateFinixPaymentInstrumentTokenResolverMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateFinixPaymentInstrumentTokenResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFinixPaymentInstrumentTokenResolverMutation,
    CreateFinixPaymentInstrumentTokenResolverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFinixPaymentInstrumentTokenResolverMutation,
    CreateFinixPaymentInstrumentTokenResolverMutationVariables
  >(CreateFinixPaymentInstrumentTokenResolverDocument, options);
}
export type CreateFinixPaymentInstrumentTokenResolverMutationHookResult = ReturnType<
  typeof useCreateFinixPaymentInstrumentTokenResolverMutation
>;
export type CreateFinixPaymentInstrumentTokenResolverMutationResult =
  Apollo.MutationResult<CreateFinixPaymentInstrumentTokenResolverMutation>;
export type CreateFinixPaymentInstrumentTokenResolverMutationOptions = Apollo.BaseMutationOptions<
  CreateFinixPaymentInstrumentTokenResolverMutation,
  CreateFinixPaymentInstrumentTokenResolverMutationVariables
>;
export const VerifyFinixPaymentInstrumentResolverDocument = gql`
  mutation verifyFinixPaymentInstrumentResolver($identity: String!, $instrument: String!) {
    verifyFinixPaymentInstrumentResolver(identity: $identity, instrument: $instrument) {
      id
    }
  }
`;
export type VerifyFinixPaymentInstrumentResolverMutationFn = Apollo.MutationFunction<
  VerifyFinixPaymentInstrumentResolverMutation,
  VerifyFinixPaymentInstrumentResolverMutationVariables
>;

/**
 * __useVerifyFinixPaymentInstrumentResolverMutation__
 *
 * To run a mutation, you first call `useVerifyFinixPaymentInstrumentResolverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyFinixPaymentInstrumentResolverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyFinixPaymentInstrumentResolverMutation, { data, loading, error }] = useVerifyFinixPaymentInstrumentResolverMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *      instrument: // value for 'instrument'
 *   },
 * });
 */
export function useVerifyFinixPaymentInstrumentResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyFinixPaymentInstrumentResolverMutation,
    VerifyFinixPaymentInstrumentResolverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyFinixPaymentInstrumentResolverMutation,
    VerifyFinixPaymentInstrumentResolverMutationVariables
  >(VerifyFinixPaymentInstrumentResolverDocument, options);
}
export type VerifyFinixPaymentInstrumentResolverMutationHookResult = ReturnType<
  typeof useVerifyFinixPaymentInstrumentResolverMutation
>;
export type VerifyFinixPaymentInstrumentResolverMutationResult =
  Apollo.MutationResult<VerifyFinixPaymentInstrumentResolverMutation>;
export type VerifyFinixPaymentInstrumentResolverMutationOptions = Apollo.BaseMutationOptions<
  VerifyFinixPaymentInstrumentResolverMutation,
  VerifyFinixPaymentInstrumentResolverMutationVariables
>;
export const CreateFinixPaymentMerchantResolverDocument = gql`
  mutation createFinixPaymentMerchantResolver($identity: String!) {
    createFinixPaymentMerchantResolver(identity: $identity) {
      id
    }
  }
`;
export type CreateFinixPaymentMerchantResolverMutationFn = Apollo.MutationFunction<
  CreateFinixPaymentMerchantResolverMutation,
  CreateFinixPaymentMerchantResolverMutationVariables
>;

/**
 * __useCreateFinixPaymentMerchantResolverMutation__
 *
 * To run a mutation, you first call `useCreateFinixPaymentMerchantResolverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinixPaymentMerchantResolverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinixPaymentMerchantResolverMutation, { data, loading, error }] = useCreateFinixPaymentMerchantResolverMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *   },
 * });
 */
export function useCreateFinixPaymentMerchantResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFinixPaymentMerchantResolverMutation,
    CreateFinixPaymentMerchantResolverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFinixPaymentMerchantResolverMutation,
    CreateFinixPaymentMerchantResolverMutationVariables
  >(CreateFinixPaymentMerchantResolverDocument, options);
}
export type CreateFinixPaymentMerchantResolverMutationHookResult = ReturnType<
  typeof useCreateFinixPaymentMerchantResolverMutation
>;
export type CreateFinixPaymentMerchantResolverMutationResult =
  Apollo.MutationResult<CreateFinixPaymentMerchantResolverMutation>;
export type CreateFinixPaymentMerchantResolverMutationOptions = Apollo.BaseMutationOptions<
  CreateFinixPaymentMerchantResolverMutation,
  CreateFinixPaymentMerchantResolverMutationVariables
>;
export const DisableFinixPaymentInstrumentResolverDocument = gql`
  mutation disableFinixPaymentInstrumentResolver($identity: String!, $instrument: String!) {
    disableFinixPaymentInstrumentResolver(identity: $identity, instrument: $instrument) {
      ok
    }
  }
`;
export type DisableFinixPaymentInstrumentResolverMutationFn = Apollo.MutationFunction<
  DisableFinixPaymentInstrumentResolverMutation,
  DisableFinixPaymentInstrumentResolverMutationVariables
>;

/**
 * __useDisableFinixPaymentInstrumentResolverMutation__
 *
 * To run a mutation, you first call `useDisableFinixPaymentInstrumentResolverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableFinixPaymentInstrumentResolverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableFinixPaymentInstrumentResolverMutation, { data, loading, error }] = useDisableFinixPaymentInstrumentResolverMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *      instrument: // value for 'instrument'
 *   },
 * });
 */
export function useDisableFinixPaymentInstrumentResolverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableFinixPaymentInstrumentResolverMutation,
    DisableFinixPaymentInstrumentResolverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableFinixPaymentInstrumentResolverMutation,
    DisableFinixPaymentInstrumentResolverMutationVariables
  >(DisableFinixPaymentInstrumentResolverDocument, options);
}
export type DisableFinixPaymentInstrumentResolverMutationHookResult = ReturnType<
  typeof useDisableFinixPaymentInstrumentResolverMutation
>;
export type DisableFinixPaymentInstrumentResolverMutationResult =
  Apollo.MutationResult<DisableFinixPaymentInstrumentResolverMutation>;
export type DisableFinixPaymentInstrumentResolverMutationOptions = Apollo.BaseMutationOptions<
  DisableFinixPaymentInstrumentResolverMutation,
  DisableFinixPaymentInstrumentResolverMutationVariables
>;
export const ExternalCustomerSetTempPasswordDocument = gql`
  mutation externalCustomerSetTempPassword($customerId: Int!) {
    externalCustomerSetTempPassword(customerId: $customerId) {
      id
    }
  }
`;
export type ExternalCustomerSetTempPasswordMutationFn = Apollo.MutationFunction<
  ExternalCustomerSetTempPasswordMutation,
  ExternalCustomerSetTempPasswordMutationVariables
>;

/**
 * __useExternalCustomerSetTempPasswordMutation__
 *
 * To run a mutation, you first call `useExternalCustomerSetTempPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalCustomerSetTempPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalCustomerSetTempPasswordMutation, { data, loading, error }] = useExternalCustomerSetTempPasswordMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useExternalCustomerSetTempPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExternalCustomerSetTempPasswordMutation,
    ExternalCustomerSetTempPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExternalCustomerSetTempPasswordMutation,
    ExternalCustomerSetTempPasswordMutationVariables
  >(ExternalCustomerSetTempPasswordDocument, options);
}
export type ExternalCustomerSetTempPasswordMutationHookResult = ReturnType<
  typeof useExternalCustomerSetTempPasswordMutation
>;
export type ExternalCustomerSetTempPasswordMutationResult =
  Apollo.MutationResult<ExternalCustomerSetTempPasswordMutation>;
export type ExternalCustomerSetTempPasswordMutationOptions = Apollo.BaseMutationOptions<
  ExternalCustomerSetTempPasswordMutation,
  ExternalCustomerSetTempPasswordMutationVariables
>;
export const GetOwedAsRefereeDocument = gql`
  query getOwedAsReferee($customer_id: Int!) {
    getOwedAsReferee(customer_id: $customer_id)
  }
`;

/**
 * __useGetOwedAsRefereeQuery__
 *
 * To run a query within a React component, call `useGetOwedAsRefereeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwedAsRefereeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwedAsRefereeQuery({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *   },
 * });
 */
export function useGetOwedAsRefereeQuery(
  baseOptions: Apollo.QueryHookOptions<GetOwedAsRefereeQuery, GetOwedAsRefereeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOwedAsRefereeQuery, GetOwedAsRefereeQueryVariables>(
    GetOwedAsRefereeDocument,
    options,
  );
}
export function useGetOwedAsRefereeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOwedAsRefereeQuery, GetOwedAsRefereeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOwedAsRefereeQuery, GetOwedAsRefereeQueryVariables>(
    GetOwedAsRefereeDocument,
    options,
  );
}
export type GetOwedAsRefereeQueryHookResult = ReturnType<typeof useGetOwedAsRefereeQuery>;
export type GetOwedAsRefereeLazyQueryHookResult = ReturnType<typeof useGetOwedAsRefereeLazyQuery>;
export type GetOwedAsRefereeQueryResult = Apollo.QueryResult<
  GetOwedAsRefereeQuery,
  GetOwedAsRefereeQueryVariables
>;
export const GetReferrerAggregateDocument = gql`
  query getReferrerAggregate($referrer_id: Int!) {
    getReferrerAggregate(referrer_id: $referrer_id) {
      total_referrals
      paid_referrals
      owed_referrals
      pending_referrals
    }
  }
`;

/**
 * __useGetReferrerAggregateQuery__
 *
 * To run a query within a React component, call `useGetReferrerAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferrerAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferrerAggregateQuery({
 *   variables: {
 *      referrer_id: // value for 'referrer_id'
 *   },
 * });
 */
export function useGetReferrerAggregateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReferrerAggregateQuery,
    GetReferrerAggregateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReferrerAggregateQuery, GetReferrerAggregateQueryVariables>(
    GetReferrerAggregateDocument,
    options,
  );
}
export function useGetReferrerAggregateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReferrerAggregateQuery,
    GetReferrerAggregateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReferrerAggregateQuery, GetReferrerAggregateQueryVariables>(
    GetReferrerAggregateDocument,
    options,
  );
}
export type GetReferrerAggregateQueryHookResult = ReturnType<typeof useGetReferrerAggregateQuery>;
export type GetReferrerAggregateLazyQueryHookResult = ReturnType<
  typeof useGetReferrerAggregateLazyQuery
>;
export type GetReferrerAggregateQueryResult = Apollo.QueryResult<
  GetReferrerAggregateQuery,
  GetReferrerAggregateQueryVariables
>;
export const GetVisibleReviewsDocument = gql`
  query getVisibleReviews {
    visibleReviews {
      id
      customer_name
      review
      created_at
    }
  }
`;

/**
 * __useGetVisibleReviewsQuery__
 *
 * To run a query within a React component, call `useGetVisibleReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisibleReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetVisibleReviewsQuery, GetVisibleReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVisibleReviewsQuery, GetVisibleReviewsQueryVariables>(
    GetVisibleReviewsDocument,
    options,
  );
}
export function useGetVisibleReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVisibleReviewsQuery,
    GetVisibleReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVisibleReviewsQuery, GetVisibleReviewsQueryVariables>(
    GetVisibleReviewsDocument,
    options,
  );
}
export type GetVisibleReviewsQueryHookResult = ReturnType<typeof useGetVisibleReviewsQuery>;
export type GetVisibleReviewsLazyQueryHookResult = ReturnType<typeof useGetVisibleReviewsLazyQuery>;
export type GetVisibleReviewsQueryResult = Apollo.QueryResult<
  GetVisibleReviewsQuery,
  GetVisibleReviewsQueryVariables
>;
export const SecureLinkCustomerUpdateDocument = gql`
  mutation secureLinkCustomerUpdate($ssn: String!, $token: String!) {
    secureLinkCustomerUpdate(ssn: $ssn, token: $token)
  }
`;
export type SecureLinkCustomerUpdateMutationFn = Apollo.MutationFunction<
  SecureLinkCustomerUpdateMutation,
  SecureLinkCustomerUpdateMutationVariables
>;

/**
 * __useSecureLinkCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useSecureLinkCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSecureLinkCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [secureLinkCustomerUpdateMutation, { data, loading, error }] = useSecureLinkCustomerUpdateMutation({
 *   variables: {
 *      ssn: // value for 'ssn'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSecureLinkCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SecureLinkCustomerUpdateMutation,
    SecureLinkCustomerUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SecureLinkCustomerUpdateMutation,
    SecureLinkCustomerUpdateMutationVariables
  >(SecureLinkCustomerUpdateDocument, options);
}
export type SecureLinkCustomerUpdateMutationHookResult = ReturnType<
  typeof useSecureLinkCustomerUpdateMutation
>;
export type SecureLinkCustomerUpdateMutationResult =
  Apollo.MutationResult<SecureLinkCustomerUpdateMutation>;
export type SecureLinkCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  SecureLinkCustomerUpdateMutation,
  SecureLinkCustomerUpdateMutationVariables
>;
export const ValidateSecureLinkDocument = gql`
  query validateSecureLink($token: String!) {
    validateSecureLink(token: $token)
  }
`;

/**
 * __useValidateSecureLinkQuery__
 *
 * To run a query within a React component, call `useValidateSecureLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSecureLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSecureLinkQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateSecureLinkQuery(
  baseOptions: Apollo.QueryHookOptions<ValidateSecureLinkQuery, ValidateSecureLinkQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateSecureLinkQuery, ValidateSecureLinkQueryVariables>(
    ValidateSecureLinkDocument,
    options,
  );
}
export function useValidateSecureLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateSecureLinkQuery,
    ValidateSecureLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidateSecureLinkQuery, ValidateSecureLinkQueryVariables>(
    ValidateSecureLinkDocument,
    options,
  );
}
export type ValidateSecureLinkQueryHookResult = ReturnType<typeof useValidateSecureLinkQuery>;
export type ValidateSecureLinkLazyQueryHookResult = ReturnType<
  typeof useValidateSecureLinkLazyQuery
>;
export type ValidateSecureLinkQueryResult = Apollo.QueryResult<
  ValidateSecureLinkQuery,
  ValidateSecureLinkQueryVariables
>;
export const GetR1CustomerCopyDocument = gql`
  query getR1CustomerCopy(
    $dealId: ID!
    $dealJacketID: String!
    $includeExtraPDFBinaries: Boolean!
    $isCobuyer: Boolean!
  ) {
    getR1CustomerCopy(
      dealId: $dealId
      dealJacketID: $dealJacketID
      includeExtraPDFBinaries: $includeExtraPDFBinaries
      isCobuyer: $isCobuyer
    ) {
      dealJacketId
      documentId
      documentName
      displayName
      documentType
      mimeType
      signAttributes {
        signRequired
        initialsType
        signCaptureTms
        actorName
        actorType
        dateCoordinates {
          width
          height
          pageNumber
          xPosition
          yPosition
        }
        dateFieldName
        signFieldName
        signPadText
        signatureCoordinates {
          height
          pageNumber
          width
          xPosition
          yPosition
        }
      }
      wetSignature
      docStatCode
      data
    }
  }
`;

/**
 * __useGetR1CustomerCopyQuery__
 *
 * To run a query within a React component, call `useGetR1CustomerCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetR1CustomerCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetR1CustomerCopyQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealJacketID: // value for 'dealJacketID'
 *      includeExtraPDFBinaries: // value for 'includeExtraPDFBinaries'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useGetR1CustomerCopyQuery(
  baseOptions: Apollo.QueryHookOptions<GetR1CustomerCopyQuery, GetR1CustomerCopyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetR1CustomerCopyQuery, GetR1CustomerCopyQueryVariables>(
    GetR1CustomerCopyDocument,
    options,
  );
}
export function useGetR1CustomerCopyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetR1CustomerCopyQuery,
    GetR1CustomerCopyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetR1CustomerCopyQuery, GetR1CustomerCopyQueryVariables>(
    GetR1CustomerCopyDocument,
    options,
  );
}
export type GetR1CustomerCopyQueryHookResult = ReturnType<typeof useGetR1CustomerCopyQuery>;
export type GetR1CustomerCopyLazyQueryHookResult = ReturnType<typeof useGetR1CustomerCopyLazyQuery>;
export type GetR1CustomerCopyQueryResult = Apollo.QueryResult<
  GetR1CustomerCopyQuery,
  GetR1CustomerCopyQueryVariables
>;
export const GetR1DealDocumentDocument = gql`
  query getR1DealDocument(
    $dealId: ID!
    $dealJacketID: String!
    $documentID: String!
    $includePdfBinary: Boolean
    $isCobuyer: Boolean!
  ) {
    getR1DealDocument(
      dealId: $dealId
      dealJacketID: $dealJacketID
      documentID: $documentID
      includePdfBinary: $includePdfBinary
      isCobuyer: $isCobuyer
    ) {
      dealJacketId
      documentId
      documentName
      displayName
      documentType
      mimeType
      signAttributes {
        signRequired
        initialsType
        signCaptureTms
        actorName
        actorType
        dateCoordinates {
          width
          height
          pageNumber
          xPosition
          yPosition
        }
        dateFieldName
        signFieldName
        signPadText
        signatureCoordinates {
          height
          pageNumber
          width
          xPosition
          yPosition
        }
      }
      wetSignature
      docStatCode
      data
    }
  }
`;

/**
 * __useGetR1DealDocumentQuery__
 *
 * To run a query within a React component, call `useGetR1DealDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetR1DealDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetR1DealDocumentQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealJacketID: // value for 'dealJacketID'
 *      documentID: // value for 'documentID'
 *      includePdfBinary: // value for 'includePdfBinary'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useGetR1DealDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<GetR1DealDocumentQuery, GetR1DealDocumentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetR1DealDocumentQuery, GetR1DealDocumentQueryVariables>(
    GetR1DealDocumentDocument,
    options,
  );
}
export function useGetR1DealDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetR1DealDocumentQuery,
    GetR1DealDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetR1DealDocumentQuery, GetR1DealDocumentQueryVariables>(
    GetR1DealDocumentDocument,
    options,
  );
}
export type GetR1DealDocumentQueryHookResult = ReturnType<typeof useGetR1DealDocumentQuery>;
export type GetR1DealDocumentLazyQueryHookResult = ReturnType<typeof useGetR1DealDocumentLazyQuery>;
export type GetR1DealDocumentQueryResult = Apollo.QueryResult<
  GetR1DealDocumentQuery,
  GetR1DealDocumentQueryVariables
>;
export const GenerateTestDocumentsDocument = gql`
  query generateTestDocuments($update_deal_id: ID!) {
    generateTestDocuments(update_deal_id: $update_deal_id)
  }
`;

/**
 * __useGenerateTestDocumentsQuery__
 *
 * To run a query within a React component, call `useGenerateTestDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTestDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTestDocumentsQuery({
 *   variables: {
 *      update_deal_id: // value for 'update_deal_id'
 *   },
 * });
 */
export function useGenerateTestDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GenerateTestDocumentsQuery,
    GenerateTestDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GenerateTestDocumentsQuery, GenerateTestDocumentsQueryVariables>(
    GenerateTestDocumentsDocument,
    options,
  );
}
export function useGenerateTestDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GenerateTestDocumentsQuery,
    GenerateTestDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GenerateTestDocumentsQuery, GenerateTestDocumentsQueryVariables>(
    GenerateTestDocumentsDocument,
    options,
  );
}
export type GenerateTestDocumentsQueryHookResult = ReturnType<typeof useGenerateTestDocumentsQuery>;
export type GenerateTestDocumentsLazyQueryHookResult = ReturnType<
  typeof useGenerateTestDocumentsLazyQuery
>;
export type GenerateTestDocumentsQueryResult = Apollo.QueryResult<
  GenerateTestDocumentsQuery,
  GenerateTestDocumentsQueryVariables
>;
export const ApplyDocumentSignatureDocument = gql`
  mutation applyDocumentSignature(
    $dealId: ID!
    $dealJacketID: String!
    $documentID: String!
    $documentName: String!
    $signatureFieldName: String!
    $signatureData: String!
    $isLastSignature: Boolean
    $isCobuyer: Boolean
  ) {
    applyDocumentSignature(
      dealId: $dealId
      dealJacketID: $dealJacketID
      documentID: $documentID
      documentName: $documentName
      signatureFieldName: $signatureFieldName
      signatureData: $signatureData
      isLastSignature: $isLastSignature
      isCobuyer: $isCobuyer
    )
  }
`;
export type ApplyDocumentSignatureMutationFn = Apollo.MutationFunction<
  ApplyDocumentSignatureMutation,
  ApplyDocumentSignatureMutationVariables
>;

/**
 * __useApplyDocumentSignatureMutation__
 *
 * To run a mutation, you first call `useApplyDocumentSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDocumentSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDocumentSignatureMutation, { data, loading, error }] = useApplyDocumentSignatureMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealJacketID: // value for 'dealJacketID'
 *      documentID: // value for 'documentID'
 *      documentName: // value for 'documentName'
 *      signatureFieldName: // value for 'signatureFieldName'
 *      signatureData: // value for 'signatureData'
 *      isLastSignature: // value for 'isLastSignature'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useApplyDocumentSignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyDocumentSignatureMutation,
    ApplyDocumentSignatureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyDocumentSignatureMutation,
    ApplyDocumentSignatureMutationVariables
  >(ApplyDocumentSignatureDocument, options);
}
export type ApplyDocumentSignatureMutationHookResult = ReturnType<
  typeof useApplyDocumentSignatureMutation
>;
export type ApplyDocumentSignatureMutationResult =
  Apollo.MutationResult<ApplyDocumentSignatureMutation>;
export type ApplyDocumentSignatureMutationOptions = Apollo.BaseMutationOptions<
  ApplyDocumentSignatureMutation,
  ApplyDocumentSignatureMutationVariables
>;
export const FinalizeR1SigningDocument = gql`
  mutation finalizeR1Signing($dealId: ID!, $dealJacketID: String!) {
    finalizeR1Signing(dealId: $dealId, dealJacketID: $dealJacketID)
  }
`;
export type FinalizeR1SigningMutationFn = Apollo.MutationFunction<
  FinalizeR1SigningMutation,
  FinalizeR1SigningMutationVariables
>;

/**
 * __useFinalizeR1SigningMutation__
 *
 * To run a mutation, you first call `useFinalizeR1SigningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeR1SigningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeR1SigningMutation, { data, loading, error }] = useFinalizeR1SigningMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealJacketID: // value for 'dealJacketID'
 *   },
 * });
 */
export function useFinalizeR1SigningMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinalizeR1SigningMutation,
    FinalizeR1SigningMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FinalizeR1SigningMutation, FinalizeR1SigningMutationVariables>(
    FinalizeR1SigningDocument,
    options,
  );
}
export type FinalizeR1SigningMutationHookResult = ReturnType<typeof useFinalizeR1SigningMutation>;
export type FinalizeR1SigningMutationResult = Apollo.MutationResult<FinalizeR1SigningMutation>;
export type FinalizeR1SigningMutationOptions = Apollo.BaseMutationOptions<
  FinalizeR1SigningMutation,
  FinalizeR1SigningMutationVariables
>;
export const StoreSignatureDataDocument = gql`
  mutation storeSignatureData(
    $customer_id: ID!
    $signature_data_url: String
    $signature_strokes: String
    $initials_data_url: String
    $initials_strokes: String
  ) {
    storeSignatureData(
      customer_id: $customer_id
      signature_data_url: $signature_data_url
      signature_strokes: $signature_strokes
      initials_data_url: $initials_data_url
      initials_strokes: $initials_strokes
    )
  }
`;
export type StoreSignatureDataMutationFn = Apollo.MutationFunction<
  StoreSignatureDataMutation,
  StoreSignatureDataMutationVariables
>;

/**
 * __useStoreSignatureDataMutation__
 *
 * To run a mutation, you first call `useStoreSignatureDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSignatureDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSignatureDataMutation, { data, loading, error }] = useStoreSignatureDataMutation({
 *   variables: {
 *      customer_id: // value for 'customer_id'
 *      signature_data_url: // value for 'signature_data_url'
 *      signature_strokes: // value for 'signature_strokes'
 *      initials_data_url: // value for 'initials_data_url'
 *      initials_strokes: // value for 'initials_strokes'
 *   },
 * });
 */
export function useStoreSignatureDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StoreSignatureDataMutation,
    StoreSignatureDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StoreSignatureDataMutation, StoreSignatureDataMutationVariables>(
    StoreSignatureDataDocument,
    options,
  );
}
export type StoreSignatureDataMutationHookResult = ReturnType<typeof useStoreSignatureDataMutation>;
export type StoreSignatureDataMutationResult = Apollo.MutationResult<StoreSignatureDataMutation>;
export type StoreSignatureDataMutationOptions = Apollo.BaseMutationOptions<
  StoreSignatureDataMutation,
  StoreSignatureDataMutationVariables
>;
export const GetSignDataDocument = gql`
  query getSignData($dealId: ID!) {
    retrieveDealDocsUploadedToR1(dealId: $dealId, includePdfBinary: false) {
      documentId
      signAttributes {
        signFieldName
        signRequired
        initialsType
        signCaptureTms
      }
      docStatCode
    }
  }
`;

/**
 * __useGetSignDataQuery__
 *
 * To run a query within a React component, call `useGetSignDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignDataQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useGetSignDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetSignDataQuery, GetSignDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSignDataQuery, GetSignDataQueryVariables>(GetSignDataDocument, options);
}
export function useGetSignDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSignDataQuery, GetSignDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSignDataQuery, GetSignDataQueryVariables>(
    GetSignDataDocument,
    options,
  );
}
export type GetSignDataQueryHookResult = ReturnType<typeof useGetSignDataQuery>;
export type GetSignDataLazyQueryHookResult = ReturnType<typeof useGetSignDataLazyQuery>;
export type GetSignDataQueryResult = Apollo.QueryResult<
  GetSignDataQuery,
  GetSignDataQueryVariables
>;
export const LogViewedDocumentEventDocument = gql`
  mutation logViewedDocumentEvent($documentViewedEvent: signingAuditDocumentViewedEvent!) {
    logViewedDocumentEvent(documentViewedEvent: $documentViewedEvent)
  }
`;
export type LogViewedDocumentEventMutationFn = Apollo.MutationFunction<
  LogViewedDocumentEventMutation,
  LogViewedDocumentEventMutationVariables
>;

/**
 * __useLogViewedDocumentEventMutation__
 *
 * To run a mutation, you first call `useLogViewedDocumentEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogViewedDocumentEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logViewedDocumentEventMutation, { data, loading, error }] = useLogViewedDocumentEventMutation({
 *   variables: {
 *      documentViewedEvent: // value for 'documentViewedEvent'
 *   },
 * });
 */
export function useLogViewedDocumentEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogViewedDocumentEventMutation,
    LogViewedDocumentEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LogViewedDocumentEventMutation,
    LogViewedDocumentEventMutationVariables
  >(LogViewedDocumentEventDocument, options);
}
export type LogViewedDocumentEventMutationHookResult = ReturnType<
  typeof useLogViewedDocumentEventMutation
>;
export type LogViewedDocumentEventMutationResult =
  Apollo.MutationResult<LogViewedDocumentEventMutation>;
export type LogViewedDocumentEventMutationOptions = Apollo.BaseMutationOptions<
  LogViewedDocumentEventMutation,
  LogViewedDocumentEventMutationVariables
>;
export const LogSigningErrorDocument = gql`
  mutation logSigningError($error: signingErrorInput!) {
    logSigningError(error: $error) {
      id
    }
  }
`;
export type LogSigningErrorMutationFn = Apollo.MutationFunction<
  LogSigningErrorMutation,
  LogSigningErrorMutationVariables
>;

/**
 * __useLogSigningErrorMutation__
 *
 * To run a mutation, you first call `useLogSigningErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogSigningErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logSigningErrorMutation, { data, loading, error }] = useLogSigningErrorMutation({
 *   variables: {
 *      error: // value for 'error'
 *   },
 * });
 */
export function useLogSigningErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogSigningErrorMutation,
    LogSigningErrorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogSigningErrorMutation, LogSigningErrorMutationVariables>(
    LogSigningErrorDocument,
    options,
  );
}
export type LogSigningErrorMutationHookResult = ReturnType<typeof useLogSigningErrorMutation>;
export type LogSigningErrorMutationResult = Apollo.MutationResult<LogSigningErrorMutation>;
export type LogSigningErrorMutationOptions = Apollo.BaseMutationOptions<
  LogSigningErrorMutation,
  LogSigningErrorMutationVariables
>;
export const SocialProofStatsDocument = gql`
  query socialProofStats($dealId: ID!) {
    socialProofStats(dealId: $dealId) {
      customerCountByState
      customerState
      allTimeFundedCount
      nationalBrandCount
      vehicleBrand
      trustpilotRating
      trustpilotReviewCount
    }
  }
`;

/**
 * __useSocialProofStatsQuery__
 *
 * To run a query within a React component, call `useSocialProofStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialProofStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialProofStatsQuery({
 *   variables: {
 *      dealId: // value for 'dealId'
 *   },
 * });
 */
export function useSocialProofStatsQuery(
  baseOptions: Apollo.QueryHookOptions<SocialProofStatsQuery, SocialProofStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SocialProofStatsQuery, SocialProofStatsQueryVariables>(
    SocialProofStatsDocument,
    options,
  );
}
export function useSocialProofStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SocialProofStatsQuery, SocialProofStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SocialProofStatsQuery, SocialProofStatsQueryVariables>(
    SocialProofStatsDocument,
    options,
  );
}
export type SocialProofStatsQueryHookResult = ReturnType<typeof useSocialProofStatsQuery>;
export type SocialProofStatsLazyQueryHookResult = ReturnType<typeof useSocialProofStatsLazyQuery>;
export type SocialProofStatsQueryResult = Apollo.QueryResult<
  SocialProofStatsQuery,
  SocialProofStatsQueryVariables
>;
export const GetTtJurisdictionDocument = gql`
  query getTTJurisdiction(
    $state: StateAbbreviation!
    $types: [TTProductType!]!
    $conditions: TTConditionFilterInput
  ) {
    jurisdiction(state: $state) {
      id
      hasRegistrationOnly
      hasTitleOnly
      hasTitleAndRegistration
      allowPlateTransfer
      requireWalkIn
      products(filter: { types: $types }) {
        count
        pageInfo {
          startCursor
          endCursor
        }
        items {
          type
          validations {
            name
            description
          }
          documents(conditions: $conditions) {
            count
            items {
              supportsImageExtraction
              productId
              documentTypeId
              type {
                name
                parameters {
                  name
                  description
                  type
                }
              }
              conditions {
                description
                variables
              }
              validations {
                name
                description
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetTtJurisdictionQuery__
 *
 * To run a query within a React component, call `useGetTtJurisdictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTtJurisdictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTtJurisdictionQuery({
 *   variables: {
 *      state: // value for 'state'
 *      types: // value for 'types'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useGetTtJurisdictionQuery(
  baseOptions: Apollo.QueryHookOptions<GetTtJurisdictionQuery, GetTtJurisdictionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTtJurisdictionQuery, GetTtJurisdictionQueryVariables>(
    GetTtJurisdictionDocument,
    options,
  );
}
export function useGetTtJurisdictionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTtJurisdictionQuery,
    GetTtJurisdictionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTtJurisdictionQuery, GetTtJurisdictionQueryVariables>(
    GetTtJurisdictionDocument,
    options,
  );
}
export type GetTtJurisdictionQueryHookResult = ReturnType<typeof useGetTtJurisdictionQuery>;
export type GetTtJurisdictionLazyQueryHookResult = ReturnType<typeof useGetTtJurisdictionLazyQuery>;
export type GetTtJurisdictionQueryResult = Apollo.QueryResult<
  GetTtJurisdictionQuery,
  GetTtJurisdictionQueryVariables
>;
export const UploadDocumentDocument = gql`
  mutation uploadDocument($bytes: String!, $documentType: TTDocumentName!) {
    uploadDocument(bytes: $bytes, documentType: $documentType) {
      documentName
      key
      fields {
        confidence
        name
        value
      }
    }
  }
`;
export type UploadDocumentMutationFn = Apollo.MutationFunction<
  UploadDocumentMutation,
  UploadDocumentMutationVariables
>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      bytes: // value for 'bytes'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useUploadDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(
    UploadDocumentDocument,
    options,
  );
}
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadDocumentMutation,
  UploadDocumentMutationVariables
>;
export const UploadDriversLicenseDocument = gql`
  mutation uploadDriversLicense($bytes: String!, $includeGender: Boolean) {
    uploadDriversLicense(bytes: $bytes, includeGender: $includeGender) {
      firstName
      middleName
      lastName
      address
      city
      state
      zip
      expirationDate
      sex
      documentNumber
    }
  }
`;
export type UploadDriversLicenseMutationFn = Apollo.MutationFunction<
  UploadDriversLicenseMutation,
  UploadDriversLicenseMutationVariables
>;

/**
 * __useUploadDriversLicenseMutation__
 *
 * To run a mutation, you first call `useUploadDriversLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDriversLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDriversLicenseMutation, { data, loading, error }] = useUploadDriversLicenseMutation({
 *   variables: {
 *      bytes: // value for 'bytes'
 *      includeGender: // value for 'includeGender'
 *   },
 * });
 */
export function useUploadDriversLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadDriversLicenseMutation,
    UploadDriversLicenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadDriversLicenseMutation, UploadDriversLicenseMutationVariables>(
    UploadDriversLicenseDocument,
    options,
  );
}
export type UploadDriversLicenseMutationHookResult = ReturnType<
  typeof useUploadDriversLicenseMutation
>;
export type UploadDriversLicenseMutationResult =
  Apollo.MutationResult<UploadDriversLicenseMutation>;
export type UploadDriversLicenseMutationOptions = Apollo.BaseMutationOptions<
  UploadDriversLicenseMutation,
  UploadDriversLicenseMutationVariables
>;
export const UserDealDocument = gql`
  query userDeal($id: ID, $isCobuyer: Boolean) {
    userDeal(id: $id, isCobuyer: $isCobuyer) {
      id
      type
      state
      import_type
      paperwork_type
      request_boot
      sales_visibility
      after_hours_held_at
      funding_jacket_id
      r1_contract_generation_date_utc
      signing_on_com
      document_progress_status
      isCobuyer
      closer_id
      came_from_marketplace
      setter_id
      car {
        id
        vin
        year
        make
        model
        mileage
        color
        book_value
        retail_book_value
        registration_expiration
        vehicle_type
        fuel_type
        kbb_trim_name
        mmr
        payoff {
          id
          lienholder_name
          lienholder_slug
          account_number
          vehicle_payoff
          lease_term
          remaining_payments
          msrp
          residual_percentage
          sales_price
          cap_reduction
          money_down
          money_factor
          termination_fees
          cap_cost
          residual_amount
          estimated_payoff
          old_lease_payment
        }
      }
      customer {
        id
        first_name
        middle_name
        last_name
        phone_number
        email
        dob
        dashboard_visited
        verified
        finished_signing
        prequalification {
          id
          created_at
          updated_at
          ltv
          payment_to_income
          prequalification_errors
        }
        address {
          id
          city
          state
          zip
          county
          address_line
          residence_type
          years_at_home
          months_at_home
          monthly_payment
          moved_states
        }
        drivers_license_address {
          id
          city
          state
          zip
          county
          address_line
          residence_type
          years_at_home
          months_at_home
          monthly_payment
          moved_states
        }
        prev_address {
          id
          city
          state
          zip
          county
          address_line
          residence_type
          years_at_home
          months_at_home
          monthly_payment
        }
        employment {
          id
          name
          job_title
          phone_number
          years_at_job
          months_at_job
          gross_income
          pay_frequency
        }
        prev_employment {
          id
          name
          job_title
          phone_number
          years_at_job
          months_at_job
          gross_income
          pay_frequency
        }
        signature_data {
          signature_data_url
          signature_strokes
          initials_data_url
          initials_strokes
        }
      }
      cobuyer {
        id
        first_name
        middle_name
        last_name
        phone_number
        email
        dob
        dashboard_visited
        verified
        finished_signing
        prequalification {
          id
          created_at
          updated_at
          ltv
          payment_to_income
          prequalification_errors
        }
        address {
          id
          city
          state
          zip
          county
          address_line
          residence_type
          years_at_home
          months_at_home
          monthly_payment
        }
        prev_address {
          id
          city
          state
          zip
          county
          address_line
          residence_type
          years_at_home
          months_at_home
          monthly_payment
        }
        employment {
          id
          name
          job_title
          phone_number
          years_at_job
          months_at_job
          gross_income
          pay_frequency
        }
        prev_employment {
          id
          name
          job_title
          phone_number
          years_at_job
          months_at_job
          gross_income
          pay_frequency
        }
        signature_data {
          signature_data_url
          signature_strokes
          initials_data_url
          initials_strokes
        }
      }
      financial_info {
        id
        deal_id
        money_down
        base_tax_amount
        warranty_tax_amount
        title_registration_option
        title_fee
        new_registration_fee
        registration_transfer_fee
        doc_fee
        sales_tax_rate
        days_to_payment
        first_payment_date
        sell_rate
        buy_rate
        term
        bank
        bank_slug
        payment
        amount_financed
        profit
        setter_commission
        closer_commission
        option_type
        plate_transfer
        credit_debit_payment_amount_allowed
        credit_payment_amount_allowed
        debit_payment_amount_allowed
        credit_payment_amount_limit
        debit_payment_amount_limit
      }
      financial_info_acquisition {
        id
        deal_id
        kbb_lending
        appraised_value
        max_cash_to_customer
        max_total_cost
        cash_to_customer
        is_approved
        auction_fees
        transport_cost
        total_cost
        auction_id
        gross_profit
        sell_price
        offer
      }
      condition_report {
        id
        deal_id
        accidents
        tires
        exterior
        interior
        smoked_in
        lights_on_dash
        overall_condition
        score
      }
      document_info {
        adobe_agreement_id
      }
      product {
        selected_package
        gap_selected
      }
      deal_states {
        state
        updated_date_utc
        created_at
      }
    }
  }
`;

/**
 * __useUserDealQuery__
 *
 * To run a query within a React component, call `useUserDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isCobuyer: // value for 'isCobuyer'
 *   },
 * });
 */
export function useUserDealQuery(
  baseOptions?: Apollo.QueryHookOptions<UserDealQuery, UserDealQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserDealQuery, UserDealQueryVariables>(UserDealDocument, options);
}
export function useUserDealLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserDealQuery, UserDealQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserDealQuery, UserDealQueryVariables>(UserDealDocument, options);
}
export type UserDealQueryHookResult = ReturnType<typeof useUserDealQuery>;
export type UserDealLazyQueryHookResult = ReturnType<typeof useUserDealLazyQuery>;
export type UserDealQueryResult = Apollo.QueryResult<UserDealQuery, UserDealQueryVariables>;
export const UserDealsDocument = gql`
  query userDeals {
    userDeals {
      id
      sales_visibility
      after_hours_held_at
      type
      car {
        id
        vin
        year
        make
        model
        mileage
        color
        book_value
        retail_book_value
        registration_expiration
        vehicle_type
        fuel_type
        kbb_trim_name
        mmr
      }
      customer {
        full_name
        email
      }
      cobuyer {
        full_name
        email
      }
      isCobuyer
    }
  }
`;

/**
 * __useUserDealsQuery__
 *
 * To run a query within a React component, call `useUserDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDealsQuery(
  baseOptions?: Apollo.QueryHookOptions<UserDealsQuery, UserDealsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserDealsQuery, UserDealsQueryVariables>(UserDealsDocument, options);
}
export function useUserDealsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserDealsQuery, UserDealsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserDealsQuery, UserDealsQueryVariables>(UserDealsDocument, options);
}
export type UserDealsQueryHookResult = ReturnType<typeof useUserDealsQuery>;
export type UserDealsLazyQueryHookResult = ReturnType<typeof useUserDealsLazyQuery>;
export type UserDealsQueryResult = Apollo.QueryResult<UserDealsQuery, UserDealsQueryVariables>;
export const HasAnyDealDocument = gql`
  query hasAnyDeal($email: String!) {
    hasAnyDeal(email: $email)
  }
`;

/**
 * __useHasAnyDealQuery__
 *
 * To run a query within a React component, call `useHasAnyDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAnyDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAnyDealQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useHasAnyDealQuery(
  baseOptions: Apollo.QueryHookOptions<HasAnyDealQuery, HasAnyDealQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HasAnyDealQuery, HasAnyDealQueryVariables>(HasAnyDealDocument, options);
}
export function useHasAnyDealLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HasAnyDealQuery, HasAnyDealQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HasAnyDealQuery, HasAnyDealQueryVariables>(
    HasAnyDealDocument,
    options,
  );
}
export type HasAnyDealQueryHookResult = ReturnType<typeof useHasAnyDealQuery>;
export type HasAnyDealLazyQueryHookResult = ReturnType<typeof useHasAnyDealLazyQuery>;
export type HasAnyDealQueryResult = Apollo.QueryResult<HasAnyDealQuery, HasAnyDealQueryVariables>;
